(function () {
/**
 * @license almond 0.3.3 Copyright jQuery Foundation and other contributors.
 * Released under MIT license, http://github.com/requirejs/almond/LICENSE
 */
//Going sloppy to avoid 'use strict' string cost, but strict practices should
//be followed.
/*global setTimeout: false */

var requirejs, require, define;
(function (undef) {
    var main, req, makeMap, handlers,
        defined = {},
        waiting = {},
        config = {},
        defining = {},
        hasOwn = Object.prototype.hasOwnProperty,
        aps = [].slice,
        jsSuffixRegExp = /\.js$/;

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @returns {String} normalized name
     */
    function normalize(name, baseName) {
        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
            foundI, foundStarMap, starI, i, j, part, normalizedBaseParts,
            baseParts = baseName && baseName.split("/"),
            map = config.map,
            starMap = (map && map['*']) || {};

        //Adjust any relative paths.
        if (name) {
            name = name.split('/');
            lastIndex = name.length - 1;

            // If wanting node ID compatibility, strip .js from end
            // of IDs. Have to do this here, and not in nameToUrl
            // because node allows either .js or non .js to map
            // to same file.
            if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
            }

            // Starts with a '.' so need the baseName
            if (name[0].charAt(0) === '.' && baseParts) {
                //Convert baseName to array, and lop off the last part,
                //so that . matches that 'directory' and not name of the baseName's
                //module. For instance, baseName of 'one/two/three', maps to
                //'one/two/three.js', but we want the directory, 'one/two' for
                //this normalization.
                normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
                name = normalizedBaseParts.concat(name);
            }

            //start trimDots
            for (i = 0; i < name.length; i++) {
                part = name[i];
                if (part === '.') {
                    name.splice(i, 1);
                    i -= 1;
                } else if (part === '..') {
                    // If at the start, or previous value is still ..,
                    // keep them so that when converted to a path it may
                    // still work when converted to a path, even though
                    // as an ID it is less than ideal. In larger point
                    // releases, may be better to just kick out an error.
                    if (i === 0 || (i === 1 && name[2] === '..') || name[i - 1] === '..') {
                        continue;
                    } else if (i > 0) {
                        name.splice(i - 1, 2);
                        i -= 2;
                    }
                }
            }
            //end trimDots

            name = name.join('/');
        }

        //Apply map config if available.
        if ((baseParts || starMap) && map) {
            nameParts = name.split('/');

            for (i = nameParts.length; i > 0; i -= 1) {
                nameSegment = nameParts.slice(0, i).join("/");

                if (baseParts) {
                    //Find the longest baseName segment match in the config.
                    //So, do joins on the biggest to smallest lengths of baseParts.
                    for (j = baseParts.length; j > 0; j -= 1) {
                        mapValue = map[baseParts.slice(0, j).join('/')];

                        //baseName segment has  config, find if it has one for
                        //this name.
                        if (mapValue) {
                            mapValue = mapValue[nameSegment];
                            if (mapValue) {
                                //Match, update name to the new value.
                                foundMap = mapValue;
                                foundI = i;
                                break;
                            }
                        }
                    }
                }

                if (foundMap) {
                    break;
                }

                //Check for a star map match, but just hold on to it,
                //if there is a shorter segment match later in a matching
                //config, then favor over this star map.
                if (!foundStarMap && starMap && starMap[nameSegment]) {
                    foundStarMap = starMap[nameSegment];
                    starI = i;
                }
            }

            if (!foundMap && foundStarMap) {
                foundMap = foundStarMap;
                foundI = starI;
            }

            if (foundMap) {
                nameParts.splice(0, foundI, foundMap);
                name = nameParts.join('/');
            }
        }

        return name;
    }

    function makeRequire(relName, forceSync) {
        return function () {
            //A version of a require function that passes a moduleName
            //value for items that may need to
            //look up paths relative to the moduleName
            var args = aps.call(arguments, 0);

            //If first arg is not require('string'), and there is only
            //one arg, it is the array form without a callback. Insert
            //a null so that the following concat is correct.
            if (typeof args[0] !== 'string' && args.length === 1) {
                args.push(null);
            }
            return req.apply(undef, args.concat([relName, forceSync]));
        };
    }

    function makeNormalize(relName) {
        return function (name) {
            return normalize(name, relName);
        };
    }

    function makeLoad(depName) {
        return function (value) {
            defined[depName] = value;
        };
    }

    function callDep(name) {
        if (hasProp(waiting, name)) {
            var args = waiting[name];
            delete waiting[name];
            defining[name] = true;
            main.apply(undef, args);
        }

        if (!hasProp(defined, name) && !hasProp(defining, name)) {
            throw new Error('No ' + name);
        }
        return defined[name];
    }

    //Turns a plugin!resource to [plugin, resource]
    //with the plugin being undefined if the name
    //did not have a plugin prefix.
    function splitPrefix(name) {
        var prefix,
            index = name ? name.indexOf('!') : -1;
        if (index > -1) {
            prefix = name.substring(0, index);
            name = name.substring(index + 1, name.length);
        }
        return [prefix, name];
    }

    //Creates a parts array for a relName where first part is plugin ID,
    //second part is resource ID. Assumes relName has already been normalized.
    function makeRelParts(relName) {
        return relName ? splitPrefix(relName) : [];
    }

    /**
     * Makes a name map, normalizing the name, and using a plugin
     * for normalization if necessary. Grabs a ref to plugin
     * too, as an optimization.
     */
    makeMap = function (name, relParts) {
        var plugin,
            parts = splitPrefix(name),
            prefix = parts[0],
            relResourceName = relParts[1];

        name = parts[1];

        if (prefix) {
            prefix = normalize(prefix, relResourceName);
            plugin = callDep(prefix);
        }

        //Normalize according
        if (prefix) {
            if (plugin && plugin.normalize) {
                name = plugin.normalize(name, makeNormalize(relResourceName));
            } else {
                name = normalize(name, relResourceName);
            }
        } else {
            name = normalize(name, relResourceName);
            parts = splitPrefix(name);
            prefix = parts[0];
            name = parts[1];
            if (prefix) {
                plugin = callDep(prefix);
            }
        }

        //Using ridiculous property names for space reasons
        return {
            f: prefix ? prefix + '!' + name : name, //fullName
            n: name,
            pr: prefix,
            p: plugin
        };
    };

    function makeConfig(name) {
        return function () {
            return (config && config.config && config.config[name]) || {};
        };
    }

    handlers = {
        require: function (name) {
            return makeRequire(name);
        },
        exports: function (name) {
            var e = defined[name];
            if (typeof e !== 'undefined') {
                return e;
            } else {
                return (defined[name] = {});
            }
        },
        module: function (name) {
            return {
                id: name,
                uri: '',
                exports: defined[name],
                config: makeConfig(name)
            };
        }
    };

    main = function (name, deps, callback, relName) {
        var cjsModule, depName, ret, map, i, relParts,
            args = [],
            callbackType = typeof callback,
            usingExports;

        //Use name if no relName
        relName = relName || name;
        relParts = makeRelParts(relName);

        //Call the callback to define the module, if necessary.
        if (callbackType === 'undefined' || callbackType === 'function') {
            //Pull out the defined dependencies and pass the ordered
            //values to the callback.
            //Default to [require, exports, module] if no deps
            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
            for (i = 0; i < deps.length; i += 1) {
                map = makeMap(deps[i], relParts);
                depName = map.f;

                //Fast path CommonJS standard dependencies.
                if (depName === "require") {
                    args[i] = handlers.require(name);
                } else if (depName === "exports") {
                    //CommonJS module spec 1.1
                    args[i] = handlers.exports(name);
                    usingExports = true;
                } else if (depName === "module") {
                    //CommonJS module spec 1.1
                    cjsModule = args[i] = handlers.module(name);
                } else if (hasProp(defined, depName) ||
                           hasProp(waiting, depName) ||
                           hasProp(defining, depName)) {
                    args[i] = callDep(depName);
                } else if (map.p) {
                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                    args[i] = defined[depName];
                } else {
                    throw new Error(name + ' missing ' + depName);
                }
            }

            ret = callback ? callback.apply(defined[name], args) : undefined;

            if (name) {
                //If setting exports via "module" is in play,
                //favor that over return value and exports. After that,
                //favor a non-undefined return value over exports use.
                if (cjsModule && cjsModule.exports !== undef &&
                        cjsModule.exports !== defined[name]) {
                    defined[name] = cjsModule.exports;
                } else if (ret !== undef || !usingExports) {
                    //Use the return value from the function.
                    defined[name] = ret;
                }
            }
        } else if (name) {
            //May just be an object definition for the module. Only
            //worry about defining if have a module name.
            defined[name] = callback;
        }
    };

    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
        if (typeof deps === "string") {
            if (handlers[deps]) {
                //callback in this case is really relName
                return handlers[deps](callback);
            }
            //Just return the module wanted. In this scenario, the
            //deps arg is the module name, and second arg (if passed)
            //is just the relName.
            //Normalize module name, if it contains . or ..
            return callDep(makeMap(deps, makeRelParts(callback)).f);
        } else if (!deps.splice) {
            //deps is a config object, not an array.
            config = deps;
            if (config.deps) {
                req(config.deps, config.callback);
            }
            if (!callback) {
                return;
            }

            if (callback.splice) {
                //callback is an array, which means it is a dependency list.
                //Adjust args if there are dependencies
                deps = callback;
                callback = relName;
                relName = null;
            } else {
                deps = undef;
            }
        }

        //Support require(['a'])
        callback = callback || function () {};

        //If relName is a function, it is an errback handler,
        //so remove it.
        if (typeof relName === 'function') {
            relName = forceSync;
            forceSync = alt;
        }

        //Simulate async callback;
        if (forceSync) {
            main(undef, deps, callback, relName);
        } else {
            //Using a non-zero value because of concern for what old browsers
            //do, and latest browsers "upgrade" to 4 if lower value is used:
            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
            //If want a value immediately, use require('id') instead -- something
            //that works in almond on the global level, but not guaranteed and
            //unlikely to work in other AMD implementations.
            setTimeout(function () {
                main(undef, deps, callback, relName);
            }, 4);
        }

        return req;
    };

    /**
     * Just drops the config on the floor, but returns req in case
     * the config return value is used.
     */
    req.config = function (cfg) {
        return req(cfg);
    };

    /**
     * Expose module registry for debugging and tooling
     */
    requirejs._defined = defined;

    define = function (name, deps, callback) {
        if (typeof name !== 'string') {
            throw new Error('See almond README: incorrect module build, no module name');
        }

        //This module may not have dependencies
        if (!deps.splice) {
            //deps is not an array, so probably means
            //an object literal or factory function for
            //the value. Adjust args.
            callback = deps;
            deps = [];
        }

        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
            waiting[name] = [name, deps, callback];
        }
    };

    define.amd = {
        jQuery: true
    };
}());

define("amd", function(){});

/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
 * @version   3.2.2+35df15ea
 */

(function() {
    "use strict";
    function lib$es6$promise$utils$$objectOrFunction(x) {
      return typeof x === 'function' || (typeof x === 'object' && x !== null);
    }

    function lib$es6$promise$utils$$isFunction(x) {
      return typeof x === 'function';
    }

    function lib$es6$promise$utils$$isMaybeThenable(x) {
      return typeof x === 'object' && x !== null;
    }

    var lib$es6$promise$utils$$_isArray;
    if (!Array.isArray) {
      lib$es6$promise$utils$$_isArray = function (x) {
        return Object.prototype.toString.call(x) === '[object Array]';
      };
    } else {
      lib$es6$promise$utils$$_isArray = Array.isArray;
    }

    var lib$es6$promise$utils$$isArray = lib$es6$promise$utils$$_isArray;
    var lib$es6$promise$asap$$len = 0;
    var lib$es6$promise$asap$$vertxNext;
    var lib$es6$promise$asap$$customSchedulerFn;

    var lib$es6$promise$asap$$asap = function asap(callback, arg) {
      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len] = callback;
      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len + 1] = arg;
      lib$es6$promise$asap$$len += 2;
      if (lib$es6$promise$asap$$len === 2) {
        // If len is 2, that means that we need to schedule an async flush.
        // If additional callbacks are queued before the queue is flushed, they
        // will be processed by this flush that we are scheduling.
        if (lib$es6$promise$asap$$customSchedulerFn) {
          lib$es6$promise$asap$$customSchedulerFn(lib$es6$promise$asap$$flush);
        } else {
          lib$es6$promise$asap$$scheduleFlush();
        }
      }
    }

    function lib$es6$promise$asap$$setScheduler(scheduleFn) {
      lib$es6$promise$asap$$customSchedulerFn = scheduleFn;
    }

    function lib$es6$promise$asap$$setAsap(asapFn) {
      lib$es6$promise$asap$$asap = asapFn;
    }

    var lib$es6$promise$asap$$browserWindow = (typeof window !== 'undefined') ? window : undefined;
    var lib$es6$promise$asap$$browserGlobal = lib$es6$promise$asap$$browserWindow || {};
    var lib$es6$promise$asap$$BrowserMutationObserver = lib$es6$promise$asap$$browserGlobal.MutationObserver || lib$es6$promise$asap$$browserGlobal.WebKitMutationObserver;
    var lib$es6$promise$asap$$isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

    // test for web worker but not in IE10
    var lib$es6$promise$asap$$isWorker = typeof Uint8ClampedArray !== 'undefined' &&
      typeof importScripts !== 'undefined' &&
      typeof MessageChannel !== 'undefined';

    // node
    function lib$es6$promise$asap$$useNextTick() {
      // node version 0.10.x displays a deprecation warning when nextTick is used recursively
      // see https://github.com/cujojs/when/issues/410 for details
      return function() {
        process.nextTick(lib$es6$promise$asap$$flush);
      };
    }

    // vertx
    function lib$es6$promise$asap$$useVertxTimer() {
      return function() {
        lib$es6$promise$asap$$vertxNext(lib$es6$promise$asap$$flush);
      };
    }

    function lib$es6$promise$asap$$useMutationObserver() {
      var iterations = 0;
      var observer = new lib$es6$promise$asap$$BrowserMutationObserver(lib$es6$promise$asap$$flush);
      var node = document.createTextNode('');
      observer.observe(node, { characterData: true });

      return function() {
        node.data = (iterations = ++iterations % 2);
      };
    }

    // web worker
    function lib$es6$promise$asap$$useMessageChannel() {
      var channel = new MessageChannel();
      channel.port1.onmessage = lib$es6$promise$asap$$flush;
      return function () {
        channel.port2.postMessage(0);
      };
    }

    function lib$es6$promise$asap$$useSetTimeout() {
      return function() {
        setTimeout(lib$es6$promise$asap$$flush, 1);
      };
    }

    var lib$es6$promise$asap$$queue = new Array(1000);
    function lib$es6$promise$asap$$flush() {
      for (var i = 0; i < lib$es6$promise$asap$$len; i+=2) {
        var callback = lib$es6$promise$asap$$queue[i];
        var arg = lib$es6$promise$asap$$queue[i+1];

        callback(arg);

        lib$es6$promise$asap$$queue[i] = undefined;
        lib$es6$promise$asap$$queue[i+1] = undefined;
      }

      lib$es6$promise$asap$$len = 0;
    }

    function lib$es6$promise$asap$$attemptVertx() {
      try {
        var r = require;
        var vertx = r('vertx');
        lib$es6$promise$asap$$vertxNext = vertx.runOnLoop || vertx.runOnContext;
        return lib$es6$promise$asap$$useVertxTimer();
      } catch(e) {
        return lib$es6$promise$asap$$useSetTimeout();
      }
    }

    var lib$es6$promise$asap$$scheduleFlush;
    // Decide what async method to use to triggering processing of queued callbacks:
    if (lib$es6$promise$asap$$isNode) {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useNextTick();
    } else if (lib$es6$promise$asap$$BrowserMutationObserver) {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMutationObserver();
    } else if (lib$es6$promise$asap$$isWorker) {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMessageChannel();
    } else if (lib$es6$promise$asap$$browserWindow === undefined && typeof require === 'function') {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$attemptVertx();
    } else {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useSetTimeout();
    }
    function lib$es6$promise$then$$then(onFulfillment, onRejection) {
      var parent = this;

      var child = new this.constructor(lib$es6$promise$$internal$$noop);

      if (child[lib$es6$promise$$internal$$PROMISE_ID] === undefined) {
        lib$es6$promise$$internal$$makePromise(child);
      }

      var state = parent._state;

      if (state) {
        var callback = arguments[state - 1];
        lib$es6$promise$asap$$asap(function(){
          lib$es6$promise$$internal$$invokeCallback(state, child, callback, parent._result);
        });
      } else {
        lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection);
      }

      return child;
    }
    var lib$es6$promise$then$$default = lib$es6$promise$then$$then;
    function lib$es6$promise$promise$resolve$$resolve(object) {
      /*jshint validthis:true */
      var Constructor = this;

      if (object && typeof object === 'object' && object.constructor === Constructor) {
        return object;
      }

      var promise = new Constructor(lib$es6$promise$$internal$$noop);
      lib$es6$promise$$internal$$resolve(promise, object);
      return promise;
    }
    var lib$es6$promise$promise$resolve$$default = lib$es6$promise$promise$resolve$$resolve;
    var lib$es6$promise$$internal$$PROMISE_ID = Math.random().toString(36).substring(16);

    function lib$es6$promise$$internal$$noop() {}

    var lib$es6$promise$$internal$$PENDING   = void 0;
    var lib$es6$promise$$internal$$FULFILLED = 1;
    var lib$es6$promise$$internal$$REJECTED  = 2;

    var lib$es6$promise$$internal$$GET_THEN_ERROR = new lib$es6$promise$$internal$$ErrorObject();

    function lib$es6$promise$$internal$$selfFulfillment() {
      return new TypeError("You cannot resolve a promise with itself");
    }

    function lib$es6$promise$$internal$$cannotReturnOwn() {
      return new TypeError('A promises callback cannot return that same promise.');
    }

    function lib$es6$promise$$internal$$getThen(promise) {
      try {
        return promise.then;
      } catch(error) {
        lib$es6$promise$$internal$$GET_THEN_ERROR.error = error;
        return lib$es6$promise$$internal$$GET_THEN_ERROR;
      }
    }

    function lib$es6$promise$$internal$$tryThen(then, value, fulfillmentHandler, rejectionHandler) {
      try {
        then.call(value, fulfillmentHandler, rejectionHandler);
      } catch(e) {
        return e;
      }
    }

    function lib$es6$promise$$internal$$handleForeignThenable(promise, thenable, then) {
       lib$es6$promise$asap$$asap(function(promise) {
        var sealed = false;
        var error = lib$es6$promise$$internal$$tryThen(then, thenable, function(value) {
          if (sealed) { return; }
          sealed = true;
          if (thenable !== value) {
            lib$es6$promise$$internal$$resolve(promise, value);
          } else {
            lib$es6$promise$$internal$$fulfill(promise, value);
          }
        }, function(reason) {
          if (sealed) { return; }
          sealed = true;

          lib$es6$promise$$internal$$reject(promise, reason);
        }, 'Settle: ' + (promise._label || ' unknown promise'));

        if (!sealed && error) {
          sealed = true;
          lib$es6$promise$$internal$$reject(promise, error);
        }
      }, promise);
    }

    function lib$es6$promise$$internal$$handleOwnThenable(promise, thenable) {
      if (thenable._state === lib$es6$promise$$internal$$FULFILLED) {
        lib$es6$promise$$internal$$fulfill(promise, thenable._result);
      } else if (thenable._state === lib$es6$promise$$internal$$REJECTED) {
        lib$es6$promise$$internal$$reject(promise, thenable._result);
      } else {
        lib$es6$promise$$internal$$subscribe(thenable, undefined, function(value) {
          lib$es6$promise$$internal$$resolve(promise, value);
        }, function(reason) {
          lib$es6$promise$$internal$$reject(promise, reason);
        });
      }
    }

    function lib$es6$promise$$internal$$handleMaybeThenable(promise, maybeThenable, then) {
      if (maybeThenable.constructor === promise.constructor &&
          then === lib$es6$promise$then$$default &&
          constructor.resolve === lib$es6$promise$promise$resolve$$default) {
        lib$es6$promise$$internal$$handleOwnThenable(promise, maybeThenable);
      } else {
        if (then === lib$es6$promise$$internal$$GET_THEN_ERROR) {
          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$GET_THEN_ERROR.error);
        } else if (then === undefined) {
          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
        } else if (lib$es6$promise$utils$$isFunction(then)) {
          lib$es6$promise$$internal$$handleForeignThenable(promise, maybeThenable, then);
        } else {
          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
        }
      }
    }

    function lib$es6$promise$$internal$$resolve(promise, value) {
      if (promise === value) {
        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$selfFulfillment());
      } else if (lib$es6$promise$utils$$objectOrFunction(value)) {
        lib$es6$promise$$internal$$handleMaybeThenable(promise, value, lib$es6$promise$$internal$$getThen(value));
      } else {
        lib$es6$promise$$internal$$fulfill(promise, value);
      }
    }

    function lib$es6$promise$$internal$$publishRejection(promise) {
      if (promise._onerror) {
        promise._onerror(promise._result);
      }

      lib$es6$promise$$internal$$publish(promise);
    }

    function lib$es6$promise$$internal$$fulfill(promise, value) {
      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }

      promise._result = value;
      promise._state = lib$es6$promise$$internal$$FULFILLED;

      if (promise._subscribers.length !== 0) {
        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, promise);
      }
    }

    function lib$es6$promise$$internal$$reject(promise, reason) {
      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }
      promise._state = lib$es6$promise$$internal$$REJECTED;
      promise._result = reason;

      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publishRejection, promise);
    }

    function lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection) {
      var subscribers = parent._subscribers;
      var length = subscribers.length;

      parent._onerror = null;

      subscribers[length] = child;
      subscribers[length + lib$es6$promise$$internal$$FULFILLED] = onFulfillment;
      subscribers[length + lib$es6$promise$$internal$$REJECTED]  = onRejection;

      if (length === 0 && parent._state) {
        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, parent);
      }
    }

    function lib$es6$promise$$internal$$publish(promise) {
      var subscribers = promise._subscribers;
      var settled = promise._state;

      if (subscribers.length === 0) { return; }

      var child, callback, detail = promise._result;

      for (var i = 0; i < subscribers.length; i += 3) {
        child = subscribers[i];
        callback = subscribers[i + settled];

        if (child) {
          lib$es6$promise$$internal$$invokeCallback(settled, child, callback, detail);
        } else {
          callback(detail);
        }
      }

      promise._subscribers.length = 0;
    }

    function lib$es6$promise$$internal$$ErrorObject() {
      this.error = null;
    }

    var lib$es6$promise$$internal$$TRY_CATCH_ERROR = new lib$es6$promise$$internal$$ErrorObject();

    function lib$es6$promise$$internal$$tryCatch(callback, detail) {
      try {
        return callback(detail);
      } catch(e) {
        lib$es6$promise$$internal$$TRY_CATCH_ERROR.error = e;
        return lib$es6$promise$$internal$$TRY_CATCH_ERROR;
      }
    }

    function lib$es6$promise$$internal$$invokeCallback(settled, promise, callback, detail) {
      var hasCallback = lib$es6$promise$utils$$isFunction(callback),
          value, error, succeeded, failed;

      if (hasCallback) {
        value = lib$es6$promise$$internal$$tryCatch(callback, detail);

        if (value === lib$es6$promise$$internal$$TRY_CATCH_ERROR) {
          failed = true;
          error = value.error;
          value = null;
        } else {
          succeeded = true;
        }

        if (promise === value) {
          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$cannotReturnOwn());
          return;
        }

      } else {
        value = detail;
        succeeded = true;
      }

      if (promise._state !== lib$es6$promise$$internal$$PENDING) {
        // noop
      } else if (hasCallback && succeeded) {
        lib$es6$promise$$internal$$resolve(promise, value);
      } else if (failed) {
        lib$es6$promise$$internal$$reject(promise, error);
      } else if (settled === lib$es6$promise$$internal$$FULFILLED) {
        lib$es6$promise$$internal$$fulfill(promise, value);
      } else if (settled === lib$es6$promise$$internal$$REJECTED) {
        lib$es6$promise$$internal$$reject(promise, value);
      }
    }

    function lib$es6$promise$$internal$$initializePromise(promise, resolver) {
      try {
        resolver(function resolvePromise(value){
          lib$es6$promise$$internal$$resolve(promise, value);
        }, function rejectPromise(reason) {
          lib$es6$promise$$internal$$reject(promise, reason);
        });
      } catch(e) {
        lib$es6$promise$$internal$$reject(promise, e);
      }
    }

    var lib$es6$promise$$internal$$id = 0;
    function lib$es6$promise$$internal$$nextId() {
      return lib$es6$promise$$internal$$id++;
    }

    function lib$es6$promise$$internal$$makePromise(promise) {
      promise[lib$es6$promise$$internal$$PROMISE_ID] = lib$es6$promise$$internal$$id++;
      promise._state = undefined;
      promise._result = undefined;
      promise._subscribers = [];
    }

    function lib$es6$promise$promise$all$$all(entries) {
      return new lib$es6$promise$enumerator$$default(this, entries).promise;
    }
    var lib$es6$promise$promise$all$$default = lib$es6$promise$promise$all$$all;
    function lib$es6$promise$promise$race$$race(entries) {
      /*jshint validthis:true */
      var Constructor = this;

      if (!lib$es6$promise$utils$$isArray(entries)) {
        return new Constructor(function(resolve, reject) {
          reject(new TypeError('You must pass an array to race.'));
        });
      } else {
        return new Constructor(function(resolve, reject) {
          var length = entries.length;
          for (var i = 0; i < length; i++) {
            Constructor.resolve(entries[i]).then(resolve, reject);
          }
        });
      }
    }
    var lib$es6$promise$promise$race$$default = lib$es6$promise$promise$race$$race;
    function lib$es6$promise$promise$reject$$reject(reason) {
      /*jshint validthis:true */
      var Constructor = this;
      var promise = new Constructor(lib$es6$promise$$internal$$noop);
      lib$es6$promise$$internal$$reject(promise, reason);
      return promise;
    }
    var lib$es6$promise$promise$reject$$default = lib$es6$promise$promise$reject$$reject;


    function lib$es6$promise$promise$$needsResolver() {
      throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
    }

    function lib$es6$promise$promise$$needsNew() {
      throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }

    var lib$es6$promise$promise$$default = lib$es6$promise$promise$$Promise;
    /**
      Promise objects represent the eventual result of an asynchronous operation. The
      primary way of interacting with a promise is through its `then` method, which
      registers callbacks to receive either a promise's eventual value or the reason
      why the promise cannot be fulfilled.

      Terminology
      -----------

      - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
      - `thenable` is an object or function that defines a `then` method.
      - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
      - `exception` is a value that is thrown using the throw statement.
      - `reason` is a value that indicates why a promise was rejected.
      - `settled` the final resting state of a promise, fulfilled or rejected.

      A promise can be in one of three states: pending, fulfilled, or rejected.

      Promises that are fulfilled have a fulfillment value and are in the fulfilled
      state.  Promises that are rejected have a rejection reason and are in the
      rejected state.  A fulfillment value is never a thenable.

      Promises can also be said to *resolve* a value.  If this value is also a
      promise, then the original promise's settled state will match the value's
      settled state.  So a promise that *resolves* a promise that rejects will
      itself reject, and a promise that *resolves* a promise that fulfills will
      itself fulfill.


      Basic Usage:
      ------------

      ```js
      var promise = new Promise(function(resolve, reject) {
        // on success
        resolve(value);

        // on failure
        reject(reason);
      });

      promise.then(function(value) {
        // on fulfillment
      }, function(reason) {
        // on rejection
      });
      ```

      Advanced Usage:
      ---------------

      Promises shine when abstracting away asynchronous interactions such as
      `XMLHttpRequest`s.

      ```js
      function getJSON(url) {
        return new Promise(function(resolve, reject){
          var xhr = new XMLHttpRequest();

          xhr.open('GET', url);
          xhr.onreadystatechange = handler;
          xhr.responseType = 'json';
          xhr.setRequestHeader('Accept', 'application/json');
          xhr.send();

          function handler() {
            if (this.readyState === this.DONE) {
              if (this.status === 200) {
                resolve(this.response);
              } else {
                reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
              }
            }
          };
        });
      }

      getJSON('/posts.json').then(function(json) {
        // on fulfillment
      }, function(reason) {
        // on rejection
      });
      ```

      Unlike callbacks, promises are great composable primitives.

      ```js
      Promise.all([
        getJSON('/posts'),
        getJSON('/comments')
      ]).then(function(values){
        values[0] // => postsJSON
        values[1] // => commentsJSON

        return values;
      });
      ```

      @class Promise
      @param {function} resolver
      Useful for tooling.
      @constructor
    */
    function lib$es6$promise$promise$$Promise(resolver) {
      this[lib$es6$promise$$internal$$PROMISE_ID] = lib$es6$promise$$internal$$nextId();
      this._result = this._state = undefined;
      this._subscribers = [];

      if (lib$es6$promise$$internal$$noop !== resolver) {
        typeof resolver !== 'function' && lib$es6$promise$promise$$needsResolver();
        this instanceof lib$es6$promise$promise$$Promise ? lib$es6$promise$$internal$$initializePromise(this, resolver) : lib$es6$promise$promise$$needsNew();
      }
    }

    lib$es6$promise$promise$$Promise.all = lib$es6$promise$promise$all$$default;
    lib$es6$promise$promise$$Promise.race = lib$es6$promise$promise$race$$default;
    lib$es6$promise$promise$$Promise.resolve = lib$es6$promise$promise$resolve$$default;
    lib$es6$promise$promise$$Promise.reject = lib$es6$promise$promise$reject$$default;
    lib$es6$promise$promise$$Promise._setScheduler = lib$es6$promise$asap$$setScheduler;
    lib$es6$promise$promise$$Promise._setAsap = lib$es6$promise$asap$$setAsap;
    lib$es6$promise$promise$$Promise._asap = lib$es6$promise$asap$$asap;

    lib$es6$promise$promise$$Promise.prototype = {
      constructor: lib$es6$promise$promise$$Promise,

    /**
      The primary way of interacting with a promise is through its `then` method,
      which registers callbacks to receive either a promise's eventual value or the
      reason why the promise cannot be fulfilled.

      ```js
      findUser().then(function(user){
        // user is available
      }, function(reason){
        // user is unavailable, and you are given the reason why
      });
      ```

      Chaining
      --------

      The return value of `then` is itself a promise.  This second, 'downstream'
      promise is resolved with the return value of the first promise's fulfillment
      or rejection handler, or rejected if the handler throws an exception.

      ```js
      findUser().then(function (user) {
        return user.name;
      }, function (reason) {
        return 'default name';
      }).then(function (userName) {
        // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
        // will be `'default name'`
      });

      findUser().then(function (user) {
        throw new Error('Found user, but still unhappy');
      }, function (reason) {
        throw new Error('`findUser` rejected and we're unhappy');
      }).then(function (value) {
        // never reached
      }, function (reason) {
        // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
        // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
      });
      ```
      If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.

      ```js
      findUser().then(function (user) {
        throw new PedagogicalException('Upstream error');
      }).then(function (value) {
        // never reached
      }).then(function (value) {
        // never reached
      }, function (reason) {
        // The `PedgagocialException` is propagated all the way down to here
      });
      ```

      Assimilation
      ------------

      Sometimes the value you want to propagate to a downstream promise can only be
      retrieved asynchronously. This can be achieved by returning a promise in the
      fulfillment or rejection handler. The downstream promise will then be pending
      until the returned promise is settled. This is called *assimilation*.

      ```js
      findUser().then(function (user) {
        return findCommentsByAuthor(user);
      }).then(function (comments) {
        // The user's comments are now available
      });
      ```

      If the assimliated promise rejects, then the downstream promise will also reject.

      ```js
      findUser().then(function (user) {
        return findCommentsByAuthor(user);
      }).then(function (comments) {
        // If `findCommentsByAuthor` fulfills, we'll have the value here
      }, function (reason) {
        // If `findCommentsByAuthor` rejects, we'll have the reason here
      });
      ```

      Simple Example
      --------------

      Synchronous Example

      ```javascript
      var result;

      try {
        result = findResult();
        // success
      } catch(reason) {
        // failure
      }
      ```

      Errback Example

      ```js
      findResult(function(result, err){
        if (err) {
          // failure
        } else {
          // success
        }
      });
      ```

      Promise Example;

      ```javascript
      findResult().then(function(result){
        // success
      }, function(reason){
        // failure
      });
      ```

      Advanced Example
      --------------

      Synchronous Example

      ```javascript
      var author, books;

      try {
        author = findAuthor();
        books  = findBooksByAuthor(author);
        // success
      } catch(reason) {
        // failure
      }
      ```

      Errback Example

      ```js

      function foundBooks(books) {

      }

      function failure(reason) {

      }

      findAuthor(function(author, err){
        if (err) {
          failure(err);
          // failure
        } else {
          try {
            findBoooksByAuthor(author, function(books, err) {
              if (err) {
                failure(err);
              } else {
                try {
                  foundBooks(books);
                } catch(reason) {
                  failure(reason);
                }
              }
            });
          } catch(error) {
            failure(err);
          }
          // success
        }
      });
      ```

      Promise Example;

      ```javascript
      findAuthor().
        then(findBooksByAuthor).
        then(function(books){
          // found books
      }).catch(function(reason){
        // something went wrong
      });
      ```

      @method then
      @param {Function} onFulfilled
      @param {Function} onRejected
      Useful for tooling.
      @return {Promise}
    */
      then: lib$es6$promise$then$$default,

    /**
      `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
      as the catch block of a try/catch statement.

      ```js
      function findAuthor(){
        throw new Error('couldn't find that author');
      }

      // synchronous
      try {
        findAuthor();
      } catch(reason) {
        // something went wrong
      }

      // async with promises
      findAuthor().catch(function(reason){
        // something went wrong
      });
      ```

      @method catch
      @param {Function} onRejection
      Useful for tooling.
      @return {Promise}
    */
      'catch': function(onRejection) {
        return this.then(null, onRejection);
      }
    };
    var lib$es6$promise$enumerator$$default = lib$es6$promise$enumerator$$Enumerator;
    function lib$es6$promise$enumerator$$Enumerator(Constructor, input) {
      this._instanceConstructor = Constructor;
      this.promise = new Constructor(lib$es6$promise$$internal$$noop);

      if (!this.promise[lib$es6$promise$$internal$$PROMISE_ID]) {
        lib$es6$promise$$internal$$makePromise(this.promise);
      }

      if (lib$es6$promise$utils$$isArray(input)) {
        this._input     = input;
        this.length     = input.length;
        this._remaining = input.length;

        this._result = new Array(this.length);

        if (this.length === 0) {
          lib$es6$promise$$internal$$fulfill(this.promise, this._result);
        } else {
          this.length = this.length || 0;
          this._enumerate();
          if (this._remaining === 0) {
            lib$es6$promise$$internal$$fulfill(this.promise, this._result);
          }
        }
      } else {
        lib$es6$promise$$internal$$reject(this.promise, lib$es6$promise$enumerator$$validationError());
      }
    }

    function lib$es6$promise$enumerator$$validationError() {
      return new Error('Array Methods must be provided an Array');
    }

    lib$es6$promise$enumerator$$Enumerator.prototype._enumerate = function() {
      var length  = this.length;
      var input   = this._input;

      for (var i = 0; this._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
        this._eachEntry(input[i], i);
      }
    };

    lib$es6$promise$enumerator$$Enumerator.prototype._eachEntry = function(entry, i) {
      var c = this._instanceConstructor;
      var resolve = c.resolve;

      if (resolve === lib$es6$promise$promise$resolve$$default) {
        var then = lib$es6$promise$$internal$$getThen(entry);

        if (then === lib$es6$promise$then$$default &&
            entry._state !== lib$es6$promise$$internal$$PENDING) {
          this._settledAt(entry._state, i, entry._result);
        } else if (typeof then !== 'function') {
          this._remaining--;
          this._result[i] = entry;
        } else if (c === lib$es6$promise$promise$$default) {
          var promise = new c(lib$es6$promise$$internal$$noop);
          lib$es6$promise$$internal$$handleMaybeThenable(promise, entry, then);
          this._willSettleAt(promise, i);
        } else {
          this._willSettleAt(new c(function(resolve) { resolve(entry); }), i);
        }
      } else {
        this._willSettleAt(resolve(entry), i);
      }
    };

    lib$es6$promise$enumerator$$Enumerator.prototype._settledAt = function(state, i, value) {
      var promise = this.promise;

      if (promise._state === lib$es6$promise$$internal$$PENDING) {
        this._remaining--;

        if (state === lib$es6$promise$$internal$$REJECTED) {
          lib$es6$promise$$internal$$reject(promise, value);
        } else {
          this._result[i] = value;
        }
      }

      if (this._remaining === 0) {
        lib$es6$promise$$internal$$fulfill(promise, this._result);
      }
    };

    lib$es6$promise$enumerator$$Enumerator.prototype._willSettleAt = function(promise, i) {
      var enumerator = this;

      lib$es6$promise$$internal$$subscribe(promise, undefined, function(value) {
        enumerator._settledAt(lib$es6$promise$$internal$$FULFILLED, i, value);
      }, function(reason) {
        enumerator._settledAt(lib$es6$promise$$internal$$REJECTED, i, reason);
      });
    };
    function lib$es6$promise$polyfill$$polyfill() {
      var local;

      if (typeof global !== 'undefined') {
          local = global;
      } else if (typeof self !== 'undefined') {
          local = self;
      } else {
          try {
              local = Function('return this')();
          } catch (e) {
              throw new Error('polyfill failed because global object is unavailable in this environment');
          }
      }

      var P = local.Promise;

      if (P && Object.prototype.toString.call(P.resolve()) === '[object Promise]' && !P.cast) {
        return;
      }

      local.Promise = lib$es6$promise$promise$$default;
    }
    var lib$es6$promise$polyfill$$default = lib$es6$promise$polyfill$$polyfill;

    var lib$es6$promise$umd$$ES6Promise = {
      'Promise': lib$es6$promise$promise$$default,
      'polyfill': lib$es6$promise$polyfill$$default
    };

    /* global define:true module:true window: true */
    if (typeof define === 'function' && define['amd']) {
      define('es6-promise',[],function() { return lib$es6$promise$umd$$ES6Promise; });
    } else if (typeof module !== 'undefined' && module['exports']) {
      module['exports'] = lib$es6$promise$umd$$ES6Promise;
    } else if (typeof this !== 'undefined') {
      this['ES6Promise'] = lib$es6$promise$umd$$ES6Promise;
    }

    lib$es6$promise$polyfill$$default();
}).call(this);


/**
 * @license
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash core -o ./dist/lodash.core.js`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.15.0';

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to compose bitmasks for function metadata. */
  var BIND_FLAG = 1,
      PARTIAL_FLAG = 32;

  /** Used to compose bitmasks for comparison styles. */
  var UNORDERED_COMPARE_FLAG = 1,
      PARTIAL_COMPARE_FLAG = 2;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991;

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      stringTag = '[object String]';

  /** Used to match HTML entities and HTML characters. */
  var reUnescapedHtml = /[&<>"'`]/g,
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /*--------------------------------------------------------------------------*/

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    array.push.apply(array, values);
    return array;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return baseMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */
  function isHostObject() {
    return false;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /*--------------------------------------------------------------------------*/

  /** Used for built-in method references. */
  var arrayProto = Array.prototype,
      objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to generate unique IDs. */
  var idCounter = 0;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var objectToString = objectProto.toString;

  /** Used to restore the original `_` reference in `_.noConflict`. */
  var oldDash = root._;

  /** Built-in value references. */
  var objectCreate = Object.create,
      propertyIsEnumerable = objectProto.propertyIsEnumerable;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeIsFinite = root.isFinite,
      nativeKeys = overArg(Object.keys, Object),
      nativeMax = Math.max;

  /*------------------------------------------------------------------------*/

  /**
   * Creates a `lodash` object which wraps `value` to enable implicit method
   * chain sequences. Methods that operate on and return arrays, collections,
   * and functions can be chained together. Methods that retrieve a single value
   * or may return a primitive value will automatically end the chain sequence
   * and return the unwrapped value. Otherwise, the value must be unwrapped
   * with `_#value`.
   *
   * Explicit chain sequences, which must be unwrapped with `_#value`, may be
   * enabled using `_.chain`.
   *
   * The execution of chained methods is lazy, that is, it's deferred until
   * `_#value` is implicitly or explicitly called.
   *
   * Lazy evaluation allows several methods to support shortcut fusion.
   * Shortcut fusion is an optimization to merge iteratee calls; this avoids
   * the creation of intermediate arrays and can greatly reduce the number of
   * iteratee executions. Sections of a chain sequence qualify for shortcut
   * fusion if the section is applied to an array of at least `200` elements
   * and any iteratees accept only one argument. The heuristic for whether a
   * section qualifies for shortcut fusion is subject to change.
   *
   * Chaining is supported in custom builds as long as the `_#value` method is
   * directly or indirectly included in the build.
   *
   * In addition to lodash methods, wrappers have `Array` and `String` methods.
   *
   * The wrapper `Array` methods are:
   * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
   *
   * The wrapper `String` methods are:
   * `replace` and `split`
   *
   * The wrapper methods that support shortcut fusion are:
   * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
   * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
   * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
   *
   * The chainable wrapper methods are:
   * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
   * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
   * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
   * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
   * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
   * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
   * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
   * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
   * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
   * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
   * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
   * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
   * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
   * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
   * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
   * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
   * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
   * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
   * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
   * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
   * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
   * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
   * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
   * `zipObject`, `zipObjectDeep`, and `zipWith`
   *
   * The wrapper methods that are **not** chainable by default are:
   * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
   * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
   * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
   * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
   * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
   * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
   * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
   * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
   * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
   * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
   * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
   * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
   * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
   * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
   * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
   * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
   * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
   * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
   * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
   * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
   * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
   * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
   * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
   * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
   * `upperFirst`, `value`, and `words`
   *
   * @name _
   * @constructor
   * @category Seq
   * @param {*} value The value to wrap in a `lodash` instance.
   * @returns {Object} Returns the new `lodash` wrapper instance.
   * @example
   *
   * function square(n) {
   *   return n * n;
   * }
   *
   * var wrapped = _([1, 2, 3]);
   *
   * // Returns an unwrapped value.
   * wrapped.reduce(_.add);
   * // => 6
   *
   * // Returns a wrapped value.
   * var squares = wrapped.map(square);
   *
   * _.isArray(squares);
   * // => false
   *
   * _.isArray(squares.value());
   * // => true
   */
  function lodash(value) {
    return value instanceof LodashWrapper
      ? value
      : new LodashWrapper(value);
  }

  /**
   * The base constructor for creating `lodash` wrapper objects.
   *
   * @private
   * @param {*} value The value to wrap.
   * @param {boolean} [chainAll] Enable explicit method chain sequences.
   */
  function LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
  }

  LodashWrapper.prototype = baseCreate(lodash.prototype);
  LodashWrapper.prototype.constructor = LodashWrapper;

  /*------------------------------------------------------------------------*/

  /**
   * Used by `_.defaults` to customize its `_.assignIn` use.
   *
   * @private
   * @param {*} objValue The destination value.
   * @param {*} srcValue The source value.
   * @param {string} key The key of the property to assign.
   * @param {Object} object The parent object of `objValue`.
   * @returns {*} Returns the value to assign.
   */
  function assignInDefaults(objValue, srcValue, key, object) {
    if (objValue === undefined ||
        (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
      return srcValue;
    }
    return objValue;
  }

  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
        (value === undefined && !(key in object))) {
      object[key] = value;
    }
  }

  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} prototype The object to inherit from.
   * @returns {Object} Returns the new object.
   */
  function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
  }

  /**
   * The base implementation of `_.delay` and `_.defer` which accepts `args`
   * to provide to `func`.
   *
   * @private
   * @param {Function} func The function to delay.
   * @param {number} wait The number of milliseconds to delay invocation.
   * @param {Array} args The arguments to provide to `func`.
   * @returns {number|Object} Returns the timer id or timeout object.
   */
  function baseDelay(func, wait, args) {
    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    return setTimeout(function() { func.apply(undefined, args); }, wait);
  }

  /**
   * The base implementation of `_.forEach` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array|Object} Returns `collection`.
   */
  var baseEach = createBaseEach(baseForOwn);

  /**
   * The base implementation of `_.every` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`
   */
  function baseEvery(collection, predicate) {
    var result = true;
    baseEach(collection, function(value, index, collection) {
      result = !!predicate(value, index, collection);
      return result;
    });
    return result;
  }

  /**
   * The base implementation of methods like `_.max` and `_.min` which accepts a
   * `comparator` to determine the extremum value.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The iteratee invoked per iteration.
   * @param {Function} comparator The comparator used to compare values.
   * @returns {*} Returns the extremum value.
   */
  function baseExtremum(array, iteratee, comparator) {
    var index = -1,
        length = array.length;

    while (++index < length) {
      var value = array[index],
          current = iteratee(value);

      if (current != null && (computed === undefined
            ? (current === current && !false)
            : comparator(current, computed)
          )) {
        var computed = current,
            result = value;
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.filter` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function baseFilter(collection, predicate) {
    var result = [];
    baseEach(collection, function(value, index, collection) {
      if (predicate(value, index, collection)) {
        result.push(value);
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.flatten` with support for restricting flattening.
   *
   * @private
   * @param {Array} array The array to flatten.
   * @param {number} depth The maximum recursion depth.
   * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
   * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
   * @param {Array} [result=[]] The initial result value.
   * @returns {Array} Returns the new flattened array.
   */
  function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1,
        length = array.length;

    predicate || (predicate = isFlattenable);
    result || (result = []);

    while (++index < length) {
      var value = array[index];
      if (depth > 0 && predicate(value)) {
        if (depth > 1) {
          // Recursively flatten arrays (susceptible to call stack limits).
          baseFlatten(value, depth - 1, predicate, isStrict, result);
        } else {
          arrayPush(result, value);
        }
      } else if (!isStrict) {
        result[result.length] = value;
      }
    }
    return result;
  }

  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */
  var baseFor = createBaseFor();

  /**
   * The base implementation of `_.forOwn` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Object} Returns `object`.
   */
  function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
  }

  /**
   * The base implementation of `_.functions` which creates an array of
   * `object` function property names filtered from `props`.
   *
   * @private
   * @param {Object} object The object to inspect.
   * @param {Array} props The property names to filter.
   * @returns {Array} Returns the function names.
   */
  function baseFunctions(object, props) {
    return baseFilter(props, function(key) {
      return isFunction(object[key]);
    });
  }

  /**
   * The base implementation of `_.gt` which doesn't coerce arguments.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if `value` is greater than `other`,
   *  else `false`.
   */
  function baseGt(value, other) {
    return value > other;
  }

  /**
   * The base implementation of `_.isDate` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
   */
  function baseIsDate(value) {
    return isObjectLike(value) && objectToString.call(value) == dateTag;
  }

  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {boolean} [bitmask] The bitmask of comparison flags.
   *  The bitmask may be composed of the following flags:
   *     1 - Unordered comparison
   *     2 - Partial comparison
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */
  function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
  }

  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
   *  for more details.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = arrayTag,
        othTag = arrayTag;

    if (!objIsArr) {
      objTag = objectToString.call(object);
      objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
      othTag = objectToString.call(other);
      othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object),
        othIsObj = othTag == objectTag && !isHostObject(other),
        isSameTag = objTag == othTag;

    stack || (stack = []);
    var objStack = find(stack, function(entry) {
      return entry[0] == object;
    });
    var othStack = find(stack, function(entry) {
      return entry[0] == other;
    });
    if (objStack && othStack) {
      return objStack[1] == other;
    }
    stack.push([object, other]);
    stack.push([other, object]);
    if (isSameTag && !objIsObj) {
      var result = (objIsArr)
        ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
        : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
      stack.pop();
      return result;
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;

        var result = equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        stack.pop();
        return result;
      }
    }
    if (!isSameTag) {
      return false;
    }
    var result = equalObjects(object, other, equalFunc, customizer, bitmask, stack);
    stack.pop();
    return result;
  }

  /**
   * The base implementation of `_.isRegExp` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
   */
  function baseIsRegExp(value) {
    return isObject(value) && objectToString.call(value) == regexpTag;
  }

  /**
   * The base implementation of `_.iteratee`.
   *
   * @private
   * @param {*} [value=_.identity] The value to convert to an iteratee.
   * @returns {Function} Returns the iteratee.
   */
  function baseIteratee(func) {
    if (typeof func == 'function') {
      return func;
    }
    if (func == null) {
      return identity;
    }
    return (typeof func == 'object' ? baseMatches : baseProperty)(func);
  }

  /**
   * The base implementation of `_.lt` which doesn't coerce arguments.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if `value` is less than `other`,
   *  else `false`.
   */
  function baseLt(value, other) {
    return value < other;
  }

  /**
   * The base implementation of `_.map` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function baseMap(collection, iteratee) {
    var index = -1,
        result = isArrayLike(collection) ? Array(collection.length) : [];

    baseEach(collection, function(value, key, collection) {
      result[++index] = iteratee(value, key, collection);
    });
    return result;
  }

  /**
   * The base implementation of `_.matches` which doesn't clone `source`.
   *
   * @private
   * @param {Object} source The object of property values to match.
   * @returns {Function} Returns the new spec function.
   */
  function baseMatches(source) {
    var props = nativeKeys(source);
    return function(object) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length];
        if (!(key in object &&
              baseIsEqual(source[key], object[key], undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG)
            )) {
          return false;
        }
      }
      return true;
    };
  }

  /**
   * The base implementation of `_.pick` without support for individual
   * property identifiers.
   *
   * @private
   * @param {Object} object The source object.
   * @param {string[]} props The property identifiers to pick.
   * @returns {Object} Returns the new object.
   */
  function basePick(object, props) {
    object = Object(object);
    return reduce(props, function(result, key) {
      if (key in object) {
        result[key] = object[key];
      }
      return result;
    }, {});
  }

  /**
   * The base implementation of `_.rest` which doesn't validate or coerce arguments.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   */
  function baseRest(func, start) {
    start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
    return function() {
      var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);

      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = array;
      return func.apply(this, otherArgs);
    };
  }

  /**
   * The base implementation of `_.slice` without an iteratee call guard.
   *
   * @private
   * @param {Array} array The array to slice.
   * @param {number} [start=0] The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the slice of `array`.
   */
  function baseSlice(array, start, end) {
    var index = -1,
        length = array.length;

    if (start < 0) {
      start = -start > length ? 0 : (length + start);
    }
    end = end > length ? length : end;
    if (end < 0) {
      end += length;
    }
    length = start > end ? 0 : ((end - start) >>> 0);
    start >>>= 0;

    var result = Array(length);
    while (++index < length) {
      result[index] = array[index + start];
    }
    return result;
  }

  /**
   * Copies the values of `source` to `array`.
   *
   * @private
   * @param {Array} source The array to copy values from.
   * @param {Array} [array=[]] The array to copy values to.
   * @returns {Array} Returns `array`.
   */
  function copyArray(source) {
    return baseSlice(source, 0, source.length);
  }

  /**
   * The base implementation of `_.some` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function baseSome(collection, predicate) {
    var result;

    baseEach(collection, function(value, index, collection) {
      result = predicate(value, index, collection);
      return !result;
    });
    return !!result;
  }

  /**
   * The base implementation of `wrapperValue` which returns the result of
   * performing a sequence of actions on the unwrapped `value`, where each
   * successive action is supplied the return value of the previous.
   *
   * @private
   * @param {*} value The unwrapped value.
   * @param {Array} actions Actions to perform to resolve the unwrapped value.
   * @returns {*} Returns the resolved value.
   */
  function baseWrapperValue(value, actions) {
    var result = value;
    return reduce(actions, function(result, action) {
      return action.func.apply(action.thisArg, arrayPush([result], action.args));
    }, result);
  }

  /**
   * Compares values to sort them in ascending order.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function compareAscending(value, other) {
    if (value !== other) {
      var valIsDefined = value !== undefined,
          valIsNull = value === null,
          valIsReflexive = value === value,
          valIsSymbol = false;

      var othIsDefined = other !== undefined,
          othIsNull = other === null,
          othIsReflexive = other === other,
          othIsSymbol = false;

      if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
          (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
          (valIsNull && othIsDefined && othIsReflexive) ||
          (!valIsDefined && othIsReflexive) ||
          !valIsReflexive) {
        return 1;
      }
      if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
          (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
          (othIsNull && valIsDefined && valIsReflexive) ||
          (!othIsDefined && valIsReflexive) ||
          !othIsReflexive) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property identifiers to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */
  function copyObject(source, props, object, customizer) {
    object || (object = {});

    var index = -1,
        length = props.length;

    while (++index < length) {
      var key = props[index];

      var newValue = customizer
        ? customizer(object[key], source[key], key, object, source)
        : undefined;

      assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
  }

  /**
   * Creates a function like `_.assign`.
   *
   * @private
   * @param {Function} assigner The function to assign values.
   * @returns {Function} Returns the new assigner function.
   */
  function createAssigner(assigner) {
    return baseRest(function(object, sources) {
      var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : undefined;

      customizer = (assigner.length > 3 && typeof customizer == 'function')
        ? (length--, customizer)
        : undefined;

      object = Object(object);
      while (++index < length) {
        var source = sources[index];
        if (source) {
          assigner(object, source, index, customizer);
        }
      }
      return object;
    });
  }

  /**
   * Creates a `baseEach` or `baseEachRight` function.
   *
   * @private
   * @param {Function} eachFunc The function to iterate over a collection.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
      if (collection == null) {
        return collection;
      }
      if (!isArrayLike(collection)) {
        return eachFunc(collection, iteratee);
      }
      var length = collection.length,
          index = fromRight ? length : -1,
          iterable = Object(collection);

      while ((fromRight ? index-- : ++index < length)) {
        if (iteratee(iterable[index], index, iterable) === false) {
          break;
        }
      }
      return collection;
    };
  }

  /**
   * Creates a base function for methods like `_.forIn` and `_.forOwn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
      var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }

  /**
   * Creates a function that produces an instance of `Ctor` regardless of
   * whether it was invoked as part of a `new` expression or by `call` or `apply`.
   *
   * @private
   * @param {Function} Ctor The constructor to wrap.
   * @returns {Function} Returns the new wrapped function.
   */
  function createCtor(Ctor) {
    return function() {
      // Use a `switch` statement to work with class constructors. See
      // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
      // for more details.
      var args = arguments;
      var thisBinding = baseCreate(Ctor.prototype),
          result = Ctor.apply(thisBinding, args);

      // Mimic the constructor's `return` behavior.
      // See https://es5.github.io/#x13.2.2 for more details.
      return isObject(result) ? result : thisBinding;
    };
  }

  /**
   * Creates a `_.find` or `_.findLast` function.
   *
   * @private
   * @param {Function} findIndexFunc The function to find the collection index.
   * @returns {Function} Returns the new find function.
   */
  function createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
      var iterable = Object(collection);
      if (!isArrayLike(collection)) {
        var iteratee = baseIteratee(predicate, 3);
        collection = keys(collection);
        predicate = function(key) { return iteratee(iterable[key], key, iterable); };
      }
      var index = findIndexFunc(collection, predicate, fromIndex);
      return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
  }

  /**
   * Creates a function that wraps `func` to invoke it with the `this` binding
   * of `thisArg` and `partials` prepended to the arguments it receives.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} partials The arguments to prepend to those provided to
   *  the new function.
   * @returns {Function} Returns the new wrapped function.
   */
  function createPartial(func, bitmask, thisArg, partials) {
    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var isBind = bitmask & BIND_FLAG,
        Ctor = createCtor(func);

    function wrapper() {
      var argsIndex = -1,
          argsLength = arguments.length,
          leftIndex = -1,
          leftLength = partials.length,
          args = Array(leftLength + argsLength),
          fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

      while (++leftIndex < leftLength) {
        args[leftIndex] = partials[leftIndex];
      }
      while (argsLength--) {
        args[leftIndex++] = arguments[++argsIndex];
      }
      return fn.apply(isBind ? thisArg : this, args);
    }
    return wrapper;
  }

  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Function} customizer The function to customize comparisons.
   * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
   *  for more details.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */
  function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
        arrLength = array.length,
        othLength = other.length;

    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var index = -1,
        result = true,
        seen = (bitmask & UNORDERED_COMPARE_FLAG) ? [] : undefined;

    // Ignore non-index properties.
    while (++index < arrLength) {
      var arrValue = array[index],
          othValue = other[index];

      var compared;
      if (compared !== undefined) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      // Recursively compare arrays (susceptible to call stack limits).
      if (seen) {
        if (!baseSome(other, function(othValue, othIndex) {
              if (!indexOf(seen, othIndex) &&
                  (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
                return seen.push(othIndex);
              }
            })) {
          result = false;
          break;
        }
      } else if (!(
            arrValue === othValue ||
              equalFunc(arrValue, othValue, customizer, bitmask, stack)
          )) {
        result = false;
        break;
      }
    }
    return result;
  }

  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Function} customizer The function to customize comparisons.
   * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
   *  for more details.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch (tag) {

      case boolTag:
      case dateTag:
      case numberTag:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq(+object, +other);

      case errorTag:
        return object.name == other.name && object.message == other.message;

      case regexpTag:
      case stringTag:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == (other + '');

    }
    return false;
  }

  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Function} customizer The function to customize comparisons.
   * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
   *  for more details.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
        objProps = keys(object),
        objLength = objProps.length,
        othProps = keys(other),
        othLength = othProps.length;

    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
        return false;
      }
    }
    var result = true;

    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
          othValue = other[key];

      var compared;
      // Recursively compare objects (susceptible to call stack limits).
      if (!(compared === undefined
            ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
            : compared
          )) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor,
          othCtor = other.constructor;

      // Non `Object` object instances with different constructors are not equal.
      if (objCtor != othCtor &&
          ('constructor' in object && 'constructor' in other) &&
          !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
            typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    return result;
  }

  /**
   * Checks if `value` is a flattenable `arguments` object or array.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
   */
  function isFlattenable(value) {
    return isArray(value) || isArguments(value);
  }

  /**
   * This function is like
   * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * except that it includes inherited enumerable properties.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function nativeKeysIn(object) {
    var result = [];
    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */
  var toKey = String;

  /*------------------------------------------------------------------------*/

  /**
   * Creates an array with all falsey values removed. The values `false`, `null`,
   * `0`, `""`, `undefined`, and `NaN` are falsey.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to compact.
   * @returns {Array} Returns the new array of filtered values.
   * @example
   *
   * _.compact([0, 1, false, 2, '', 3]);
   * // => [1, 2, 3]
   */
  function compact(array) {
    return baseFilter(array, Boolean);
  }

  /**
   * Creates a new array concatenating `array` with any additional arrays
   * and/or values.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Array
   * @param {Array} array The array to concatenate.
   * @param {...*} [values] The values to concatenate.
   * @returns {Array} Returns the new concatenated array.
   * @example
   *
   * var array = [1];
   * var other = _.concat(array, 2, [3], [[4]]);
   *
   * console.log(other);
   * // => [1, 2, 3, [4]]
   *
   * console.log(array);
   * // => [1]
   */
  function concat() {
    var length = arguments.length,
        args = Array(length ? length - 1 : 0),
        array = arguments[0],
        index = length;

    while (index--) {
      args[index - 1] = arguments[index];
    }
    return length
      ? arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1))
      : [];
  }

  /**
   * This method is like `_.find` except that it returns the index of the first
   * element `predicate` returns truthy for instead of the element itself.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Array
   * @param {Array} array The array to inspect.
   * @param {Function} [predicate=_.identity]
   *  The function invoked per iteration.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {number} Returns the index of the found element, else `-1`.
   * @example
   *
   * var users = [
   *   { 'user': 'barney',  'active': false },
   *   { 'user': 'fred',    'active': false },
   *   { 'user': 'pebbles', 'active': true }
   * ];
   *
   * _.findIndex(users, function(o) { return o.user == 'barney'; });
   * // => 0
   *
   * // The `_.matches` iteratee shorthand.
   * _.findIndex(users, { 'user': 'fred', 'active': false });
   * // => 1
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.findIndex(users, ['active', false]);
   * // => 0
   *
   * // The `_.property` iteratee shorthand.
   * _.findIndex(users, 'active');
   * // => 2
   */
  function findIndex(array, predicate, fromIndex) {
    var length = array ? array.length : 0;
    if (!length) {
      return -1;
    }
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) {
      index = nativeMax(length + index, 0);
    }
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
  }

  /**
   * Flattens `array` a single level deep.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to flatten.
   * @returns {Array} Returns the new flattened array.
   * @example
   *
   * _.flatten([1, [2, [3, [4]], 5]]);
   * // => [1, 2, [3, [4]], 5]
   */
  function flatten(array) {
    var length = array ? array.length : 0;
    return length ? baseFlatten(array, 1) : [];
  }

  /**
   * Recursively flattens `array`.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Array
   * @param {Array} array The array to flatten.
   * @returns {Array} Returns the new flattened array.
   * @example
   *
   * _.flattenDeep([1, [2, [3, [4]], 5]]);
   * // => [1, 2, 3, 4, 5]
   */
  function flattenDeep(array) {
    var length = array ? array.length : 0;
    return length ? baseFlatten(array, INFINITY) : [];
  }

  /**
   * Gets the first element of `array`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @alias first
   * @category Array
   * @param {Array} array The array to query.
   * @returns {*} Returns the first element of `array`.
   * @example
   *
   * _.head([1, 2, 3]);
   * // => 1
   *
   * _.head([]);
   * // => undefined
   */
  function head(array) {
    return (array && array.length) ? array[0] : undefined;
  }

  /**
   * Gets the index at which the first occurrence of `value` is found in `array`
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons. If `fromIndex` is negative, it's used as the
   * offset from the end of `array`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   * @example
   *
   * _.indexOf([1, 2, 1, 2], 2);
   * // => 1
   *
   * // Search from the `fromIndex`.
   * _.indexOf([1, 2, 1, 2], 2, 2);
   * // => 3
   */
  function indexOf(array, value, fromIndex) {
    var length = array ? array.length : 0;
    if (typeof fromIndex == 'number') {
      fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
    } else {
      fromIndex = 0;
    }
    var index = (fromIndex || 0) - 1,
        isReflexive = value === value;

    while (++index < length) {
      var other = array[index];
      if ((isReflexive ? other === value : other !== other)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Gets the last element of `array`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to query.
   * @returns {*} Returns the last element of `array`.
   * @example
   *
   * _.last([1, 2, 3]);
   * // => 3
   */
  function last(array) {
    var length = array ? array.length : 0;
    return length ? array[length - 1] : undefined;
  }

  /**
   * Creates a slice of `array` from `start` up to, but not including, `end`.
   *
   * **Note:** This method is used instead of
   * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
   * returned.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Array
   * @param {Array} array The array to slice.
   * @param {number} [start=0] The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the slice of `array`.
   */
  function slice(array, start, end) {
    var length = array ? array.length : 0;
    start = start == null ? 0 : +start;
    end = end === undefined ? length : +end;
    return length ? baseSlice(array, start, end) : [];
  }

  /*------------------------------------------------------------------------*/

  /**
   * Creates a `lodash` wrapper instance that wraps `value` with explicit method
   * chain sequences enabled. The result of such sequences must be unwrapped
   * with `_#value`.
   *
   * @static
   * @memberOf _
   * @since 1.3.0
   * @category Seq
   * @param {*} value The value to wrap.
   * @returns {Object} Returns the new `lodash` wrapper instance.
   * @example
   *
   * var users = [
   *   { 'user': 'barney',  'age': 36 },
   *   { 'user': 'fred',    'age': 40 },
   *   { 'user': 'pebbles', 'age': 1 }
   * ];
   *
   * var youngest = _
   *   .chain(users)
   *   .sortBy('age')
   *   .map(function(o) {
   *     return o.user + ' is ' + o.age;
   *   })
   *   .head()
   *   .value();
   * // => 'pebbles is 1'
   */
  function chain(value) {
    var result = lodash(value);
    result.__chain__ = true;
    return result;
  }

  /**
   * This method invokes `interceptor` and returns `value`. The interceptor
   * is invoked with one argument; (value). The purpose of this method is to
   * "tap into" a method chain sequence in order to modify intermediate results.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Seq
   * @param {*} value The value to provide to `interceptor`.
   * @param {Function} interceptor The function to invoke.
   * @returns {*} Returns `value`.
   * @example
   *
   * _([1, 2, 3])
   *  .tap(function(array) {
   *    // Mutate input array.
   *    array.pop();
   *  })
   *  .reverse()
   *  .value();
   * // => [2, 1]
   */
  function tap(value, interceptor) {
    interceptor(value);
    return value;
  }

  /**
   * This method is like `_.tap` except that it returns the result of `interceptor`.
   * The purpose of this method is to "pass thru" values replacing intermediate
   * results in a method chain sequence.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Seq
   * @param {*} value The value to provide to `interceptor`.
   * @param {Function} interceptor The function to invoke.
   * @returns {*} Returns the result of `interceptor`.
   * @example
   *
   * _('  abc  ')
   *  .chain()
   *  .trim()
   *  .thru(function(value) {
   *    return [value];
   *  })
   *  .value();
   * // => ['abc']
   */
  function thru(value, interceptor) {
    return interceptor(value);
  }

  /**
   * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
   *
   * @name chain
   * @memberOf _
   * @since 0.1.0
   * @category Seq
   * @returns {Object} Returns the new `lodash` wrapper instance.
   * @example
   *
   * var users = [
   *   { 'user': 'barney', 'age': 36 },
   *   { 'user': 'fred',   'age': 40 }
   * ];
   *
   * // A sequence without explicit chaining.
   * _(users).head();
   * // => { 'user': 'barney', 'age': 36 }
   *
   * // A sequence with explicit chaining.
   * _(users)
   *   .chain()
   *   .head()
   *   .pick('user')
   *   .value();
   * // => { 'user': 'barney' }
   */
  function wrapperChain() {
    return chain(this);
  }

  /**
   * Executes the chain sequence to resolve the unwrapped value.
   *
   * @name value
   * @memberOf _
   * @since 0.1.0
   * @alias toJSON, valueOf
   * @category Seq
   * @returns {*} Returns the resolved unwrapped value.
   * @example
   *
   * _([1, 2, 3]).value();
   * // => [1, 2, 3]
   */
  function wrapperValue() {
    return baseWrapperValue(this.__wrapped__, this.__actions__);
  }

  /*------------------------------------------------------------------------*/

  /**
   * Checks if `predicate` returns truthy for **all** elements of `collection`.
   * Iteration is stopped once `predicate` returns falsey. The predicate is
   * invoked with three arguments: (value, index|key, collection).
   *
   * **Note:** This method returns `true` for
   * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
   * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
   * elements of empty collections.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [predicate=_.identity]
   *  The function invoked per iteration.
   * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   * @example
   *
   * _.every([true, 1, null, 'yes'], Boolean);
   * // => false
   *
   * var users = [
   *   { 'user': 'barney', 'age': 36, 'active': false },
   *   { 'user': 'fred',   'age': 40, 'active': false }
   * ];
   *
   * // The `_.matches` iteratee shorthand.
   * _.every(users, { 'user': 'barney', 'active': false });
   * // => false
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.every(users, ['active', false]);
   * // => true
   *
   * // The `_.property` iteratee shorthand.
   * _.every(users, 'active');
   * // => false
   */
  function every(collection, predicate, guard) {
    predicate = guard ? undefined : predicate;
    return baseEvery(collection, baseIteratee(predicate));
  }

  /**
   * Iterates over elements of `collection`, returning an array of all elements
   * `predicate` returns truthy for. The predicate is invoked with three
   * arguments: (value, index|key, collection).
   *
   * **Note:** Unlike `_.remove`, this method returns a new array.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [predicate=_.identity]
   *  The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   * @see _.reject
   * @example
   *
   * var users = [
   *   { 'user': 'barney', 'age': 36, 'active': true },
   *   { 'user': 'fred',   'age': 40, 'active': false }
   * ];
   *
   * _.filter(users, function(o) { return !o.active; });
   * // => objects for ['fred']
   *
   * // The `_.matches` iteratee shorthand.
   * _.filter(users, { 'age': 36, 'active': true });
   * // => objects for ['barney']
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.filter(users, ['active', false]);
   * // => objects for ['fred']
   *
   * // The `_.property` iteratee shorthand.
   * _.filter(users, 'active');
   * // => objects for ['barney']
   */
  function filter(collection, predicate) {
    return baseFilter(collection, baseIteratee(predicate));
  }

  /**
   * Iterates over elements of `collection`, returning the first element
   * `predicate` returns truthy for. The predicate is invoked with three
   * arguments: (value, index|key, collection).
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} [predicate=_.identity]
   *  The function invoked per iteration.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {*} Returns the matched element, else `undefined`.
   * @example
   *
   * var users = [
   *   { 'user': 'barney',  'age': 36, 'active': true },
   *   { 'user': 'fred',    'age': 40, 'active': false },
   *   { 'user': 'pebbles', 'age': 1,  'active': true }
   * ];
   *
   * _.find(users, function(o) { return o.age < 40; });
   * // => object for 'barney'
   *
   * // The `_.matches` iteratee shorthand.
   * _.find(users, { 'age': 1, 'active': true });
   * // => object for 'pebbles'
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.find(users, ['active', false]);
   * // => object for 'fred'
   *
   * // The `_.property` iteratee shorthand.
   * _.find(users, 'active');
   * // => object for 'barney'
   */
  var find = createFind(findIndex);

  /**
   * Iterates over elements of `collection` and invokes `iteratee` for each element.
   * The iteratee is invoked with three arguments: (value, index|key, collection).
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * **Note:** As with other "Collections" methods, objects with a "length"
   * property are iterated like arrays. To avoid this behavior use `_.forIn`
   * or `_.forOwn` for object iteration.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @alias each
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @returns {Array|Object} Returns `collection`.
   * @see _.forEachRight
   * @example
   *
   * _([1, 2]).forEach(function(value) {
   *   console.log(value);
   * });
   * // => Logs `1` then `2`.
   *
   * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
   *   console.log(key);
   * });
   * // => Logs 'a' then 'b' (iteration order is not guaranteed).
   */
  function forEach(collection, iteratee) {
    return baseEach(collection, baseIteratee(iteratee));
  }

  /**
   * Creates an array of values by running each element in `collection` thru
   * `iteratee`. The iteratee is invoked with three arguments:
   * (value, index|key, collection).
   *
   * Many lodash methods are guarded to work as iteratees for methods like
   * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
   *
   * The guarded methods are:
   * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
   * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
   * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
   * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   * @example
   *
   * function square(n) {
   *   return n * n;
   * }
   *
   * _.map([4, 8], square);
   * // => [16, 64]
   *
   * _.map({ 'a': 4, 'b': 8 }, square);
   * // => [16, 64] (iteration order is not guaranteed)
   *
   * var users = [
   *   { 'user': 'barney' },
   *   { 'user': 'fred' }
   * ];
   *
   * // The `_.property` iteratee shorthand.
   * _.map(users, 'user');
   * // => ['barney', 'fred']
   */
  function map(collection, iteratee) {
    return baseMap(collection, baseIteratee(iteratee));
  }

  /**
   * Reduces `collection` to a value which is the accumulated result of running
   * each element in `collection` thru `iteratee`, where each successive
   * invocation is supplied the return value of the previous. If `accumulator`
   * is not given, the first element of `collection` is used as the initial
   * value. The iteratee is invoked with four arguments:
   * (accumulator, value, index|key, collection).
   *
   * Many lodash methods are guarded to work as iteratees for methods like
   * `_.reduce`, `_.reduceRight`, and `_.transform`.
   *
   * The guarded methods are:
   * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
   * and `sortBy`
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @returns {*} Returns the accumulated value.
   * @see _.reduceRight
   * @example
   *
   * _.reduce([1, 2], function(sum, n) {
   *   return sum + n;
   * }, 0);
   * // => 3
   *
   * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
   *   (result[value] || (result[value] = [])).push(key);
   *   return result;
   * }, {});
   * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
   */
  function reduce(collection, iteratee, accumulator) {
    return baseReduce(collection, baseIteratee(iteratee), accumulator, arguments.length < 3, baseEach);
  }

  /**
   * Gets the size of `collection` by returning its length for array-like
   * values or the number of own enumerable string keyed properties for objects.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object|string} collection The collection to inspect.
   * @returns {number} Returns the collection size.
   * @example
   *
   * _.size([1, 2, 3]);
   * // => 3
   *
   * _.size({ 'a': 1, 'b': 2 });
   * // => 2
   *
   * _.size('pebbles');
   * // => 7
   */
  function size(collection) {
    if (collection == null) {
      return 0;
    }
    collection = isArrayLike(collection) ? collection : nativeKeys(collection);
    return collection.length;
  }

  /**
   * Checks if `predicate` returns truthy for **any** element of `collection`.
   * Iteration is stopped once `predicate` returns truthy. The predicate is
   * invoked with three arguments: (value, index|key, collection).
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [predicate=_.identity] The function invoked per iteration.
   * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   * @example
   *
   * _.some([null, 0, 'yes', false], Boolean);
   * // => true
   *
   * var users = [
   *   { 'user': 'barney', 'active': true },
   *   { 'user': 'fred',   'active': false }
   * ];
   *
   * // The `_.matches` iteratee shorthand.
   * _.some(users, { 'user': 'barney', 'active': false });
   * // => false
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.some(users, ['active', false]);
   * // => true
   *
   * // The `_.property` iteratee shorthand.
   * _.some(users, 'active');
   * // => true
   */
  function some(collection, predicate, guard) {
    predicate = guard ? undefined : predicate;
    return baseSome(collection, baseIteratee(predicate));
  }

  /**
   * Creates an array of elements, sorted in ascending order by the results of
   * running each element in a collection thru each iteratee. This method
   * performs a stable sort, that is, it preserves the original sort order of
   * equal elements. The iteratees are invoked with one argument: (value).
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {...(Function|Function[])} [iteratees=[_.identity]]
   *  The iteratees to sort by.
   * @returns {Array} Returns the new sorted array.
   * @example
   *
   * var users = [
   *   { 'user': 'fred',   'age': 48 },
   *   { 'user': 'barney', 'age': 36 },
   *   { 'user': 'fred',   'age': 40 },
   *   { 'user': 'barney', 'age': 34 }
   * ];
   *
   * _.sortBy(users, function(o) { return o.user; });
   * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
   *
   * _.sortBy(users, ['user', 'age']);
   * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
   *
   * _.sortBy(users, 'user', function(o) {
   *   return Math.floor(o.age / 10);
   * });
   * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
   */
  function sortBy(collection, iteratee) {
    var index = 0;
    iteratee = baseIteratee(iteratee);

    return baseMap(baseMap(collection, function(value, key, collection) {
      return { 'value': value, 'index': index++, 'criteria': iteratee(value, key, collection) };
    }).sort(function(object, other) {
      return compareAscending(object.criteria, other.criteria) || (object.index - other.index);
    }), baseProperty('value'));
  }

  /*------------------------------------------------------------------------*/

  /**
   * Creates a function that invokes `func`, with the `this` binding and arguments
   * of the created function, while it's called less than `n` times. Subsequent
   * calls to the created function return the result of the last `func` invocation.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Function
   * @param {number} n The number of calls at which `func` is no longer invoked.
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new restricted function.
   * @example
   *
   * jQuery(element).on('click', _.before(5, addContactToList));
   * // => Allows adding up to 4 contacts to the list.
   */
  function before(n, func) {
    var result;
    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    n = toInteger(n);
    return function() {
      if (--n > 0) {
        result = func.apply(this, arguments);
      }
      if (n <= 1) {
        func = undefined;
      }
      return result;
    };
  }

  /**
   * Creates a function that invokes `func` with the `this` binding of `thisArg`
   * and `partials` prepended to the arguments it receives.
   *
   * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
   * may be used as a placeholder for partially applied arguments.
   *
   * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
   * property of bound functions.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to bind.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {...*} [partials] The arguments to be partially applied.
   * @returns {Function} Returns the new bound function.
   * @example
   *
   * function greet(greeting, punctuation) {
   *   return greeting + ' ' + this.user + punctuation;
   * }
   *
   * var object = { 'user': 'fred' };
   *
   * var bound = _.bind(greet, object, 'hi');
   * bound('!');
   * // => 'hi fred!'
   *
   * // Bound with placeholders.
   * var bound = _.bind(greet, object, _, '!');
   * bound('hi');
   * // => 'hi fred!'
   */
  var bind = baseRest(function(func, thisArg, partials) {
    return createPartial(func, BIND_FLAG | PARTIAL_FLAG, thisArg, partials);
  });

  /**
   * Defers invoking the `func` until the current call stack has cleared. Any
   * additional arguments are provided to `func` when it's invoked.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to defer.
   * @param {...*} [args] The arguments to invoke `func` with.
   * @returns {number} Returns the timer id.
   * @example
   *
   * _.defer(function(text) {
   *   console.log(text);
   * }, 'deferred');
   * // => Logs 'deferred' after one or more milliseconds.
   */
  var defer = baseRest(function(func, args) {
    return baseDelay(func, 1, args);
  });

  /**
   * Invokes `func` after `wait` milliseconds. Any additional arguments are
   * provided to `func` when it's invoked.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to delay.
   * @param {number} wait The number of milliseconds to delay invocation.
   * @param {...*} [args] The arguments to invoke `func` with.
   * @returns {number} Returns the timer id.
   * @example
   *
   * _.delay(function(text) {
   *   console.log(text);
   * }, 1000, 'later');
   * // => Logs 'later' after one second.
   */
  var delay = baseRest(function(func, wait, args) {
    return baseDelay(func, toNumber(wait) || 0, args);
  });

  /**
   * Creates a function that negates the result of the predicate `func`. The
   * `func` predicate is invoked with the `this` binding and arguments of the
   * created function.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Function
   * @param {Function} predicate The predicate to negate.
   * @returns {Function} Returns the new negated function.
   * @example
   *
   * function isEven(n) {
   *   return n % 2 == 0;
   * }
   *
   * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
   * // => [1, 3, 5]
   */
  function negate(predicate) {
    if (typeof predicate != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    return function() {
      var args = arguments;
      return !predicate.apply(this, args);
    };
  }

  /**
   * Creates a function that is restricted to invoking `func` once. Repeat calls
   * to the function return the value of the first invocation. The `func` is
   * invoked with the `this` binding and arguments of the created function.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new restricted function.
   * @example
   *
   * var initialize = _.once(createApplication);
   * initialize();
   * initialize();
   * // => `createApplication` is invoked once
   */
  function once(func) {
    return before(2, func);
  }

  /*------------------------------------------------------------------------*/

  /**
   * Creates a shallow clone of `value`.
   *
   * **Note:** This method is loosely based on the
   * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
   * and supports cloning arrays, array buffers, booleans, date objects, maps,
   * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
   * arrays. The own enumerable properties of `arguments` objects are cloned
   * as plain objects. An empty object is returned for uncloneable values such
   * as error objects, functions, DOM nodes, and WeakMaps.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to clone.
   * @returns {*} Returns the cloned value.
   * @see _.cloneDeep
   * @example
   *
   * var objects = [{ 'a': 1 }, { 'b': 2 }];
   *
   * var shallow = _.clone(objects);
   * console.log(shallow[0] === objects[0]);
   * // => true
   */
  function clone(value) {
    if (!isObject(value)) {
      return value;
    }
    return isArray(value) ? copyArray(value) : copyObject(value, nativeKeys(value));
  }

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || (value !== value && other !== other);
  }

  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
      (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
  }

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }

  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */
  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }

  /**
   * Checks if `value` is classified as a boolean primitive or object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
   * @example
   *
   * _.isBoolean(false);
   * // => true
   *
   * _.isBoolean(null);
   * // => false
   */
  function isBoolean(value) {
    return value === true || value === false ||
      (isObjectLike(value) && objectToString.call(value) == boolTag);
  }

  /**
   * Checks if `value` is classified as a `Date` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
   * @example
   *
   * _.isDate(new Date);
   * // => true
   *
   * _.isDate('Mon April 23 2012');
   * // => false
   */
  var isDate = baseIsDate;

  /**
   * Checks if `value` is an empty object, collection, map, or set.
   *
   * Objects are considered empty if they have no own enumerable string keyed
   * properties.
   *
   * Array-like values such as `arguments` objects, arrays, buffers, strings, or
   * jQuery-like collections are considered empty if they have a `length` of `0`.
   * Similarly, maps and sets are considered empty if they have a `size` of `0`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is empty, else `false`.
   * @example
   *
   * _.isEmpty(null);
   * // => true
   *
   * _.isEmpty(true);
   * // => true
   *
   * _.isEmpty(1);
   * // => true
   *
   * _.isEmpty([1, 2, 3]);
   * // => false
   *
   * _.isEmpty({ 'a': 1 });
   * // => false
   */
  function isEmpty(value) {
    if (isArrayLike(value) &&
        (isArray(value) || isString(value) ||
          isFunction(value.splice) || isArguments(value))) {
      return !value.length;
    }
    return !nativeKeys(value).length;
  }

  /**
   * Performs a deep comparison between two values to determine if they are
   * equivalent.
   *
   * **Note:** This method supports comparing arrays, array buffers, booleans,
   * date objects, error objects, maps, numbers, `Object` objects, regexes,
   * sets, strings, symbols, and typed arrays. `Object` objects are compared
   * by their own, not inherited, enumerable properties. Functions and DOM
   * nodes are **not** supported.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.isEqual(object, other);
   * // => true
   *
   * object === other;
   * // => false
   */
  function isEqual(value, other) {
    return baseIsEqual(value, other);
  }

  /**
   * Checks if `value` is a finite primitive number.
   *
   * **Note:** This method is based on
   * [`Number.isFinite`](https://mdn.io/Number/isFinite).
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
   * @example
   *
   * _.isFinite(3);
   * // => true
   *
   * _.isFinite(Number.MIN_VALUE);
   * // => true
   *
   * _.isFinite(Infinity);
   * // => false
   *
   * _.isFinite('3');
   * // => false
   */
  function isFinite(value) {
    return typeof value == 'number' && nativeIsFinite(value);
  }

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
  }

  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' &&
      value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
  }

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Checks if `value` is `NaN`.
   *
   * **Note:** This method is based on
   * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
   * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
   * `undefined` and other non-number values.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   * @example
   *
   * _.isNaN(NaN);
   * // => true
   *
   * _.isNaN(new Number(NaN));
   * // => true
   *
   * isNaN(undefined);
   * // => true
   *
   * _.isNaN(undefined);
   * // => false
   */
  function isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return isNumber(value) && value != +value;
  }

  /**
   * Checks if `value` is `null`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
   * @example
   *
   * _.isNull(null);
   * // => true
   *
   * _.isNull(void 0);
   * // => false
   */
  function isNull(value) {
    return value === null;
  }

  /**
   * Checks if `value` is classified as a `Number` primitive or object.
   *
   * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
   * classified as numbers, use the `_.isFinite` method.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a number, else `false`.
   * @example
   *
   * _.isNumber(3);
   * // => true
   *
   * _.isNumber(Number.MIN_VALUE);
   * // => true
   *
   * _.isNumber(Infinity);
   * // => true
   *
   * _.isNumber('3');
   * // => false
   */
  function isNumber(value) {
    return typeof value == 'number' ||
      (isObjectLike(value) && objectToString.call(value) == numberTag);
  }

  /**
   * Checks if `value` is classified as a `RegExp` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
   * @example
   *
   * _.isRegExp(/abc/);
   * // => true
   *
   * _.isRegExp('/abc/');
   * // => false
   */
  var isRegExp = baseIsRegExp;

  /**
   * Checks if `value` is classified as a `String` primitive or object.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a string, else `false`.
   * @example
   *
   * _.isString('abc');
   * // => true
   *
   * _.isString(1);
   * // => false
   */
  function isString(value) {
    return typeof value == 'string' ||
      (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
  }

  /**
   * Checks if `value` is `undefined`.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
   * @example
   *
   * _.isUndefined(void 0);
   * // => true
   *
   * _.isUndefined(null);
   * // => false
   */
  function isUndefined(value) {
    return value === undefined;
  }

  /**
   * Converts `value` to an array.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {Array} Returns the converted array.
   * @example
   *
   * _.toArray({ 'a': 1, 'b': 2 });
   * // => [1, 2]
   *
   * _.toArray('abc');
   * // => ['a', 'b', 'c']
   *
   * _.toArray(1);
   * // => []
   *
   * _.toArray(null);
   * // => []
   */
  function toArray(value) {
    if (!isArrayLike(value)) {
      return values(value);
    }
    return value.length ? copyArray(value) : [];
  }

  /**
   * Converts `value` to an integer.
   *
   * **Note:** This method is loosely based on
   * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted integer.
   * @example
   *
   * _.toInteger(3.2);
   * // => 3
   *
   * _.toInteger(Number.MIN_VALUE);
   * // => 0
   *
   * _.toInteger(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toInteger('3.2');
   * // => 3
   */
  var toInteger = Number;

  /**
   * Converts `value` to a number.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {number} Returns the number.
   * @example
   *
   * _.toNumber(3.2);
   * // => 3.2
   *
   * _.toNumber(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toNumber(Infinity);
   * // => Infinity
   *
   * _.toNumber('3.2');
   * // => 3.2
   */
  var toNumber = Number;

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString(value) {
    if (typeof value == 'string') {
      return value;
    }
    return value == null ? '' : (value + '');
  }

  /*------------------------------------------------------------------------*/

  /**
   * Assigns own enumerable string keyed properties of source objects to the
   * destination object. Source objects are applied from left to right.
   * Subsequent sources overwrite property assignments of previous sources.
   *
   * **Note:** This method mutates `object` and is loosely based on
   * [`Object.assign`](https://mdn.io/Object/assign).
   *
   * @static
   * @memberOf _
   * @since 0.10.0
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @see _.assignIn
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * function Bar() {
   *   this.c = 3;
   * }
   *
   * Foo.prototype.b = 2;
   * Bar.prototype.d = 4;
   *
   * _.assign({ 'a': 0 }, new Foo, new Bar);
   * // => { 'a': 1, 'c': 3 }
   */
  var assign = createAssigner(function(object, source) {
    copyObject(source, nativeKeys(source), object);
  });

  /**
   * This method is like `_.assign` except that it iterates over own and
   * inherited source properties.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @alias extend
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @see _.assign
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * function Bar() {
   *   this.c = 3;
   * }
   *
   * Foo.prototype.b = 2;
   * Bar.prototype.d = 4;
   *
   * _.assignIn({ 'a': 0 }, new Foo, new Bar);
   * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
   */
  var assignIn = createAssigner(function(object, source) {
    copyObject(source, nativeKeysIn(source), object);
  });

  /**
   * This method is like `_.assignIn` except that it accepts `customizer`
   * which is invoked to produce the assigned values. If `customizer` returns
   * `undefined`, assignment is handled by the method instead. The `customizer`
   * is invoked with five arguments: (objValue, srcValue, key, object, source).
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @alias extendWith
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} sources The source objects.
   * @param {Function} [customizer] The function to customize assigned values.
   * @returns {Object} Returns `object`.
   * @see _.assignWith
   * @example
   *
   * function customizer(objValue, srcValue) {
   *   return _.isUndefined(objValue) ? srcValue : objValue;
   * }
   *
   * var defaults = _.partialRight(_.assignInWith, customizer);
   *
   * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
   * // => { 'a': 1, 'b': 2 }
   */
  var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
    copyObject(source, keysIn(source), object, customizer);
  });

  /**
   * Creates an object that inherits from the `prototype` object. If a
   * `properties` object is given, its own enumerable string keyed properties
   * are assigned to the created object.
   *
   * @static
   * @memberOf _
   * @since 2.3.0
   * @category Object
   * @param {Object} prototype The object to inherit from.
   * @param {Object} [properties] The properties to assign to the object.
   * @returns {Object} Returns the new object.
   * @example
   *
   * function Shape() {
   *   this.x = 0;
   *   this.y = 0;
   * }
   *
   * function Circle() {
   *   Shape.call(this);
   * }
   *
   * Circle.prototype = _.create(Shape.prototype, {
   *   'constructor': Circle
   * });
   *
   * var circle = new Circle;
   * circle instanceof Circle;
   * // => true
   *
   * circle instanceof Shape;
   * // => true
   */
  function create(prototype, properties) {
    var result = baseCreate(prototype);
    return properties ? assign(result, properties) : result;
  }

  /**
   * Assigns own and inherited enumerable string keyed properties of source
   * objects to the destination object for all destination properties that
   * resolve to `undefined`. Source objects are applied from left to right.
   * Once a property is set, additional values of the same property are ignored.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @see _.defaultsDeep
   * @example
   *
   * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
   * // => { 'a': 1, 'b': 2 }
   */
  var defaults = baseRest(function(args) {
    args.push(undefined, assignInDefaults);
    return assignInWith.apply(undefined, args);
  });

  /**
   * Checks if `path` is a direct property of `object`.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   * @example
   *
   * var object = { 'a': { 'b': 2 } };
   * var other = _.create({ 'a': _.create({ 'b': 2 }) });
   *
   * _.has(object, 'a');
   * // => true
   *
   * _.has(object, 'a.b');
   * // => true
   *
   * _.has(object, ['a', 'b']);
   * // => true
   *
   * _.has(other, 'a');
   * // => false
   */
  function has(object, path) {
    return object != null && hasOwnProperty.call(object, path);
  }

  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */
  var keys = nativeKeys;

  /**
   * Creates an array of the own and inherited enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keysIn(new Foo);
   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
   */
  var keysIn = nativeKeysIn;

  /**
   * Creates an object composed of the picked `object` properties.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The source object.
   * @param {...(string|string[])} [props] The property identifiers to pick.
   * @returns {Object} Returns the new object.
   * @example
   *
   * var object = { 'a': 1, 'b': '2', 'c': 3 };
   *
   * _.pick(object, ['a', 'c']);
   * // => { 'a': 1, 'c': 3 }
   */
  var pick = baseRest(function(object, props) {
    return object == null ? {} : basePick(object, baseMap(baseFlatten(props, 1), toKey));
  });

  /**
   * This method is like `_.get` except that if the resolved value is a
   * function it's invoked with the `this` binding of its parent object and
   * its result is returned.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to resolve.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
   *
   * _.result(object, 'a[0].b.c1');
   * // => 3
   *
   * _.result(object, 'a[0].b.c2');
   * // => 4
   *
   * _.result(object, 'a[0].b.c3', 'default');
   * // => 'default'
   *
   * _.result(object, 'a[0].b.c3', _.constant('default'));
   * // => 'default'
   */
  function result(object, path, defaultValue) {
    var value = object == null ? undefined : object[path];
    if (value === undefined) {
      value = defaultValue;
    }
    return isFunction(value) ? value.call(object) : value;
  }

  /**
   * Creates an array of the own enumerable string keyed property values of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property values.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.values(new Foo);
   * // => [1, 2] (iteration order is not guaranteed)
   *
   * _.values('hi');
   * // => ['h', 'i']
   */
  function values(object) {
    return object ? baseValues(object, keys(object)) : [];
  }

  /*------------------------------------------------------------------------*/

  /**
   * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
   * their corresponding HTML entities.
   *
   * **Note:** No other characters are escaped. To escape additional
   * characters use a third-party library like [_he_](https://mths.be/he).
   *
   * Though the ">" character is escaped for symmetry, characters like
   * ">" and "/" don't need escaping in HTML and have no special meaning
   * unless they're part of a tag or unquoted attribute value. See
   * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
   * (under "semi-related fun fact") for more details.
   *
   * Backticks are escaped because in IE < 9, they can break out of
   * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
   * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
   * [#133](https://html5sec.org/#133) of the
   * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
   *
   * When working with HTML you should always
   * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
   * XSS vectors.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category String
   * @param {string} [string=''] The string to escape.
   * @returns {string} Returns the escaped string.
   * @example
   *
   * _.escape('fred, barney, & pebbles');
   * // => 'fred, barney, &amp; pebbles'
   */
  function escape(string) {
    string = toString(string);
    return (string && reHasUnescapedHtml.test(string))
      ? string.replace(reUnescapedHtml, escapeHtmlChar)
      : string;
  }

  /*------------------------------------------------------------------------*/

  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }

  /**
   * Creates a function that invokes `func` with the arguments of the created
   * function. If `func` is a property name, the created function returns the
   * property value for a given element. If `func` is an array or object, the
   * created function returns `true` for elements that contain the equivalent
   * source properties, otherwise it returns `false`.
   *
   * @static
   * @since 4.0.0
   * @memberOf _
   * @category Util
   * @param {*} [func=_.identity] The value to convert to a callback.
   * @returns {Function} Returns the callback.
   * @example
   *
   * var users = [
   *   { 'user': 'barney', 'age': 36, 'active': true },
   *   { 'user': 'fred',   'age': 40, 'active': false }
   * ];
   *
   * // The `_.matches` iteratee shorthand.
   * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
   * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.filter(users, _.iteratee(['user', 'fred']));
   * // => [{ 'user': 'fred', 'age': 40 }]
   *
   * // The `_.property` iteratee shorthand.
   * _.map(users, _.iteratee('user'));
   * // => ['barney', 'fred']
   *
   * // Create custom iteratee shorthands.
   * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
   *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
   *     return func.test(string);
   *   };
   * });
   *
   * _.filter(['abc', 'def'], /ef/);
   * // => ['def']
   */
  var iteratee = baseIteratee;

  /**
   * Creates a function that performs a partial deep comparison between a given
   * object and `source`, returning `true` if the given object has equivalent
   * property values, else `false`.
   *
   * **Note:** The created function is equivalent to `_.isMatch` with `source`
   * partially applied.
   *
   * Partial comparisons will match empty array and empty object `source`
   * values against any array or object value, respectively. See `_.isEqual`
   * for a list of supported value comparisons.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Util
   * @param {Object} source The object of property values to match.
   * @returns {Function} Returns the new spec function.
   * @example
   *
   * var objects = [
   *   { 'a': 1, 'b': 2, 'c': 3 },
   *   { 'a': 4, 'b': 5, 'c': 6 }
   * ];
   *
   * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
   * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
   */
  function matches(source) {
    return baseMatches(assign({}, source));
  }

  /**
   * Adds all own enumerable string keyed function properties of a source
   * object to the destination object. If `object` is a function, then methods
   * are added to its prototype as well.
   *
   * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
   * avoid conflicts caused by modifying the original.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {Function|Object} [object=lodash] The destination object.
   * @param {Object} source The object of functions to add.
   * @param {Object} [options={}] The options object.
   * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
   * @returns {Function|Object} Returns `object`.
   * @example
   *
   * function vowels(string) {
   *   return _.filter(string, function(v) {
   *     return /[aeiou]/i.test(v);
   *   });
   * }
   *
   * _.mixin({ 'vowels': vowels });
   * _.vowels('fred');
   * // => ['e']
   *
   * _('fred').vowels().value();
   * // => ['e']
   *
   * _.mixin({ 'vowels': vowels }, { 'chain': false });
   * _('fred').vowels();
   * // => ['e']
   */
  function mixin(object, source, options) {
    var props = keys(source),
        methodNames = baseFunctions(source, props);

    if (options == null &&
        !(isObject(source) && (methodNames.length || !props.length))) {
      options = source;
      source = object;
      object = this;
      methodNames = baseFunctions(source, keys(source));
    }
    var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
        isFunc = isFunction(object);

    baseEach(methodNames, function(methodName) {
      var func = source[methodName];
      object[methodName] = func;
      if (isFunc) {
        object.prototype[methodName] = function() {
          var chainAll = this.__chain__;
          if (chain || chainAll) {
            var result = object(this.__wrapped__),
                actions = result.__actions__ = copyArray(this.__actions__);

            actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
            result.__chain__ = chainAll;
            return result;
          }
          return func.apply(object, arrayPush([this.value()], arguments));
        };
      }
    });

    return object;
  }

  /**
   * Reverts the `_` variable to its previous value and returns a reference to
   * the `lodash` function.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @returns {Function} Returns the `lodash` function.
   * @example
   *
   * var lodash = _.noConflict();
   */
  function noConflict() {
    if (root._ === this) {
      root._ = oldDash;
    }
    return this;
  }

  /**
   * This method returns `undefined`.
   *
   * @static
   * @memberOf _
   * @since 2.3.0
   * @category Util
   * @example
   *
   * _.times(2, _.noop);
   * // => [undefined, undefined]
   */
  function noop() {
    // No operation performed.
  }

  /**
   * Generates a unique ID. If `prefix` is given, the ID is appended to it.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {string} [prefix=''] The value to prefix the ID with.
   * @returns {string} Returns the unique ID.
   * @example
   *
   * _.uniqueId('contact_');
   * // => 'contact_104'
   *
   * _.uniqueId();
   * // => '105'
   */
  function uniqueId(prefix) {
    var id = ++idCounter;
    return toString(prefix) + id;
  }

  /*------------------------------------------------------------------------*/

  /**
   * Computes the maximum value of `array`. If `array` is empty or falsey,
   * `undefined` is returned.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Math
   * @param {Array} array The array to iterate over.
   * @returns {*} Returns the maximum value.
   * @example
   *
   * _.max([4, 2, 8, 6]);
   * // => 8
   *
   * _.max([]);
   * // => undefined
   */
  function max(array) {
    return (array && array.length)
      ? baseExtremum(array, identity, baseGt)
      : undefined;
  }

  /**
   * Computes the minimum value of `array`. If `array` is empty or falsey,
   * `undefined` is returned.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Math
   * @param {Array} array The array to iterate over.
   * @returns {*} Returns the minimum value.
   * @example
   *
   * _.min([4, 2, 8, 6]);
   * // => 2
   *
   * _.min([]);
   * // => undefined
   */
  function min(array) {
    return (array && array.length)
      ? baseExtremum(array, identity, baseLt)
      : undefined;
  }

  /*------------------------------------------------------------------------*/

  // Add methods that return wrapped values in chain sequences.
  lodash.assignIn = assignIn;
  lodash.before = before;
  lodash.bind = bind;
  lodash.chain = chain;
  lodash.compact = compact;
  lodash.concat = concat;
  lodash.create = create;
  lodash.defaults = defaults;
  lodash.defer = defer;
  lodash.delay = delay;
  lodash.filter = filter;
  lodash.flatten = flatten;
  lodash.flattenDeep = flattenDeep;
  lodash.iteratee = iteratee;
  lodash.keys = keys;
  lodash.map = map;
  lodash.matches = matches;
  lodash.mixin = mixin;
  lodash.negate = negate;
  lodash.once = once;
  lodash.pick = pick;
  lodash.slice = slice;
  lodash.sortBy = sortBy;
  lodash.tap = tap;
  lodash.thru = thru;
  lodash.toArray = toArray;
  lodash.values = values;

  // Add aliases.
  lodash.extend = assignIn;

  // Add methods to `lodash.prototype`.
  mixin(lodash, lodash);

  /*------------------------------------------------------------------------*/

  // Add methods that return unwrapped values in chain sequences.
  lodash.clone = clone;
  lodash.escape = escape;
  lodash.every = every;
  lodash.find = find;
  lodash.forEach = forEach;
  lodash.has = has;
  lodash.head = head;
  lodash.identity = identity;
  lodash.indexOf = indexOf;
  lodash.isArguments = isArguments;
  lodash.isArray = isArray;
  lodash.isBoolean = isBoolean;
  lodash.isDate = isDate;
  lodash.isEmpty = isEmpty;
  lodash.isEqual = isEqual;
  lodash.isFinite = isFinite;
  lodash.isFunction = isFunction;
  lodash.isNaN = isNaN;
  lodash.isNull = isNull;
  lodash.isNumber = isNumber;
  lodash.isObject = isObject;
  lodash.isRegExp = isRegExp;
  lodash.isString = isString;
  lodash.isUndefined = isUndefined;
  lodash.last = last;
  lodash.max = max;
  lodash.min = min;
  lodash.noConflict = noConflict;
  lodash.noop = noop;
  lodash.reduce = reduce;
  lodash.result = result;
  lodash.size = size;
  lodash.some = some;
  lodash.uniqueId = uniqueId;

  // Add aliases.
  lodash.each = forEach;
  lodash.first = head;

  mixin(lodash, (function() {
    var source = {};
    baseForOwn(lodash, function(func, methodName) {
      if (!hasOwnProperty.call(lodash.prototype, methodName)) {
        source[methodName] = func;
      }
    });
    return source;
  }()), { 'chain': false });

  /*------------------------------------------------------------------------*/

  /**
   * The semantic version number.
   *
   * @static
   * @memberOf _
   * @type {string}
   */
  lodash.VERSION = VERSION;

  // Add `Array` methods to `lodash.prototype`.
  baseEach(['pop', 'join', 'replace', 'reverse', 'split', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
    var func = (/^(?:replace|split)$/.test(methodName) ? String.prototype : arrayProto)[methodName],
        chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
        retUnwrapped = /^(?:pop|join|replace|shift)$/.test(methodName);

    lodash.prototype[methodName] = function() {
      var args = arguments;
      if (retUnwrapped && !this.__chain__) {
        var value = this.value();
        return func.apply(isArray(value) ? value : [], args);
      }
      return this[chainName](function(value) {
        return func.apply(isArray(value) ? value : [], args);
      });
    };
  });

  // Add chain sequence methods to the `lodash` wrapper.
  lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

  /*--------------------------------------------------------------------------*/

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = lodash;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define('lodash',[],function() {
      return lodash;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = lodash)._ = lodash;
    // Export for CommonJS support.
    freeExports._ = lodash;
  }
  else {
    // Export to the global object.
    root._ = lodash;
  }
}.call(this));

define('constants/common',{
    availabilityStatus: {
        AVAILABLE: 'Available',
        NOT_AVAILABLE: 'NotAvailable'
    },

    modality: {
        CHAT: 'chat',
        EMAIL: 'email',
        PHONE: 'phone'
    },

    serviceLocator: {
        GATEWAY: 'gatewayService',
        PUBSUB: 'pubSub',
        AGENT_CONTEXT: 'agentContext',
        CHAT_ENGAGEMENTS: 'chatEngagements',
        ACTIVE_ENGAGEMENTS: 'activeEngagements',
        SKYPE_AUTH_CONTEXT: 'skypeAuthContext',
        EXCEPTION_MANAGER: 'exceptionManager',
        AUTH_SERVICE: 'authService'
    },

    headerKey: {
        PARTNER_ID: 'x-ms-partner-id',
        SESSION_ID: 'x-ms-session-id',
        VISIT_ID: 'x-ms-visit-id',
        ENGAGEMENT_ID: 'x-ms-engagement-id',
        CONFERENCE_ID: 'x-ms-conference-id',
        BEARER_TOKEN: 'Authorization',
        TEST: 'x-ms-test',
        TARGET_AGENT_ID: 'x-ms-target-oid',
        ASSIGNEE_UPN: 'x-ms-assignee-upn'
    },

    skypeLoginState: {
        SignedOut: 'SignedOut',
        SigningIn: 'SigningIn',
        SignedIn: 'SignedIn',
        SigningOut: 'SigningOut'
    },

    skypePresence: {
        OFFLINE: 'Offline',
        ONLINE: 'Online',
        BUSY: 'Busy',
        AWAY: 'Away',
        DONOTDISTURB: 'DoNotDisturb'
    },

    skypeMessageFormat: {
        TEXTMESSAGE: 'TextMessage'
    },

    skypeMessageDirection: {
        INCOMING: 'Incoming',
        OUTGOING: 'Outgoing'
    },

    skypeMessageStatus: {
        SUCCEEDED: 'Succeeded',
        FAILED: 'Failed'
    },

    conversationState: {
        Created: 'Created',
        Conferenced: 'Conferenced',
        Conferencing: 'Conferencing',
        Connected: 'Connected',
        Connecting: 'Connecting',
        Disconnected: 'Disconnected',
        Disconnecting: 'Disconnecting',
        Incoming: 'Incoming',
        InLobby: 'InLobby'
    },

    inviteType: {
        Unknown: 'Default',
        Normal: 'Normal',
        Rejoin: 'Rejoin',
        Transfer: 'Transfer',
        Group: 'Group',
        Consult: 'Consult',
        Supervisor: 'Supervisor',
        Internal: 'Internal'
    },

    chatType: {
        Incoming: 'Incoming',
        Outgoing: 'Outgoing',
        Rehydration: 'Rehydration'
    },

    conversationExtensionState: {
        ConversationExtensionStarted: 'ConversationExtensionStarted',
        AgentParticipantInvitationFailed: 'AgentParticipantInvitationFailed',
        ParticipantFilterRemoved: 'ParticipantFilterRemoved',
        BridgedParticipantsSettingRestored: 'BridgedParticipantsSettingRestored',
        CustomerUnreachable: 'CustomerUnreachable',
        CustomerReachable: 'CustomerReachable',
        CustomerLeftDueToEndChat: 'CustomerLeftDueToEndChat',
        CustomerLeftDueToUnreachable: 'CustomerLeftDueToUnreachable',
        AgentsReachableDetect: 'AgentsReachableDetect'
    },

    command: {
        Ping: 'Ping',
        AutomatedMessage: 'AutomatedMessage',
        Message: 'Message',
        TranscriptLoaded: 'TranscriptLoaded'
    },

    events: {
        // App level events
        INCOMING_CHAT_REQUEST: 'incomingChatRequest',
        CHAT_ENGAGEMENT_REHYDRATION_FAILED: 'chatEngagementRehydrationFailed',
        CHAT_CHANNEL_UNAVAILABLE: 'chatChannelUnavailable', // when skype signs out
        UNREACHABLE_BY_SERVICE: 'unreachableByService',
        GET_AVAILABILITY_FAILED: 'getAvailabilityFailed',
        GET_AVAILABILITY_RESTORED: 'getAvailabilityRestored',
        NO_CHAT_ENGAGEMENT: 'noChatEngagement',
        CHAT_ENGAGEMENT_ADDED: 'chatEngagementAdded',
        AVAILABILITY_UPDATED: 'availabilityUpdated',
        MAX_CHAT_COUNT_UPDATED: 'maxChatCountUpdated',
        // Chat engagement level events
        CHAT_MESSAGE_ADDED: 'chatMessageAdded',
        COMMAND_RECEIVED: 'commandReceived',
        PARTICIPANT_ADDED: 'participantAdded',
        PARTICIPANT_REMOVED: 'participantRemoved',
        IS_PARTICIPANT_TYPING: 'isParticipantTyping',
        CONSULTING_AGENT_ADDED: 'consultingAgentAdded',
        PARTICIPANT_FILTER_REMOVED: 'participantFilterRemoved',
        PARTICIPANT_INVITE_FAILED: 'agentParticipantInvitationFailed',
        CUSTOMER_REJOINED: 'customerRejoined',
        PARTICIPANT_DISCONNECTED: 'participantDisconnected',
        PARTICIPANT_RECONNECTED: 'participantReconnected',
        CUSTOMER_LEFT: 'customerLeft',
        TRANSCRIPT_LOADED: 'transcriptLoaded'
    },

    browser: {
        UNLOAD: 'unload'
    },

    endChatReason: {
        AGENTINVOKEDISENGAGE: 'AgentInvokeEndChat',
        ENDENGAGEMENTINVOKED: 'EndEngagementInvoked'
    },

    participantRemovedReason: {
        EndChat: 'EndChat',
        Unreachable: 'Unreachable'
    },

    errorMessage: {
        APIDISABLED: 'Api disabled since there is no customer connected',
        CONVERSATIONEXTENSIONMISSING: 'Skype conversation extension is missing'
    },

    errorCodes: {
        REQUEST_INVALID: 'REQUEST_INVALID',
        REQUEST_FAILED: 'REQUEST_FAILED',
        REQUEST_UNAUTHORIZED: 'REQUEST_UNAUTHORIZED',
        REQUEST_FORBIDDEN: 'REQUEST_FORBIDDEN',
        SERVER_ERROR: 'SERVER_ERROR',
        CHANNEL_ERROR: 'CHANNEL_ERROR',
        AAD_ERROR: 'AAD_ERROR'
    },

    // response code for transfer/consult apis
    responseCodes: {
        QUEUED: 'Queued',
        OUT_OF_HOOPS: 'OutOfHOOPS',
        QUEUE_INVALID: 'QueueInvalid'
    },

    authErrorKey: {
        CODE: 'code',
        DESCRIPTION:'description'
    },

    authErrorCodes: {
        OAUTH_FAILED: 'OAuthFailed',
        REQUEST_FAILED: 'RequestFailed'
    },

    oauthUriFormat: 'https://login.microsoftonline.com/common/oauth2/authorize?login_hint=',
    getAvailabilityInterval: 60000, // 1 min
    jlyncPendingGetTimeoutInSecond: 60
});
define('settings',{
    gatewayService: {
        baseUrl: 'https://api-ppe.support.microsoft.com',
        queueApiRoute: '/v0/queues/',
        agentApiRoute: '/v0/agentstatus/',
        contextApiRoute: '/v0/contexts',
        transcriptApiRoute: '/v0/transcripts',
        configApiRoute: '/v0/configurations/',
        acdApiRoute: '/v0/orchestrations/',
        assignmentApiRoute: '/v0/assignment/'
    },

    gatewayAudienceUri: 'c8b3e0dd-990b-4882-b119-acddfcaa7ace',

    jlync: {
        apiKey: 'a42fcebd-5b43-4b89-a065-74450fb91255'
    },

    asimov: {
        appId: 'agentclientsdk.channelservicesint.microsoft.com-int'
    },

    correlationVector: null,
    disableSkypeSilentReauth: false,
    requestTimeoutInMillisecond: 60000,
    requestMaxRetry: 1,
    version: '1.1.5'
});
define('skype/jlyncApplication',['require','lodash'],function (require) {
    'use strict';

    var instance,
        _ = require('lodash'),
        params = {
            settings: {
                disableConversationHistory: true,
                userInactivityTimeout: 216000000,
                sendActivityTelemetry: true,
                verboseTelemetry: true
            }
        },
        appSubscriptions = [],
        App;

    function set(api) {
        App = api.application;
        instance = new api.application(params);
    }

    function get() {
        if (!instance) {
            throw new Error('Skype SDK instance does not exist yet.');
        }

        return instance;
    }

    function create() {
        if (!App) {
            throw new Error('Skype app does not exist yet.');
        }

        dispose();
        instance = new App(params);
    }

    function dispose() {
        _.forEach(appSubscriptions, function (sub) {
            sub.dispose();
        });

        appSubscriptions = [];

        if (instance && instance.signInManager.signOut.enabled()) {
            instance.signInManager.signOut();
        }
    }

    function addSubscription(sub) {
        appSubscriptions.push(sub);
    }

    return {
        set: set,
        get: get,
        create: create,
        addSubscription: addSubscription,
        dispose: dispose
    };
});
define('services/serviceLocator',['require','lodash'],function (require) {
    'use strict';

    var _ = require('lodash');

    var services = {};

    return {
        contains: function (name) {
            return services[name];
        },
        register: function (name, service) {
            if (!_.isString(name) || name === '') {
                throw new Error('You must provide a valid name for this service');
            }

            if (services[name]) {
                throw new Error('Service \'' + name + '\' already registered');
            }

            services[name] = service;
        },
        resolve: function (name) {
            if (!services[name]) {
                throw new Error('Service \'' + name + '\' not found');
            }

            return services[name];
        },
        destroy: function (name) {
            delete services[name];
        },
        reset: function () {
            services = {};
        }
    };
});
define('constants/telemetry',{
    // eventId = ComponentCode(2) + MilestoneCode(2) + StatusEventCode(2) + OutcomeBit(1) + Event.ID(4)
    ComponentCode: '20',
    MilestoneCodes: {
        Default: '00',
        HOOPS: '11',
        Normal: '22',
        Rejoin: '33',
        Transfer: '44',
        Consult: '55',
        Availability: '66',
        Supervisor: '77',
        Config: '88',
        Group: '99',
        Internal: '50',
        Initialize: '01'
    },
    StatusEventCodes: {
        Default: '00',
        Initiated: '11',
        Queued: '12',
        Dequeued: '13',
        Routed: '14',
        Accepted: '15',
        Declined: '16',
        // chat transfer cancelled by the agent
        Cancelled: '17',
        Connected: '18',
        Disconnected: '19',
        Ended: '20',
        Abandoned: '21'
    },
    OutcomeBits: {
        Unknown: '0',
        Success: '1',
        Failure: '2'
    },
    Events: {
        // agent client sdk related events starting from 0001
        InitAgentWebSdk: {
            ID: '0001',
            NAME: 'InitAgentWebSdk',
            MESSAGE: 'Initializing agent client web SDK.'
        },
        AgentWebSdkInitialized: {
            ID: '0002',
            NAME: 'AgentWebSdkInitialized',
            MESSAGE: 'Agent client web sdk has been initialized.'
        },
        InitAgentWebSdkFailed: {
            ID: '0003',
            NAME: 'InitAgentWebSdkFailed',
            MESSAGE: 'Fail to initialize agent client web SDK.'
        },
        InitAgentInitiated: {
            ID: '0005',
            NAME: 'InitAgentInitiated',
            MESSAGE: 'Initializing agent.'
        },
        AgentInitialized: {
            ID: '0006',
            NAME: 'AgentInitialized',
            MESSAGE: 'Agent has been intialized.'
        },
        InitAgentFailed: {
            ID: '0007',
            NAME: 'InitAgentFailed',
            MESSAGE: 'Fail to intialize the agent.'
        },
        SetAvailabilityInitiated: {
            ID: '0008',
            NAME: 'SetAvailabilityInitiated',
            MESSAGE: 'Setting agent availability.'
        },
        AvailabilitySet: {
            ID: '0009',
            NAME: 'AvailabilitySet',
            MESSAGE: 'Agent availability has been set.'
        },
        SetAvailabilityFailed: {
            ID: '0010',
            NAME: 'SetAvailabilityFailed',
            MESSAGE: 'Fail to set agent availability.'
        },
        BrowserClosed: {
            ID: '0014',
            NAME: 'BrowserClosed',
            MESSAGE: 'Browser has been closed.'
        },
        EventPublished: {
            ID: '0015',
            NAME: 'EventPublished',
            MESSAGE: 'An event has been published by the agent web SDK.'
        },
        AvailabilityFetched: {
            ID: '0016',
            NAME: 'AvailabilityFetched',
            MESSAGE: 'Agent availability status fetched.'
        },
        FetchAvailabilityFailed: {
            ID: '0017',
            NAME: 'FetchAvailabilityFailed',
            MESSAGE: 'Fail to get agent availability status.'
        },
        GetTokenFailed: {
            ID: '0018',
            NAME: 'GetTokenFailed',
            MESSAGE: 'Fail to get AAD access token.'
        },
        // gateway related events starting from 1001
        GetVisitInitiated: {
            ID: '1001',
            NAME: 'GetVisitInitiated',
            MESSAGE: 'Get visit context initiated.'
        },
        VisitFetched: {
            ID: '1002',
            NAME: 'VisitFetched',
            MESSAGE: 'Visit context has been fetched.'
        },
        GetVisitFailed: {
            ID: '1003',
            NAME: 'GetVisitFailed',
            MESSAGE: 'Fail to get the visit context.'
        },
        UpdateVisitInitiated: {
            ID: '1004',
            NAME: 'UpdateVisitInitiated',
            MESSAGE: 'Update visit context initiated.'
        },
        VisitUpdated: {
            ID: '1005',
            NAME: 'VisitUpdated',
            MESSAGE: 'Visit context has been updated.'
        },
        UpdateVisitFailed: {
            ID: '1006',
            NAME: 'UpdateVisitFailed',
            MESSAGE: 'Fail to update the visit context.'
        },
        GetTranscriptInitiated: {
            ID: '1007',
            NAME: 'GetTranscriptInitiated',
            MESSAGE: 'Get transcript initiated.'
        },
        TranscriptFetched: {
            ID: '1008',
            NAME: 'TranscriptFetched',
            MESSAGE: 'Transcript has been fetched.'
        },
        GetTranscriptFailed: {
            ID: '1009',
            NAME: 'GetTranscriptFailed',
            MESSAGE: 'Fail to fetch transcript.'
        },
        EndEngagementInitiated: {
            ID: '1010',
            NAME: 'EndEngagementInitiated',
            MESSAGE: 'End engagement initiated.'
        },
        EngagementEnded: {
            ID: '1011',
            NAME: 'EngagementEnded',
            MESSAGE: 'Engagement/case has been ended.'
        },
        EndEngagementFailed: {
            ID: '1012',
            NAME: 'EndEngagementFailed',
            MESSAGE: 'Fail to end the engagement.'
        },
        WhisperChatInitiated: {
            ID: '1013',
            NAME: 'WhisperChatInitiated',
            MESSAGE: 'Whiper chat initiated.'
        },
        WhiperChatRequested: {
            ID: '1014',
            NAME: 'WhiperChatRequested',
            MESSAGE: 'Whiper chat has been requested successfully.'
        },
        WhiperChatFailed: {
            ID: '1015',
            NAME: 'WhiperChatFailed',
            MESSAGE: 'Fail to whiper the chat engagement.'
        },
        GetHoopsInitiated: {
            ID: '1016',
            NAME: 'GetHoopsInitiated',
            MESSAGE: 'Get hoops initiated.'
        },
        HoopsFetched: {
            ID: '1017',
            NAME: 'HoopsFetched',
            MESSAGE: 'Hoops has been fetched.'
        },
        GetHoopsFailed: {
            ID: '1018',
            NAME: 'GetHoopsFailed',
            MESSAGE: 'Fail to fetch hoops.'
        },
        GetChatQueueLengthInitiated: {
            ID: '1019',
            NAME: 'GetChatQueueLengthInitiated',
            MESSAGE: 'Get chat queue length initiated.'
        },
        ChatQueueLengthFetched: {
            ID: '1020',
            NAME: 'ChatQueueLengthFetched',
            MESSAGE: 'Chat queue length has been fetched.'
        },
        GetChatQueueLengthFailed: {
            ID: '1021',
            NAME: 'GetChatQueueLengthFailed',
            MESSAGE: 'Fail to get chat queue length.'
        },
        ChatTranscriptSaved: {
            ID: '1022',
            NAME: 'ChatTranscriptSaved',
            MESSAGE: 'Chat transcript has been saved for internal chat.'
        },
        SaveChatTranscriptFailed: {
            ID: '1023',
            NAME: 'SaveChatTranscriptFailed',
            MESSAGE: 'Fail to save chat transcript for internal chat.'
        },
        GetReachableAgentCountInitiated: {
            ID: '1024',
            NAME: 'GetReachableAgentCountInitiated',
            MESSAGE: 'Get reachable agent count initiated.'
        },
        ReachableAgentCountFetched: {
            ID: '1025',
            NAME: 'ReachableAgentCountFetched',
            MESSAGE: 'Reachable agent count has been fetched.'
        },
        GetReachableAgentCountFailed: {
            ID: '1026',
            NAME: 'GetReachableAgentCountFailed',
            MESSAGE: 'Fail to fetch reachable agent count.'
        },
        CaseAssigned: {
            ID: '1027',
            NAME: 'CaseAssigned',
            MESSAGE: 'Case has been assigned.'
        },
        AssignCaseFailed: {
            ID: '1028',
            NAME: 'AssignCaseFailed',
            MESSAGE: 'Fail to assign the case.'
        },
        // skype related events starting from 2001
        SkypeSigningIn: {
            ID: '2001',
            NAEM: 'SkypeSigningIn',
            MESSAGE: 'Agent is signing in to Skype.'
        },
        SkypeSignedIn: {
            ID: '2002',
            NAME: 'SkypeSignedIn',
            MESSAGE: 'Agent has signed in to Skype.'
        },
        SkypeSigningInFailed: {
            ID: '2003',
            NAME: 'SkypeSigningInFailed',
            MESSAGE: 'Agent fails to sign in to Skype'
        },
        SkypeSignedOut: {
            ID: '2004',
            NAME: 'SkypeSignedOut',
            MESSAGE: 'Skype signin state changed to SignedOut.'
        },
        LoadSkypeSdkInitiated: {
            ID: '2005',
            NAME:'LoadSkypeSdkInitiated',
            MESSAGE: 'Loading Skype SDK.'
        },
        SkypeSdkLoaded: {
            ID: '2006',
            NAME: 'SkypeSdkLoaded',
            MESSAGE: 'Skype SDK has been loaded.'
        },
        LoadSkypeSdkFailed: {
            ID: '2007',
            NAME: 'LoadSkypeSdkFailed',
            MESSAGE: 'Fail to load Skype SDK.'
        },
        IncomingConversationReceived: {
            ID: '2008',
            NAME: 'IncomingConversationReceived',
            MESSAGE: 'An incoming conversation received.'
        },
        ChatEngagementAccepted: {
            ID: '2009',
            NAME: 'ChatEngagementAccepted',
            MESSAGE: 'Chat engagement accepted.'
        },
        AcceptChatEngagementFailed: {
            ID: '2010',
            NAME: 'AcceptChatEngagementFailed',
            MESSAGE: 'Fail to accept the chat engagement.'
        },
        ChatEngagementRejected: {
            ID: '2011',
            NAME: 'ChatEngagementRejected',
            MESSAGE: 'Chat engagement rejected.'
        },
        RejectChatEngagementFailed: {
            ID: '2012',
            NAME: 'RejectChatEngagementFailed',
            MESSAGE: 'Fail to reject the chat engagement.'
        },
        ChatMessageSent: {
            ID: '2013',
            NAME: 'ChatMessageSent',
            MESSAGE: 'A chat message has been sent.'
        },
        SendChatMessageFailed: {
            ID: '2014',
            NAME: 'SendChatMessageFailed',
            MESSAGE: 'Fail to send a chat message.'
        },
        CommandMessageSent: {
            ID: '2015',
            NAME: 'CommandMessageSent',
            MESSAGE: 'A command has been sent.'
        },
        SendCommandMessageFailed: {
            ID: '2016',
            NAME: 'SendCommandMessageFailed',
            MESSAGE: 'Fail to send a command.'
        },
        IsTypingSent: {
            ID: '2017',
            NAME: 'IsTypingSent',
            MESSAGE: 'IsTying event has been sent.'
        },
        SendIsTypingFailed: {
            ID: '2018',
            NAME: 'SendIsTypingFailed',
            MESSAGE: 'Fail to send isTyping event.'
        },
        TransferRequested: {
            ID: '2019',
            NAME: 'TransferRequested',
            MESSAGE: 'A request for transferring the chat has been sent.'
        },
        TransferFailed: {
            ID: '2020',
            NAME: 'TransferFailed',
            MESSAGE: 'Fail to send the transfer request.'
        },
        GroupRequested: {
            ID: '2021',
            NAME: 'GroupRequested',
            MESSAGE: 'A request for starting a group chat has been sent.'
        },
        GroupFailed: {
            ID: '2022',
            NAME: 'GroupFailed',
            MESSAGE: 'Fail to send the group chat request.'
        },
        ConsultRequested: {
            ID: '2023',
            NAME: 'ConsultRequested',
            MESSAGE: 'A request for starting consultation has been sent.'
        },
        ConsultFailed: {
            ID: '2024',
            NAME: 'ConsultFailed',
            MESSAGE: 'Fail to send the consult request.'
        },
        SwitchToGroupRequested: {
            ID: '2025',
            NAME: 'SwitchToGroupRequested',
            MESSAGE: 'A request for switching to a group chat has been sent.'
        },
        SwitchToGroupFailed: {
            ID: '2026',
            NAME: 'SwitchToGroupFailed',
            MESSAGE: 'Fail to send the switching to a group chat request.'
        },
        BargeInRequested: {
            ID: '2027',
            NAME: 'BargeInRequested',
            MESSAGE: 'A request for barging in to a chat has been sent.'
        },
        BargeInFailed: {
            ID: '2028',
            NAME: 'BargeInFailed',
            MESSAGE: 'Fail to send the barging request.'
        },
        ChatEnded: {
            ID: '2029',
            NAME: 'ChatEnded',
            MESSAGE: 'Chat has ended.'
        },
        EndChatFailed: {
            ID: '2030',
            NAME: 'EndChatFailed',
            MESSAGE: 'Fail to end the chat engagement.'
        },
        InternalChatStarted: {
            ID: '2031',
            NAME: 'InternalChatSent',
            MESSAGE: 'Starting an internal chat.'
        },
        StartInternalChatFailed: {
            ID: '2032',
            NAME: 'StartInternalChatFailed',
            MESSAGE: 'Fail to start an internal chat.'
        },
        ChatMessageReceived: {
            ID: '2033',
            NAME: 'ChatMessageReceived',
            MESSAGE: 'A chat message has been received.'
        },
        CommandMessageReceived: {
            ID: '2034',
            NAME: 'CommandMessageReceived',
            MESSAGE: 'A command has been received.'
        },
        JlyncSuspended: {
            ID: '2035',
            NAME: 'JlyncSuspended',
            MESSAGE: 'jlync app has been suspended.'
        },
        JlyncActive: {
            ID: '2036',
            NAME: 'JlyncActive',
            MESSAGE: 'jlync app is active.'
        },
        ConversationDisconnected: {
            ID: '2037',
            NAME: 'ConversationDisconnected',
            MESSAGE: 'Conversation gets disconnected.'
        },
        ChatEngagementRehydrated: {
            ID: '2038',
            NAME: 'ChatEngagementRehydrated',
            MESSAGE: 'The chat engagement has been rehydrated.'
        },
        RehydrateChatEngagementError: {
            ID: '2039',
            NAME: 'RehydrateChatEngagementError',
            MESSAGE: 'Errors from Skype during the chat engagement rehydration.'
        },
        ConversationExtensionAdded: {
            ID: '2040',
            NAME: 'ConversationExtensionAdded',
            MESSAGE: 'Skype conversation extension has been added.'
        },
        SipEndpointUriUpdated: {
            ID: '2041',
            NAME: 'SipEndpointUriUpdated',
            MESSAGE: 'Skype sip endpoint uri has been updated.'
        },
        AcceptingChatEngagement: {
            ID: '2042',
            NAME: 'AcceptingChatEngagement',
            MESSAGE: 'Start to accept a chat engagement.'
        },
        RequestDequeued: {
            ID: '2043',
            NAME: 'RequestDequeued',
            MESSAGE: 'Dequeued a consult or group chat request.'
        },
        DequeueRequestFailed: {
            ID: '2044',
            NAME: 'DequeueRequestFailed',
            MESSAGE: 'Fail to send the dequeue request.'
        },
        JlyncMeAvailable: {
            ID: '2045',
            NAME: 'JlyncMeAvailable',
            MESSAGE: 'Jlync me object is available.'
        },
        MeActive: {
            ID: '2046',
            NAME: 'MeActive',
            MESSAGE: 'jlync me object becomes active.'
        },
        MeInactive: {
            ID: '2047',
            NAME: 'MeInactive',
            MESSAGE: 'jlync me object becomes inactive.'
        },
        ConversationExtensionUpdate: {
            ID: '2048',
            NAME: 'ConversationExtensionUpdate',
            MESSAGE: 'Skype conversation extension update.'
        },
        FilterEnabled: {
            ID: '2049',
            NAME: 'FilterEnabled',
            MESSAGE: 'Filter enabled for the participant.'
        },
        EnableFilterFailed: {
            ID: '2050',
            NAME: 'EnableFilterFailed',
            MESSAGE: 'Fail to enable the filter for the participant.'
        },
        FilterDisabled: {
            ID: '2051',
            NAME: 'FilterDisabled',
            MESSAGE: 'Filter disabled for the participant.'
        },
        DisableFilterFailed: {
            ID: '2052',
            NAME: 'DisableFilterFailed',
            MESSAGE: 'Fail to disable the filter for the participant.'
        },
        SkypePresenceUpdate: {
            ID: '2053',
            NAME: 'SkypePresenceUpdate',
            MESSAGE: 'Skype presence updated.'
        }
    }
});
define('telemetry/asimovCustomEventSchema',{
    'name': 'MSEG.CMC.Channels.SharedLibrary.TelemetrySchema.ChannelServicesEvent',
    'MSEG.CMC.Channels.SharedLibrary.TelemetrySchema.ChannelServicesEvent': {
        'part': 'C',
        'def': {
            'fields': [
                // Common fields
                {
                    'name': 'orgId',
                    'type': 'string'
                },
                {
                    'name': 'partnerId',
                    'type': 'string'
                },
                {
                    'name': 'agentIdPrimary',
                    'type': 'string'
                },
                {
                    'name': 'agentIdSecondary',
                    'type': 'string'
                },
                {
                    'name': 'visitId',
                    'type': 'string'
                },
                {
                    'name': 'engagementId',
                    'type': 'string'
                },
                {
                    'name': 'eventTimeStamp',
                    'type': 'string'
                },
                {
                    'name': 'isRejoin',
                    'type': 'bool'
                },
                {
                    'name': 'isRejoinDirectToAgent',
                    'type': 'bool'
                },
                {
                    'name': 'caseId',
                    'type': 'string'
                },
                {
                    'name': 'caseAttributes',
                    'type': 'string'
                },
                {
                    'name': 'sdkVersion',
                    'type': 'string'
                },
                {
                    'name': 'agentIds',
                    'type': 'string'
                },
                {
                    'name': 'customerId',
                    'type': 'string'
                },
                {
                    'name': 'conferenceId',
                    'type': 'string'
                },
                {
                    'name': 'siteId',
                    'type': 'string'
                },
                // Non-common fields
                {
                    'name': 'eventId',
                    'type': 'string'
                },
                {
                    'name': 'eventName',
                    'type': 'string'
                },
                {
                    'name': 'message',
                    'type': 'string'
                },
                // If a service call fails
                {
                    'name': 'serviceName',
                    'type': 'string'
                },
                // xhr status code sent by the service
                {
                    'name': 'faultCode',
                    'type': 'string'
                },
                {
                    'name': 'faultContext',
                    'type': 'string'
                },
                // error code from the service
                {
                    'name': 'errorCode',
                    'type': 'string'
                },
                {
                    'name': 'errorMessage',
                    'type': 'string'
                },
                {
                    'name': 'context',
                    'type': 'string'
                }
            ]
        }
    }
});
define('telemetry/chatEntityEventSchema',{
    'name': 'MSEG.CMC.Channels.SharedLibrary.TelemetrySchema.ChatEntityEvent',
    'MSEG.CMC.Channels.SharedLibrary.TelemetrySchema.ChatEntityEvent': {
        'part': 'C',
        'def': {
            'fields': [
                // Common fields
                {
                    'name': 'orgId',
                    'type': 'string'
                },
                {
                    'name': 'partnerId',
                    'type': 'string'
                },
                {
                    'name': 'agentIdPrimary',
                    'type': 'string'
                },
                {
                    'name': 'agentIdSecondary',
                    'type': 'string'
                },
                {
                    'name': 'visitId',
                    'type': 'string'
                },
                {
                    'name': 'engagementId',
                    'type': 'string'
                },
                {
                    'name': 'eventTimeStamp',
                    'type': 'string'
                },
                {
                    'name': 'isRejoin',
                    'type': 'bool'
                },
                {
                    'name': 'isRejoinDirectToAgent',
                    'type': 'bool'
                },
                {
                    'name': 'caseId',
                    'type': 'string'
                },
                {
                    'name': 'caseAttributes',
                    'type': 'string'
                },
                {
                    'name': 'sdkVersion',
                    'type': 'string'
                },
                {
                    'name': 'agentIds',
                    'type': 'string'
                },
                {
                    'name': 'customerId',
                    'type': 'string'
                },
                {
                    'name': 'conferenceId',
                    'type': 'string'
                },
                {
                    'name': 'siteId',
                    'type': 'string'
                },
                // Non-common fields
                {
                    'name': 'eventId',
                    'type': 'string'
                },
                {
                    'name': 'eventName',
                    'type': 'string'
                },
                {
                    'name': 'message',
                    'type': 'string'
                },
                // If a service call fails
                {
                    'name': 'serviceName',
                    'type': 'string'
                },
                // xhr status code sent by the service
                {
                    'name': 'faultCode',
                    'type': 'string'
                },
                {
                    'name': 'faultContext',
                    'type': 'string'
                },
                // error code from the service
                {
                    'name': 'errorCode',
                    'type': 'string'
                },
                {
                    'name': 'errorMessage',
                    'type': 'string'
                },
                {
                    'name': 'context',
                    'type': 'string'
                }
            ]
        }
    }
});
(function($)
{
    $.fn.extend({
        inViewport: function(options)
        {
            var visibleElements = this.filter(function()
                {
                    return $.inViewport(this, options)
                });
            return this.pushStack(visibleElements)
        }, mostVisible: function()
            {
                var visibleElements = this.inViewport(),
                    max = 0,
                    visibility,
                    mostVisible;
                visibleElements.each(function(i, el)
                {
                    visibility = $(el).data('vpVisibility');
                    if (visibility > max)
                    {
                        max = visibility;
                        mostVisible = el
                    }
                });
                return $(mostVisible)
            }
    });
    var defaults = {
            offsetTop: 0, offsetBottom: 0
        };
    $.inViewport = function(element, options)
    {
        var $element = $(element),
            opts,
            scrollTop,
            viewportHeight,
            elementHeight,
            elementOffset,
            elementTop,
            elementBottom,
            a,
            b,
            visibility;
        opts = $.extend({}, defaults, options || {});
        scrollTop = $(window).scrollTop();
        viewportHeight = $(window).height() - opts.offsetTop - opts.offsetBottom;
        elementHeight = $element.height();
        elementOffset = $element.offset();
        elementTop = elementOffset.top - scrollTop - opts.offsetTop;
        elementBottom = elementTop + elementHeight;
        a = Math.max(0, Math.min(elementTop - (viewportHeight - elementHeight), elementHeight));
        b = Math.max(0, Math.min(elementBottom, elementHeight));
        visibility = (b - a) / elementHeight;
        $element.data('vpVisibility', visibility);
        return visibility
    }
})(jQuery);
;
var awa = awa || {};
awa.isInitialized = false;
awa.verbosityLevels = {
    NONE: 0, ERROR: 1, WARNING: 2, INFORMATION: 3
};
awa.behavior = {
    UNDEFINED: 0, NAVIGATIONBACK: 1, NAVIGATION: 2, NAVIGATIONFORWARD: 3, APPLY: 4, REMOVE: 5, SORT: 6, EXPAND: 7, REDUCE: 8, CONTEXTMENU: 9, TAB: 10, COPY: 11, EXPERIMENTATION: 12, PRINT: 13, STARTPROCESS: 20, PROCESSCHECKPOINT: 21, COMPLETEPROCESS: 22, SCENARIOCANCEL: 23, DOWNLOADCOMMIT: 40, DOWNLOAD: 41, SEARCHAUTOCOMPLETE: 60, SEARCH: 61, SEARCHINITIATE: 62, PURCHASE: 80, ADDTOCART: 81, VIEWCART: 82, ADDWISHLIST: 83, FINDSTORE: 84, CHECKOUT: 85, REMOVEFROMCART: 86, PURCHASECOMPLETE: 87, VIEWCHECKOUTPAGE: 88, VIEWCARTPAGE: 89, VIEWPDP: 90, UPDATEITEMQUANTITY: 91, SIGNIN: 100, SIGNOUT: 101, SOCIALSHARE: 120, SOCIALLIKE: 121, SOCIALREPLY: 122, CALL: 123, EMAIL: 124, COMMUNITY: 125, VOTE: 140, SURVEYINITIATE: 141, SURVEYCOMPLETE: 142, REPORTAPPLICATION: 143, REPORTREVIEW: 144, CONTACT: 160, REGISTRATIONINITIATE: 161, REGISTRATIONCOMPLETE: 162, CANCELSUBSCRIPTION: 163, RENEWSUBSCRIPTION: 164, CHANGESUBSCRIPTION: 165, CHATINITIATE: 180, CHATEND: 181, TRIALSIGNUP: 200, TRIALINITIATE: 201, PARTNERREFERRAL: 220, VIDEOSTART: 240, VIDEOPAUSE: 241, VIDEOCONTINUE: 242, VIDEOCHECKPOINT: 243, VIDEOJUMP: 244, VIDEOCOMPLETE: 245, VIDEOBUFFERING: 246, VIDEOERROR: 247, VIDEOMUTE: 248, VIDEOUNMUTE: 249, VIDEOFULLSCREEN: 250, VIDEOUNFULLSCREEN: 251, VIDEOREPLAY: 252, VIDEPLAYERLOAD: 253, VIRTUALEVENTJOIN: 260, VIRTUALEVENTEND: 261, IMPRESSION: 280, CLICK: 281, RICHMEDIACOMPLETE: 282, ADBUFFERING: 283, ADERROR: 284, ADSTART: 285, ADCOMPLETE: 286, ADSKIP: 287, ADTIMEOUT: 288, OTHER: 300
};
awa.behaviorKeys = [];
for (var behaviorKey in awa.behavior)
{
    awa.behaviorKeys.push(behaviorKey)
}
awa.actionType = {
    CLICKLEFT: "CL", CLICKRIGHT: "CR", SCROLL: "S", ZOOM: "Z", RESIZE: "R", KEYBOARDENTER: "KE", KEYBOARDSPACE: "KS", OTHER: "O"
};
awa.cookie = (function()
{
    function getCookieKeyValue(cookieName, keyName)
    {
        var cookie = getCookie(cookieName);
        if (cookie && keyName)
        {
            for (var u = cookie.split("&"), r = 0; r < u.length; r++)
            {
                var keyvalue = u[r].split("=");
                if (keyvalue[0] && keyName.toLowerCase() === keyvalue[0].toLowerCase())
                {
                    return keyvalue[1]
                }
            }
        }
        return undefined
    }
    function getCookie(name, valuePrefix)
    {
        var allcookies = document.cookie.split(";");
        for (var i = 0; i < allcookies.length; i++)
        {
            var cookie = allcookies[i];
            while (cookie.charAt(0) === " ")
            {
                cookie = cookie.substring(1)
            }
            var parts = cookie.split("=");
            var cookieName = decode(parts.shift());
            if (cookieName === name && parts[0].indexOf(valuePrefix) == (awa.utils.isValueAssigned(valuePrefix) ? 0 : -1))
            {
                return decode(parts.join("="))
            }
        }
        return undefined
    }
    function decode(inputString)
    {
        var value = decodeURIComponent(inputString.replace("/\+/g", " "));
        if (value.indexOf("\"") === 0)
        {
            value = value.slice(1, -1).replace(/\\"/g, "\"").replace(/\\\\/g, "\\")
        }
        return value
    }
    function setCookie(name, value, days)
    {
        var expires;
        if (days)
        {
            var date = new Date;
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString()
        }
        else
        {
            expires = ""
        }
        window.document.cookie = name + "=" + value + expires + "; path=/;"
    }
    function deleteCookie(name)
    {
        setCookie(name, "", -1)
    }
    return {
            getCookie: getCookie, getCookieKeyValue: getCookieKeyValue, setCookie: setCookie, deleteCookie: deleteCookie
        }
})();
awa.cv = (function()
{
    var UNINITIALIZED_CV = "";
    var base = UNINITIALIZED_CV;
    var currentElement = 0;
    var eventTag = "cV";
    var header = "MS-CV";
    var base64CharSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var cv1Constants = {};
    cv1Constants.maxCorrelationVectorLength = 63;
    cv1Constants.baseLength = 16;
    cv1Constants.validationPattern = new RegExp("^[" + base64CharSet + "]{" + cv1Constants.baseLength.toString() + "}(.[0-9]+)+$");
    var cv2Constants = {};
    cv2Constants.maxCorrelationVectorLength = 127;
    cv2Constants.baseLength = 22;
    cv2Constants.validationPattern = new RegExp("^[" + base64CharSet + "]{" + cv2Constants.baseLength.toString() + "}(.[0-9]+)+$");
    var currentCvConstants = cv2Constants;
    var cvVersionAtLatestValidityCheck = 2;
    function isInit()
    {
        return isValid(storedCv())
    }
    function storedCv()
    {
        return base.concat(".", currentElement.toString())
    }
    function getValue()
    {
        var value = storedCv();
        if (isValid(value))
        {
            return value
        }
    }
    function incrementExternal(externalCv)
    {
        if (isValid(externalCv))
        {
            var externalCvParts = externalCv.split(".");
            var numberOfCvParts = externalCvParts.length;
            externalCvParts[numberOfCvParts - 1] = (parseInt(externalCvParts[numberOfCvParts - 1], 10) + 1).toString();
            var incrementedCv = "";
            for (var i = 0; i < numberOfCvParts; i++)
            {
                incrementedCv += (externalCvParts[i]);
                if (i < (numberOfCvParts - 1))
                {
                    incrementedCv += "."
                }
            }
            var maxLength = (externalCvParts[0].length === cv2Constants.baseLength) ? cv2Constants.maxCorrelationVectorLength : cv1Constants.maxCorrelationVectorLength;
            if (incrementedCv.length <= maxLength)
            {
                return incrementedCv
            }
        }
    }
    function canExtend()
    {
        var currentCv = storedCv();
        if (isValid(currentCv))
        {
            return isLeqThanMaxCorrelationVectorLength(currentCv.length + 2)
        }
        return false
    }
    function canIncrement()
    {
        if (isValid(storedCv()))
        {
            return isLeqThanMaxCorrelationVectorLength(base.length + 1 + ((currentElement + 1) + "").length)
        }
        return false
    }
    function setValue(cv)
    {
        if (isValid(cv))
        {
            var lastIndex = cv.lastIndexOf(".");
            base = cv.substr(0, lastIndex);
            currentElement = parseInt(cv.substr(lastIndex + 1), 10)
        }
        else
        {
            awa.logger.logWarning("Cannot set invalid correlation vector value");
            return null
        }
        return storedCv()
    }
    function init(cvInitValue)
    {
        if (cvInitValue)
        {
            return setValue(cvInitValue)
        }
        else
        {
            base = seedCorrelationVector();
            currentElement = 0;
            return getValue()
        }
    }
    function seedCorrelationVector()
    {
        var result = "";
        for (var i = 0; i < currentCvConstants.baseLength; i++)
        {
            result += base64CharSet.charAt(Math.floor(Math.random() * base64CharSet.length))
        }
        return result
    }
    function extend()
    {
        if (canExtend())
        {
            base = base.concat(".", currentElement.toString());
            currentElement = 0;
            return storedCv()
        }
    }
    function increment()
    {
        if (canIncrement())
        {
            currentElement = currentElement + 1;
            return storedCv()
        }
    }
    function isValid(cvValue)
    {
        if (cvValue)
        {
            var baseValue = cvValue.split(".")[0];
            if (baseValue)
            {
                if (baseValue.length === 16)
                {
                    cvVersionAtLatestValidityCheck = 1;
                    return validateWithCv1(cvValue)
                }
                else if (baseValue.length === 22)
                {
                    cvVersionAtLatestValidityCheck = 2;
                    return validateWithCv2(cvValue)
                }
            }
        }
    }
    function validateWithCv1(cv)
    {
        if (cv1Constants.validationPattern.test(cv) && cv.length <= cv1Constants.maxCorrelationVectorLength)
        {
            return true
        }
    }
    function validateWithCv2(cv)
    {
        if (cv2Constants.validationPattern.test(cv) && cv.length <= cv2Constants.maxCorrelationVectorLength)
        {
            return true
        }
    }
    function isLeqThanMaxCorrelationVectorLength(length)
    {
        if (cvVersionAtLatestValidityCheck === 1)
        {
            return length <= cv1Constants.maxCorrelationVectorLength
        }
        else
        {
            return length <= cv2Constants.maxCorrelationVectorLength
        }
    }
    function useCv1()
    {
        currentCvConstants = cv1Constants
    }
    function useCv2()
    {
        currentCvConstants = cv2Constants
    }
    return {
            header: header, tag: eventTag, isInit: isInit, canExtend: canExtend, canIncrement: canIncrement, getValue: getValue, setValue: setValue, init: init, extend: extend, increment: increment, incrementExternal: incrementExternal, isValid: isValid, useCv1: useCv1, useCv2: useCv2
        }
})();
awa.logger = (function()
{
    function logError(message)
    {
        if (awa.consoleVerbosity >= awa.verbosityLevels.ERROR && console && console.error)
        {
            console.error("JSLL: " + message)
        }
    }
    function logWarning(message)
    {
        if (awa.consoleVerbosity >= awa.verbosityLevels.WARNING && console && console.warn)
        {
            console.warn("JSLL: " + message)
        }
    }
    function logInformation(message)
    {
        if (awa.consoleVerbosity >= awa.verbosityLevels.INFORMATION && console && console.log)
        {
            console.log("JSLL: " + message)
        }
    }
    return {
            logError: logError, logWarning: logWarning, logInformation: logInformation
        }
})();
awa.capabilitiesCheck = (function()
{
    return function()
        {
            if (!JSON || !JSON.stringify)
            {
                awa.logger.logError("Unable to write event: the global JSON.stringify method does not exist");
                awa.isAvailable = false;
                return false
            }
        }
})();
awa.utils = (function()
{
    var os = "";
    var userAgent = "";
    var windowPerformanceTiming = window.performance ? window.performance.timing : undefined;
    var APPIDPREFIX = "JS:";
    var attributeToLookFor = "";
    function stringifyField(fieldName, value)
    {
        if (value)
        {
            try
            {
                var stringified = JSON.stringify(value);
                if (stringified === "{}")
                {
                    if (fieldName === "timing")
                    {
                        return stringifyWindowPerformanceTiming()
                    }
                }
                return stringified
            }
            catch(e)
            {
                var message = "{\"error\": \"ERROR: could not stringify {0} {1}\"}";
                var token = (typeof value === "string") ? value : "";
                return message.replace("{0}", fieldName).replace("{1}", token)
            }
        }
    }
    function stringifyWindowPerformanceTiming()
    {
        var WPTfields = ["navigationStart", "unloadEventStart", "unloadEventEnd", "redirectStart", "redirectEnd", "fetchStart", "domainLookupStart", "domainLookupEnd", "connectStart", "connectEnd", "secureConnectionStart", "requestStart", "responseStart", "responseEnd", "domLoading", "domInteractive", "domContentLoadedEventStart", "domContentLoadedEventEnd", "domComplete", "loadEventStart", "loadEventEnd"];
        var performanceString = "{";
        for (var i = 0; i < WPTfields.length; i++)
        {
            var WindowPerformanceTimingTempValue = windowPerformanceTiming[WPTfields[i]];
            if (isValueAssigned(WindowPerformanceTimingTempValue))
            {
                performanceString += "\"" + WPTfields[i] + "\":" + WindowPerformanceTimingTempValue;
                if (i < WPTfields.length - 1)
                {
                    performanceString += ","
                }
            }
        }
        performanceString += "}";
        return performanceString
    }
    function getMuidHost(rootDomain)
    {
        var supportedMuidHosts = {
                "microsoft.com": "c1.microsoft.com", "xbox.com": "c.xbox.com", "live.com": "c.live.com", "microsoftstore.com": "c.microsoftstore.com", "msn.com": "c.msn.com", "windows.com": "c.windows.com"
            };
        return supportedMuidHosts[rootDomain]
    }
    function isOfCorrectType(type, value)
    {
        if (type === "string")
        {
            return (typeof value === "string") || (value instanceof String) || (value instanceof Date)
        }
        else if (type === "bool")
        {
            return (typeof value === "boolean") || (value instanceof Boolean)
        }
        else
        {
            if (!((typeof value === "number") || (value instanceof Number)))
            {
                return false
            }
            if (type === "uint8")
            {
                if (value < 0 || value > 255 || (value % 1 !== 0))
                {
                    return false
                }
            }
            else if (type === "uint16")
            {
                if (value < 0 || value > 65535 || (value % 1 !== 0))
                {
                    return false
                }
            }
            else if (type === "uint32")
            {
                if (value < 0 || value > 4294967295 || (value % 1 !== 0))
                {
                    return false
                }
            }
            else if (type === "uint64")
            {
                if (value < 0 || value > 18446744073709551615 || value % 1 !== 0)
                {
                    return false
                }
            }
            else if (type === "int8")
            {
                if (value < -128 || value > 127 || value % 1 !== 0)
                {
                    return false
                }
            }
            else if (type === "int16")
            {
                if (value < -32768 || value > 32767 || value % 1 !== 0)
                {
                    return false
                }
            }
            else if (type === "int32")
            {
                if (value < -2147483648 || value > 2147483647 || value % 1 !== 0)
                {
                    return false
                }
            }
            else if (type === "int64")
            {
                if (value < -9223372036854775808 || value > 9223372036854775807 || value % 1 !== 0)
                {
                    return false
                }
            }
            else if (type === "float")
            {
                if (value < -3.402823e38 || value > 3.402823e38)
                {
                    return false
                }
            }
            else if (type === "double")
            {
                if (value < -Number.MAX_VALUE || value > Number.MAX_VALUE)
                {
                    return false
                }
            }
            return true
        }
    }
    function getOs()
    {
        if (os === "")
        {
            var lowercaseUserAgent = getUserAgent().toLowerCase();
            if (lowercaseUserAgent.indexOf("windows phone") !== -1)
            {
                os = "WindowsPhone"
            }
            else if (lowercaseUserAgent.indexOf("win") !== -1)
            {
                os = "Windows"
            }
            else if (lowercaseUserAgent.indexOf("mac") !== -1)
            {
                os = "MacOS"
            }
            else if (lowercaseUserAgent.indexOf("x11") !== -1)
            {
                os = "Unix"
            }
            else if (lowercaseUserAgent.indexOf("android") !== -1)
            {
                os = "Android"
            }
            else if (lowercaseUserAgent.indexOf("linux") !== -1)
            {
                os = "Linux"
            }
            else if (lowercaseUserAgent.indexOf("webos") !== -1)
            {
                os = "webOS"
            }
            else if (lowercaseUserAgent.indexOf("blackberry") !== -1)
            {
                os = "BlackBerry"
            }
            else if ((lowercaseUserAgent.indexOf("ipod") !== -1) || (lowercaseUserAgent.indexOf("ipad") !== -1) || (lowercaseUserAgent.indexOf("iphone") !== -1))
            {
                os = "iOS"
            }
            else if (lowercaseUserAgent.indexOf("symbian") !== -1)
            {
                os = "Symbian"
            }
            else if (lowercaseUserAgent.indexOf("nokia") !== -1)
            {
                os = "Nokia"
            }
            else
            {
                os = "Unknown"
            }
        }
        return os
    }
    function readAndAssignUserAgent()
    {
        userAgent = (window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : ""
    }
    function getUserAgent()
    {
        if (userAgent === "")
        {
            readAndAssignUserAgent()
        }
        return userAgent
    }
    function extractFieldFromObject(obj, fieldName)
    {
        var fieldValue;
        if (obj && obj[fieldName])
        {
            fieldValue = obj[fieldName];
            delete obj[fieldName]
        }
        return fieldValue
    }
    function isElementTrulyVisible(element, viewportBoundingRect)
    {
        element = returnDomObjectIfjQuery(element);
        var rect = element.getBoundingClientRect();
        var intersectionArea = getIntersectionArea(rect, viewportBoundingRect);
        if (intersectionArea > 0)
        {
            return true
        }
        else
        {
            return false
        }
    }
    function getIntersectionArea(rect1, rect2)
    {
        var x11 = rect1.left,
            y11 = rect1.top,
            x12 = rect1.right,
            y12 = rect1.bottom,
            x21 = rect2.left,
            y21 = rect2.top,
            x22 = rect2.right,
            y22 = rect2.bottom;
        var x_overlap = Math.max(0, Math.min(x12, x22) - Math.max(x11, x21));
        var y_overlap = Math.max(0, Math.min(y12, y22) - Math.max(y11, y21));
        return x_overlap * y_overlap
    }
    function returnDomObjectIfjQuery(element)
    {
        if (typeof jQuery === "function" && element instanceof jQuery)
        {
            return element[0]
        }
        return element
    }
    function pad(number)
    {
        var r = String(number);
        if (r.length === 1)
        {
            r = "0" + r
        }
        return r
    }
    function dateToISOString(date)
    {
        return date.getUTCFullYear() + "-" + pad(date.getUTCMonth() + 1) + "-" + pad(date.getUTCDate()) + "T" + pad(date.getUTCHours()) + ":" + pad(date.getUTCMinutes()) + ":" + pad(date.getUTCSeconds()) + "." + String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5) + "Z"
    }
    var extend = function()
        {
            var extended = {};
            var deep = false;
            var i = 0;
            var length = arguments.length;
            if (Object.prototype.toString.call(arguments[0]) === "[object Boolean]")
            {
                deep = arguments[0];
                i++
            }
            var merge = function(obj)
                {
                    for (var prop in obj)
                    {
                        if (Object.prototype.hasOwnProperty.call(obj, prop))
                        {
                            if (deep && Object.prototype.toString.call(obj[prop]) === "[object Object]")
                            {
                                extended[prop] = extend(true, extended[prop], obj[prop])
                            }
                            else
                            {
                                extended[prop] = obj[prop]
                            }
                        }
                    }
                };
            for (; i < length; i++)
            {
                var obj = arguments[i];
                merge(obj)
            }
            return extended
        };
    function getPerformanceData()
    {
        var performanceData;
        try
        {
            performanceData = window.performance.getEntries().filter(function(item)
            {
                return item.initiatorType === "script" || item.initiatorType === "link"
            })
        }
        catch(ex) {}
        return performanceData
    }
    function getPageLoadTime()
    {
        var pageLoadTime;
        if (windowPerformanceTiming.loadEventStart > 0)
        {
            pageLoadTime = windowPerformanceTiming.loadEventStart - windowPerformanceTiming.navigationStart
        }
        return pageLoadTime
    }
    function getTitle()
    {
        return document.title.substring(0, 150)
    }
    function bracketIt(str)
    {
        return "[" + str + "]"
    }
    function findClosestByAttribute(el, attribute)
    {
        attributeToLookFor = attribute;
        return walkUpDomChainWithElementValidation(el, isAttributeInElement)
    }
    function findClosestAnchor(el)
    {
        return walkUpDomChainWithElementValidation(el, isElementAnAnchor)
    }
    function walkUpDomChainWithElementValidation(el, validationMethod)
    {
        var element = el;
        if (element)
        {
            element = returnDomObjectIfjQuery(element);
            while (!validationMethod(element))
            {
                element = element.parentNode;
                element = returnDomObjectIfjQuery(element);
                if (!element || !(element.getAttribute))
                {
                    return null
                }
            }
            return element
        }
    }
    function isAttributeInElement(element)
    {
        var value = element.getAttribute(attributeToLookFor);
        return isValueAssigned(value) || value === ""
    }
    function isElementAnAnchor(element)
    {
        return element.nodeName === "A"
    }
    function getAppIdWithPrefix(appId)
    {
        var result;
        if (appId)
        {
            var appIdArray = appId.split(":");
            result = appIdArray.length > 1 && appIdArray[0].toLowerCase() === "js" ? appId : APPIDPREFIX + appId
        }
        return result
    }
    function removeInvalidElements(object)
    {
        for (var property in object)
        {
            if (!isValueAssigned(object[property]) || (JSON.stringify(object[property]) === "{}" && (property !== "callback")))
            {
                delete object[property]
            }
        }
    }
    function isValueAssigned(value)
    {
        return !(value === undefined || value === null || value === "")
    }
    function removeNonObjectsAndInvalidElements(overrideConfig, attributeNamesExpectedObjects)
    {
        removeInvalidElements(overrideConfig);
        for (var i in attributeNamesExpectedObjects)
        {
            var objectName = attributeNamesExpectedObjects[i];
            if (typeof overrideConfig[objectName] === "object")
            {
                removeInvalidElements(overrideConfig[objectName])
            }
            else
            {
                delete overrideConfig[objectName]
            }
        }
    }
    return {
            stringifyField: stringifyField, getMuidHost: getMuidHost, isOfCorrectType: isOfCorrectType, getOs: getOs, getUserAgent: getUserAgent, extractFieldFromObject: extractFieldFromObject, isElementTrulyVisible: isElementTrulyVisible, dateToISOString: dateToISOString, extend: extend, returnDomObjectIfjQuery: returnDomObjectIfjQuery, findClosestByAttribute: findClosestByAttribute, findClosestAnchor: findClosestAnchor, getPerformanceData: getPerformanceData, getPageLoadTime: getPageLoadTime, getTitle: getTitle, removeInvalidElements: removeInvalidElements, removeNonObjectsAndInvalidElements: removeNonObjectsAndInvalidElements, bracketIt: bracketIt, getAppIdWithPrefix: getAppIdWithPrefix, isValueAssigned: isValueAssigned, testHook: {getIntersectionArea: getIntersectionArea}
        }
})();
awa.ids = (function()
{
    var impressionGuid = createGuid(),
        cookie = awa.cookie,
        appUserId = null,
        appExpId = null,
        firstImpressionGuidSent = false,
        expIdCookieName = "Treatments",
        deviceClass,
        userIdPrefixes = ["c:", "i:", "w:"],
        flightIdNameSpaces = ["AX", "EX", "SF", "CS", "CF", "CT", "CU", "DC", "DF", "H5", "HL", "WS", "WP"];
    function createGuid()
    {
        var guidPattern = "xxxxxxxx-xxxx-4xxx-Rxxx-xxxxxxxxxxxx";
        function randomHexDigit()
        {
            return Math.floor(Math.random() * 16).toString(16)
        }
        var result = guidPattern.replace(/x/g, randomHexDigit);
        return result.replace("R", (8 | Math.floor(Math.random() * 3)).toString(16))
    }
    function sessionId()
    {
        return cookie.getCookie("MS0")
    }
    function visitorId()
    {
        var userId = cookie.getCookie("MUID");
        return userId
    }
    function getImpressionGuid()
    {
        return impressionGuid
    }
    function getPageViewImpressionGuid()
    {
        if (firstImpressionGuidSent)
        {
            impressionGuid = createGuid()
        }
        else
        {
            firstImpressionGuidSent = true
        }
        return impressionGuid
    }
    function groups()
    {
        return cookie.getCookie(expIdCookieName)
    }
    function muidUserId()
    {
        var muidValue = cookie.getCookie("MUID");
        return muidValue && muidValue.length ? "t:" + muidValue : muidValue
    }
    function setAppUserId(uid)
    {
        appUserId = null;
        if (!uid)
        {
            return
        }
        for (var i = 0; i < userIdPrefixes.length; i++)
        {
            if (userIdPrefixes[i] === uid.substring(0, 2))
            {
                appUserId = uid;
                break
            }
        }
        if (!appUserId)
        {
            awa.logger.logWarning("Unsupported app user id: " + uid + ". Supported app user ids are: c:, i:, and w:")
        }
    }
    function isValidAppFlightId(appFlightId)
    {
        if (!appFlightId || appFlightId.length < 4)
        {
            return false
        }
        var isValid = false,
            MAXFLIGHTIDLENGTH = 256,
            curNameSpace = (appFlightId.substring(0, 3)).toString().toUpperCase();
        for (var i = 0; i < flightIdNameSpaces.length; i++)
        {
            if (flightIdNameSpaces[i] + ":" === curNameSpace && appFlightId.length <= MAXFLIGHTIDLENGTH)
            {
                isValid = true;
                break
            }
        }
        return isValid
    }
    function setAppExpId(appExpIdNew)
    {
        if (!appExpIdNew)
        {
            appExpId = null;
            return
        }
        else if (appExpIdNew === appExpId)
        {
            return
        }
        else
        {
            appExpId = null;
            var expIdArray = appExpIdNew.split(",");
            for (var i = 0; i < expIdArray.length; i++)
            {
                if (isValidAppFlightId(expIdArray[i]))
                {
                    if (!appExpId)
                    {
                        appExpId = expIdArray[i]
                    }
                    else
                    {
                        appExpId += "," + expIdArray[i]
                    }
                }
                else
                {
                    awa.logger.logWarning("Unsupported flight id format for this app expId: " + expIdArray[i])
                }
            }
        }
    }
    function getAppExpId()
    {
        return appExpId
    }
    function setDeviceClass(newDeviceClass)
    {
        if (newDeviceClass)
        {
            deviceClass = newDeviceClass
        }
    }
    function getDeviceClass()
    {
        return deviceClass
    }
    return {
            getSessionId: sessionId, getVisitorId: visitorId, getMuidUserId: muidUserId, setAppUserId: setAppUserId, getAppUserId: function()
                {
                    return appUserId
                }, readExpIdFromCookie: function()
                {
                    setAppExpId(groups());
                    return getAppExpId()
                }, readExpIdFromCoreData: function(expId)
                {
                    setAppExpId(expId);
                    return getAppExpId()
                }, getImpressionGuid: getImpressionGuid, getPageViewImpressionGuid: getPageViewImpressionGuid, getGroups: groups, setDeviceClass: setDeviceClass, getDeviceClass: getDeviceClass, setExpIdCookieName: function(name)
                {
                    expIdCookieName = name
                }, getExpIdCookieName: function()
                {
                    return expIdCookieName
                }
        }
})();
awa.vortexEvents = (function()
{
    var ids = awa.ids;
    var nonCriticalEventsQueue = [];
    var overrideReadyState = "notInit";
    var numberOfEventsToBatch = 0;
    function batchQueuedEvents()
    {
        if (nonCriticalEventsQueue.length > 0)
        {
            awa.writeEvent(nonCriticalEventsQueue);
            nonCriticalEventsQueue = []
        }
    }
    function drainQueuedEvents()
    {
        if (document.readyState === "complete")
        {
            while (nonCriticalEventsQueue.length > 0)
            {
                awa.writeEvent(nonCriticalEventsQueue.pop())
            }
        }
        else
        {
            awa.ct.onDomReadyDo(awa.firstEventDoneTasks)
        }
    }
    function sendOrScheduleEvent(event, isCriticalEvent)
    {
        if (isCriticalEvent === true)
        {
            awa.writeEvent(event);
            return
        }
        else
        {
            if (overrideReadyState === "complete")
            {
                awa.writeEvent(event);
                return
            }
            nonCriticalEventsQueue.push(event);
            if (numberOfEventsToBatch > 1 && nonCriticalEventsQueue.length >= numberOfEventsToBatch)
            {
                batchQueuedEvents()
            }
        }
    }
    function jsllEvent(eventData)
    {
        var event = {};
        if (eventData.type === "CorsDisallowed")
        {
            awa.ct.captureCorsDisallowed(eventData)
        }
        else if (eventData.type === "EventTooLong")
        {
            awa.ct.captureEventTooLong(eventData)
        }
        ;
    }
    function error(errorInfo, displayedToUser)
    {
        awa.ct.captureClientError({
            errorInfo: errorInfo, displayedToUser: displayedToUser
        })
    }
    function outgoingRequest(eventData)
    {
        var event = {
                name: "Ms.Webi.OutgoingRequest", cV: eventData.cV, data: {
                        baseData: {
                            operationName: eventData.currentOperationName, targetUri: eventData.requestUri, latencyMs: eventData.latencyMs, serviceErrorCode: eventData.serviceErrorCode || -1, succeeded: eventData.isSuccess, requestMethod: eventData.httpMethod, responseContentType: eventData.contentType, protocolStatusCode: eventData.httpStatusCode, dependencyOperationName: eventData.operationName, dependencyOperationVersion: eventData.operationVersion, dependencyName: eventData.serviceName, dependencyType: eventData.serviceType || "WebService", responseSizeBytes: eventData.responseSize
                        }, baseType: "Ms.Qos.OutgoingServiceRequest", customSessionGuid: ids.getSessionId(), impressionGuid: ids.getImpressionGuid(), message: eventData.errorMessage, retryCount: eventData.retryCount, customData: eventData.customData
                    }
            };
        awa.ct.captureQos(event)
    }
    return {
            sendError: error, sendApiComplete: outgoingRequest, sendJsllEvent: jsllEvent, SendOrScheduleEvent: sendOrScheduleEvent, batchQueuedEvents: batchQueuedEvents, drainQueuedEvents: drainQueuedEvents, batchEventsByNumber: function(number)
                {
                    numberOfEventsToBatch = number
                }, addEventToQueue: function(obj)
                {
                    nonCriticalEventsQueue.push(obj)
                }, overrideQueueBehavior: function(options)
                {
                    if (options)
                    {
                        if (options.domReadyState)
                        {
                            overrideReadyState = options.domReadyState
                        }
                    }
                }
        }
})();
awa.errorHandler = (function()
{
    var vortexEvents = awa.vortexEvents;
    function windowErrorHandler(nextHandler)
    {
        var prevError = window.onerror;
        window.onerror = function()
        {
            if (prevError)
            {
                prevError.apply(this, arguments)
            }
            nextHandler.apply(this, arguments)
        }
    }
    function extractStackTrace(errorObject)
    {
        return errorObject.stack ? errorObject.stack.substring(0, 1000) : ""
    }
    function defaultHandler()
    {
        if (arguments)
        {
            var errorDetails = {
                    Page: window.location.href, Script: arguments[1] || "", Message: arguments[0] || "", LineNumber: arguments[2] || 0, StackTrace: arguments[4] ? extractStackTrace(arguments[4]) : "", UserAgent: awa.utils.getUserAgent() || "", Platform: window.navigator.platform || ""
                };
            vortexEvents.sendError(errorDetails, false)
        }
    }
    function init()
    {
        windowErrorHandler(defaultHandler)
    }
    return {init: init}
})();
awa.timespanHandler = (function()
{
    var timers = {};
    function recordTimeSpan(counterName, isComplete)
    {
        var timestamp = (new Date).getTime();
        if (!isComplete)
        {
            timers[counterName] = timestamp
        }
        else
        {
            return timestamp - timers[counterName]
        }
    }
    return {recordTimeSpan: recordTimeSpan}
})();
(function()
{
    awa._schemas = awa._schemas || [];
    var utils = awa.utils;
    var isValueAssigned = utils.isValueAssigned;
    var config = {
            endpoint: "https://web.vortex.data.microsoft.com/collect/v1", sendMode: 1, batchSize: 10, authMethod: 0, validateEvents: true, sendEvents: true, logLevel: awa.verbosityLevels.NONE, syncMuid: false, provisionMsfpc: true, useDefaultContentName: true, useShortNameForContentBlob: false, debounceMs: {
                    scroll: 600, resize: 3000
                }, muidDomain: "microsoft.com", biBlobAttributeTag: "data-m", isLoggedIn: false, shareAuthStatus: false, cookiesToCollect: ["MSFPC", "ANON"], mscomCookies: false, userConsentCookieName: "MSCC", useBeacon: true, urlCollectHash: false, urlCollectQuery: true, initCv: false, ix: {
                    a: false, g: false
                }, autoCapture: {
                    pageView: true, onLoad: true, onUnload: true, click: true, scroll: false, resize: false, jsError: true, addin: true, perf: true, assets: false, lineage: false, invalidEvents: false, msTags: true, eventTooLong: true, corsDisallowed: true
                }, callback: {
                    pageName: null, pageActionPageTags: null, pageViewPageTags: null, contentUpdatePageTags: null, pageActionContentTags: null, signedinStatus: null, jsllEventCallback: null, pageUnloadTimings: null
                }, coreData: {
                    referrerUri: document.referrer || undefined, requestUri: "", appId: window.location.hostname, pageName: "", pageType: "", env: "", product: "", market: "", serverImpressionGuid: "", expId: "", pageTags: {}
                }
        };
    awa.getConfig = function()
    {
        return config
    };
    var attributesThatAreObjectsInConfig = [];
    for (var attribute in config)
    {
        if (typeof config[attribute] === "object")
        {
            attributesThatAreObjectsInConfig.push(attribute)
        }
    }
    var CS_ENVLOPE_VERSION = "2.1";
    var JSLL_VERSION = "4.2.3";
    var JSEXTENSION_VERSION = "1.1";
    var partAfieldsInOrder = ["ver", "name", "time", "flags", "os", "appId", "cV", "deviceClass"];
    var numberOfPartAFields = partAfieldsInOrder.length;
    var isOldIE = isOldIEBrowser();
    var allowedGetLength = isOldIE ? 2083 : 15000;
    var queryParameters = "";
    var signInRedirectCount = 0;
    var firstEventSent = false;
    var isBeaconAvailable = isValueAssigned(navigator) && isValueAssigned(navigator.sendBeacon);
    var isMsfpcProvisioned = isValueAssigned(awa.cookie.getCookie("MSFPC"));
    awa.experimentIdTag = "expId";
    awa.isAvailable = true;
    awa.requestBody = "";
    awa.getQueryStringParameters = function()
    {
        return queryParameters
    };
    if (Object.freeze)
    {
        Object.freeze(awa.verbosityLevels)
    }
    awa.capabilitiesCheck();
    var requestMechanism = window.XDomainRequest ? "XDomainRequest" : "xhr";
    var canMakeCrossDomainCall = function()
        {
            if (requestMechanism === "XDomainRequest")
            {
                if (config.endpoint && (config.endpoint.indexOf(window.location.protocol) !== 0))
                {
                    awa.logger.logError("Unable to write event: CORS requests are not supported cross-protocol in this browser");
                    return false
                }
            }
            return true
        };
    var modeOneFirstEventSent = function()
        {
            firstEventSent = true;
            if (config.sendMode == 1)
            {
                awa.vortexEvents.overrideQueueBehavior({domReadyState: "complete"});
                awa.vortexEvents.drainQueuedEvents()
            }
        };
    awa.firstEventDone = modeOneFirstEventSent;
    awa.firstEventDoneTasks = function()
    {
        awa.vortexEvents.drainQueuedEvents()
    };
    var xhrFailureCallback = function(textStatus, errorThrown)
        {
            awa.logger.logError("Failure sending data to vortex: " + textStatus + "Error: " + errorThrown.toString())
        };
    var xhrSuccessCallback = function(src, event, isScript)
        {
            if (awa.OnSuccessfulVortexRequest)
            {
                awa.OnSuccessfulVortexRequest(src)
            }
            if (event && typeof config.callback.jsllEventCallback === "function")
            {
                config.callback.jsllEventCallback(event)
            }
            if (firstEventSent === false)
            {
                firstEventSent = true;
                if (config.sendMode === 1 && !isScript)
                {
                    modeOneFirstEventSent()
                }
            }
            awa.logger.logInformation("Success sending data to vortex")
        };
    var xdrFailureCallback = function(xdr)
        {
            awa.logger.logError("Failure sending data to vortex using XDomainRequest.  Status code:" + xdr.status)
        };
    var quoteCharacter = "'";
    var doubleQuoteCharacter = "\"";
    var dashCharacter = "-";
    var starCharacter = "*";
    function addToQueryParam(queryParam, key, value)
    {
        if (isValueAssigned(value))
        {
            var returnString = "";
            if (queryParam.length > 0)
            {
                returnString += "&"
            }
            if (utils.isOfCorrectType("number", value) || utils.isOfCorrectType("bool", value))
            {
                returnString += key + "=" + value
            }
            else if (typeof value == "object")
            {
                returnString += key + "=" + JSON.stringify(value)
            }
            else
            {
                returnString += key + "=" + quoteCharacter + encodeURIComponent(value) + quoteCharacter
            }
            return returnString
        }
        else
        {
            return ""
        }
    }
    function addToRequestBody(requestBody, key, value)
    {
        if (isValueAssigned(value))
        {
            var returnString = "";
            if (requestBody.length > 1)
            {
                returnString += ","
            }
            if (utils.isOfCorrectType("number", value) || utils.isOfCorrectType("bool", value))
            {
                returnString += doubleQuoteCharacter + key + doubleQuoteCharacter + ":" + value
            }
            else if (typeof value == "object")
            {
                returnString += doubleQuoteCharacter + key + doubleQuoteCharacter + ":" + JSON.stringify(value)
            }
            else
            {
                returnString += doubleQuoteCharacter + key + doubleQuoteCharacter + ":" + doubleQuoteCharacter + value + doubleQuoteCharacter
            }
            return returnString
        }
        else
        {
            return ""
        }
    }
    function getQueryFromJSON(event)
    {
        var queryParameters = "";
        for (var i = 0; i < numberOfPartAFields; i++)
        {
            queryParameters += addToQueryParam(queryParameters, partAfieldsInOrder[i], event[partAfieldsInOrder[i]])
        }
        var data = event.data;
        for (var dataKey in data)
        {
            if (dataKey == "baseData")
            {
                var baseData = data[dataKey];
                for (var baseDataKey in baseData)
                {
                    queryParameters += addToQueryParam(queryParameters, dashCharacter + baseDataKey, baseData[baseDataKey])
                }
            }
            else
            {
                queryParameters += addToQueryParam(queryParameters, starCharacter + dataKey, data[dataKey])
            }
        }
        var extensions = event.ext;
        for (var extensionKey in extensions)
        {
            var currentExtension = extensions[extensionKey];
            for (var subExtensionKey in currentExtension)
            {
                queryParameters += addToQueryParam(queryParameters, "ext" + dashCharacter + extensionKey + dashCharacter + subExtensionKey, currentExtension[subExtensionKey])
            }
        }
        queryParameters += "&" + getMsComQueryParam();
        setGlobalQueryParamForUnitTests(queryParameters);
        return queryParameters
    }
    ;
    function getRequestBodyFromJSON(event)
    {
        var openingCurl = "{";
        var closingCurl = "}";
        var requestBody = openingCurl;
        for (var i = 0; i < numberOfPartAFields; i++)
        {
            requestBody += addToRequestBody(requestBody, partAfieldsInOrder[i], event[partAfieldsInOrder[i]])
        }
        var data = event.data;
        if (data)
        {
            requestBody += addToRequestBody(requestBody, "data", data)
        }
        var extensions = event.ext;
        if (extensions)
        {
            requestBody += addToRequestBody(requestBody, "ext", extensions)
        }
        requestBody += closingCurl;
        awa.requestBody = requestBody;
        return requestBody
    }
    ;
    function setGlobalQueryParamForUnitTests(queryP)
    {
        queryParameters = queryP
    }
    awa.init = function(overrideConfig)
    {
        if (!awa.isInitialized)
        {
            awa.isInitialized = true;
            if (overrideConfig)
            {
                utils.removeNonObjectsAndInvalidElements(overrideConfig, attributesThatAreObjectsInConfig);
                config = utils.extend(true, config, overrideConfig)
            }
            var sendMode = config.sendMode;
            if (sendMode == 0)
            {
                firstEventSent = true;
                awa.vortexEvents.overrideQueueBehavior({domReadyState: "complete"})
            }
            if (sendMode >= 1)
            {
                awa.vortexEvents.overrideQueueBehavior({domReadyState: "notComplete"})
            }
            if (sendMode === 2)
            {
                awa.vortexEvents.batchEventsByNumber(config.batchSize)
            }
            awa.consoleVerbosity = config.logLevel;
            awa.ct.initialize(config);
            awa.ix.init(config);
            if (config.initCv)
            {
                awa.cv.init()
            }
        }
    };
    var populatePartAandExtensions = function(event)
        {
            if (awa.translateEventFromIntermediateStructure)
            {
                event = awa.translateEventFromIntermediateStructure(event)
            }
            var cV = event.cV;
            var appId = event.appId;
            event.ver = "2.1";
            event.cV = isValueAssigned(cV) ? cV : awa.cv.getValue();
            event.time = utils.dateToISOString(new Date);
            event.os = utils.getOs();
            event.deviceClass = awa.ids.getDeviceClass() || undefined;
            event.appId = utils.getAppIdWithPrefix(appId ? appId : config.coreData.appId);
            var domain = window.location.hostname;
            if (!isValueAssigned(domain))
            {
                domain = window.location.protocol == "file:" ? "local" : domain
            }
            var javascriptExtensionObject = {
                    ver: "1.1", libVer: "4.2.3", domain: domain, msfpc: awa.cookie.getCookie("MSFPC", "GUID"), userConsent: isValueAssigned(awa.cookie.getCookie(config.userConsentCookieName)) ? true : false
                };
            if (event.ext)
            {
                event.ext.javascript = javascriptExtensionObject
            }
            else
            {
                event.ext = {javascript: javascriptExtensionObject}
            }
            var localId = awa.ids.getMuidUserId();
            if (localId)
            {
                event.ext.user = {localId: localId}
            }
            var configEnv = config.coreData.env;
            var envFromCT = event.ext.app ? event.ext.app.env : undefined;
            var envValue = isValueAssigned(envFromCT) ? envFromCT : configEnv;
            var expIdValue = config.coreData.expId ? awa.ids.readExpIdFromCoreData(config.coreData.expId) : awa.ids.readExpIdFromCookie();
            var userIdValue = awa.ids.getAppUserId();
            if (isValueAssigned(envValue) || isValueAssigned(expIdValue) || isValueAssigned(userIdValue))
            {
                if (!event.ext.app)
                {
                    event.ext.app = {}
                }
                if (envValue)
                {
                    event.ext.app.env = envValue
                }
                if (expIdValue)
                {
                    event.ext.app.expId = expIdValue
                }
                if (userIdValue)
                {
                    event.ext.app.userId = userIdValue
                }
            }
            if (config.validateEvents && awa.isEventValid && !awa.isEventValid(event))
            {
                return undefined
            }
            else
            {
                awa._validateAndTranslateEvent(event);
                return event
            }
        };
    awa.writeEvent = function(event)
    {
        if (!awa.isInitialized)
        {
            awa.vortexEvents.addEventToQueue(event);
            return
        }
        var actuallyUseGet = true;
        if (Object.prototype.toString.call(event) === "[object Array]")
        {
            var arrayOfEventsToSend = [];
            for (var i = 0; i < event.length; i++)
            {
                var currentEvent = populatePartAandExtensions(event[i]);
                if (currentEvent)
                {
                    arrayOfEventsToSend.push(currentEvent)
                }
            }
            if (arrayOfEventsToSend.length != 0)
            {
                event = arrayOfEventsToSend;
                actuallyUseGet = false
            }
            else
            {
                return
            }
        }
        else
        {
            event = populatePartAandExtensions(event);
            if (!event)
            {
                return
            }
        }
        if (config.sendEvents)
        {
            var payloadLength = JSON.stringify(event).length + config.endpoint.length;
            if (actuallyUseGet && payloadLength + 7 > allowedGetLength)
            {
                awa.logger.logWarning("event is too large to send using get -- using post instead");
                if (config.autoCapture.eventTooLong)
                {
                    var jsllEvent = {};
                    jsllEvent.eventName = event.name;
                    jsllEvent.payloadLength = payloadLength;
                    awa.ct.captureEventTooLong(jsllEvent)
                }
                actuallyUseGet = false
            }
            if (!actuallyUseGet && !canMakeCrossDomainCall())
            {
                if (config.autoCapture.corsDisallowed)
                {
                    var jsllEvent = {};
                    jsllEvent.eventName = event.name;
                    jsllEvent.type = "CorsDisallowed";
                    awa.ct.captureCorsDisallowed(jsllEvent)
                }
                return
            }
            if (awa.testHook && awa.testHook.testUsePost == true)
            {
                actuallyUseGet = false
            }
            if (actuallyUseGet)
            {
                if (firstEventSent === false || config.provisionMsfpc && !isMsfpcProvisioned)
                {
                    isMsfpcProvisioned = true;
                    var telemetryResource = "/t.js";
                    var isAlreadyAuthed = !(document.cookie.toLowerCase().indexOf("bounced=") === -1);
                    if (isAlreadyAuthed)
                    {
                        makeImageRequest(event);
                        return
                    }
                    else if (config.shareAuthStatus === true && getSignedInStatus() === true)
                    {
                        telemetryResource = config.authMethod === 1 ? "/asm.js" : (config.authMethod === 2 ? "/asa.js" : telemetryResource)
                    }
                    sendThroughScript(config.endpoint + telemetryResource + "?" + getQueryFromJSON(event), event)
                }
                else
                {
                    if (isBeaconAvailable && config.useBeacon === true && config.shareAuthStatus === false)
                    {
                        sendThroughBeacon(event)
                    }
                    else
                    {
                        makeImageRequest(event)
                    }
                }
            }
            else
            {
                if (isBeaconAvailable && config.useBeacon === true && config.shareAuthStatus === false)
                {
                    sendThroughBeacon(event)
                }
                else
                {
                    sendThroughPost(event)
                }
            }
        }
        else
        {
            xhrSuccessCallback(getQueryFromJSON(event), event)
        }
    };
    function makeImageRequest(event)
    {
        var telemetryResource = "/t.gif";
        if (config.shareAuthStatus === true && getSignedInStatus() === true)
        {
            telemetryResource = config.authMethod === 1 ? "/asm.gif" : (config.authMethod === 2 ? "/asa.gif" : telemetryResource)
        }
        sendThroughImage(config.endpoint + telemetryResource + "?" + getQueryFromJSON(event), event)
    }
    function sendThroughImage(imageSrc, event)
    {
        var newImage = new Image;
        newImage.onload = function()
        {
            if (newImage.width === 1)
            {
                xhrSuccessCallback(imageSrc, event)
            }
        };
        newImage.onerror = function()
        {
            awa.logger.logWarning("Telemetry image beacon not sent properly. Sending through POST.");
            sendThroughPost(event)
        };
        newImage.src = imageSrc
    }
    function serializeEventForPost(translatedEvents)
    {
        var requestBody = "";
        var qp = "";
        var msfpc = "";
        if (translatedEvents.length)
        {
            msfpc = translatedEvents[0].ext.javascript.msfpc;
            for (var j = 0; j < translatedEvents.length; j++)
            {
                if (j > 0)
                {
                    requestBody += "\n"
                }
                requestBody += getRequestBodyFromJSON(translatedEvents[j])
            }
        }
        else
        {
            msfpc = translatedEvents.ext.javascript.msfpc;
            requestBody = getRequestBodyFromJSON(translatedEvents)
        }
        var requestSrc = config.endpoint + "/t.req?" + requestBody;
        var qp = "?" + getMsComQueryParam();
        qp += isValueAssigned(msfpc) ? "&ext-javascript-msfpc=" + encodeURIComponent(quoteCharacter + msfpc + quoteCharacter) : "";
        return {
                qp: qp, requestBody: requestBody, requestSrc: requestSrc
            }
    }
    function getMsComQueryParam()
    {
        return "$mscomCookies=" + config.mscomCookies
    }
    function sendThroughPost(translatedEvents)
    {
        var serializedEvent = serializeEventForPost(translatedEvents);
        if (requestMechanism === "xhr")
        {
            var request = new XMLHttpRequest;
            request.open("POST", config.endpoint + serializedEvent.qp, true);
            request.withCredentials = true;
            request.onload = function()
            {
                if (request.status === 200)
                {
                    xhrSuccessCallback(serializedEvent.requestSrc, translatedEvents)
                }
                else
                {
                    xhrFailureCallback(request.statusText, request.status)
                }
            };
            request.onerror = function()
            {
                xhrFailureCallback(request.statusText, request.status)
            };
            request.send(serializedEvent.requestBody)
        }
        else if (requestMechanism === "XDomainRequest")
        {
            var xdr = new window.XDomainRequest;
            xdr.onload = function()
            {
                xhrSuccessCallback(serializedEvent.requestSrc, translatedEvents)
            };
            xdr.onerror = function()
            {
                xdrFailureCallback(xdr)
            };
            xdr.open("POST", config.endpoint);
            xdr.send(serializedEvent.requestBody)
        }
        else
        {
            awa.logger.logError("No event is sent.")
        }
    }
    function sendThroughBeacon(translatedEvents)
    {
        var serializedEvent = serializeEventForPost(translatedEvents);
        if (navigator.sendBeacon(config.endpoint + serializedEvent.qp, serializedEvent.requestBody))
        {
            xhrSuccessCallback(serializedEvent.requestSrc, translatedEvents)
        }
        else
        {
            sendThroughPost(translatedEvents)
        }
    }
    function sendThroughScript(scriptSrc, event)
    {
        var head = document.head || document.getElementsByTagName("head")[0] || document.documentElement;
        var script = document.createElement("script");
        script.onload = function()
        {
            xhrSuccessCallback(scriptSrc, event, true)
        };
        script.onerror = function()
        {
            modeOneFirstEventSent();
            awa.writeEvent(event)
        };
        script.async = true;
        script.src = scriptSrc;
        head.appendChild(script)
    }
    function getSignedInStatus()
    {
        if (config.callback && typeof(config.callback.signedinStatus) === "function")
        {
            return config.callback.signedinStatus()
        }
        else
        {
            return config.isLoggedIn
        }
    }
    function iframeCallback()
    {
        setTimeout(modeOneFirstEventSent, 3000)
    }
    awa.sendEventThroughIframe = function(frameSrc)
    {
        var frame = document.createElement("iframe");
        frame.id = "telframe";
        frame.style.display = "none";
        if (frame.addEventListener)
        {
            frame.addEventListener("load", iframeCallback)
        }
        else
        {
            frame.attachEvent("onload", iframeCallback)
        }
        frame.src = frameSrc;
        document.body.appendChild(frame)
    };
    awa._registerSchemas = function(schemas)
    {
        for (var i = 0; i < schemas.length; i++)
        {
            awa._schemas[schemas[i].name] = schemas[i]
        }
    };
    awa.console = window.console || {};
    awa.console.fallback = awa.console.log || function(){};
    var logTypes = ["log", "info", "warn", "error", "trace"];
    for (var i = 0; i < logTypes.length; i++)
    {
        var m = logTypes[i];
        if (!awa.console[m])
        {
            awa.console[m] = awa.console.fallback
        }
    }
    function isOldIEBrowser()
    {
        var newerBrowserVersion = 9;
        var ua = utils.getUserAgent();
        var msie = ua.indexOf("MSIE ");
        if (msie > 0)
        {
            return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10) < newerBrowserVersion
        }
        return false
    }
    awa.extendCoreData = function(data)
    {
        utils.removeInvalidElements(data);
        config.coreData = utils.extend(true, config.coreData, data)
    };
    awa._validateAndTranslateEvent = function(eventObject)
    {
        return {event: eventObject}
    };
    awa.testHook = {
        JSLL_VERSION: JSLL_VERSION, defaultConfig: function()
            {
                return config
            }, setAllowedGetLength: function(len)
            {
                allowedGetLength = len
            }, testUsePost: false, getAllowedGetLength: function()
            {
                return allowedGetLength
            }, getQueryFromJSON: getQueryFromJSON
    }
})();
awa._registerSchemas([{
        name: "Ms.Cll.Javascript.CorsDisallowed", "Ms.Cll.Javascript.CorsDisallowed": {
                part: "C", def: {fields: [{
                                req: true, name: "eventName", type: "string"
                            }, {
                                name: "pageName", type: "string"
                            }, {
                                name: "market", type: "string"
                            }, {
                                name: "uri", type: "string"
                            }, {
                                name: "impressionGuid", type: "string"
                            }, {
                                name: "serverImpressionGuid", type: "string"
                            }]}
            }
    }, {
        name: "Ms.Cll.Javascript.EventTooLong", "Ms.Cll.Javascript.EventTooLong": {
                part: "C", def: {fields: [{
                                req: true, name: "eventName", type: "string"
                            }, {
                                req: true, name: "payloadLength", type: "int32"
                            }, {
                                name: "pageName", type: "string"
                            }, {
                                name: "market", type: "string"
                            }, {
                                name: "uri", type: "string"
                            }, {
                                name: "impressionGuid", type: "string"
                            }, {
                                name: "serverImpressionGuid", type: "string"
                            }]}
            }
    }, {
        name: "Ms.Cll.Javascript.Error", "Ms.Telemetry.Error": {
                part: "B", def: {fields: [{
                                name: "errorName", type: "string"
                            }, {
                                name: "errorMessage", type: "string"
                            }, {
                                name: "severity", type: "int32"
                            }, {
                                name: "errorType", type: "string"
                            }, {
                                name: "errorCode", type: "int32"
                            }, {
                                name: "lineNumber", type: "uint32"
                            }, {
                                name: "isDisplayed", type: "bool"
                            }, {
                                name: "errorLocation", type: "string"
                            }, {
                                name: "errorMethod", type: "string"
                            }]}
            }, "Ms.Cll.Javascript.Error": {
                part: "C", def: {fields: [{
                                req: true, name: "code", type: "int32"
                            }, {
                                req: true, name: "message", type: "string"
                            }, {
                                name: "pageName", type: "string"
                            }, {
                                name: "market", type: "string"
                            }, {
                                name: "uri", type: "string"
                            }, {
                                name: "impressionGuid", type: "string"
                            }, {
                                name: "serverImpressionGuid", type: "string"
                            }]}
            }
    }, {
        name: "Ms.Cll.Javascript.EventDropped", "Ms.Cll.Javascript.EventDropped": {
                part: "C", def: {fields: [{
                                req: true, name: "eventName", type: "string"
                            }, {
                                name: "pageName", type: "string"
                            }, {
                                name: "market", type: "string"
                            }, {
                                name: "uri", type: "string"
                            }, {
                                name: "impressionGuid", type: "string"
                            }, {
                                name: "serverImpressionGuid", type: "string"
                            }, {
                                name: "droppedInfo", type: "string"
                            }]}
            }
    }, {
        name: "Ms.Webi.ClientError", "Ms.Webi.ClientError": {
                part: "B", def: {fields: [{
                                req: true, name: "errorInfo", type: "string"
                            }, {
                                name: "wasDisplayed", type: "bool"
                            }, {
                                name: "customSessionGuid", type: "string"
                            }, {
                                name: "impressionGuid", type: "string"
                            }, {
                                name: "serverImpressionGuid", type: "string"
                            }, {
                                name: "pageName", type: "string"
                            }, {
                                name: "market", type: "string"
                            }, {
                                name: "uri", type: "string"
                            }, {
                                name: "errorName", type: "string"
                            }, {
                                name: "errorMessage", type: "string"
                            }, {
                                name: "severity", type: "int32"
                            }, {
                                name: "errorType", type: "string"
                            }, {
                                name: "errorCode", type: "int32"
                            }, {
                                name: "lineNumber", type: "uint32"
                            }, {
                                name: "isDisplayed", type: "bool"
                            }, {
                                name: "errorLocation", type: "string"
                            }, {
                                name: "errorMethod", type: "string"
                            }]}
            }
    }, {
        name: "Ms.Webi.OutgoingRequest", "Ms.Qos.OutgoingServiceRequest": {
                part: "B", def: {fields: [{
                                req: true, name: "operationName", type: "string"
                            }, {
                                name: "targetUri", type: "string"
                            }, {
                                req: true, name: "latencyMs", type: "int32"
                            }, {
                                name: "serviceErrorCode", type: "int32"
                            }, {
                                req: true, name: "succeeded", type: "bool"
                            }, {
                                name: "requestMethod", type: "string"
                            }, {
                                name: "responseContentType", type: "string"
                            }, {
                                name: "protocol", type: "string"
                            }, {
                                name: "protocolStatusCode", type: "string"
                            }, {
                                req: true, name: "dependencyOperationName", type: "string"
                            }, {
                                name: "dependencyOperationVersion", type: "string"
                            }, {
                                req: true, name: "dependencyName", type: "string"
                            }, {
                                name: "dependencyType", type: "string"
                            }, {
                                name: "responseSizeBytes", type: "int32"
                            }, {
                                name: "requestStatus", type: "int32"
                            }]}
            }, "Ms.Webi.OutgoingRequest": {
                part: "C", def: {fields: [{
                                name: "customSessionGuid", type: "string"
                            }, {
                                name: "impressionGuid", type: "string"
                            }, {
                                name: "message", type: "string"
                            }, {
                                name: "retryCount", type: "int32"
                            }, {
                                name: "customData", type: "string"
                            }, {
                                name: "serverImpressionGuid", type: "string"
                            }, {
                                name: "pageName", type: "string"
                            }, {
                                name: "market", type: "string"
                            }, {
                                name: "uri", type: "string"
                            }]}
            }
    }, {
        name: "Ms.Webi.PageView", "Ms.Content.PageView": {
                part: "B", def: {fields: [{
                                name: "ver", type: "string"
                            }, {
                                req: true, name: "impressionGuid", type: "string"
                            }, {
                                req: true, name: "pageName", type: "string"
                            }, {
                                name: "uri", type: "string"
                            }, {
                                name: "referrerUri", type: "string"
                            }, {
                                name: "pageType", type: "string"
                            }, {
                                name: "pageTags", type: "string"
                            }, {
                                name: "product", type: "string"
                            }, {
                                name: "screenState", type: "int32"
                            }, {
                                name: "actionType", type: "string"
                            }, {
                                name: "behavior", type: "int32"
                            }, {
                                name: "resHeight", type: "int32"
                            }, {
                                name: "resWidth", type: "int32"
                            }, {
                                name: "vpHeight", type: "int32"
                            }, {
                                name: "vpWidth", type: "int32"
                            }, {
                                name: "market", type: "string"
                            }]}
            }, "Ms.Webi.PageView": {
                part: "C", def: {fields: [{
                                name: "cookieEnabled", type: "bool"
                            }, {
                                name: "flashInstalled", type: "bool"
                            }, {
                                name: "flashVersion", type: "string"
                            }, {
                                name: "cookies", type: "string"
                            }, {
                                name: "isJs", type: "bool"
                            }, {
                                name: "title", type: "string"
                            }, {
                                name: "isLoggedIn", type: "bool"
                            }, {
                                name: "isManual", type: "bool"
                            }, {
                                name: "serverImpressionGuid", type: "string"
                            }]}
            }
    }, {
        name: "Ms.Webi.ContentUpdate", "Ms.Content.ContentUpdate": {
                part: "B", def: {fields: [{
                                name: "ver", type: "string"
                            }, {
                                req: true, name: "impressionGuid", type: "string"
                            }, {
                                req: true, name: "pageName", type: "string"
                            }, {
                                name: "uri", type: "string"
                            }, {
                                name: "pageTags", type: "string"
                            }, {
                                name: "pageHeight", type: "int32"
                            }, {
                                name: "vpHeight", type: "int32"
                            }, {
                                name: "vpWidth", type: "int32"
                            }, {
                                name: "market", type: "string"
                            }, {
                                name: "actionType", type: "string"
                            }, {
                                name: "behavior", type: "int32"
                            }, {
                                name: "vScrollOffset", type: "int32"
                            }, {
                                name: "hScrollOffset", type: "int32"
                            }, {
                                name: "contentVer", type: "string"
                            }, {
                                req: true, name: "content", type: "string"
                            }]}
            }, "Ms.Webi.ContentUpdate": {
                part: "C", def: {fields: [{
                                name: "pageLoadTime", type: "int32"
                            }, {
                                name: "title", type: "string"
                            }, {
                                name: "isJs", type: "bool"
                            }, {
                                name: "cookieEnabled", type: "bool"
                            }, {
                                name: "isLoggedIn", type: "bool"
                            }, {
                                name: "isManual", type: "bool"
                            }, {
                                name: "isDomComplete", type: "bool"
                            }, {
                                name: "serverImpressionGuid", type: "string"
                            }, {
                                name: "timings", type: "string"
                            }]}
            }
    }, {
        name: "Ms.Webi.PageAction", "Ms.Content.PageAction": {
                part: "B", def: {fields: [{
                                name: "ver", type: "string"
                            }, {
                                req: true, name: "impressionGuid", type: "string"
                            }, {
                                req: true, name: "pageName", type: "string"
                            }, {
                                name: "uri", type: "string"
                            }, {
                                name: "destUri", type: "string"
                            }, {
                                name: "market", type: "string"
                            }, {
                                name: "pageType", type: "string"
                            }, {
                                name: "pageTags", type: "string"
                            }, {
                                name: "product", type: "string"
                            }, {
                                name: "screenState", type: "int32"
                            }, {
                                name: "actionType", type: "string"
                            }, {
                                name: "behavior", type: "int32"
                            }, {
                                name: "contentVer", type: "string"
                            }, {
                                name: "content", type: "string"
                            }]}
            }, "Ms.Webi.PageAction": {
                part: "C", def: {fields: [{
                                name: "timeToAction", type: "int32"
                            }, {
                                name: "cookieEnabled", type: "bool"
                            }, {
                                name: "cookies", type: "string"
                            }, {
                                name: "isJs", type: "bool"
                            }, {
                                name: "title", type: "string"
                            }, {
                                name: "referrerUri", type: "string"
                            }, {
                                name: "isLoggedIn", type: "bool"
                            }, {
                                name: "isManual", type: "bool"
                            }, {
                                name: "serverImpressionGuid", type: "string"
                            }]}
            }
    }, {
        name: "Ms.Webi.PageUnload", "Ms.Content.PageUnload": {
                part: "B", def: {fields: [{
                                name: "ver", type: "string"
                            }, {
                                req: true, name: "impressionGuid", type: "string"
                            }, {
                                req: true, name: "pageName", type: "string"
                            }, {
                                name: "uri", type: "string"
                            }]}
            }, "Ms.Webi.PageUnload": {
                part: "C", def: {fields: [{
                                name: "dwellTime", type: "int32"
                            }, {
                                name: "scrollDepth", type: "string"
                            }, {
                                name: "serverImpressionGuid", type: "string"
                            }, {
                                name: "timings", type: "string"
                            }]}
            }
    }]);
awa.isEventValid = (function(event)
{
    var logWarning = awa.logger.logWarning;
    function logAndSend(overrideValues, isDropped)
    {
        var details = overrideValues.eventName + " - " + overrideValues.droppedInfo;
        if (isDropped)
        {
            logWarning("Dropped event " + details);
            awa.ct.captureEventDrop(overrideValues)
        }
        else
        {
            logWarning("Dropped field from " + details)
        }
    }
    function isInArray(array, obj)
    {
        for (var i = 0; i < array.length; i++)
        {
            if (array[i] == obj)
            {
                return true
            }
        }
        return false
    }
    function validatePart(part, partSchema)
    {
        var partFields = [];
        var schemaFields = [];
        var numberOfFields = partSchema.length;
        for (var fieldIndex = 0; fieldIndex < numberOfFields; fieldIndex++)
        {
            var field = partSchema[fieldIndex];
            var fieldName = field.name;
            schemaFields.push(fieldName);
            var fieldType = field.type;
            var fieldValue = part[fieldName];
            var required = field.req;
            if (!awa.utils.isValueAssigned(fieldValue))
            {
                if (required === true)
                {
                    logAndSend({
                        eventName: eventName, droppedInfo: "Missing field: " + fieldName
                    }, true);
                    return false
                }
            }
            else if (!awa.utils.isOfCorrectType(fieldType, fieldValue))
            {
                logAndSend({
                    eventName: eventName, droppedInfo: "Incorrect type: " + fieldName
                }, required);
                if (required === true)
                {
                    return false
                }
                else
                {
                    delete part[fieldName]
                }
            }
        }
        var numberOfpartFieldsInEvent = partFields.length;
        for (var partField in part)
        {
            if (!(partField == "baseData" || partField == "baseType"))
            {
                if (!isInArray(schemaFields, partField))
                {
                    logAndSend({
                        eventName: eventName, droppedInfo: "Unexpected field " + partField
                    }, false);
                    delete part[partField]
                }
            }
        }
        return true
    }
    if (event)
    {
        var eventName = event.name;
        var schemas = awa._schemas;
        var partBName = event.data.baseType;
        var partCName = eventName;
        var thisEventSchema = schemas[eventName];
        if (thisEventSchema)
        {
            if (partBName)
            {
                var partB = event.data.baseData;
                var partBSchema = thisEventSchema[partBName] ? thisEventSchema[partBName].def.fields : undefined;
                if (partB && partBSchema)
                {
                    if (!validatePart(partB, partBSchema))
                    {
                        return false
                    }
                }
            }
            if (partCName)
            {
                var partC = event.data;
                var partCSchema = thisEventSchema[partCName] ? thisEventSchema[partCName].def.fields : undefined;
                if (partC && partCSchema)
                {
                    if (!validatePart(partC, partCSchema))
                    {
                        return false
                    }
                }
            }
        }
        else
        {
            logAndSend({
                eventName: eventName, droppedInfo: "Not registered in JSLL"
            }, true);
            return false
        }
        return true
    }
    else
    {
        return false
    }
});
awa.translateEventFromIntermediateStructure = (function(oldEvent)
{
    var eventName = oldEvent.name;
    var oldEventData = oldEvent.data;
    var utils = awa.utils;
    if (utils.isValueAssigned(oldEventData[eventName]))
    {
        var oldPartC = utils.extend(true, oldEventData[eventName]);
        delete oldEventData[eventName];
        var keysInData = [];
        for (var key in oldEventData)
        {
            keysInData.push(key)
        }
        var oldPartB = utils.extend(true, oldEventData[keysInData[0]]);
        delete oldEventData[keysInData[0]];
        delete oldEvent.content;
        var data = utils.extend(true, JSON.stringify(oldPartB) !== "{}" ? {baseData: oldPartB} : {}, oldPartC, {baseType: keysInData[0]});
        var returnObject = utils.extend(true, oldEvent, {data: data});
        return returnObject
    }
    else
    {
        return oldEvent
    }
});
awa.ix = (function()
{
    var configIx = {};
    var mc1 = "";
    var anid = "";
    var isAssigned = awa.utils.isValueAssigned;
    function init(config)
    {
        configIx = config.ix
    }
    function getAdobeUrl()
    {
        var mc1IdKey = "88170%01";
        var anidKey = "88169%01";
        var qpSeparation = "%01";
        var versionAndSuffix = "&d_ver=2";
        var authStatus = "%010";
        if (isAssigned(mc1) || isAssigned(anid))
        {
            return "https://dpm.demdex.net/id?d_orgid=A5FF776A5245AF830A490D44@AdobeOrg&d_cid=" + (isAssigned(mc1) ? mc1IdKey + mc1 + authStatus : "") + (isAssigned(anid) ? (isAssigned(mc1) ? qpSeparation : "") + anidKey + anid + authStatus : "") + versionAndSuffix
        }
        else
        {
            return undefined
        }
    }
    function getGoogleUrl()
    {
        if (isAssigned(mc1))
        {
            return "https://ad.doubleclick.net/ddm/activity/src=6952136;type=store0;cat=jsll;u58=" + mc1 + ";dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=1?"
        }
        return undefined
    }
    function receiveIdsFromVortex(ids)
    {
        if (ids)
        {
            mc1 = ids.mc1;
            anid = ids.anid;
            if (isAssigned(mc1) || isAssigned(anid))
            {
                if (configIx.a)
                {
                    var request = new XMLHttpRequest;
                    request.onreadystatechange = function()
                    {
                        if (request.readyState == 4 && request.status == 200)
                        {
                            awa.ct.captureSwap(JSON.parse(request.responseText))
                        }
                    };
                    var requestSrc = getAdobeUrl();
                    if (isAssigned(requestSrc))
                    {
                        request.open("GET", requestSrc, true);
                        request.setRequestHeader("Accept", "application/json; charset=utf-8");
                        request.send()
                    }
                }
                if (configIx.g)
                {
                    var requestSrc = getGoogleUrl();
                    if (isAssigned(requestSrc))
                    {
                        var newImage = new Image;
                        newImage.src = requestSrc
                    }
                }
            }
        }
    }
    ;
    return {
            init: init, set: receiveIdsFromVortex, testHook: {
                    getAdobeUrl: getAdobeUrl, getGoogleUrl: getGoogleUrl, setMc1: function(newMc1)
                        {
                            mc1 = newMc1
                        }, setAnid: function(newAnid)
                        {
                            anid = newAnid
                        }
                }
        }
})();
awa.ct = (function()
{
    var MSCONTENT_PARTB_VERSION = "1.0";
    var CONTENT_VERSION = "2.0";
    var MAX_CONTENTNAME_LENGTH = 200;
    var IS_SENSITIVE_FLAG = 0x080000;
    var config = {};
    var autoCapture = {};
    var cookie = awa.cookie;
    var errorHandler = awa.errorHandler;
    var ids = awa.ids;
    var vortexEvents = awa.vortexEvents;
    var utils = awa.utils;
    var actionTypeEnum = awa.actionType;
    var maxScroll = {
            h: 0, v: 0
        };
    var doNotTrackFieldName = "data-bi-dnt";
    var isPageUnloadFired = false;
    var contentBlobFieldNameObjects = {
            longNames: {
                isShortNames: false, id: "data-bi-id", areaName: "data-bi-area", slotNumber: "data-bi-slot", contentName: "data-bi-name", contentSource: "data-bi-source", templateName: "data-bi-view", productId: "data-bi-product", contentType: "data-bi-type"
            }, shortNames: {
                    isShortNames: true, id: "data-bi-id", areaName: "data-bi-an", slotNumber: "data-bi-sn", contentName: "data-bi-cn", contentSource: "data-bi-cs", templateName: "data-bi-tn", productId: "data-bi-pid", contentType: "data-bi-ct"
                }
        };
    var contentBlobFieldNames = contentBlobFieldNameObjects.longNames;
    var clickCaptureInputTypes = {
            BUTTON: true, CHECKBOX: true, RADIO: true, RESET: true, SUBMIT: true
        };
    function init(inputConfig)
    {
        if (!awa.isAvailable)
        {
            return
        }
        config = inputConfig;
        autoCapture = config.autoCapture;
        contentBlobFieldNames = config.useShortNameForContentBlob === true ? contentBlobFieldNameObjects.shortNames : contentBlobFieldNameObjects.longNames;
        if (autoCapture.pageView)
        {
            sendPageView({isAuto: true})
        }
        if (autoCapture.click)
        {
            if (window.addEventListener)
            {
                var event = (navigator.appVersion.indexOf("MSIE") !== -1) ? "click" : "mousedown";
                window.addEventListener(event, processClick, false);
                window.addEventListener("keyup", processClick, false)
            }
            else if (document.attachEvent)
            {
                document.attachEvent("onclick", processClick);
                document.attachEvent("keyup", processClick)
            }
        }
        if (autoCapture.jsError)
        {
            errorHandler.init()
        }
        if (autoCapture.scroll)
        {
            var processScroll = debounce(null, function()
                {
                    sendContentUpdate({
                        isAuto: true, actionType: awa.actionType.SCROLL
                    })
                }, config.debounceMs.scroll);
            if (window.addEventListener)
            {
                window.addEventListener("scroll", processScroll)
            }
            else if (window.attachEvent)
            {
                window.attachEvent("onscroll", processScroll)
            }
        }
        if (autoCapture.resize)
        {
            var processResize = debounce(function()
                {
                    sendContentUpdate({
                        isAuto: true, actionType: awa.actionType.RESIZE
                    })
                }, null, config.debounceMs.resize);
            if (window.addEventListener)
            {
                window.addEventListener("resize", processResize)
            }
            else if (window.attachEvent)
            {
                window.attachEvent("onresize", processResize)
            }
        }
        if (autoCapture.onUnload || config.manualPageUnload)
        {
            var getMaxScrollDepth = function()
                {
                    var currentScroll = getScrollOffset();
                    maxScroll.v = maxScroll.v > currentScroll.v ? maxScroll.v : currentScroll.v
                };
            if (window.addEventListener)
            {
                window.addEventListener("scroll", getMaxScrollDepth)
            }
            else if (window.attachEvent)
            {
                window.attachEvent("onscroll", getMaxScrollDepth)
            }
        }
        if (autoCapture.onUnload)
        {
            if (window.addEventListener)
            {
                window.addEventListener("beforeunload", sendPageUnload);
                window.addEventListener("unload", sendPageUnload)
            }
            else if (window.attachEvent)
            {
                window.attachEvent("onbeforeunload", sendPageUnload);
                window.attachEvent("onunload", sendPageUnload)
            }
        }
        if (config.sendMode == 2)
        {
            var sendBatched = awa.vortexEvents.batchQueuedEvents;
            if (window.addEventListener)
            {
                window.addEventListener("beforeunload", sendBatched);
                window.addEventListener("unload", sendBatched)
            }
            else if (window.attachEvent)
            {
                window.attachEvent("onbeforeunload", sendBatched);
                window.attachEvent("onunload", sendBatched)
            }
        }
        onDomReadyDo(awa.ct.domReadyTasksWrapper)
    }
    function onDomReadyDo(f)
    {
        /in/.test(document.readyState) ? setTimeout("awa.ct.onDomReadyDo(" + f + ")", 9) : f.call()
    }
    function domReadyTasks()
    {
        if (config.syncMuid)
        {
            syncupMuid()
        }
        if (autoCapture.onLoad)
        {
            if (document.readyState === "complete")
            {
                sendAutoContentUpdate()
            }
            else
            {
                if (window.addEventListener)
                {
                    window.addEventListener("load", sendAutoContentUpdate)
                }
                else if (window.attachEvent)
                {
                    window.attachEvent("onload", sendAutoContentUpdate)
                }
            }
        }
    }
    function domReadyTasksWrapper()
    {
        awa.ct.domReadyTasks()
    }
    function getPageName()
    {
        if (config.callback && typeof(config.callback.pageName) === "function")
        {
            return config.callback.pageName()
        }
        else if (config.coreData.pageName)
        {
            return config.coreData.pageName
        }
        else
        {
            var pagename = window.location.pathname;
            var framents = pagename.split("/");
            if (framents.length > 2 && framents[2] !== "")
            {
                pagename = framents[2]
            }
            else
            {
                pagename = "Home"
            }
            return pagename
        }
    }
    function syncupMuid()
    {
        var muidHost = utils.getMuidHost(config.muidDomain || "microsoft.com");
        if (muidHost)
        {
            var muidsrc = (window.location.protocol || "http:") + "//" + muidHost + "/c.gif?DI=4050&did=1&t=";
            var img = document.createElement("IMG");
            img.style.display = "none";
            img.src = muidsrc;
            img.hidden = "";
            img["aria-hidden"] = "true";
            img.role = "presentation"
        }
        else
        {
            awa.logger.logWarning("Unable to get a muid host for the configured muidDomain '" + config.muidDomain + "'.  Unable to sync muid")
        }
    }
    function isRightClick(evt)
    {
        if ("which" in evt)
        {
            return (evt.which === 3)
        }
        else if ("button" in evt)
        {
            return (evt.button === 2)
        }
    }
    function isLeftClick(evt)
    {
        if ("which" in evt)
        {
            return (evt.which === 1)
        }
        else if ("button" in evt)
        {
            return (evt.button === 1)
        }
    }
    function isKeyboardEnter(evt)
    {
        if ("keyCode" in evt)
        {
            return (evt.keyCode === 13)
        }
    }
    function isKeyboardSpace(evt)
    {
        if ("keyCode" in evt)
        {
            return (evt.keyCode === 32)
        }
    }
    function processClick(event)
    {
        var clickCaptureElements = {
                A: true, BUTTON: true, AREA: true, INPUT: true
            };
        var evt = event || window.event;
        var e = evt.srcElement || evt.target;
        var overrideValues = {isAuto: true};
        if (isRightClick(evt))
        {
            overrideValues.behavior = awa.behavior.CONTEXTMENU;
            overrideValues.actionType = actionTypeEnum.CLICKRIGHT
        }
        else if (isLeftClick(evt))
        {
            overrideValues.actionType = actionTypeEnum.CLICKLEFT
        }
        else if (isKeyboardEnter(evt))
        {
            overrideValues.actionType = actionTypeEnum.KEYBOARDENTER
        }
        else if (isKeyboardSpace(evt))
        {
            overrideValues.actionType = actionTypeEnum.KEYBOARDSPACE
        }
        else
        {
            return
        }
        while (e && e.tagName)
        {
            if (!clickCaptureElements[e.tagName.toUpperCase()])
            {
                e = e.parentElement || e.parentNode;
                continue
            }
            else
            {
                var sendEvent = e.tagName.toUpperCase() === "INPUT" ? clickCaptureInputTypes[e.type.toUpperCase()] : true;
                if (sendEvent)
                {
                    if (!isElementDnt(e))
                    {
                        sendClickEvent(e, overrideValues)
                    }
                }
                break
            }
        }
    }
    function isElementDnt(element)
    {
        var dntElement = utils.findClosestByAttribute(element, doNotTrackFieldName);
        if (!utils.isValueAssigned(dntElement))
        {
            return false
        }
        return true
    }
    function debounce(firstCallFunction, secondCallFunction, wait)
    {
        var timeout;
        return function()
            {
                var context = this,
                    args = arguments;
                var later = function()
                    {
                        timeout = null;
                        if (secondCallFunction)
                        {
                            secondCallFunction.apply(context, args)
                        }
                    };
                var callNow = !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow)
                {
                    if (firstCallFunction)
                    {
                        firstCallFunction.apply(context, args)
                    }
                }
            }
    }
    function sendPageView(overrideValues)
    {
        resetPageUnloadProperties();
        var eventData = {};
        var pageTags = awa.utils.extend(true, config.coreData.pageTags);
        pageTags.metaTags = collectMetaTagsAndSetEventProperty(eventData, true);
        setEnabledFeatures(pageTags);
        if (typeof(config.callback.pageViewPageTags) === "function")
        {
            pageTags = utils.extend(true, pageTags, config.callback.pageViewPageTags())
        }
        var screenRes = getScreenResolution();
        var pageViewEvent = {
                name: "Ms.Webi.PageView", data: {
                        baseData: {
                            ver: MSCONTENT_PARTB_VERSION, impressionGuid: ids.getPageViewImpressionGuid(), pageName: getPageName(), uri: getUri(), referrerUri: config.coreData.referrerUri, market: eventData.market, pageType: eventData.pageType, product: eventData.product, resHeight: screenRes.h, resWidth: screenRes.w, pageTags: pageTags, behavior: eventData.behavior ? eventData.behavior : awa.behavior.UNDEFINED
                        }, baseType: "Ms.Content.PageView", cookieEnabled: getCookieEnabled(), cookies: getClientCookies(), isJs: true, title: utils.getTitle(), isLoggedIn: config.isLoggedIn, serverImpressionGuid: eventData.serverImpressionGuid, isManual: true
                    }, flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
            };
        if (config.autoCapture.addin)
        {
            var flashInfo = getFlashInfo();
            pageViewEvent.data.flashInstalled = flashInfo["installed"] || false;
            pageViewEvent.data.flashVersion = flashInfo["version"] || ""
        }
        sendEventAfterOverridesAndStringify(pageViewEvent, overrideValues, pageTags, eventData, true)
    }
    function sendAutoContentUpdate()
    {
        sendContentUpdate({
            isAuto: true, isDomComplete: true
        })
    }
    function sendContentUpdate(overrideValues)
    {
        var eventData = {};
        var pageTags = awa.utils.extend(true, config.coreData.pageTags);
        pageTags.metaTags = collectMetaTagsAndSetEventProperty(eventData);
        setEnabledFeatures(pageTags);
        if (overrideValues && overrideValues.isDomComplete)
        {
            if (autoCapture.perf === true)
            {
                if (window.performance)
                {
                    if (window.performance.timing)
                    {
                        pageTags.timing = utils.stringifyField("timing", window.performance.timing)
                    }
                    if (autoCapture.assets === true)
                    {
                        var perfData = utils.getPerformanceData();
                        if (perfData)
                        {
                            pageTags.AssetPerformance = utils.stringifyField("AssetPerformance", perfData)
                        }
                    }
                }
            }
        }
        if (typeof(config.callback.contentUpdatePageTags) === "function")
        {
            pageTags = utils.extend(true, pageTags, config.callback.contentUpdatePageTags())
        }
        var viewportDim = getViewportDimensions();
        var scrollOffset = getScrollOffset();
        var viewportBoundingRect = getViewportBoundingRect(viewportDim);
        var contentUpdateEvent = {
                name: "Ms.Webi.ContentUpdate", data: {
                        baseData: {
                            ver: MSCONTENT_PARTB_VERSION, impressionGuid: ids.getImpressionGuid(), pageName: getPageName(), uri: getUri(), market: eventData.market, pageTags: pageTags, pageHeight: document.body.scrollHeight, vpHeight: viewportDim.h, vpWidth: viewportDim.w, behavior: eventData.behavior ? eventData.behavior : awa.behavior.UNDEFINED, vScrollOffset: scrollOffset.v, hScrollOffset: scrollOffset.h, contentVer: CONTENT_VERSION, content: getPageContent(viewportBoundingRect)
                        }, baseType: "Ms.Content.ContentUpdate", title: utils.getTitle(), cookieEnabled: getCookieEnabled(), isJs: true, isManual: true, isDomComplete: false, isLoggedIn: config.isLoggedIn, serverImpressionGuid: eventData.serverImpressionGuid
                    }, flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
            };
        sendEventAfterOverridesAndStringify(contentUpdateEvent, overrideValues, pageTags, eventData, false)
    }
    function sendCustomClickEvent(overrideValues)
    {
        sendClickEvent(null, overrideValues)
    }
    function sendElementClickEvent(element, overrideValues)
    {
        sendClickEvent(element, overrideValues)
    }
    function sendClickEvent(element, overrideValues)
    {
        var eventData = {};
        var pageTags = awa.utils.extend(true, config.coreData.pageTags);
        var elementContent = {};
        element = utils.returnDomObjectIfjQuery(element);
        if (element)
        {
            eventData.targetUri = getClickTarget(element);
            elementContent = getElementContent(element, true);
            if (autoCapture.msTags)
            {
                elementContent = utils.extend(elementContent, getCustomTags(element))
            }
            if (elementContent.bhvr)
            {
                eventData.behavior = getValidBehavior(utils.extractFieldFromObject(elementContent, "bhvr"))
            }
        }
        pageTags.metaTags = collectMetaTagsAndSetEventProperty(eventData);
        setEnabledFeatures(pageTags);
        if (typeof(config.callback.pageActionPageTags) === "function")
        {
            pageTags = utils.extend(true, pageTags, config.callback.pageActionPageTags(element))
        }
        var pageActionContentTags = config.callback.pageActionContentTags;
        var pageActionEvent = {
                name: "Ms.Webi.PageAction", data: {
                        baseData: {
                            ver: MSCONTENT_PARTB_VERSION, impressionGuid: ids.getImpressionGuid(), pageName: getPageName(), uri: getUri(), pageTags: pageTags, contentVer: CONTENT_VERSION, market: eventData.market, destUri: eventData.targetUri, pageType: eventData.pageType, product: eventData.product, actionType: eventData.actionType, behavior: eventData.behavior, content: utils.bracketIt(JSON.stringify(utils.extend(elementContent, typeof pageActionContentTags === "function" ? pageActionContentTags(element) : {}, overrideValues && overrideValues.contentTags ? overrideValues.contentTags : {})))
                        }, baseType: "Ms.Content.PageAction", timeToAction: getTimeToClick(), cookieEnabled: getCookieEnabled(), cookies: getClientCookies(), isJs: true, title: utils.getTitle(), isLoggedIn: config.isLoggedIn, isManual: true, referrerUri: config.coreData.referrerUri, serverImpressionGuid: eventData.serverImpressionGuid
                    }, flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
            };
        sendEventAfterOverridesAndStringify(pageActionEvent, overrideValues, pageTags, eventData, true)
    }
    function resetPageUnloadProperties()
    {
        awa.timespanHandler.recordTimeSpan("dwellTime", false);
        maxScroll.v = 0;
        isPageUnloadFired = false
    }
    function sendPageUnload()
    {
        if (!isPageUnloadFired)
        {
            isPageUnloadFired = true;
            var eventData = {};
            collectMetaTagsAndSetEventProperty(eventData);
            var timingsCallback = config.callback.pageUnloadTimings;
            var pageUnloadEvent = {
                    name: "Ms.Webi.PageUnload", data: {
                            baseData: {
                                ver: MSCONTENT_PARTB_VERSION, impressionGuid: ids.getImpressionGuid(), pageName: getPageName()
                            }, baseType: "Ms.Content.PageUnload", dwellTime: awa.timespanHandler.recordTimeSpan("dwellTime", true), scrollDepth: maxScroll.v.toString() + "/" + document.body.scrollHeight.toString(), serverImpressionGuid: eventData.serverImpressionGuid, timings: timingsCallback ? timingsCallback() : undefined
                        }, flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
                };
            sendEventAfterOverridesAndStringify(pageUnloadEvent, undefined, undefined, eventData, true)
        }
    }
    function sendClientError(overrideValues)
    {
        if (overrideValues)
        {
            var eventData = {};
            collectMetaTagsAndSetEventProperty(eventData);
            var clientErrorEvent = {
                    name: "Ms.Webi.ClientError", data: {
                            errorInfo: JSON.stringify(overrideValues.errorInfo), wasDisplayed: overrideValues.displayedToUser || false, customSessionGuid: ids.getSessionId(), impressionGuid: ids.getImpressionGuid(), pageName: getPageName(), uri: getUri(), market: eventData.market, serverImpressionGuid: eventData.serverImpressionGuid
                        }, flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
                };
            sendEventAfterOverridesAndStringify(clientErrorEvent, undefined, undefined, eventData, false)
        }
    }
    function sendCorsDisallowed(overrideValues)
    {
        if (overrideValues)
        {
            var eventData = {};
            collectMetaTagsAndSetEventProperty(eventData);
            var corsDisallowedEvent = {
                    name: "Ms.Cll.Javascript.CorsDisallowed", data: {
                            eventName: overrideValues.eventName, pageName: getPageName(), uri: getUri(), market: eventData.market, impressionGuid: ids.getImpressionGuid(), serverImpressionGuid: eventData.serverImpressionGuid
                        }, flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
                };
            sendEventAfterOverridesAndStringify(corsDisallowedEvent, undefined, undefined, eventData, false)
        }
    }
    function sendEventTooLong(overrideValues)
    {
        if (overrideValues)
        {
            var eventData = {};
            collectMetaTagsAndSetEventProperty(eventData);
            var eventTooLongEvent = {
                    name: "Ms.Cll.Javascript.EventTooLong", data: {
                            eventName: overrideValues.eventName, payloadLength: overrideValues.payloadLength, pageName: getPageName(), uri: getUri(), market: eventData.market, impressionGuid: ids.getImpressionGuid(), serverImpressionGuid: eventData.serverImpressionGuid
                        }, flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
                };
            sendEventAfterOverridesAndStringify(eventTooLongEvent, undefined, undefined, eventData, false)
        }
    }
    function sendEventDropped(overrideValues)
    {
        if (overrideValues && autoCapture.invalidEvents)
        {
            var eventData = {};
            collectMetaTagsAndSetEventProperty(eventData);
            var eventTooLongEvent = {
                    name: "Ms.Cll.Javascript.EventDropped", data: {
                            eventName: overrideValues.eventName, droppedInfo: overrideValues.droppedInfo, pageName: getPageName(), uri: getUri(), market: eventData.market, impressionGuid: ids.getImpressionGuid(), serverImpressionGuid: eventData.serverImpressionGuid
                        }, flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
                };
            sendEventAfterOverridesAndStringify(eventTooLongEvent, undefined, undefined, eventData, false)
        }
    }
    function sendIdSwap(overrideValues)
    {
        return
    }
    function extendAndSendQos(qosEvent)
    {
        var eventData = {};
        collectMetaTagsAndSetEventProperty(eventData);
        var partC = qosEvent.data;
        partC.market = eventData.market;
        partC.pageName = getPageName();
        partC.uri = getUri();
        sendEventAfterOverridesAndStringify(qosEvent, undefined, undefined, eventData, false)
    }
    function populateOverridesInEvent(event, partB, partC, overrideValues, pageTags)
    {
        if (overrideValues.appId)
        {
            event.appId = overrideValues.appId
        }
        if (overrideValues.behavior)
        {
            partB.behavior = getValidBehavior(overrideValues.behavior)
        }
        if (overrideValues.uri)
        {
            partB.uri = overrideValues.uri
        }
        if (overrideValues.referrerUri)
        {
            if (event.name == "Ms.Webi.PageAction")
            {
                partC.referrerUri = overrideValues.referrerUri
            }
            else
            {
                partB.referrerUri = overrideValues.referrerUri
            }
        }
        if (overrideValues.pageName)
        {
            partB.pageName = overrideValues.pageName
        }
        if (overrideValues.actionType)
        {
            partB.actionType = overrideValues.actionType
        }
        if (overrideValues.pageHeight)
        {
            partB.pageHeight = overrideValues.pageHeight
        }
        if (overrideValues.content)
        {
            partB.content = utils.bracketIt(JSON.stringify(overrideValues.content))
        }
        if (overrideValues.targetUri)
        {
            partB.destUri = overrideValues.targetUri
        }
        if (overrideValues.vScrollOffset)
        {
            partB.vScrollOffset = overrideValues.vScrollOffset
        }
        if (overrideValues.hScrollOffset)
        {
            partB.hScrollOffset = overrideValues.hScrollOffset
        }
        if (overrideValues.pageTags)
        {
            partB.pageTags = utils.extend(true, pageTags, overrideValues.pageTags)
        }
        if (overrideValues.isAuto !== true)
        {
            partC.isManual = true
        }
        else
        {
            partC.isManual = undefined
        }
        if (overrideValues.isDomComplete)
        {
            partC.isDomComplete = overrideValues.isDomComplete;
            partC.pageLoadTime = utils.getPageLoadTime()
        }
        if (overrideValues.pageLoadTime)
        {
            partC.pageLoadTime = overrideValues.pageLoadTime
        }
        if (overrideValues.timings)
        {
            partC.timings = JSON.stringify(overrideValues.timings)
        }
    }
    function sendEventAfterOverridesAndStringify(event, overrideValues, pageTags, eventData, isCritical)
    {
        var partB = event.data.baseData;
        var partC = event.data;
        if (overrideValues)
        {
            populateOverridesInEvent(event, partB, partC, overrideValues, pageTags)
        }
        if (eventData.env)
        {
            event.ext = {app: {env: eventData.env}}
        }
        if (partB && partB.pageTags)
        {
            partB.pageTags = utils.stringifyField("pageTags", partB.pageTags)
        }
        vortexEvents.SendOrScheduleEvent(event, isCritical)
    }
    function getTimeToClick()
    {
        if (window.performance && window.performance.timing)
        {
            var isNavigationStart = window.performance.timing.navigationStart;
            if (isNavigationStart !== 0)
            {
                return (new Date).getTime() - isNavigationStart
            }
        }
        return -1
    }
    function getViewportBoundingRect(viewportDimensions)
    {
        var viewportBoundingRect = {
                top: 0, bottom: viewportDimensions.h, left: 0, right: viewportDimensions.w
            };
        return viewportBoundingRect
    }
    function getPageContent(viewportBoundingRect)
    {
        var arrayOfContents = [];
        var elementsToCapture = document.querySelectorAll(utils.bracketIt(contentBlobFieldNames.areaName) + "," + utils.bracketIt(contentBlobFieldNames.slotNumber) + "," + utils.bracketIt(config.biBlobAttributeTag));
        pushToArrayOfContentsIfVisible(elementsToCapture, arrayOfContents, viewportBoundingRect);
        return JSON.stringify(arrayOfContents)
    }
    function pushToArrayOfContentsIfVisible(elements, arrayOfContents, viewportBoundingRect)
    {
        if (elements)
        {
            for (var i = 0; i < elements.length; i++)
            {
                var element = elements[i];
                if (!isElementDnt(element))
                {
                    if (utils.isElementTrulyVisible(element, viewportBoundingRect))
                    {
                        var elementContent = getElementContent(element, false);
                        if (elementContent)
                        {
                            arrayOfContents.push(elementContent)
                        }
                    }
                }
            }
        }
    }
    function getLineageDetails(element)
    {
        var name = [];
        var identifier = [];
        var lineageDelimiter = ">";
        var elementBiDataAttribute = config.biBlobAttributeTag;
        var elementModuleIdAttribute = "data-module-id";
        var containerName = undefined;
        var nameValue;
        var idValue;
        while (element && element.getAttribute)
        {
            var dataAttr = element.getAttribute(elementBiDataAttribute) || element[elementBiDataAttribute];
            var moduleIdAttribute = element.getAttribute(elementModuleIdAttribute) || element[elementModuleIdAttribute];
            if (dataAttr)
            {
                var telemetryObject = JSON.parse(dataAttr);
                if (telemetryObject)
                {
                    nameValue = telemetryObject.cN || telemetryObject.cT;
                    idValue = telemetryObject.id || undefined;
                    if (nameValue || idValue)
                    {
                        name.push(nameValue);
                        if (moduleIdAttribute)
                        {
                            containerName = nameValue
                        }
                        identifier.push(idValue)
                    }
                }
            }
            else
            {
                nameValue = element.getAttribute(contentBlobFieldNames.contentName) || element.getAttribute(contentBlobFieldNames.contentType);
                idValue = element.getAttribute(contentBlobFieldNames.id) || undefined;
                if (nameValue || idValue)
                {
                    name.push(nameValue);
                    if (moduleIdAttribute)
                    {
                        containerName = nameValue
                    }
                    identifier.push(idValue)
                }
            }
            element = element.parentElement
        }
        var lineageDetails = {
                lineage: name.join(lineageDelimiter), lineageById: identifier.join(lineageDelimiter), lineageContainerName: containerName
            };
        return lineageDetails
    }
    ;
    function getElementContent(element, isPageAction)
    {
        if (!element)
        {
            return ""
        }
        var elementContent = {};
        var biBlobElement = awa.utils.findClosestByAttribute(element, config.biBlobAttributeTag);
        var biBlobValue;
        if (biBlobElement)
        {
            biBlobValue = biBlobElement.getAttribute(config.biBlobAttributeTag)
        }
        if (biBlobValue)
        {
            elementContent = JSON.parse(biBlobValue)
        }
        else
        {
            var contentElement = utils.findClosestByAttribute(element, utils.bracketIt(contentBlobFieldNames.id));
            contentElement = utils.returnDomObjectIfjQuery(element);
            var areaElement = utils.findClosestByAttribute(element, contentBlobFieldNames.areaName);
            var areaContent = awa.utils.extend({}, getAreaContent(areaElement));
            elementContent = {
                id: contentElement.getAttribute(contentBlobFieldNames.id) || element.id || "", aN: areaContent.areaName, sN: contentElement.getAttribute(contentBlobFieldNames.slotNumber), cN: contentElement.getAttribute(contentBlobFieldNames.contentName) || getDefaultContentName(element) || contentElement.getAttribute("alt") || "", cS: contentElement.getAttribute(contentBlobFieldNames.contentSource) || areaContent.contentSource, tN: areaContent.templateName, pid: contentElement.getAttribute(contentBlobFieldNames.productId), cT: contentElement.getAttribute(contentBlobFieldNames.contentType) || areaContent.type
            };
            if (!elementContent.id || !elementContent.aN || !elementContent.sN || !elementContent.cN)
            {
                awa.logger.logWarning("Invalid content blob.  Missing required attributes (id, aN/area, sN/slot), cN/contentName. " + " Content information will still be collected!")
            }
            if (!contentBlobFieldNames.isShortNames)
            {
                elementContent = {
                    contentId: elementContent.id, areaName: elementContent.aN, slotNumber: elementContent.sN, contentName: elementContent.cN, contentSource: elementContent.cS, templateName: elementContent.tN, productId: elementContent.pid, contentType: elementContent.cT
                }
            }
            for (var i = 0, attrib; i < contentElement.attributes.length; i++)
            {
                attrib = contentElement.attributes[i];
                if (attrib.name === contentBlobFieldNames.id || attrib.name === contentBlobFieldNames.areaName || attrib.name === contentBlobFieldNames.slotNumber || attrib.name === contentBlobFieldNames.contentName || attrib.name === contentBlobFieldNames.contentSource || attrib.name === contentBlobFieldNames.templateName || attrib.name === contentBlobFieldNames.productId || attrib.name === contentBlobFieldNames.contentType || attrib.name.indexOf("data-bi-") === -1)
                {
                    continue
                }
                var attribName = attrib.name.replace("data-bi-", "");
                elementContent[attribName] = attrib.value
            }
        }
        awa.utils.removeInvalidElements(elementContent);
        if (config.autoCapture.lineage && isPageAction)
        {
            elementContent = awa.utils.extend(elementContent, getLineageDetails(element))
        }
        return elementContent
    }
    function getDefaultContentName(element)
    {
        if (config.useDefaultContentName === false || isPii(element) || !element.tagName)
        {
            return ""
        }
        var contentName;
        switch (element.tagName)
        {
            case"A":
                contentName = document.all ? element.innerText || element.innerHTML : element.text || element.innerHTML;
            case"IMG":
            case"AREA":
                contentName = element.alt;
            default:
                contentName = element.value || element.name || element.alt || element.innerText || element.id
        }
        return contentName.substring(0, MAX_CONTENTNAME_LENGTH)
    }
    function getAreaContent(areaElement)
    {
        areaElement = utils.returnDomObjectIfjQuery(areaElement);
        if (areaElement)
        {
            return {
                    areaName: areaElement.getAttribute(contentBlobFieldNames.areaName), templateName: areaElement.getAttribute(contentBlobFieldNames.templateName), contentSource: areaElement.getAttribute(contentBlobFieldNames.contentSource), product: areaElement.getAttribute(contentBlobFieldNames.productId), type: areaElement.getAttribute(contentBlobFieldNames.contentType)
                }
        }
    }
    function getClientCookies()
    {
        var cookies = "";
        var uniqueCookies = {};
        var mergedCookies = [];
        var cookiesConfig = config.cookiesToCollect;
        if (config.shareAuthStatus === false)
        {
            mergedCookies = cookiesConfig
        }
        else
        {
            for (var i = 0; i < cookiesConfig.length; i++)
            {
                if (cookiesConfig[i] !== "ANON")
                {
                    mergedCookies.push(cookiesConfig[i])
                }
            }
        }
        var key;
        var cookieValue;
        try
        {
            try
            {
                if (window.varCustomerCookies && window.varCustomerCookies.length > 0)
                {
                    mergedCookies = mergedCookies.concat(window.varCustomerCookies)
                }
            }
            catch(e) {}
            for (key in mergedCookies)
            {
                if (!uniqueCookies.hasOwnProperty(mergedCookies[key]))
                {
                    uniqueCookies[mergedCookies[key]] = "";
                    cookieValue = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(mergedCookies[key]).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1"));
                    if (cookieValue !== "")
                    {
                        cookies += mergedCookies[key] + "=" + cookieValue + ";"
                    }
                }
            }
        }
        catch(e) {}
        return cookies || undefined
    }
    function getClickTarget(element)
    {
        var clickTarget = "";
        switch (element.tagName)
        {
            case"A":
            case"AREA":
                clickTarget = element.href || "";
                break;
            case"IMG":
                clickTarget = getImageHref(element);
                break;
            case"INPUT":
                var type = element.type;
                var e = window.event;
                if (type && (clickCaptureInputTypes[type.toUpperCase()]))
                {
                    if (element.form)
                    {
                        clickTarget = element.form.action || window.location.pathname
                    }
                    else
                    {
                        clickTarget = window.location.pathname
                    }
                }
                break;
            default:
                break
        }
        return clickTarget
    }
    function getCustomTags(obj)
    {
        var customParameters = {};
        while (obj)
        {
            if (isPii(obj))
            {
                continue
            }
            for (var attr in obj.attributes)
            {
                if (attr)
                {
                    if (obj.attributes[attr])
                    {
                        var nn = obj.attributes[attr].name;
                        if (nn)
                        {
                            if (nn.toLowerCase().indexOf("ms.") === 0)
                            {
                                customParameters[nn] = obj.attributes[attr].value
                            }
                        }
                    }
                }
            }
            obj = (obj.parentElement || obj.parentNode)
        }
        return customParameters
    }
    function getFlashInfo()
    {
        var flashInfo = {};
        if (navigator.plugins["Shockwave Flash"])
        {
            flashInfo.installed = true;
            var plugin = navigator.plugins["Shockwave Flash"];
            flashInfo.version = plugin.description.split(" ")[2]
        }
        else if (navigator.userAgent.indexOf("MSIE") !== -1)
        {
            var flashMax = (new Date).getFullYear() - 1992;
            for (var i = flashMax; i > 0; i--)
            {
                try
                {
                    var flash = new ActiveXObject("ShockwaveFlash.ShockwaveFlash." + i);
                    flashInfo.installed = true;
                    flashInfo.version = i + ".0";
                    break
                }
                catch(e) {}
            }
        }
        return flashInfo
    }
    function setEnabledFeatures(pageTags)
    {
        if (pageTags.enabledFeatures)
        {
            return
        }
        var enabledFeatures = cookie.getCookie("Features");
        if (enabledFeatures)
        {
            pageTags.enabledFeatures = enabledFeatures
        }
    }
    function collectMetaTagsAndSetEventProperty(event, isPageView)
    {
        var awaTags = {};
        var msTags = {};
        awaTags = getMetaDataFromDom("awa-", true);
        event.env = getMetaData(awaTags, config.coreData, "env");
        event.pageType = getMetaData(awaTags, config.coreData, "pageType");
        event.product = getMetaData(awaTags, config.coreData, "product");
        event.market = getMetaData(awaTags, config.coreData, "market");
        event.serverImpressionGuid = getMetaData(awaTags, config.coreData, "serverImpressionGuid");
        event.isSensitive = getMetaData(awaTags, config.coreData, "isSensitive");
        if (!event.behavior && isPageView)
        {
            event.behavior = getValidBehavior(getMetaData(awaTags, config.coreData, "behavior"))
        }
        if (config.autoCapture.msTags)
        {
            msTags = getMetaDataFromDom("ms.", false);
            awaTags = utils.extend(true, awaTags, msTags)
        }
        return awaTags
    }
    function getMetaData(awaTags, coreData, metaTagName)
    {
        var data = utils.extractFieldFromObject(awaTags, metaTagName);
        if (coreData[metaTagName])
        {
            return coreData[metaTagName]
        }
        else
        {
            return data
        }
    }
    function getMetaDataFromDom(prefix, removePrefix)
    {
        var metaElements;
        var metaData = {};
        metaElements = document.querySelectorAll("meta");
        for (var i = 0; i < metaElements.length; i++)
        {
            var meta = metaElements[i];
            if (meta.name)
            {
                var mt = meta.name.toLowerCase();
                if (mt.indexOf(prefix) === 0)
                {
                    var name = removePrefix ? meta.name.replace(prefix, "") : meta.name;
                    metaData[name] = meta.content
                }
            }
        }
        return metaData
    }
    function getScreenResolution()
    {
        var screenRes = {
                h: 0, w: 0
            };
        if (window.screen)
        {
            screenRes.h = screen.height;
            screenRes.w = screen.width
        }
        return screenRes
    }
    function getViewportDimensions()
    {
        var viewport = {
                h: 0, w: 0
            };
        if (window.screen)
        {
            viewport.h = window.innerHeight || document.body.clientHeight || document.documentElement.clientHeight;
            viewport.w = window.innerWidth || document.body.clientWidth || document.documentElement.clientWidth
        }
        return viewport
    }
    function getScrollOffset()
    {
        var scrollOffset = {
                h: parseInt(document.body.scrollLeft || document.documentElement.scrollLeft || window.pageXOffset || 0, 10), v: parseInt(document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset || 0, 10)
            };
        return scrollOffset
    }
    function getCookieEnabled()
    {
        if (navigator.cookieEnabled)
        {
            return navigator.cookieEnabled
        }
        var testCookieName = "MC0";
        var cookiePresent = cookie.getCookie(testCookieName);
        if (!cookiePresent)
        {
            document.cookie = testCookieName + "=1";
            cookiePresent = cookie.getCookie(testCookieName)
        }
        return cookiePresent ? true : false
    }
    function getImageHref(element)
    {
        var temp = element;
        if (temp)
        {
            var parent = utils.findClosestAnchor(temp);
            if (parent && parent.length === 1)
            {
                if (parent[0].href)
                {
                    return parent[0].href
                }
                else if (parent[0].src)
                {
                    return (parent[0].src)
                }
            }
        }
        return ""
    }
    function isPii(element)
    {
        if (!element || !element.attributes)
        {
            return false
        }
        try
        {
            var pii = element.getAttribute("data-dc");
            if (utils.isValueAssigned(pii))
            {
                if (pii.toLowerCase() === "pii")
                {
                    return true
                }
                else
                {
                    return false
                }
            }
            else
            {
                return false
            }
        }
        catch(e)
        {
            return false
        }
    }
    function isBehaviorValid(behaviorValue)
    {
        for (var i = 0; i < awa.behaviorKeys.length; i++)
        {
            if (awa.behavior[awa.behaviorKeys[i]] === behaviorValue)
            {
                return true
            }
        }
        awa.logger.logWarning("Unsupported behavior: " + behaviorValue + ".");
        return false
    }
    function getValidBehavior(behaviorValue)
    {
        var behaviorValueNumber = Number(behaviorValue);
        if (utils.isOfCorrectType("uint16", behaviorValueNumber))
        {
            if (isBehaviorValid(behaviorValueNumber))
            {
                return behaviorValueNumber
            }
        }
        else if (utils.isOfCorrectType("string", behaviorValue))
        {
            var value = awa.behavior[behaviorValue.toUpperCase()];
            if (utils.isOfCorrectType("uint16", value))
            {
                return value
            }
        }
    }
    function getUri()
    {
        var windowLocation = window.location;
        if (config.coreData.requestUri === "" && windowLocation)
        {
            var url = windowLocation.protocol + "//" + windowLocation.hostname + (utils.isValueAssigned(windowLocation.port) ? ":" + windowLocation.port : "") + windowLocation.pathname;
            if (config.urlCollectHash)
            {
                url += windowLocation.hash
            }
            if (config.urlCollectQuery)
            {
                var query = windowLocation.search;
                if (!query)
                {
                    var hash = window.location.hash;
                    query = hash.slice(hash.indexOf("?"))
                }
                url += query;
                return url
            }
        }
        else
        {
            return config.coreData.requestUri
        }
    }
    return {
            initialize: init, capturePageView: sendPageView, captureContentUpdate: sendContentUpdate, capturePageAction: sendElementClickEvent, captureContentPageAction: sendCustomClickEvent, capturePageUnload: sendPageUnload, captureCorsDisallowed: sendCorsDisallowed, captureEventTooLong: sendEventTooLong, captureClientError: sendClientError, captureEventDrop: sendEventDropped, captureQos: extendAndSendQos, captureSwap: sendIdSwap, domReadyTasksWrapper: domReadyTasksWrapper, onDomReadyDo: onDomReadyDo, domReadyTasks: domReadyTasks, getTimeToClick: getTimeToClick, testHook: {
                    isBehaviorValid: isBehaviorValid, getValidBehavior: getValidBehavior, collectMetaTagsAndSetEventProperty: collectMetaTagsAndSetEventProperty, getElementContent: getElementContent, getPageContent: getPageContent, debounce: debounce, getScreenResolution: getScreenResolution, getViewportDimensions: getViewportDimensions
                }
        }
})();
awa.service = (function()
{
    var timespanHandler = awa.timespanHandler;
    var willChangeSupportCors = true;
    var alwaysAddCvToRequestHeader = false;
    var targetUriOverrideCallbackFunction = null;
    var makeRequest = function(requestOptions)
        {
            if (typeof jQuery === "function")
            {
                if (willChangeSupportCors)
                {
                    $.support.cors = true
                }
                var additionalHeaders = requestOptions.additionalHeaders || {};
                var body = requestOptions.body;
                var requestData = body ? JSON.stringify(body) : requestOptions.data || undefined;
                var maxRetry = requestOptions.maxRetry || 0;
                var retryCount = 0;
                var jqXhrCallback = $.noop;
                var operationName = requestOptions.operationName || requestOptions.url;
                var errorFormatter = requestOptions.errorFormatter || function(jqXhr)
                    {
                        return jqXhr
                    };
                var ids = awa.ids;
                var cachedCv;
                var options = {
                        url: requestOptions.url, type: requestOptions.method, data: requestData, crossDomain: true, headers: {}, success: requestOptions.success, timeout: requestOptions.timeout, error: requestOptions.error, jsonp: requestOptions.jsonp, jsonpCallback: requestOptions.jsonpCallback, cache: requestOptions.cache, beforeSend: function(jqXhr)
                            {
                                jqXhrCallback(jqXhr);
                                if (requestOptions.contractVersion)
                                {
                                    jqXhr.setRequestHeader("MS-Contract-Version", requestOptions.contractVersion)
                                }
                                if (((!awa.utils.isValueAssigned(requestOptions.addCvToRequestHeader)) && alwaysAddCvToRequestHeader) || requestOptions.addCvToRequestHeader)
                                {
                                    if (awa.cv.isValid(cachedCv))
                                    {
                                        jqXhr.setRequestHeader("MS-CV", cachedCv)
                                    }
                                }
                                if (additionalHeaders)
                                {
                                    for (var header in additionalHeaders)
                                    {
                                        jqXhr.setRequestHeader(header, additionalHeaders[header])
                                    }
                                }
                            }
                    };
                if (requestOptions.dataType)
                {
                    options.dataType = requestOptions.dataType
                }
                if (!requestOptions.noCacheBusting)
                {
                    options.cache = false
                }
                if (requestOptions.contentType)
                {
                    options.contentType = requestOptions.contentType
                }
                if (requestOptions.accept)
                {
                    options.headers.Accept = requestOptions.accept
                }
                if (requestOptions.accepts)
                {
                    options.accepts = requestOptions.accepts
                }
                if (requestOptions.async)
                {
                    options.async = requestOptions.async
                }
                if (requestOptions.xhrFields)
                {
                    options.xhrFields = requestOptions.xhrFields
                }
                if (requestOptions.complete)
                {
                    options.complete = requestOptions.complete
                }
                if (requestOptions.contents)
                {
                    options.contents = requestOptions.contents
                }
                if (requestOptions.context)
                {
                    options.context = requestOptions.context
                }
                if (requestOptions.dataFilter)
                {
                    options.dataFilter = requestOptions.dataFilter
                }
                if (requestOptions.global)
                {
                    options.global = requestOptions.global
                }
                if (requestOptions.ifModified)
                {
                    options.ifModified = requestOptions.ifModified
                }
                if (requestOptions.isLocal)
                {
                    options.isLocal = requestOptions.isLocal
                }
                if (requestOptions.mimeType)
                {
                    options.mimeType = requestOptions.mimeType
                }
                if (requestOptions.password)
                {
                    options.password = requestOptions.password
                }
                if (requestOptions.processData)
                {
                    options.processData = requestOptions.processData
                }
                if (requestOptions.scriptCharset)
                {
                    options.scriptCharset = requestOptions.scriptCharset
                }
                if (requestOptions.statusCode)
                {
                    options.statusCode = requestOptions.statusCode
                }
                if (requestOptions.traditional)
                {
                    options.traditional = requestOptions.traditional
                }
                if (requestOptions.type)
                {
                    options.type = requestOptions.type
                }
                if (requestOptions.username)
                {
                    options.username = requestOptions.username
                }
                if (requestOptions.xhr)
                {
                    options.xhr = requestOptions.xhr
                }
                if (awa.cv.isValid(requestOptions.cV))
                {
                    cachedCv = requestOptions.cV
                }
                else
                {
                    cachedCv = awa.cv.increment()
                }
                var sendApiComplete = function(jqXhr, isSuccess, timeTaken)
                    {
                        var contentLength = jqXhr.getResponseHeader("Content-Length");
                        var event = {
                                name: "Ms.Webi.OutgoingRequest", cV: cachedCv, data: {
                                        baseData: {
                                            operationName: requestOptions.currentOperationName || window.location.href, targetUri: targetUriOverrideCallbackFunction ? targetUriOverrideCallbackFunction(options.url) : options.url, latencyMs: timeTaken, serviceErrorCode: (!isSuccess && jqXhr.responseJSON && jqXhr.responseJSON.code && !isNaN(jqXhr.responseJSON.code)) ? jqXhr.responseJSON.code : -1, succeeded: isSuccess, requestMethod: options.type, responseContentType: options.dataType, protocolStatusCode: jqXhr.status.toString(), dependencyOperationName: operationName, dependencyOperationVersion: requestOptions.version && requestOptions.version.toString(), dependencyName: requestOptions.serviceName, dependencyType: "WebService", responseSizeBytes: contentLength && parseInt(contentLength, 10)
                                        }, baseType: "Ms.Qos.OutgoingServiceRequest", customSessionGuid: ids.getSessionId(), impressionGuid: ids.getImpressionGuid(), message: isSuccess ? undefined : awa.utils.stringifyField("errorMessage", jqXhr.errorThrown), retryCount: retryCount, customData: (requestOptions.customDataCallBack && typeof requestOptions.customDataCallBack === "function") ? JSON.stringify(requestOptions.customDataCallBack(jqXhr)) : undefined
                                    }
                            };
                        if (requestOptions.QosCallback && typeof requestOptions.QosCallback === "function")
                        {
                            requestOptions.QosCallback(jqXhr, event)
                        }
                        awa.ct.captureQos(event)
                    };
                var callWithRetry = function()
                    {
                        var apiName = operationName + "_Retry_" + retryCount;
                        timespanHandler.recordTimeSpan(apiName);
                        return $.ajax(options).then(function(data, textStatus, jqXhr)
                            {
                                var timeTaken = timespanHandler.recordTimeSpan(apiName, true);
                                sendApiComplete(jqXhr, true, timeTaken);
                                return jqXhr
                            }, function(jqXhr, status)
                            {
                                var timeTaken = timespanHandler.recordTimeSpan(apiName, true);
                                sendApiComplete(jqXhr, false, timeTaken);
                                var defer = $.Deferred();
                                if (maxRetry > retryCount && (jqXhr.status === 0 || (jqXhr.status >= 500 && jqXhr.status < 600)))
                                {
                                    retryCount++;
                                    if (awa.cv.isValid(requestOptions.cV))
                                    {
                                        cachedCv = awa.cv.incrementExternal(cachedCv)
                                    }
                                    else
                                    {
                                        cachedCv = awa.cv.increment()
                                    }
                                    setTimeout(function()
                                    {
                                        callWithRetry().done(defer.resolve).fail(defer.reject)
                                    }, 50)
                                }
                                else
                                {
                                    defer.reject(jqXhr, status)
                                }
                                return defer.promise()
                            })
                    };
                return callWithRetry().then(function(data, textStatus, jqXhr)
                    {
                        return jqXhr
                    }, function(jqXhr)
                    {
                        return errorFormatter(jqXhr, requestOptions)
                    })
            }
            else
            {
                awa.logger.logError("jQuery is not defined, cannot use service module")
            }
        };
    function setTargetUriCallbackFunctionOrString(targetUriOverrideStringOrCallback)
    {
        if (typeof(targetUriOverrideStringOrCallback) === "function")
        {
            targetUriOverrideCallbackFunction = targetUriOverrideStringOrCallback
        }
        else if (typeof(targetUriOverrideStringOrCallback) === "string")
        {
            targetUriOverrideCallbackFunction = function()
            {
                return targetUriOverrideStringOrCallback
            }
        }
    }
    return {
            post: function(requestOptions)
            {
                return makeRequest(awa.utils.extend({}, requestOptions, {method: "POST"}))
            }, get: function(requestOptions)
                {
                    return makeRequest(awa.utils.extend({maxRetry: 1}, requestOptions, {method: "GET"}))
                }, put: function(requestOptions)
                {
                    return makeRequest(awa.utils.extend({}, requestOptions, {method: "PUT"}))
                }, del: function(requestOptions)
                {
                    return makeRequest(awa.utils.extend({}, requestOptions, {method: "DELETE"}))
                }, patch: function(requestOptions)
                {
                    return makeRequest(awa.utils.extend({}, requestOptions, {method: "PATCH"}))
                }, doNotChangeSupportCors: function()
                {
                    willChangeSupportCors = false
                }, alwaysAddCvToRequestHeader: function()
                {
                    alwaysAddCvToRequestHeader = true
                }, setTargetUriOverride: setTargetUriCallbackFunctionOrString
        }
})();
define("asimov", function(){});

define('telemetry/telemetryManager',['require','exports','module','settings','constants/common','services/serviceLocator','lodash','constants/telemetry','telemetry/asimovCustomEventSchema','telemetry/chatEntityEventSchema'],function(require, exports) {
    'use strict';

    /* global awa */
    require(['asimov']);

    function TelemetryManager() {
        function createEventId(eventIdArray) {
            return telemetry.ComponentCode + eventIdArray.join('');
        }

        function addCommonProperties(properties) {
            if (agentContextApi.getId()) {
                properties.agentIdPrimary = agentContextApi.getId();
            }

            if (agentContextApi.getSite()) {
                properties.siteId = agentContextApi.getSite();
            }

            if (!properties.extraContext) {
                properties.extraContext = {
                    agentId: agentContextApi.getId(),
                    activeEngagementCount: activeEngagementsApi.currentChatCount()
                };
            } else {
                properties.extraContext['agentId'] = agentContextApi.getId();
                properties.extraContext['activeEngagementCount'] = activeEngagementsApi.currentChatCount();
            }

            properties.context = JSON.stringify(properties.extraContext);
            delete properties.extraContext;
            properties.eventTimeStamp = (new Date()).toJSON();
            properties.sdkVersion = settings.version;

            return properties;
        }

        var settings = require('settings'),
            constants = require('constants/common'),
            serviceLocator = require('services/serviceLocator'),
            _ = require('lodash'),
            telemetry = require('constants/telemetry'),
            asimovConfig = {
                sendMode: 0,
                initCv: true,
                isLoggedIn: true,
                shareAuthStatus: true,
                authMethod: 2,
                coreData: {
                    appId: settings.asimov.appId
                },
                autoCapture: {
                    pageView: false,
                    onLoad: false,
                    onUnload: false,
                    click: false,
                    addIn: false,
                    perf: false
                }
            },
            eventSchemaName = require('telemetry/asimovCustomEventSchema').name,
            chatEntityEventSchemaName = require('telemetry/chatEntityEventSchema').name,
            agentContextApi = serviceLocator.resolve(constants.serviceLocator.AGENT_CONTEXT),
            exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER),
            activeEngagementsApi = serviceLocator.resolve(constants.serviceLocator.ACTIVE_ENGAGEMENTS),
            authService = serviceLocator.resolve(constants.serviceLocator.AUTH_SERVICE);

        awa.init(asimovConfig);
        awa.service.alwaysAddCvToRequestHeader();
        this.registerSchemas = awa._registerSchemas;

        if (settings.correlationVector) {
            awa.cv.setValue(settings.correlationVector);
        }

        this.sendEvent = function (loggingContext) {
            var properties = {},
                rawEvent,
                eventContent = {},
                eventToSend;

            properties.eventId = createEventId(loggingContext.eventId);
            properties.eventName = loggingContext.eventName;
            _.assignIn(properties, loggingContext.data);
            rawEvent = addCommonProperties(properties);

            if (loggingContext.isChatEntityEvent) {
                var chatEntityEvent = {};

                chatEntityEvent[chatEntityEventSchemaName] = rawEvent;
                eventToSend = {
                    name: chatEntityEventSchemaName,
                    data: chatEntityEvent,
                    appId: settings.asimov.appId
                };

                awa.writeEvent(eventToSend);
            }

            eventContent[eventSchemaName] = rawEvent;
            eventToSend = {
                name: eventSchemaName,
                data: eventContent,
                appId: settings.asimov.appId
            };

            awa.writeEvent(eventToSend);
        };

        // We are using Asimov.service as the http client in order to send QoS events.
        // Asimov uses jquery promise which is not standard and misses catch api.
        this.service = {};
        this.service.get = function (requestOptions) {
            return authService.getToken()
                .then(function (token) {
                    requestOptions.additionalHeaders[constants.headerKey.BEARER_TOKEN] = token;
                    requestOptions.maxRetry = settings.requestMaxRetry;
                    requestOptions.timeout = settings.requestTimeoutInMillisecond;
                    return requestOptions;
                }).then(awa.service.get)
                .catch(function (error) {
                    var exception = exceptionManager.wrapAjaxResponseError(error);

                    return Promise.reject(exception);
                });
        };

        this.service.post = function (requestOptions) {
            return authService.getToken()
                .then(function (token) {
                    requestOptions.additionalHeaders[constants.headerKey.BEARER_TOKEN] = token;
                    requestOptions.maxRetry = settings.requestMaxRetry;
                    requestOptions.timeout = settings.requestTimeoutInMillisecond;
                    return requestOptions;
                }).then(awa.service.post).
                catch(function (error) {
                    var exception = exceptionManager.wrapAjaxResponseError(error);

                    return Promise.reject(exception);
                });
        };

        this.service.put = function (requestOptions) {
            return authService.getToken()
                .then(function (token) {
                    requestOptions.additionalHeaders[constants.headerKey.BEARER_TOKEN] = token;
                    requestOptions.maxRetry = settings.requestMaxRetry;
                    requestOptions.timeout = settings.requestTimeoutInMillisecond;
                    return requestOptions;
                }).then(awa.service.put)
                .catch(function (error) {
                    var exception = exceptionManager.wrapAjaxResponseError(error);

                    return Promise.reject(exception);
                });
        };
    }

    exports.create = function () {
        return new TelemetryManager();
    };
});
define('telemetry/telemetryClient',['require','exports','module','telemetry/telemetryManager','telemetry/asimovCustomEventSchema','telemetry/chatEntityEventSchema'],function (require, exports) {
    'use strict';

    var instance,
        telemetryManager = require('telemetry/telemetryManager'),
        eventSchema = require('telemetry/asimovCustomEventSchema'),
        chatEntityEventSchema = require('telemetry/chatEntityEventSchema');

    exports.get = function () {
        if (!instance) {
            instance = telemetryManager.create();
            instance.registerSchemas([eventSchema, chatEntityEventSchema]);
        }

        return instance;
    };
});
define('telemetry/skypeAuthTelemetry',['require','exports','module','skype/jlyncApplication','telemetry/telemetryClient','constants/telemetry','constants/common'],function (require, exports) {
    'use strict';

    var jlyncApp = require('skype/jlyncApplication'),
        telemetryClient = require('telemetry/telemetryClient'),
        telemetry = require('constants/telemetry'),
        constants = require('constants/common'),
        loggingContext;

    function onSigningIn() {
        loggingContext = {
            eventId: [
                telemetry.MilestoneCodes.Initialize,
                telemetry.StatusEventCodes.Initiated,
                telemetry.OutcomeBits.Unknown,
                telemetry.Events.SkypeSigningIn.ID
            ],
            eventName: telemetry.Events.SkypeSigningIn.NAME,
            data: {
                message: telemetry.Events.SkypeSigningIn.MESSAGE
            }
        };
        telemetryClient.get().sendEvent(loggingContext);
    }

    function onSignedIn() {
        loggingContext = {
            eventId: [
                telemetry.MilestoneCodes.Initialize,
                telemetry.StatusEventCodes.Initiated,
                telemetry.OutcomeBits.Success,
                telemetry.Events.SkypeSignedIn.ID
            ],
            eventName: telemetry.Events.SkypeSignedIn.NAME,
            data: {
                message: telemetry.Events.SkypeSignedIn.MESSAGE
            }
        };
        telemetryClient.get().sendEvent(loggingContext);
    }

    function onSignedOut(reason, oldState) {
        if (!oldState) {
            return;
        }

        loggingContext = {
            eventId: [
                telemetry.MilestoneCodes.Initialize,
                telemetry.StatusEventCodes.Default,
                telemetry.OutcomeBits.Unknown,
                telemetry.Events.SkypeSignedOut.ID
            ],
            eventName: telemetry.Events.SkypeSignedOut.NAME,
            data: {
                message: telemetry.Events.SkypeSignedOut.MESSAGE,
                faultContext: typeof reason === 'string' ? reason : JSON.stringify(reason)
            }
        };
        telemetryClient.get().sendEvent(loggingContext);
    }

    exports.init = function (signInState) {
        var signingInSub, singedOutSub, signedInSub;

        signingInSub = signInState.when(constants.skypeLoginState.SigningIn, onSigningIn);
        signedInSub = signInState.when(constants.skypeLoginState.SignedIn, onSignedIn);
        singedOutSub = signInState.when(constants.skypeLoginState.SignedOut, onSignedOut);
        jlyncApp.addSubscription(signingInSub);
        jlyncApp.addSubscription(signedInSub);
        jlyncApp.addSubscription(singedOutSub);
    };
});
define('skype/skypePresenceHandler',['require','exports','module','skype/jlyncApplication','constants/common','services/serviceLocator','telemetry/telemetryClient','constants/telemetry'],function (require, exports){
    'use strict';

    var jlyncApp = require('skype/jlyncApplication'),
        constants = require('constants/common'),
        serviceLocator = require('services/serviceLocator'),
        telemetryClient = require('telemetry/telemetryClient'),
        telemetry = require('constants/telemetry'),
        loggingContext;

    exports.init = function () {
        function onPresenceUpdate(status) {
            loggingContext = {
                eventId: [
                    telemetry.MilestoneCodes.Default,
                    telemetry.StatusEventCodes.Default,
                    telemetry.OutcomeBits.Unknown,
                    telemetry.Events.SkypePresenceUpdate.ID
                ],
                eventName: telemetry.Events.SkypePresenceUpdate.NAME,
                data: {
                    message: telemetry.Events.SkypePresenceUpdate.MESSAGE,
                    extraContext: {
                        skypePresence: status
                    }
                }
            };
            telemetryClient.get().sendEvent(loggingContext);

            if (status === constants.skypePresence.DONOTDISTURB) {
                var eventData = {
                    reason: 'DoNotDisturb'
                };

                pubSub.publish(constants.events.CHAT_CHANNEL_UNAVAILABLE, [eventData]);
            }
        }

        var presenceSub,
            jlync = jlyncApp.get(),
            pubSub = serviceLocator.resolve(constants.serviceLocator.PUBSUB);

        presenceSub = jlync.personsAndGroupsManager.mePerson.status.changed(onPresenceUpdate);
        jlyncApp.addSubscription(presenceSub);
    };
});
define('skype/skypeUnavailableEventsHandler',['require','exports','module','skype/jlyncApplication','constants/common','services/serviceLocator','telemetry/telemetryClient','constants/telemetry'],function (require, exports){
    'use strict';

    var jlyncApp = require('skype/jlyncApplication'),
        constants = require('constants/common'),
        serviceLocator = require('services/serviceLocator'),
        telemetryClient = require('telemetry/telemetryClient'),
        telemetry = require('constants/telemetry'),
        loggingContext;

    exports.init = function () {
        function onSignedOut(reason, oldState) {
            if (oldState && reason) {
                var eventData = {
                    reason: 'SkypeSignedOut',
                    context: reason
                };

                pubSub.publish(constants.events.CHAT_CHANNEL_UNAVAILABLE, [eventData]);
            }
        }

        function onAppSuspended() {
            loggingContext = {
                eventId: [
                    telemetry.MilestoneCodes.Default,
                    telemetry.StatusEventCodes.Default,
                    telemetry.OutcomeBits.Unknown,
                    telemetry.Events.JlyncSuspended.ID
                ],
                eventName: telemetry.Events.JlyncSuspended.NAME,
                data: {
                    message: telemetry.Events.JlyncSuspended.MESSAGE
                }
            };
            telemetryClient.get().sendEvent(loggingContext);

            if (!activateJlyncTimeout) {
                activateJlyncTimeout = setTimeout(function () {
                    jlync.suspended(false);
                    activateJlyncTimeout = null;
                }, ACTIVATION_TIMEOUT);
            }
        }

        function onAppActive() {
            loggingContext = {
                eventId: [
                    telemetry.MilestoneCodes.Default,
                    telemetry.StatusEventCodes.Default,
                    telemetry.OutcomeBits.Success,
                    telemetry.Events.JlyncActive.ID
                ],
                eventName: telemetry.Events.JlyncActive.NAME,
                data: {
                    message: telemetry.Events.JlyncActive.MESSAGE
                }
            };
            telemetryClient.get().sendEvent(loggingContext);
        }

        function onMeInactive() {
            loggingContext = {
                eventId: [
                    telemetry.MilestoneCodes.Default,
                    telemetry.StatusEventCodes.Default,
                    telemetry.OutcomeBits.Unknown,
                    telemetry.Events.MeInactive.ID
                ],
                eventName: telemetry.Events.MeInactive.NAME,
                data: {
                    message: telemetry.Events.MeInactive.MESSAGE
                }
            };
            telemetryClient.get().sendEvent(loggingContext);

            if (!activateMeTimeout) {
                activateMeTimeout = setTimeout(function () {
                    jlync.personsAndGroupsManager.mePerson.active(true);
                    activateMeTimeout = null;
                }, ACTIVATION_TIMEOUT);
            }
        }

        function onMeActive() {
            loggingContext = {
                eventId: [
                    telemetry.MilestoneCodes.Default,
                    telemetry.StatusEventCodes.Default,
                    telemetry.OutcomeBits.Success,
                    telemetry.Events.MeActive.ID
                ],
                eventName: telemetry.Events.MeActive.NAME,
                data: {
                    message: telemetry.Events.MeActive.MESSAGE
                }
            };
            telemetryClient.get().sendEvent(loggingContext);
        }

        var ACTIVATION_TIMEOUT = 3000,
            activateJlyncTimeout,
            activateMeTimeout,
            loginStateSub, suspendedTrueSub, suspendedFalseSub, meActiveSub, meInactiveSub,
            jlync = jlyncApp.get(),
            pubSub = serviceLocator.resolve(constants.serviceLocator.PUBSUB);

        loginStateSub = jlync.signInManager.state.when(constants.skypeLoginState.SignedOut, onSignedOut);
        suspendedTrueSub = jlync.suspended.when(true, onAppSuspended);
        suspendedFalseSub = jlync.suspended.when(false, onAppActive);
        meActiveSub = jlync.personsAndGroupsManager.mePerson.active.when(true, onMeActive);
        meInactiveSub = jlync.personsAndGroupsManager.mePerson.active.when(false, onMeInactive);
        jlyncApp.addSubscription(loginStateSub);
        jlyncApp.addSubscription(suspendedTrueSub);
        jlyncApp.addSubscription(suspendedFalseSub);
        jlyncApp.addSubscription(meActiveSub);
        jlyncApp.addSubscription(meInactiveSub);
    };
});
define('skype/auth',['require','exports','module','skype/jlyncApplication','telemetry/skypeAuthTelemetry','skype/skypePresenceHandler','skype/skypeUnavailableEventsHandler','constants/common','services/serviceLocator','telemetry/telemetryClient','constants/telemetry'],function (require, exports){
    'use strict';

    var jlyncApp = require('skype/jlyncApplication'),
        skypeAuthTelemetry = require('telemetry/skypeAuthTelemetry'),
        skypePresenceHandler = require('skype/skypePresenceHandler'),
        skypeUnavailableEventsHandler = require('skype/skypeUnavailableEventsHandler'),
        constants = require('constants/common'),
        serviceLocator = require('services/serviceLocator'),
        telemetryClient = require('telemetry/telemetryClient'),
        telemetry = require('constants/telemetry'),
        loggingContext, agentContextApi,
        skypeAuthContextApi, exceptionManager, jlync;

    exports.signIn = function (snapshot) {
        return new Promise(function (resolve, reject) {
            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Initiated,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.JlyncMeAvailable.ID
                    ],
                    eventName: telemetry.Events.JlyncMeAvailable.NAME,
                    data: {
                        message: telemetry.Events.JlyncMeAvailable.MESSAGE
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                clearTimeout(signInTimeout);
                skypeAuthTelemetry.init(jlync.signInManager.state);
                skypeUnavailableEventsHandler.init();
                skypePresenceHandler.init();
                agentContextApi.setSip(me.id());
                agentContextApi.setSkypeEndpointUri(me.endpointUri());
                agentContextApi.setDisplayName(me.displayName());
                resolve(me.endpointUri());
            }

            function onError(error) {
                var errorMessage = typeof error === 'string' ? error : JSON.stringify(error),
                    parsedError;

                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Initiated,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.SkypeSigningInFailed.ID
                    ],
                    eventName: telemetry.Events.SkypeSigningInFailed.NAME,
                    data: {
                        message: telemetry.Events.SkypeSigningInFailed.MESSAGE,
                        faultContext: errorMessage
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                clearTimeout(signInTimeout);
                // reset the jlync app
                jlyncApp.create();

                if (error &&
                    error.hasOwnProperty(constants.authErrorKey.CODE) &&
                    error.hasOwnProperty(constants.authErrorKey.DESCRIPTION)) {
                    parsedError = {
                        errorCode: constants.errorCodes.CHANNEL_ERROR,
                        oauthErrorCode: error.code,
                        oauthErrorDescription: error.description
                    };

                    // OauthFailed
                    if (error.hasOwnProperty('error')) {
                        parsedError.oauthError = error.error;
                    }

                    // Proxy 401 error from agent sites
                    if (error.hasOwnProperty('rsp') && error.rsp.statusText === 'authenticationrequired') {
                        parsedError.oauthError = error.rsp.statusText;
                    }

                    parsedError.context = {
                        message: telemetry.Events.SkypeSigningInFailed.MESSAGE
                    };
                }

                var exception = exceptionManager.wrapChannelError(parsedError, telemetry.Events.SkypeSigningInFailed.MESSAGE);

                reject(exception);
            }

            jlync = jlyncApp.get();
            agentContextApi = serviceLocator.resolve(constants.serviceLocator.AGENT_CONTEXT);
            skypeAuthContextApi = serviceLocator.resolve(constants.serviceLocator.SKYPE_AUTH_CONTEXT);
            exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER);

            var signInParams = skypeAuthContextApi.get(),
                me = jlync.personsAndGroupsManager.mePerson,
                SINGNIN_TIMEOUT = 60000,
                signInTimeout = null, meSub;

            if (snapshot) {
                signInParams.snapshot = snapshot;
            }

            signInTimeout = setTimeout(function () {
                if (!me.available()) {
                    onError('Skype sign in timed out');
                    return;
                }
            }, SINGNIN_TIMEOUT);

            meSub = me.endpointUri.changed(function () {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Initiated,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.SipEndpointUriUpdated.ID
                    ],
                    eventName: telemetry.Events.SipEndpointUriUpdated.NAME,
                    data: {
                        message: telemetry.Events.SipEndpointUriUpdated.MESSAGE
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
            });
            jlyncApp.addSubscription(meSub);

            Promise.resolve(signInParams)
            .then(jlync.signInManager.signIn)
            .then(function () {
                me.available.once(true, onSuccess);
            }).catch(onError);
        });
    };
});
define('api/helpers/visitContext',['require','exports','module','lodash'],function (require, exports) {
    'use strict';

    var _ = require('lodash');

    exports.getSrId = function (context) {
        if (_.has(context, 'SrId')) {
            return context.SrId;
        }

        if (_.has(context, 'srId')) {
            return context.srId;
        }
    };
});
define('models/postTranscriptRequest',['require','exports','module'],function (require, exports) {
    'use strict';

    exports.create = function (request) {
        return {
            visitId: request.visitId,
            engagementId: request.engagementId,
            partnerId: request.partnerId,
            isVirtualAgent: false,
            rawMessages: [{
                from: request.agentId,
                to: [],
                message: request.message,
                timestamp: (new Date()).toJSON(),
                isMessageFromAgent: true,
                isAgentViewOnly: true,
                SendFromByParticipantName: request.agentDisplayName,
                SendFromBySip: request.agentSip
            }]
        };
    };
});
define('api/engagement',['require','exports','module','constants/common','api/helpers/visitContext','services/serviceLocator','lodash','models/postTranscriptRequest','telemetry/telemetryClient','constants/telemetry'],function(require, exports){
    'use strict';

    var constants = require('constants/common'),
        visitContextHelperApi = require('api/helpers/visitContext'),
        serviceLocator = require('services/serviceLocator'),
        _ = require('lodash'),
        postTranscriptRequestModel = require('models/postTranscriptRequest'),
        telemetryClient = require('telemetry/telemetryClient'),
        telemetry = require('constants/telemetry'),
        loggingContext, gatewayService, chatEngagementsApi, activeEngagementsApi,
        exceptionManager, pubSub, agentContextApi;

    exports.getContext = function (params) {
        return new Promise(function (resolve, reject) {
            function onSuccess(result) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.VisitFetched.ID
                    ],
                    eventName: telemetry.Events.VisitFetched.NAME,
                    data: {
                        message: telemetry.Events.VisitFetched.MESSAGE
                    }
                };
                _.assignIn(loggingContext.data, params);
                telemetryClient.get().sendEvent(loggingContext);
                resolve(result);
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.GetVisitFailed.ID
                    ],
                    eventName: telemetry.Events.GetVisitFailed.NAME,
                    data: {
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        message: telemetry.Events.GetVisitFailed.MESSAGE
                    }
                };

                if (params) {
                    _.assignIn(loggingContext.data, params);
                }

                loggingContext.isChatEntityEvent = true;
                telemetryClient.get().sendEvent(loggingContext);

                var exception = exceptionManager.wrapServerError(error, telemetry.Events.GetVisitFailed.MESSAGE);

                reject(exception);
            }

            exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER);

            if (!params || !params.visitId) {
                var exception = exceptionManager.wrapRequestInvalid('visitId is missing in the parameter object.');

                onError(exception);
                return;
            }

            var requestParams = {
                visitId: params.visitId
            };

            if (params.partnerId) {
                requestParams.partnerId = params.partnerId;
            }

            if (params.engagementId) {
                requestParams.engagementId = params.engagementId;
            }

            gatewayService = serviceLocator.resolve(constants.serviceLocator.GATEWAY);
            gatewayService.getContext(requestParams).then(onSuccess).catch(onError);
        });
    };

    exports.updateContext = function (params) {
        return new Promise (function (resolve, reject) {
            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.VisitUpdated.ID
                    ],
                    eventName: telemetry.Events.VisitUpdated.NAME,
                    data: {
                        message: telemetry.Events.VisitUpdated.MESSAGE,
                        visitId: sessionContext.visitId,
                        engagementId: sessionContext.engagementId,
                        partnerId: sessionContext.partnerId
                    }
                };

                if (srId) {
                    loggingContext.data.extraContext = {
                        srId: srId
                    };
                }

                if (activeEngagementsApi.hasEngagement(sessionContext.engagementId)) {
                    var chatEngagement = activeEngagementsApi.getActiveEngagement(sessionContext.engagementId);

                    loggingContext.data.conferenceId = chatEngagement.conferenceId;
                }

                loggingContext.isChatEntityEvent = true;
                telemetryClient.get().sendEvent(loggingContext);
                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.UpdateVisitFailed.ID
                    ],
                    eventName: telemetry.Events.UpdateVisitFailed.NAME,
                    data: {
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        message: telemetry.Events.UpdateVisitFailed.MESSAGE
                    }
                };

                if (params) {
                    if (params.visitId) {
                        loggingContext.data.visitId = params.visitId;
                    }

                    if (params.engagementId) {
                        loggingContext.data.engagementId = params.engagementId;
                    }

                    if (params.partnerId) {
                        loggingContext.data.partnerId = params.partnerId;
                    }
                }

                if (srId) {
                    loggingContext.data.extraContext = {
                        srId: srId
                    };
                }

                loggingContext.isChatEntityEvent = true;
                telemetryClient.get().sendEvent(loggingContext);

                var exception = exceptionManager.wrapServerError(error, telemetry.Events.UpdateVisitFailed.MESSAGE);

                reject(exception);
            }

            function validate(params) {
                if (params && params.isFromSdk) {
                    return;
                }

                if (!params || !params.context) {
                    return 'context object is required for updating engagement context';
                }

                if (!params.visitId){
                    return 'visitId is required for updating engagement context';
                }

                if (!params.engagementId){
                    return 'engagementId is required for updating engagement context';
                }

                if (!params.partnerId){
                    return 'partnerId is required for updating engagement context';
                }
            }

            exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER);

            var errorMessage = validate(params),
                srId,
                sessionContext;

            if (errorMessage) {
                var exception = exceptionManager.wrapRequestInvalid(errorMessage);

                onError(exception);
                return;
            }

            if (params.isFromSdk) {
                delete params.isFromSdk;
                sessionContext = params;
            } else {
                srId = visitContextHelperApi.getSrId(params.context);
                sessionContext = {
                    visitId: params.visitId,
                    engagementId: params.engagementId,
                    partnerId: params.partnerId,
                    extendedProperties: params.context
                };
            }

            activeEngagementsApi = serviceLocator.resolve(constants.serviceLocator.ACTIVE_ENGAGEMENTS);
            gatewayService = serviceLocator.resolve(constants.serviceLocator.GATEWAY);
            gatewayService.updateContext(sessionContext).then(onSuccess).catch(onError);
        });
    };

    exports.getTranscript = function (params) {
        return new Promise(function (resolve, reject) {
            function onSuccess(result) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.TranscriptFetched.ID
                    ],
                    eventName: telemetry.Events.TranscriptFetched.NAME,
                    data: {
                        message: telemetry.Events.TranscriptFetched.MESSAGE
                    }
                };
                _.assignIn(loggingContext.data, params);
                telemetryClient.get().sendEvent(loggingContext);
                resolve(result);
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.GetTranscriptFailed.ID
                    ],
                    eventName: telemetry.Events.GetTranscriptFailed.NAME,
                    data: {
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        message: telemetry.Events.GetTranscriptFailed.MESSAGE
                    }
                };

                if (params) {
                    _.assignIn(loggingContext.data, params);
                }

                loggingContext.isChatEntityEvent = true;
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapServerError(error, telemetry.Events.GetTranscriptFailed.MESSAGE);

                reject(exception);
            }

            exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER);

            if (!params || !params.visitId || !params.engagementId || !params.partnerId) {
                var exception = exceptionManager.wrapRequestInvalid('visitId, engagementId or partnerId is missing in the parameter object.');

                onError(exception);
                return;
            }

            var getTranscriptParams = {
                visitId: params.visitId,
                engagementId: params.engagementId,
                partnerId: params.partnerId
            };

            if (params.isIncludeEvent) {
                getTranscriptParams.isIncludeEvent = true;
            }

            gatewayService = serviceLocator.resolve(constants.serviceLocator.GATEWAY);
            gatewayService.getTranscript(getTranscriptParams).then(onSuccess).catch(onError);
        });
    };

    exports.postTranscript = function (params) {
        return new Promise(function (resolve, reject) {
            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.ChatTranscriptSaved.ID
                    ],
                    eventName: telemetry.Events.ChatTranscriptSaved.NAME,
                    data: {
                        message: telemetry.Events.ChatTranscriptSaved.MESSAGE
                    }
                };
                _.assignIn(loggingContext.data, context);
                telemetryClient.get().sendEvent(loggingContext);
                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.SaveChatTranscriptFailed.ID
                    ],
                    eventName: telemetry.Events.SaveChatTranscriptFailed.NAME,
                    data: {
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        message: telemetry.Events.SaveChatTranscriptFailed.MESSAGE
                    }
                };
                _.assignIn(loggingContext.data, context);
                loggingContext.isChatEntityEvent = true;
                telemetryClient.get().sendEvent(loggingContext);
                reject(error);
            }

            var context = {
                    visitId: params.visitId,
                    engagementId: params.engagementId,
                    partnerId: params.partnerId
                },
                requestModel;

            agentContextApi = serviceLocator.resolve(constants.serviceLocator.AGENT_CONTEXT);
            gatewayService = serviceLocator.resolve(constants.serviceLocator.GATEWAY);
            params.agentId = agentContextApi.getId();
            params.agentSip = agentContextApi.getSip();
            params.agentDisplayName = agentContextApi.getDisplayName();
            requestModel = postTranscriptRequestModel.create(params);
            gatewayService.postTranscript(requestModel).then(onSuccess).catch(onError);
        });
    };

    exports.endEngagement = function (params) {
        return new Promise(function (resolve, reject) {
            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Ended,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.EngagementEnded.ID
                    ],
                    eventName: telemetry.Events.EngagementEnded.NAME,
                    data: {
                        message: telemetry.Events.EngagementEnded.MESSAGE,
                        extraContext: {
                            engagementInfo: engagementInfo,
                            conferenceId: params.conferenceId ? params.conferenceId : ''
                        }
                    }
                };
                _.assignIn(loggingContext.data, params);
                loggingContext.isChatEntityEvent = true;
                params.chatId && chatEngagementsApi.removeChatEngagement(params.chatId);
                activeEngagementsApi.removeActiveEngagement(params.engagementId);
                telemetryClient.get().sendEvent(loggingContext);
                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Ended,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.EndEngagementFailed.ID
                    ],
                    eventName: telemetry.Events.EndEngagementFailed.NAME,
                    data: {
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        message: telemetry.Events.EndEngagementFailed.MESSAGE,
                        extraContext: {
                            engagementInfo: engagementInfo,
                            conferenceId: params.conferenceId ? params.conferenceId : ''
                        }
                    }
                };

                if (params) {
                    _.assignIn(loggingContext.data, params);
                }

                loggingContext.isChatEntityEvent = true;
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapServerError(error, telemetry.Events.EndEngagementFailed.MESSAGE);

                reject(exception);
            }

            var engagementInfo = {},
                chatEngagement;

            if (params && params.engagementInfo) {
                // Data needed for ESP
                engagementInfo = params.engagementInfo;
                delete params.engagementInfo;
            }

            exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER);

            if (!params || !params.visitId || !params.engagementId) {
                var exception = exceptionManager.wrapRequestInvalid('visitId or engagementId is missing in the parameter object.');

                onError(exception);
                return;
            }

            agentContextApi = serviceLocator.resolve(constants.serviceLocator.AGENT_CONTEXT);
            gatewayService = serviceLocator.resolve(constants.serviceLocator.GATEWAY);
            chatEngagementsApi = serviceLocator.resolve(constants.serviceLocator.CHAT_ENGAGEMENTS);
            activeEngagementsApi = serviceLocator.resolve(constants.serviceLocator.ACTIVE_ENGAGEMENTS);

            if (params.chatId) {
                chatEngagement = chatEngagementsApi.getChatEngagement(params.chatId);

                if (!params.conferenceId && chatEngagement) {
                    params.conferenceId = chatEngagement.conferenceId;
                }
            }

            var endChatPromise = chatEngagement ? chatEngagement.endChat(constants.endChatReason.ENDENGAGEMENTINVOKED) : Promise.resolve();

            endChatPromise.then(function () {
                return gatewayService.endEngagement(params.visitId, params.engagementId, params.conferenceId, params.partnerId, !!params.predicted);
            }).then(onSuccess).catch(onError);
        });
    };

    exports.whisper = function (params) {
        return new Promise(function (resolve, reject) {
            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Supervisor,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.WhiperChatRequested.ID
                    ],
                    eventName: telemetry.Events.WhiperChatRequested.NAME,
                    data: {
                        message: telemetry.Events.WhiperChatRequested.MESSAGE
                    }
                };
                _.assignIn(loggingContext.data, params);
                telemetryClient.get().sendEvent(loggingContext);
                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Supervisor,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.WhiperChatFailed.ID
                    ],
                    eventName: telemetry.Events.WhiperChatFailed.NAME,
                    data: {
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        message: telemetry.Events.WhiperChatFailed.MESSAGE
                    }
                };

                if (params) {
                    _.assignIn(loggingContext.data, params);
                }

                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapServerError(error, telemetry.Events.WhiperChatFailed.MESSAGE);

                reject(exception);
            }

            exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER);

            if (!params || !params.visitId || !params.engagementId || !params.partnerId) {
                var exception = exceptionManager.wrapRequestInvalid('visitId, engagementId or partnerId is missing in the parameter object.');

                onError(exception);
                return;
            }

            gatewayService = serviceLocator.resolve(constants.serviceLocator.GATEWAY);
            gatewayService.whisper(params.visitId, params.engagementId, params.partnerId).then(onSuccess).catch(onError);
        });
    };

    exports.getSupportHours = function (params) {
        return new Promise(function (resolve, reject) {
            function onSuccess(result) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.HOOPS,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.HoopsFetched.ID
                    ],
                    eventName: telemetry.Events.HoopsFetched.NAME,
                    data: {
                        message: telemetry.Events.HoopsFetched.MESSAGE,
                        visitId: logContext.visitId,
                        engagementId: logContext.engagementId,
                        partnerId: logContext.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);

                resolve(result);
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.HOOPS,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.GetHoopsFailed.ID
                    ],
                    eventName: telemetry.Events.GetHoopsFailed.NAME,
                    data: {
                        message: telemetry.Events.GetHoopsFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error)
                    }
                };

                if (logContext.visitId) {
                    loggingContext.data.visitId = logContext.visitId;
                }

                if (logContext.engagementId) {
                    loggingContext.data.engagementId = logContext.engagementId;
                }

                if (logContext.partnerId) {
                    loggingContext.data.partnerId = logContext.partnerId;
                }

                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapServerError(error, telemetry.Events.GetHoopsFailed.MESSAGE);

                reject(exception);
            }

            var context = {},
                logContext = {},
                validationError;

            if (params) {
                logContext.visitId = params.visitId ? params.visitId : null;
                logContext.engagementId = params.engagementId ? params.engagementId : null;
                logContext.partnerId = params.partnerId ? params.partnerId : null;
                context.subject = params.subject ? params.subject : null;
                context.language = params.language ? params.language : null;
                context.country = params.country ? params.country : null;
                context.tier = params.tier ? params.tier : null;
                context.mode = params.mode ? params.mode : null;
            }

            exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER);

            _.forEach(logContext, function (value, key) {
                if (_.isNull(value) || _.isUndefined(value) || value === '') {
                    validationError = key + ' is required for getting HOOPS';
                    return false;
                }
            });

            if (validationError) {
                var exception = exceptionManager.wrapRequestInvalid(validationError);

                onError(exception);
                return;
            }

            _.forEach(context, function (value, key) {
                if (_.isNull(value) || _.isUndefined(value) || value === '') {
                    validationError = key + ' is required for getting HOOPS';
                    return false;
                }
            });

            if (validationError) {
                var exception = exceptionManager.wrapRequestInvalid(validationError);

                onError(exception);
                return;
            }

            if (params && params.channel) {
                context.channel = params.channel;
            }

            if (params && _.isBoolean(params.returnSchedules)) {
                context.returnSchedules = params.returnSchedules;
            }

            gatewayService = serviceLocator.resolve(constants.serviceLocator.GATEWAY);
            gatewayService.getSupportHours(context, logContext).then(onSuccess).catch(onError);
        });
    };

    exports.getChatQueueLength = function (params) {
        return new Promise(function (resolve, reject) {
            function onSuccess(result) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.ChatQueueLengthFetched.ID
                    ],
                    eventName: telemetry.Events.ChatQueueLengthFetched.NAME,
                    data: {
                        message: telemetry.Events.ChatQueueLengthFetched.MESSAGE,
                        visitId: logContext.visitId,
                        engagementId: logContext.engagementId,
                        partnerId: logContext.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);

                resolve(result);
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.GetChatQueueLengthFailed.ID
                    ],
                    eventName: telemetry.Events.GetChatQueueLengthFailed.NAME,
                    data: {
                        message: telemetry.Events.GetChatQueueLengthFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error)
                    }
                };

                if (logContext.visitId) {
                    loggingContext.data.visitId = logContext.visitId;
                }

                if (logContext.engagementId) {
                    loggingContext.data.engagementId = logContext.engagementId;
                }

                if (logContext.partnerId) {
                    loggingContext.data.partnerId = logContext.partnerId;
                }

                telemetryClient.get().sendEvent(loggingContext);

                var exception = exceptionManager.wrapServerError(error, telemetry.Events.GetChatQueueLengthFailed.MESSAGE);

                reject(exception);
            }

            var context = {},
                logContext = {},
                validationError;

            if (params) {
                logContext.visitId = params.visitId ? params.visitId : null;
                logContext.engagementId = params.engagementId ? params.engagementId : null;
                logContext.partnerId = params.partnerId ? params.partnerId : null;
                context.subject = params.subject ? params.subject : null;
                context.language = params.language ? params.language : null;
                context.country = params.country ? params.country : null;
                context.tier = params.tier ? params.tier : null;
                context.mode = params.mode ? params.mode : null;
            }

            exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER);

            _.forEach(logContext, function (value, key) {
                if (_.isNull(value) || _.isUndefined(value) || value === '') {
                    validationError = key + ' is required for getting chat queue length';
                    return false;
                }
            });

            if (validationError) {
                var exception = exceptionManager.wrapRequestInvalid(validationError);

                onError(exception);
                return;
            }

            _.forEach(context, function (value, key) {
                if (_.isNull(value) || _.isUndefined(value) || value === '') {
                    validationError = key + ' is required for getting chat queue length';
                    return false;
                }
            });

            if (validationError) {
                var exception = exceptionManager.wrapRequestInvalid(validationError);

                onError(exception);
                return;
            }

            gatewayService = serviceLocator.resolve(constants.serviceLocator.GATEWAY);
            gatewayService.getChatQueueLength(context, logContext).then(onSuccess).catch(onError);
        });
    };

    exports.getReachableAgentCount = function (params) {
        return new Promise(function (resolve, reject) {
            function onSuccess(result) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.ReachableAgentCountFetched.ID
                    ],
                    eventName: telemetry.Events.ReachableAgentCountFetched.NAME,
                    data: {
                        message: telemetry.Events.ReachableAgentCountFetched.MESSAGE,
                        visitId: logContext.visitId,
                        engagementId: logContext.engagementId,
                        partnerId: logContext.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);

                resolve(result);
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.GetReachableAgentCountFailed.ID
                    ],
                    eventName: telemetry.Events.GetReachableAgentCountFailed.NAME,
                    data: {
                        message: telemetry.Events.GetReachableAgentCountFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error)
                    }
                };

                if (logContext.visitId) {
                    loggingContext.data.visitId = logContext.visitId;
                }

                if (logContext.engagementId) {
                    loggingContext.data.engagementId = logContext.engagementId;
                }

                if (logContext.partnerId) {
                    loggingContext.data.partnerId = logContext.partnerId;
                }

                telemetryClient.get().sendEvent(loggingContext);

                var exception = exceptionManager.wrapServerError(error, telemetry.Events.GetChatQueueLengthFailed.MESSAGE);

                reject(exception);
            }

            var context = {},
                logContext = {},
                validationError;

            if (params) {
                logContext.visitId = params.visitId ? params.visitId : null;
                logContext.engagementId = params.engagementId ? params.engagementId : null;
                logContext.partnerId = params.partnerId ? params.partnerId : null;
                context.subject = params.subject ? params.subject : null;
                context.language = params.language ? params.language : null;
                context.country = params.country ? params.country : null;
            } else {
                params = {};
            }

            exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER);
            _.forEach(logContext, function (value, key) {
                if (_.isNull(value) || _.isUndefined(value) || value === '') {
                    validationError = key + ' is required for getting reachable agent count';
                    return false;
                }
            });

            if (validationError) {
                var exception = exceptionManager.wrapRequestInvalid(validationError);

                onError(exception);
                return;
            }

            _.forEach(context, function (value, key) {
                if (_.isNull(value) || _.isUndefined(value) || value === '') {
                    validationError = key + ' is required for getting reachable agent count';
                    return false;
                }
            });

            if (validationError) {
                var exception = exceptionManager.wrapRequestInvalid(validationError);

                onError(exception);
                return;
            }

            if (params.mode) {
                context.mode = params.mode;
            }

            if (params.tier) {
                context.tier = params.tier;
            }

            gatewayService = serviceLocator.resolve(constants.serviceLocator.GATEWAY);
            gatewayService.getReachableAgentCount(context, logContext).then(onSuccess).catch(onError);
        });
    };

    exports.assign = function (params) {
        return new Promise(function (resolve, reject) {
            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.CaseAssigned.ID
                    ],
                    eventName: telemetry.Events.CaseAssigned.NAME,
                    data: {
                        message: telemetry.Events.CaseAssigned.MESSAGE,
                        extraContext: {
                            caseId: params.caseId,
                            taskId: params.taskId ? params.taskId : ''
                        }
                    }
                };
                _.assignIn(loggingContext.data, params);
                telemetryClient.get().sendEvent(loggingContext);
                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.AssignCaseFailed.ID
                    ],
                    eventName: telemetry.Events.AssignCaseFailed.NAME,
                    data: {
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        message: telemetry.Events.AssignCaseFailed.MESSAGE,
                        extraContext: {
                            caseId: params ? params.caseId : '',
                            taskId: params.taskId ? params.taskId : ''
                        }
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapServerError(error, telemetry.Events.AssignCaseFailed.MESSAGE);

                reject(exception);
            }

            exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER);

            if (!params || !params.caseId || !params.assigneeUpn) {
                var exception = exceptionManager.wrapRequestInvalid('caseId, currentOwnerAgentUpn or assigneeUpn is missing in the parameter object.');

                onError(exception);
                return;
            }

            gatewayService = serviceLocator.resolve(constants.serviceLocator.GATEWAY);
            gatewayService.assign(params).then(onSuccess).catch(onError);
        });
    };

    exports.chatEngagements = (function () {
        function added(callback) {
            pubSub = serviceLocator.resolve(constants.serviceLocator.PUBSUB);
            pubSub.subscribe(constants.events.INCOMING_CHAT_REQUEST, callback);
        }

        function get(chatId) {
            chatEngagementsApi = serviceLocator.resolve(constants.serviceLocator.CHAT_ENGAGEMENTS);
            return chatEngagementsApi.getChatEngagement(chatId);
        }

        function getSnapshot() {
            chatEngagementsApi = serviceLocator.resolve(constants.serviceLocator.CHAT_ENGAGEMENTS);
            return chatEngagementsApi.getSnapshot();
        }

        return {
            get: get,
            getSnapshot: getSnapshot,
            added: added
        };
    })();
});
define('api/helpers/engagements',['require','exports','module','constants/common','api/engagement','services/serviceLocator','lodash'],function (require, exports) {
    'use strict';

    var constants = require('constants/common'),
        engagementApi = require('api/engagement'),
        serviceLocator = require('services/serviceLocator'),
        _ = require('lodash');

    function endEngagements(engagementsToEnd) {
        _.forEach(engagementsToEnd, function (value) {
            value.predicted = true;
            engagementApi.endEngagement(value);
        });
    }

    function addEngagements(engagementsToAdd) {
        var gatewayService = serviceLocator.resolve(constants.serviceLocator.GATEWAY);

        _.forEach(engagementsToAdd, function (value) {
            gatewayService.addEngagement(value);
        });
    }

    exports.syncEngagements = function (engagementList) {
        var activeEngagementsApi = serviceLocator.resolve(constants.serviceLocator.ACTIVE_ENGAGEMENTS),
            engagementsToAdd = activeEngagementsApi.getActiveEngagement(),
            engagementsToEnd = {};

        _.forEach(engagementList, function (value) {
            engagementsToEnd[value.EngagementId] = {
                visitId: value.VisitId,
                engagementId: value.EngagementId,
                conferenceId: value.ConferenceId
            };
        });

        _.forEach(engagementList, function (value) {
            var engagementId = value.EngagementId;

            if (activeEngagementsApi.hasEngagement(engagementId)) {
                delete engagementsToAdd[engagementId];
                delete engagementsToEnd[engagementId];
            }
        });

        endEngagements(engagementsToEnd);
        addEngagements(engagementsToAdd);
    };
});
define('eventHandlers/agentAvailabilityHandler',['require','exports','module','lodash','constants/common','api/helpers/engagements','api/agentAvailability','services/serviceLocator'],function (require, exports){
    'use strict';

    var _ = require('lodash'),
        constants = require('constants/common'),
        engagementsHelperApi = require('api/helpers/engagements'),
        agentAvailabilityApi = require('api/agentAvailability'),
        serviceLocator = require('services/serviceLocator'),
        pubSub, agentContextApi;

    exports.init = function () {
        var hasFailed = false;

        pubSub = serviceLocator.resolve(constants.serviceLocator.PUBSUB);
        agentContextApi = serviceLocator.resolve(constants.serviceLocator.AGENT_CONTEXT);

        function onUnreachable() {
            pubSub.publish(constants.events.CHAT_CHANNEL_UNAVAILABLE, [{reason: 'UnreachableByService'}]);
        }

        function syncAvailabilityStatus(modalityDetails) {
            var changedModalityDetails = [],
                currentStatus = agentContextApi.getModalityDetails();

            _.forEach(modalityDetails, function(detail) {
                var modality = detail.modality,
                    status = currentStatus[modality] ? currentStatus[modality].availabilityStatus : '',
                    reason = currentStatus[modality] ? currentStatus[modality].reason : '';

                if ((status !== detail.availabilityStatus.toLowerCase()) || (reason !== detail.reason)) {
                    changedModalityDetails.push(detail);
                }
            });

            return changedModalityDetails;
        }

        function startSync() {
            var getAvailabilityLoopId = setInterval(function () {
                agentAvailabilityApi.getAvailability(true).then(function (status) {
                    var updatedModalityDetails = syncAvailabilityStatus(status.modalityDetails),
                        currentMaxChatCount = agentContextApi.getMaxChatCount();

                    if (hasFailed) {
                        hasFailed = false;
                        pubSub.publish(constants.events.GET_AVAILABILITY_RESTORED, []);
                    }

                    if (updatedModalityDetails.length > 0) {
                        var eventData = {
                            modalityDetails: updatedModalityDetails,
                            updatedBy: status.updatedById
                        };

                        agentContextApi.setModalityDetails(updatedModalityDetails);
                        pubSub.publish(constants.events.AVAILABILITY_UPDATED, [eventData]);
                    }

                    if (agentContextApi.isSupportingChat() && !agentContextApi.isPendingAcceptance()) {
                        engagementsHelperApi.syncEngagements(status.activeEngagements);
                    }

                    if (agentContextApi.isSupportingChat() && status.isUnreachable) {
                        onUnreachable();
                    }

                    if (agentContextApi.isSupportingChat() && (status.maxChatCount !== currentMaxChatCount)) {
                        var eventData = {
                            maxChatCount: status.maxChatCount
                        };

                        agentContextApi.setMaxChatCount(status.maxChatCount);
                        pubSub.publish(constants.events.MAX_CHAT_COUNT_UPDATED, [eventData]);
                    }
                }).catch(function (error) {
                    var errorMsg = typeof error === 'string' ? error : JSON.stringify(error);

                    // Expose IE memory leak issue
                    if (errorMsg.indexOf('Not enough storage is available') > -1 || errorMsg.indexOf('download of the specified resource has failed') > -1) {
                        pubSub.publish(constants.events.CHAT_CHANNEL_UNAVAILABLE, [{reason: 'NotEnoughStorage'}]);
                    }

                    hasFailed = true;
                    pubSub.publish(constants.events.GET_AVAILABILITY_FAILED, [{reason: error}]);
                });
            }, constants.getAvailabilityInterval);

            agentContextApi.setAvailabilityPingLoop(getAvailabilityLoopId);
        }

        startSync();
    };

    exports.dispose = function () {
        var availabilityPingLoopId;

        agentContextApi = serviceLocator.resolve(constants.serviceLocator.AGENT_CONTEXT);
        availabilityPingLoopId = agentContextApi.getAvailabilityPingLoop();
        window.clearInterval(availabilityPingLoopId);
    };
});
define('models/chatEngagement',['require','exports','module','constants/common'],function (require, exports) {
    'use strict';

    var constants = require('constants/common');

    exports.build = function (conversation) {
        var chatEngagement = {};

        chatEngagement.visitId = conversation.visitId;
        chatEngagement.engagementId = conversation.engagementId;
        chatEngagement.partnerId = conversation.partnerId;
        chatEngagement.conferenceId = conversation.conferenceId;
        chatEngagement.chatId = conversation.chatId;
        chatEngagement.chatType = conversation.chatType;
        chatEngagement.inviteType = conversation.inviteType;
        chatEngagement.initiatedAgentDisplayName = conversation.initiatedAgentDisplayName;
        chatEngagement.fromSubject = conversation.fromSubject;
        chatEngagement.accept = conversation.accept.bind(conversation);
        chatEngagement.reject = conversation.reject.bind(conversation);
        chatEngagement.startInternalChat = conversation.startInternalChat.bind(conversation);
        chatEngagement.sendMessage = conversation.sendMessage.bind(conversation);
        chatEngagement.sendCommand = conversation.sendCommand.bind(conversation);
        chatEngagement.sendIsTyping = conversation.sendIsTyping.bind(conversation);
        chatEngagement.transfer = conversation.transfer.bind(conversation);
        chatEngagement.group = conversation.group.bind(conversation);
        chatEngagement.consult = conversation.consult.bind(conversation);
        chatEngagement.dequeue = conversation.dequeue.bind(conversation);
        chatEngagement.switchToGroup = conversation.switchToGroup.bind(conversation);
        chatEngagement.barge = conversation.barge.bind(conversation);
        chatEngagement.endChat = conversation.endChat.bind(conversation);
        chatEngagement.event = (function () {
            function subscribe(eventName, callback) {
                conversation.pubSub.subscribe(eventName, callback);
            }

            function unsubscribe(eventName, callback) {
                conversation.pubSub.unsubscribe(eventName, callback);
            }

            return {
                on: subscribe,
                off: unsubscribe
            };
        })();

        chatEngagement.events = (function () {
            return {
                chatMessageAdded: constants.events.CHAT_MESSAGE_ADDED,
                commandReceived: constants.events.COMMAND_RECEIVED,
                participantAdded: constants.events.PARTICIPANT_ADDED,
                participantRemoved: constants.events.PARTICIPANT_REMOVED,
                isParticipantTyping: constants.events.IS_PARTICIPANT_TYPING,
                consultingAgentAdded: constants.events.CONSULTING_AGENT_ADDED,
                participantFilterRemoved: constants.events.PARTICIPANT_FILTER_REMOVED,
                participantInvitationFailed: constants.events.PARTICIPANT_INVITE_FAILED,
                customerRejoined: constants.events.CUSTOMER_REJOINED,
                participantDisconnected: constants.events.PARTICIPANT_DISCONNECTED,
                participantReconnected: constants.events.PARTICIPANT_RECONNECTED,
                customerLeft: constants.events.CUSTOMER_LEFT,
                transcriptLoaded: constants.events.TRANSCRIPT_LOADED
            };
        })();

        chatEngagement.endChatReasons = (function () {
            return {
                endChat: constants.participantRemovedReason.EndChat,
                unreachable: constants.participantRemovedReason.Unreachable
            };
        })();

        chatEngagement._getConversation = function () {
            return conversation.conversation;
        };

        chatEngagement._getSnapshot = function () {
            return {
                visitId: conversation.visitId,
                engagementId: conversation.engagementId,
                partnerId: conversation.partnerId,
                conferenceId: conversation.conferenceId,
                chatId: conversation.chatId,
                inviteType: conversation.inviteType,
                isFilterOn: conversation.isFilterOn
            };
        };

        return chatEngagement;
    };
});
define('models/internalChat',['require','exports','module','constants/common'],function (require, exports) {
    'use strict';

    var constants = require('constants/common');

    exports.build = function (conversation) {
        var internalChat = {};

        internalChat.visitId = conversation.visitId;
        internalChat.engagementId = conversation.engagementId;
        internalChat.partnerId = conversation.partnerId;
        internalChat.chatType = conversation.chatType;
        internalChat.inviteType = conversation.inviteType;
        internalChat.initiatedAgentDisplayName = conversation.initiatedAgentDisplayName;
        internalChat.chatId = conversation.chatId;
        internalChat.accept = conversation.accept.bind(conversation);
        internalChat.reject = conversation.reject.bind(conversation);
        internalChat.sendMessage = conversation.sendMessage.bind(conversation);
        internalChat.sendIsTyping = conversation.sendIsTyping.bind(conversation);
        internalChat.endChat = conversation.endChat.bind(conversation);
        internalChat.event = (function () {
            function subscribe(eventName, callback) {
                conversation.pubSub.subscribe(eventName, callback);
            }

            function unsubscribe(eventName, callback) {
                conversation.pubSub.unsubscribe(eventName, callback);
            }

            return {
                on: subscribe,
                off: unsubscribe
            };
        })();

        internalChat.events = (function () {
            return {
                chatMessageAdded: constants.events.CHAT_MESSAGE_ADDED,
                commandReceived: constants.events.COMMAND_RECEIVED,
                participantAdded: constants.events.PARTICIPANT_ADDED,
                participantDisconnected: constants.events.PARTICIPANT_DISCONNECTED,
                participantReconnected: constants.events.PARTICIPANT_RECONNECTED,
                isParticipantTyping: constants.events.IS_PARTICIPANT_TYPING
            };
        })();

        internalChat._getConversation = function () {
            return conversation.conversation;
        };

        return internalChat;
    };
});
define('skype/conversation',['require','exports','module','skype/jlyncApplication'],function (require, exports){
    'use strict';

    var jlyncApp = require('skype/jlyncApplication'),
        jlync;

    exports.startConversation = function (agentSip, visitContext) {
        return new Promise(function (resolve, reject) {
            function onSuccess() {
                conv.context = function () {
                    return visitContext.context;
                };
                resolve(conv);
            }

            function onError(error) {
                reject(error);
            }

            jlync = jlyncApp.get();
            var conv = jlync.conversationsManager.createConversation({isConference: false});

            conv.participants.add(agentSip);
            Promise.resolve(visitContext)
            .then(conv.chatService.start)
            .then(onSuccess)
            .catch(onError);
        });
    };

    exports.removeConversation = function (jlync, conv) {
        return Promise.resolve(conv).then(jlync.conversationsManager.conversations.remove);
    };
});
define('models/transferConsultResponse',['require','exports','module'],function (require, exports) {
    'use strict';

    function Response(responseCode, position, schedule) {
        this.code = responseCode;
        this.position = position;
        this.schedule = schedule;
    }

    exports.create = function (responseCode, position, schedule) {
        return new Response(responseCode, position, schedule);
    };
});
define('api/helpers/hoops',['require','exports','module','constants/common','lodash','models/transferConsultResponse'],function (require, exports) {
    'use strict';

    var constants = require('constants/common'),
        _ = require('lodash'),
        transferConsultResponseHelperApi = require('models/transferConsultResponse');

    exports.parseHoops = function (hoops) {
        var reponseCode,
            output = null;

        if (_.isEmpty(hoops)) {
            reponseCode = constants.responseCodes.QUEUE_INVALID;

            return transferConsultResponseHelperApi.create(reponseCode, null, null);
        }

        _.forEach(hoops, function (value) {
            if (value.IsInHOOPS === null) {
                reponseCode = constants.responseCodes.QUEUE_INVALID;
                output = transferConsultResponseHelperApi.create(reponseCode, null, null);

                return false;
            }

            if (value.IsInHOOPS === false) {
                reponseCode = constants.responseCodes.OUT_OF_HOOPS;
                output = transferConsultResponseHelperApi.create(reponseCode, null, value);

                return false;
            }
        });

        return output;
    };
});
define('api/helpers/message',[],function () {
    'use strict';

    function isCommandMessage(message) {
        try {
            var commandMsg = JSON.parse(message);

            if (!commandMsg || !commandMsg.Command || commandMsg.Command === 'Message') {
                return false;
            }
        } catch (ex) {
            return false;
        }

        return true;
    }

    return {
        isCommandMessage: isCommandMessage
    };
});
define('models/messageFacade',['require','exports','module'],function (require, exports) {
    'use strict';

    function parseMessage(message) {
        try {
            var commandMsg = JSON.parse(message);

            if (commandMsg.Message) {
                return {
                    message: decodeURIComponent(commandMsg.Message),
                    isAgentViewOnly: commandMsg.IsAgentViewOnly
                };
            } else {
                return {
                    message: message,
                    isAgentViewOnly: false
                };
            }
        } catch (ex) {
            return {
                message: message,
                isAgentViewOnly: false
            };
        }
    }

    function MessageFacade(sfbMessage) {
        var parsedMessage = parseMessage(sfbMessage.html());

        this.textMessage = parsedMessage.message;
        this.isAgentViewOnly = parsedMessage.isAgentViewOnly;
        this.timestamp = sfbMessage.timestamp().toJSON();
        this.direction = sfbMessage.direction();
        this.senderId = sfbMessage.sender ? sfbMessage.sender.id() : '';
        this.senderDisplayName = sfbMessage.sender ? sfbMessage.sender.displayName() : '';
    }

    exports.create = function (message) {
        return new MessageFacade(message);
    };
});
define('models/participantFacade',['require','exports','module','lodash'],function (require, exports) {
    'use strict';

    var _ = require('lodash');

    function ParticipantFacade(participant) {
        this.id = participant.person.id();
        this.isCustomer = (/@anonymous\.invalid$/).test(this.id);
        this.displayName = participant.person.displayName();
    }

    exports.create = function (participant) {
        return new ParticipantFacade(participant);
    };

    exports.createParticipants = function (participantList) {
        var participants = [];

        _.forEach(participantList, function (id) {
            var participant = {
                id: id,
                isCustomer: false,
                displayName: id
            };

            participants.push(participant);
        });

        return participants;
    };
});
define('services/pubSub',['require','exports','module','lodash','telemetry/telemetryClient','constants/telemetry'],function (require, exports) {
    'use strict';

    var _ = require('lodash'),
        telemetryClient = require('telemetry/telemetryClient'),
        telemetry = require('constants/telemetry');

    function PubSub() {
        this.callbacks = {};
    }

    PubSub.prototype.subscribe = function (eventName, callback) {
        this.callbacks[eventName] = this.callbacks[eventName] || [];

        if (_.isFunction(callback) && this.callbacks[eventName].indexOf(callback) < 0) {
            this.callbacks[eventName].push(callback);
        }
    };

    PubSub.prototype.unsubscribe = function (eventName, callback) {
        var callbacksToBeCalled = this.callbacks[eventName];

        if (!callbacksToBeCalled || callbacksToBeCalled.indexOf(callback) < 0) {
            return;
        }

        callbacksToBeCalled.splice(callbacksToBeCalled.indexOf(callback), 1);
    };

    PubSub.prototype.publish = function (eventName, eventArgsArray) {
        var callbacksToBeCalled = this.callbacks[eventName],
            loggingContext = {
                eventId: [
                    telemetry.MilestoneCodes.Default,
                    telemetry.StatusEventCodes.Default,
                    telemetry.OutcomeBits.Success,
                    telemetry.Events.EventPublished.ID
                ],
                eventName: telemetry.Events.EventPublished.NAME,
                data: {
                    message: telemetry.Events.EventPublished.MESSAGE,
                    extraContext: {
                        eventName: eventName
                    }
                }
            };

        telemetryClient.get().sendEvent(loggingContext);

        if (callbacksToBeCalled) {
            _(callbacksToBeCalled).forEach(function (callback) {
                callback.apply(null, eventArgsArray);
            });
        }
    };

    PubSub.prototype.dispose = function () {
        this.callbacks = {};
    };

    exports.build = function() {
        return new PubSub();
    };
});
define('models/conversation',['require','exports','module','skype/jlyncApplication','api/engagement','api/helpers/hoops','models/transferConsultResponse','services/serviceLocator','api/helpers/message','models/messageFacade','models/participantFacade','constants/common','services/pubSub','skype/conversation','models/internalChat','telemetry/telemetryClient','constants/telemetry','lodash'],function (require, exports) {
    'use strict';

    var jlyncApp = require('skype/jlyncApplication'),
        engagementApi = require('api/engagement'),
        hoopsHelperApi = require('api/helpers/hoops'),
        transferConsultResponseHelperApi = require('models/transferConsultResponse'),
        serviceLocator = require('services/serviceLocator'),
        messageHelperApi = require('api/helpers/message'),
        messageFacadeModel = require('models/messageFacade'),
        participantFacadeModel = require('models/participantFacade'),
        constants = require('constants/common'),
        pubSubService = require('services/pubSub'),
        skypeConversationApi = require('skype/conversation'),
        internalChatModel = require('models/internalChat'),
        telemetryClient = require('telemetry/telemetryClient'),
        telemetry = require('constants/telemetry'),
        _ = require('lodash'),
        loggingContext, agentContextApi, chatEngagementsApi,
        exceptionManager;

    function Conversation(params) {
        function commandMessageHandler(commandObj) {
            var command = commandObj.Command;

            switch (command) {
                case constants.command.Ping:
                    break;
                case constants.command.TranscriptLoaded:
                    self.pubSub.publish(constants.events.TRANSCRIPT_LOADED, []);

                    break;
                default:
                    self.pubSub.publish(constants.events.COMMAND_RECEIVED, [commandObj]);
            }
        }

        function registerMessageAddedHandler() {
            var chatMessages = {},
                messages = self.conversation.historyService.activityItems.filter(function (message) {
                    return message.type() === constants.skypeMessageFormat.TEXTMESSAGE;
                });

            var messageAddedSub = messages.added(function (message) {
                var chatMessage = message.html(),
                    key = message.key(),
                    direction = message.direction(),
                    isIncomingMessage = (direction === constants.skypeMessageDirection.INCOMING);

                // ignore empty messages
                if (!chatMessage) {
                    return;
                }

                // jlync will reinsert the activity item if its timestamp changes for outgoing messages.
                // Doing this would simplify the UI behavior. Otherwise removed events also need to be subsribed to.
                if (!messageHelperApi.isCommandMessage(chatMessage) && !chatMessages[key]) {
                    if (isIncomingMessage) {
                        loggingContext = {
                            eventId: [
                                telemetry.MilestoneCodes[self.inviteType],
                                telemetry.StatusEventCodes.Connected,
                                telemetry.OutcomeBits.Success,
                                telemetry.Events.ChatMessageReceived.ID
                            ],
                            eventName: telemetry.Events.ChatMessageReceived.NAME,
                            data: {
                                message: telemetry.Events.ChatMessageReceived.MESSAGE,
                                visitId: self.visitId,
                                engagementId: self.engagementId,
                                partnerId: self.partnerId
                            }
                        };
                        telemetryClient.get().sendEvent(loggingContext);
                    }

                    if (isIncomingMessage && !self.customerConnected) {
                        self.customerConnected = true;
                        self.pubSub.publish(constants.events.PARTICIPANT_RECONNECTED, [self.customer]);
                    }

                    var messageFacade = messageFacadeModel.create(message);

                    chatMessages[key] = messageFacade;
                    self.pubSub.publish(constants.events.CHAT_MESSAGE_ADDED, [messageFacade]);
                } else {
                    if (isIncomingMessage) {
                        var commandObj = JSON.parse(chatMessage);

                        commandMessageHandler(commandObj);
                    }
                }
            });

            self.subscriptionList.push(messageAddedSub);
        }

        function registerParticipantChangedHandler() {
            function onParticipantTypingChanged(isTyping) {
                self.pubSub.publish(constants.events.IS_PARTICIPANT_TYPING, [{participant: participant, isTyping: !!isTyping}]);
            }

            var participants = self.conversation.participants,
                participant,
                participantAddedSub,
                participantRemovedSub;

            participantAddedSub = participants.added(function (p) {
                p.person.id.get().then(function () {
                    participant = participantFacadeModel.create(p);

                    if (participant.isCustomer) {
                        self.customer = participant;
                        self.isApiEnabled = true;
                    }

                    self.pubSub.publish(constants.events.PARTICIPANT_ADDED, [participant]);
                    p.chat.isTyping.changed(onParticipantTypingChanged);
                });
            });
            participantRemovedSub = participants.removed(function (p) {
                participant = participantFacadeModel.create(p);

                if (participant.isCustomer) {
                    if (self.customerConnected) {
                        self.customerLeftReason = constants.participantRemovedReason.EndChat;
                    } else {
                        self.customerLeftReason = constants.participantRemovedReason.Unreachable;
                    }

                    self.isApiEnabled = false;
                    participant.reason = self.customerLeftReason;
                    self.pubSub.publish(constants.events.CUSTOMER_LEFT, [participant]);
                } else {
                    self.pubSub.publish(constants.events.PARTICIPANT_REMOVED, [participant]);
                }

                p.chat.isTyping.changed.off(onParticipantTypingChanged);
            });
            self.subscriptionList.push(participantAddedSub);
            self.subscriptionList.push(participantRemovedSub);

            if (!self.conversation.isGroupConversation()) {
                var state = self.conversation.state(),
                    connectedSub, disconnectedSub;

                connectedSub = self.conversation.state.when(constants.conversationState.Connected, function () {
                    if (state === constants.conversationState.Disconnected) {
                        state = self.conversation.state();
                        self.pubSub.publish(constants.events.PARTICIPANT_RECONNECTED, [participant]);
                    }
                });
                disconnectedSub = self.conversation.state.when(constants.conversationState.Disconnected, function () {
                    if (state === constants.conversationState.Connected) {
                        state = self.conversation.state();
                        self.pubSub.publish(constants.events.PARTICIPANT_DISCONNECTED, [participant]);
                    }
                });
                self.subscriptionList.push(connectedSub);
                self.subscriptionList.push(disconnectedSub);
            }
        }

        function registerConversationExtensionChangedHandler() {
            var conExtensionAddedSub = self.conversation.extensions.added(function (extension) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[self.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.ConversationExtensionAdded.ID
                    ],
                    eventName: telemetry.Events.ConversationExtensionAdded.NAME,
                    data: {
                        message: telemetry.Events.ConversationExtensionAdded.MESSAGE,
                        visitId: self.visitId,
                        engagementId: self.engagementId,
                        partnerId: self.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                self.acdConversationExtension = extension;
                extension.content.changed(function (content) {
                    console.log('conversation extesnion update for chat ' + self.chatId + ':' + content);

                    var contentObject = JSON.parse(content),
                        notifyState = contentObject ? contentObject.NotifyState : null,
                        agentId = agentContextApi.getSip();

                    switch (notifyState) {
                        case constants.conversationExtensionState.ParticipantFilterRemoved:
                            if (contentObject.InitiatedAgentSipId === agentId || contentObject.TargetAgentSipId === agentId) {
                                self.isFilterOn = (contentObject.TargetAgentSipId === agentId) ? false : self.isFilterOn;
                                self.inviteType = constants.inviteType.Group;
                                self.pubSub.publish(constants.events.PARTICIPANT_FILTER_REMOVED, [contentObject.InitiatedAgentSipId === agentId]);
                            }

                            break;
                        case constants.conversationExtensionState.AgentParticipantInvitationFailed:
                            if (contentObject.InitiatedAgentSipId === agentId || contentObject.TargetAgentSipId === agentId) {
                                self.pubSub.publish(constants.events.PARTICIPANT_INVITE_FAILED, [contentObject.TargetAgentSipId]);
                            }

                            break;
                        case constants.conversationExtensionState.BridgedParticipantsSettingRestored:
                            self.pubSub.publish(constants.events.CUSTOMER_REJOINED, []);

                            break;
                        case constants.conversationExtensionState.CustomerUnreachable:
                            if (self.customerConnected) {
                                self.customerConnected = false;
                                self.pubSub.publish(constants.events.PARTICIPANT_DISCONNECTED, [self.customer]);
                            }

                            break;
                        case constants.conversationExtensionState.CustomerReachable:
                            if (!self.customerConnected) {
                                self.customerConnected = true;
                                self.pubSub.publish(constants.events.PARTICIPANT_RECONNECTED, [self.customer]);
                            }

                            break;
                        case constants.conversationExtensionState.AgentsReachableDetect:
                            if (!_.isEmpty(contentObject.UnreachableAgentNames)) {
                                var participants = participantFacadeModel.createParticipants(contentObject.UnreachableAgentNames);

                                _.forEach(participants, function (participant) {
                                    self.pubSub.publish(constants.events.PARTICIPANT_DISCONNECTED, [participant]);
                                });
                            }

                            if (!_.isEmpty(contentObject.ReachableAgentNames)) {
                                var participants = participantFacadeModel.createParticipants(contentObject.ReachableAgentNames);

                                _.forEach(participants, function (participant) {
                                    self.pubSub.publish(constants.events.PARTICIPANT_RECONNECTED, [participant]);
                                });
                            }

                            break;
                    }

                    loggingContext = {
                        eventId: [
                            telemetry.MilestoneCodes[self.inviteType],
                            telemetry.StatusEventCodes.Connected,
                            telemetry.OutcomeBits.Success,
                            telemetry.Events.ConversationExtensionUpdate.ID
                        ],
                        eventName: telemetry.Events.ConversationExtensionUpdate.NAME,
                        data: {
                            message: telemetry.Events.ConversationExtensionUpdate.MESSAGE,
                            visitId: self.visitId,
                            engagementId: self.engagementId,
                            partnerId: self.partnerId,
                            extraContext: {
                                state: notifyState
                            }
                        }
                    };
                    telemetryClient.get().sendEvent(loggingContext);
                });
            });

            self.subscriptionList.push(conExtensionAddedSub);
        }

        function registerConversationStateChangedHandler() {
            var stateSub = self.conversation.state.when(constants.conversationState.Disconnected, function (reason) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[self.inviteType],
                        telemetry.StatusEventCodes.Disconnected,
                        telemetry.OutcomeBits.Unknown,
                        telemetry.Events.ConversationDisconnected.ID
                    ],
                    eventName: telemetry.Events.ConversationDisconnected.NAME,
                    data: {
                        message: telemetry.Events.ConversationDisconnected.MESSAGE,
                        faultContext: typeof reason === 'string' ? reason : JSON.stringify(reason),
                        visitId: self.visitId,
                        engagementId: self.engagementId,
                        partnerId: self.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
            });

            self.subscriptionList.push(stateSub);
        }

        function initEventHandler() {
            registerMessageAddedHandler();
            registerParticipantChangedHandler();
            registerConversationExtensionChangedHandler();
            registerConversationStateChangedHandler();
        }

        function dispose() {
            _.forEach(self.subscriptionList, function (sub) {
                sub.dispose();
            });
        }

        var context = params.conversation.context() ? params.conversation.context() : params.conversation.topic(),
            convContext,
            self = this;

        // conversation.context() is string when sending from ACD and is an object when
        // sending as an internal chat
        if (typeof context === 'string') {
            try {
                convContext = JSON.parse(context);
            } catch (ex) {}

            self.visitId = convContext && convContext.VId ? convContext.VId : null;
            self.engagementId = convContext && convContext.EId ? convContext.EId : null;
            self.partnerId = convContext && convContext.PId ? convContext.PId : null;
            self.conferenceId = convContext ? convContext.CId : null;
            self.inviteType = convContext && convContext.Type ? convContext.Type : constants.inviteType.Unknown;
            self.initiatedAgentDisplayName = convContext && convContext.FromAgent ? convContext.FromAgent : null;
            self.fromSubject = convContext ? convContext.FromSubject : null;
        } else {
            convContext = context;
            self.visitId = convContext ? convContext.visitId : null;
            self.engagementId = convContext ? convContext.engagementId : null;
            self.partnerId = convContext ? convContext.partnerId : null;
            self.conferenceId = convContext ? convContext.conferenceId : null;
            self.inviteType = convContext ? convContext.inviteType : constants.inviteType.Unknown;
            self.initiatedAgentDisplayName = convContext ? convContext.initiatedAgentName : null;
        }

        self.isFilterOn = (self.inviteType === constants.inviteType.Consult);
        self.isFilterOn = (convContext && _.has(convContext, 'isFilterOn')) ? convContext.isFilterOn : self.isFilterOn;
        self.isApiEnabled = true;
        self.transferSlcContext;
        self.customerLeftReason = constants.participantRemovedReason.Unreachable;
        self.customerConnected = true;
        self.acdConversationExtension = null;
        self.chatType = params.chatType;
        self.chatId = params.conversation.id();
        self.onlineMeetingUri = params.conversation.uri();
        self.conversation = params.conversation;
        self.pubSub = pubSubService.build();
        self.init = initEventHandler;
        self.subscriptionList = [];
        self.dispose = dispose;
        self.jlync = params.jlync ? params.jlync : jlyncApp.get();
        agentContextApi = serviceLocator.resolve(constants.serviceLocator.AGENT_CONTEXT);
        chatEngagementsApi = serviceLocator.resolve(constants.serviceLocator.CHAT_ENGAGEMENTS);
        exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER);

        // Only log this when it is an incoming/rehydration conversation. Outgoing conversation is sending
        // internal chat and the event will be logged when the conversation is sent.
        if (self.chatType === constants.chatType.Incoming) {
            loggingContext = {
                eventId: [
                    telemetry.MilestoneCodes[self.inviteType],
                    telemetry.StatusEventCodes.Routed,
                    telemetry.OutcomeBits.Success,
                    telemetry.Events.IncomingConversationReceived.ID
                ],
                eventName: telemetry.Events.IncomingConversationReceived.NAME,
                data: {
                    message: telemetry.Events.IncomingConversationReceived.MESSAGE,
                    visitId: self.visitId,
                    engagementId: self.engagementId,
                    partnerId: self.partnerId,
                    extraContext: {
                        inviteType: self.inviteType,
                        conferenceId: self.conferenceId,
                        chatId: self.chatId
                    }
                }
            };

            telemetryClient.get().sendEvent(loggingContext);
        } else {
            if (self.chatType === constants.chatType.Rehydration) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[self.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.ChatEngagementRehydrated.ID
                    ],
                    eventName: telemetry.Events.ChatEngagementRehydrated.NAME,
                    data: {
                        message: telemetry.Events.ChatEngagementRehydrated.MESSAGE,
                        visitId: self.visitId,
                        engagementId: self.engagementId,
                        partnerId: self.partnerId,
                        extraContext: {
                            inviteType: self.inviteType,
                            conferenceId: self.conferenceId,
                            chatId: self.chatId
                        }
                    }
                };

                telemetryClient.get().sendEvent(loggingContext);
            }

            // Init event handlers for rehydration/outgoing internal chat
            // Using setTimeout for init function is to delay its execution and make sure clients subscribe to events
            // before the app starts publishing them.
            setTimeout(self.init, 0);
        }
    }

    Conversation.prototype.accept = function () {
        var currentEngagement = this,
            conversation = currentEngagement.conversation,
            jlync = currentEngagement.jlync,
            activeEngagementsApi = serviceLocator.resolve(constants.serviceLocator.ACTIVE_ENGAGEMENTS);

        return new Promise(function (resolve, reject) {
            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Accepted,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.ChatEngagementAccepted.ID
                    ],
                    eventName: telemetry.Events.ChatEngagementAccepted.NAME,
                    data: {
                        message: telemetry.Events.ChatEngagementAccepted.MESSAGE,
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };

                if (currentEngagement.inviteType !== constants.inviteType.Internal) {
                    activeEngagementsApi.addActiveEngagement(currentEngagement);
                }

                telemetryClient.get().sendEvent(loggingContext);
                agentContextApi.setIsPendingAcceptance(false);
                setTimeout(currentEngagement.init, 0);
                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.AcceptChatEngagementFailed.ID
                    ],
                    eventName: telemetry.Events.AcceptChatEngagementFailed.NAME,
                    data: {
                        message: telemetry.Events.AcceptChatEngagementFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);

                // if the new chat comes with the same participants, there will be no
                // conversations.added event firing because the conversation has already been added.
                skypeConversationApi.removeConversation(jlync, conversation);
                chatEngagementsApi.removeChatEngagement(currentEngagement.chatId);
                agentContextApi.setIsPendingAcceptance(false);
                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.AcceptChatEngagementFailed.MESSAGE);

                reject(exception);
            }

            loggingContext = {
                eventId: [
                    telemetry.MilestoneCodes[currentEngagement.inviteType],
                    telemetry.StatusEventCodes.Routed,
                    telemetry.OutcomeBits.Unknown,
                    telemetry.Events.AcceptingChatEngagement.ID
                ],
                eventName: telemetry.Events.AcceptingChatEngagement.NAME,
                data: {
                    message: telemetry.Events.AcceptingChatEngagement.MESSAGE,
                    visitId: currentEngagement.visitId,
                    engagementId: currentEngagement.engagementId,
                    partnerId: currentEngagement.partnerId
                }
            };
            telemetryClient.get().sendEvent(loggingContext);
            agentContextApi.setIsPendingAcceptance(true);
            conversation.chatService.accept().then(onSuccess).catch(onError);
        });
    };

    Conversation.prototype.reject = function (reason) {
        var currentEngagement = this,
            conversation = currentEngagement.conversation,
            jlync = currentEngagement.jlync;

        return new Promise(function (resolve, reject) {
            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Declined,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.ChatEngagementRejected.ID
                    ],
                    eventName: telemetry.Events.ChatEngagementRejected.NAME,
                    data: {
                        message: telemetry.Events.ChatEngagementRejected.MESSAGE,
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId,
                        extraContext: {
                            reason: reason
                        }
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                chatEngagementsApi.removeChatEngagement(currentEngagement.chatId);
                agentContextApi.setIsPendingAcceptance(false);
                skypeConversationApi.removeConversation(jlync, conversation);
                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Default,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.RejectChatEngagementFailed.ID
                    ],
                    eventName: telemetry.Events.RejectChatEngagementFailed.NAME,
                    data: {
                        message: telemetry.Events.RejectChatEngagementFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId,
                        extraContext: {
                            reason: reason
                        }
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                chatEngagementsApi.removeChatEngagement(currentEngagement.chatId);
                agentContextApi.setIsPendingAcceptance(false);

                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.RejectChatEngagementFailed.MESSAGE);

                reject(exception);
            }

            conversation.chatService.reject().then(onSuccess).catch(onError);
        });
    };

    Conversation.prototype.sendMessage = function (params) {
        var currentEngagement = this,
            conversation = currentEngagement.conversation;

        return new Promise(function (resolve, reject) {
            function onSuccess(delivered) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.ChatMessageSent.ID
                    ],
                    eventName: telemetry.Events.ChatMessageSent.NAME,
                    data: {
                        message: telemetry.Events.ChatMessageSent.MESSAGE,
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId,
                        conferenceId: currentEngagement.conferenceId,
                        extraContext: {
                            delivered: delivered,
                            conferenceOnlineMeetingUri: currentEngagement.onlineMeetingUri,
                            conferenceId: currentEngagement.conferenceId
                        }
                    }
                };
                loggingContext.isChatEntityEvent = true;
                telemetryClient.get().sendEvent(loggingContext);
                resolve(delivered);
            }

            function onError(error, failedDeliveryParticipants) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.SendChatMessageFailed.ID
                    ],
                    eventName: telemetry.Events.SendChatMessageFailed.NAME,
                    data: {
                        message: telemetry.Events.SendChatMessageFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.SendChatMessageFailed.MESSAGE);

                exception.failedDeliveryParticipants = failedDeliveryParticipants ? failedDeliveryParticipants : [];
                reject(exception);
            }

            function onMessageSent(sfbMessage) {
                sfbMessage.status.once(constants.skypeMessageStatus.FAILED, function (reason) {
                    console.log('Sent message failed with reason: ' + JSON.stringify(reason));

                    sfbMessage.failedDeliveryParticipants.get().then(function () {
                        var participants = sfbMessage.failedDeliveryParticipants(),
                            participantList = [];

                        _.forEach(participants, function (p) {
                            participantList.push(participantFacadeModel.create(p));
                        });

                        // suppress the error for now as transcript will save it.
                        onSuccess(false);
                    });
                });

                sfbMessage.status.once(constants.skypeMessageStatus.SUCCEEDED, function () {
                    if (!currentEngagement.customerConnected) {
                        currentEngagement.customerConnected = true;
                        currentEngagement.pubSub.publish(constants.events.PARTICIPANT_RECONNECTED, [currentEngagement.customer]);
                    }

                    onSuccess(true);
                });
            }

            if (!currentEngagement.isApiEnabled) {
                var exception = exceptionManager.wrapRequestInvalid(constants.errorMessage.APIDISABLED);

                onError(exception);
                return;
            }

            var message = _.isString(params) ? params : (params ? params.message : ''),
                isAgentViewOnly = params ? !!params.isAgentViewOnly : false,
                messageToSend,
                convExPromise = Promise.resolve();

            if (_.isString(params)) {
                messageToSend = message;
            } else {
                messageToSend = JSON.stringify({
                    Command: constants.command.Message,
                    Message: encodeURIComponent(message),
                    IsAgentViewOnly: isAgentViewOnly
                });
            }

            if (currentEngagement.inviteType === constants.inviteType.Internal) {
                var postTranscriptModel = {
                    visitId: currentEngagement.visitId,
                    engagementId: currentEngagement.engagementId,
                    partnerId: currentEngagement.partnerId,
                    message: messageToSend
                };

                engagementApi.postTranscript(postTranscriptModel);
            }

            if (isAgentViewOnly) {
                if (!currentEngagement.isFilterOn) {
                    convExPromise = currentEngagement.enableFilter();
                }
            } else {
                if (currentEngagement.isFilterOn) {
                    convExPromise = currentEngagement.disableFilter();
                }
            }

            convExPromise.then(function () {
                return conversation.chatService.sendMessage(messageToSend, 'html');
            }).then(onMessageSent).catch(onError);
        });
    };

    Conversation.prototype.sendCommand = function (command) {
        var currentEngagement = this,
            conversation = currentEngagement.conversation;

        return new Promise(function (resolve, reject) {
            function onSuccess(delivered) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.CommandMessageSent.ID
                    ],
                    eventName: telemetry.Events.CommandMessageSent.NAME,
                    data: {
                        message: telemetry.Events.CommandMessageSent.MESSAGE,
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId,
                        extraContext: {
                            commandName: command.Command,
                            delivered: delivered
                        }
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                resolve(delivered);
            }

            function onError(error, failedDeliveryParticipants) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.SendCommandMessageFailed.ID
                    ],
                    eventName: telemetry.Events.SendCommandMessageFailed.NAME,
                    data: {
                        message: telemetry.Events.SendCommandMessageFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.SendCommandMessageFailed.MESSAGE);

                exception.failedDeliveryParticipants = failedDeliveryParticipants ? failedDeliveryParticipants : [];
                reject(exception);
            }

            function onMessageSent(sfbMessage) {
                sfbMessage.status.once(constants.skypeMessageStatus.FAILED, function (reason) {
                    console.log('Sent command failed with reason: ' + JSON.stringify(reason));

                    sfbMessage.failedDeliveryParticipants.get().then(function () {
                        var participants = sfbMessage.failedDeliveryParticipants(),
                            participantList = [];

                        _.forEach(participants, function (p) {
                            participantList.push(participantFacadeModel.create(p));
                        });

                        onSuccess(false);
                    });
                });

                sfbMessage.status.once(constants.skypeMessageStatus.SUCCEEDED, function () {
                    if (!currentEngagement.customerConnected) {
                        currentEngagement.customerConnected = true;
                        currentEngagement.pubSub.publish(constants.events.PARTICIPANT_RECONNECTED, [currentEngagement.customer]);
                    }

                    onSuccess(true);
                });
            }

            function validate() {
                if (!currentEngagement.isApiEnabled) {
                    return constants.errorMessage.APIDISABLED;
                }

                if (!_.isObject(command) || !command.Command) {
                    return 'The command format is invalid';
                }
            }

            var errorMessage = validate();

            if (errorMessage) {
                var exception = exceptionManager.wrapRequestInvalid(errorMessage);

                onError(exception);
                return;
            }

            var commandMessage = (command.Command === constants.command.AutomatedMessage) ? command.Context.Message : JSON.stringify(command);

            Promise.resolve({ html: commandMessage }).then(conversation.chatService.sendMessage).then(onMessageSent).catch(onError);
        });
    };

    Conversation.prototype.sendIsTyping = function () {
        var currentEngagement = this,
            conversation = currentEngagement.conversation;

        return new Promise(function (resolve, reject) {
            function onSuccess() {
                resolve();
            }

            function onError(error) {
                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.SendIsTypingFailed.MESSAGE);

                reject(exception);
            }

            if (!currentEngagement.isApiEnabled) {
                var exception = exceptionManager.wrapRequestInvalid(constants.errorMessage.APIDISABLED);

                onError(exception);
                return;
            }

            conversation.chatService.sendIsTyping().then(onSuccess).catch(onError);
        });
    };

    Conversation.prototype.transfer = function (args) {
        var currentEngagement = this;

        return new Promise(function (resolve, reject) {
            function onSuccess(result) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.TransferRequested.ID
                    ],
                    eventName: telemetry.Events.TransferRequested.NAME,
                    data: {
                        message: telemetry.Events.TransferRequested.MESSAGE,
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);

                var reponseCode = constants.responseCodes.QUEUED,
                    position,
                    output;

                try {
                    position = JSON.parse(result.content).Position;
                } catch (ex) {
                    position = null;
                }

                output = transferConsultResponseHelperApi.create(reponseCode, position, null);
                resolve(output);
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.TransferFailed.ID
                    ],
                    eventName: telemetry.Events.TransferFailed.NAME,
                    data: {
                        message: telemetry.Events.TransferFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.TransferFailed.MESSAGE);

                reject(exception);
            }

            if (!currentEngagement.isApiEnabled) {
                var exception = exceptionManager.wrapRequestInvalid(constants.errorMessage.APIDISABLED);

                onError(exception);
                return;
            }

            if (!currentEngagement.acdConversationExtension) {
                var exception = exceptionManager.wrapChannelError(null, constants.errorMessage.CONVERSATIONEXTENSIONMISSING);

                onError(exception);
                return;
            }

            var validationError,
                context = {};

            if (args) {
                context.subject = args.subject ? args.subject : null;
                context.language = args.language ? args.language : null;
                context.country = args.country ? args.country : null;
                context.tier = args.tier ? args.tier : null;
                context.mode = args.mode ? args.mode : null;
            }

            _.forEach(context, function (value, key) {
                if (_.isNull(value) || _.isUndefined(value) || value === '') {
                    validationError = key + ' is required for transferring a chat engagement';
                    return false;
                }
            });

            if (validationError) {
                var exception = exceptionManager.wrapRequestInvalid(validationError);

                onError(exception);
                return;
            }

            var acdConversationExtension = currentEngagement.acdConversationExtension,
                transferContext = {
                    actionType: 'Transfer',
                    slcContext: context,
                    initiatedAgentId: agentContextApi.getId(),
                    initiatedAgentSipId: agentContextApi.getSip(),
                    initiatedAgentName: agentContextApi.getDisplayName(),
                    fromSubject: args.fromSubject
                },
                contentType = 'text/json',
                getHoopsContext = _.clone(context);

            currentEngagement.transferSlcContext = context;
            getHoopsContext.channel = 'chat';
            getHoopsContext.mode = 'live';
            getHoopsContext.returnSchedules = true;
            getHoopsContext.visitId = currentEngagement.visitId;
            getHoopsContext.engagementId = currentEngagement.engagementId;
            getHoopsContext.partnerId = currentEngagement.partnerId;

            engagementApi.getSupportHours(getHoopsContext).then(function (result) {
                var output = hoopsHelperApi.parseHoops(result);

                if (output) {
                    resolve(output);
                } else {
                    return acdConversationExtension.sendData(transferContext, contentType).then(onSuccess);
                }
            }).catch(onError);
        });
    };

    Conversation.prototype.group = function (args) {
        var currentEngagement = this;

        return new Promise(function (resolve, reject) {
            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.GroupRequested.ID
                    ],
                    eventName: telemetry.Events.GroupRequested.NAME,
                    data: {
                        message: telemetry.Events.GroupRequested.MESSAGE,
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.GroupFailed.ID
                    ],
                    eventName: telemetry.Events.GroupFailed.NAME,
                    data: {
                        message: telemetry.Events.GroupFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.GroupFailed.MESSAGE);

                reject(exception);
            }

            if (!currentEngagement.isApiEnabled) {
                var exception = exceptionManager.wrapRequestInvalid(constants.errorMessage.APIDISABLED);

                onError(exception);
                return;
            }

            if (!currentEngagement.acdConversationExtension) {
                var exception = exceptionManager.wrapChannelError(null, constants.errorMessage.CONVERSATIONEXTENSIONMISSING);

                onError(exception);
                return;
            }

            var validationError,
                context = {};

            if (args) {
                context.subject = args.subject ? args.subject : null;
                context.language = args.language ? args.language : null;
                context.country = args.country ? args.country : null;
                context.tier = args.tier ? args.tier : null;
                context.mode = args.mode ? args.mode : null;
            }

            _.forEach(context, function (value, key) {
                if (_.isNull(value) || _.isUndefined(value) || value === '') {
                    validationError = key + ' is required for sending a group chat request.';
                    return false;
                }
            });

            if (validationError) {
                var exception = exceptionManager.wrapRequestInvalid(validationError);

                onError(exception);
                return;
            }

            var acdConversationExtension = currentEngagement.acdConversationExtension,
                groupChatContext = {
                    actionType: 'Group',
                    slcContext: context,
                    initiatedAgentId: agentContextApi.getId(),
                    initiatedAgentSipId: agentContextApi.getSip(),
                    initiatedAgentName: agentContextApi.getDisplayName()
                },
                contentType = 'text/json';

            acdConversationExtension.sendData(groupChatContext, contentType).then(onSuccess).catch(onError);
        });
    };

    Conversation.prototype.consult = function (args) {
        function onParticipantAdded(p) {
            if (!p.isCustomer) {
                currentEngagement.pubSub.publish(constants.events.CONSULTING_AGENT_ADDED, [p]);
                currentEngagement.pubSub.unsubscribe(constants.events.PARTICIPANT_ADDED, onParticipantAdded);
            }
        }

        var currentEngagement = this;

        return new Promise(function (resolve, reject) {
            function onSuccess(result) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.ConsultRequested.ID
                    ],
                    eventName: telemetry.Events.ConsultRequested.NAME,
                    data: {
                        message: telemetry.Events.ConsultRequested.MESSAGE,
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                currentEngagement.pubSub.subscribe(constants.events.PARTICIPANT_ADDED, onParticipantAdded);

                var reponseCode = constants.responseCodes.QUEUED,
                    position,
                    output;

                try {
                    position = JSON.parse(result.content).Position;
                } catch (ex) {
                    position = null;
                }

                output = transferConsultResponseHelperApi.create(reponseCode, position, null);
                resolve(output);
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.ConsultFailed.ID
                    ],
                    eventName: telemetry.Events.ConsultFailed.NAME,
                    data: {
                        message: telemetry.Events.ConsultFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.ConsultFailed.MESSAGE);

                reject(exception);
            }

            if (!currentEngagement.isApiEnabled) {
                var exception = exceptionManager.wrapRequestInvalid(constants.errorMessage.APIDISABLED);

                onError(exception);
                return;
            }

            if (!currentEngagement.acdConversationExtension) {
                var exception = exceptionManager.wrapChannelError(null, constants.errorMessage.CONVERSATIONEXTENSIONMISSING);

                onError(exception);
                return;
            }

            var validationError,
                context = {};

            if (args) {
                context.subject = args.subject ? args.subject : null;
                context.language = args.language ? args.language : null;
                context.country = args.country ? args.country : null;
                context.tier = args.tier ? args.tier : null;
                context.mode = args.mode ? args.mode : null;
            }

            _.forEach(context, function (value, key) {
                if (_.isNull(value) || _.isUndefined(value) || value === '') {
                    validationError = key + ' is required for sending a consult chat request.';
                    return false;
                }
            });

            if (validationError) {
                var exception = exceptionManager.wrapRequestInvalid(validationError);

                onError(exception);
                return;
            }

            var acdConversationExtension = currentEngagement.acdConversationExtension,
                consultingContext = {
                    actionType: 'Consult',
                    slcContext: context,
                    initiatedAgentId: agentContextApi.getId(),
                    initiatedAgentSipId: agentContextApi.getSip(),
                    initiatedAgentName: agentContextApi.getDisplayName(),
                    fromSubject: args.fromSubject
                },
                contentType = 'text/json',
                getHoopsContext = _.clone(context);

            currentEngagement.transferSlcContext = context;
            getHoopsContext.channel = 'chat';
            getHoopsContext.mode = 'live';
            getHoopsContext.returnSchedules = true;
            getHoopsContext.visitId = currentEngagement.visitId;
            getHoopsContext.engagementId = currentEngagement.engagementId;
            getHoopsContext.partnerId = currentEngagement.partnerId;

            engagementApi.getSupportHours(getHoopsContext).then(function (result) {
                var output = hoopsHelperApi.parseHoops(result);

                if (output) {
                    resolve(output);
                } else {
                    return acdConversationExtension.sendData(consultingContext, contentType).then(onSuccess);
                }
            }).catch(onError);
        });
    };

    Conversation.prototype.enableFilter = function () {
        var currentEngagement = this;

        return new Promise(function (resolve, reject) {
            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.FilterEnabled.ID
                    ],
                    eventName: telemetry.Events.FilterEnabled.NAME,
                    data: {
                        message: telemetry.Events.FilterEnabled.MESSAGE,
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);

                currentEngagement.isFilterOn = true;
                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.EnableFilterFailed.ID
                    ],
                    eventName: telemetry.Events.EnableFilterFailed.NAME,
                    data: {
                        message: telemetry.Events.EnableFilterFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.EnableFilterFailed.MESSAGE);

                reject(exception);
            }

            if (!currentEngagement.isApiEnabled) {
                var exception = exceptionManager.wrapRequestInvalid(constants.errorMessage.APIDISABLED);

                onError(exception);
                return;
            }

            if (!currentEngagement.acdConversationExtension) {
                var exception = exceptionManager.wrapChannelError(null, constants.errorMessage.CONVERSATIONEXTENSIONMISSING);

                onError(exception);
                return;
            }

            var acdConversationExtension = currentEngagement.acdConversationExtension,
                context = {
                    actionType: 'EnableFilter',
                    initiatedAgentId: agentContextApi.getId(),
                    initiatedAgentSipId: agentContextApi.getSip(),
                    initiatedAgentName: agentContextApi.getDisplayName()
                },
                contentType = 'text/json';

            acdConversationExtension.sendData(context, contentType).then(onSuccess).catch(onError);
        });
    };

    Conversation.prototype.disableFilter = function () {
        var currentEngagement = this;

        return new Promise(function (resolve, reject) {
            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.FilterDisabled.ID
                    ],
                    eventName: telemetry.Events.FilterDisabled.NAME,
                    data: {
                        message: telemetry.Events.FilterDisabled.MESSAGE,
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);

                currentEngagement.isFilterOn = false;
                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.ConsultFailed.ID
                    ],
                    eventName: telemetry.Events.DisableFilterFailed.NAME,
                    data: {
                        message: telemetry.Events.DisableFilterFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.DisableFilterFailed.MESSAGE);

                reject(exception);
            }

            if (!currentEngagement.isApiEnabled) {
                var exception = exceptionManager.wrapRequestInvalid(constants.errorMessage.APIDISABLED);

                onError(exception);
                return;
            }

            if (!currentEngagement.acdConversationExtension) {
                var exception = exceptionManager.wrapChannelError(null, constants.errorMessage.CONVERSATIONEXTENSIONMISSING);

                onError(exception);
                return;
            }

            var acdConversationExtension = currentEngagement.acdConversationExtension,
                context = {
                    actionType: 'DisableFilter',
                    initiatedAgentId: agentContextApi.getId(),
                    initiatedAgentSipId: agentContextApi.getSip(),
                    initiatedAgentName: agentContextApi.getDisplayName()
                },
                contentType = 'text/json';

            acdConversationExtension.sendData(context, contentType).then(onSuccess).catch(onError);
        });
    };

    // This API is used to cancel consult/group chat requests once enqueued.
    Conversation.prototype.dequeue = function () {
        var currentEngagement = this;

        return new Promise(function (resolve, reject) {
            function onResponse(result) {
                var position;

                if (result && result.content) {
                    try {
                        position = JSON.parse(result.content).Position;
                    } catch (ex) {
                        position = null;
                    }
                }

                // ACD sets the position as -1 if it gets 409 from routing service.
                if (position === -1) {
                    var error = {
                        errorCode: constants.errorCodes.REQUEST_INVALID,
                        context: {
                            statusCode: 409
                        }
                    };

                    onError(error);
                } else {
                    onSuccess();
                }
            }

            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.RequestDequeued.ID
                    ],
                    eventName: telemetry.Events.RequestDequeued.NAME,
                    data: {
                        message: telemetry.Events.RequestDequeued.MESSAGE,
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.DequeueRequestFailed.ID
                    ],
                    eventName: telemetry.Events.DequeueRequestFailed.NAME,
                    data: {
                        message: telemetry.Events.DequeueRequestFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.DequeueRequestFailed.MESSAGE);

                reject(exception);
            }

            if (!currentEngagement.isApiEnabled) {
                var exception = exceptionManager.wrapRequestInvalid(constants.errorMessage.APIDISABLED);

                onError(exception);
                return;
            }

            if (!currentEngagement.acdConversationExtension) {
                var exception = exceptionManager.wrapChannelError(null, constants.errorMessage.CONVERSATIONEXTENSIONMISSING);

                onError(exception);
                return;
            }

            var acdConversationExtension = currentEngagement.acdConversationExtension,
                dequeueContext = {
                    actionType: 'Dequeue',
                    initiatedAgentId: agentContextApi.getId(),
                    initiatedAgentSipId: agentContextApi.getSip(),
                    initiatedAgentName: agentContextApi.getDisplayName()
                },
                contentType = 'text/json';

            acdConversationExtension.sendData(dequeueContext, contentType).then(onResponse).catch(onError);
        });
    };

    Conversation.prototype.switchToGroup = function (agentId) {
        var currentEngagement = this;

        return new Promise(function (resolve, reject) {
            function onSuccess(result) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.SwitchToGroupRequested.ID
                    ],
                    eventName: telemetry.Events.SwitchToGroupRequested.NAME,
                    data: {
                        message: telemetry.Events.SwitchToGroupRequested.MESSAGE,
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);

                var agentAadId = '',
                    updateContextParams;

                try {
                    agentAadId = JSON.parse(result.content).AgentId;
                } catch (ex) {}

                updateContextParams = {
                    visitId: currentEngagement.visitId,
                    engagementId: currentEngagement.engagementId,
                    partnerId: currentEngagement.partnerId,
                    agentId: agentAadId,
                    isFromSdk: true
                };
                _.assignIn(updateContextParams, currentEngagement.transferSlcContext);
                engagementApi.updateContext(updateContextParams);

                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.SwitchToGroupFailed.ID
                    ],
                    eventName: telemetry.Events.SwitchToGroupFailed.NAME,
                    data: {
                        message: telemetry.Events.SwitchToGroupFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.SwitchToGroupFailed.MESSAGE);

                reject(exception);
            }

            if (!currentEngagement.isApiEnabled) {
                var exception = exceptionManager.wrapRequestInvalid(constants.errorMessage.APIDISABLED);

                onError(exception);
                return;
            }

            if (!currentEngagement.acdConversationExtension) {
                var exception = exceptionManager.wrapChannelError(null, constants.errorMessage.CONVERSATIONEXTENSIONMISSING);

                onError(exception);
                return;
            }

            var acdConversationExtension = currentEngagement.acdConversationExtension,
                switchToGroupContext = {
                    actionType: 'SwitchToGroup',
                    initiatedAgentId: agentContextApi.getId(),
                    initiatedAgentSipId: agentContextApi.getSip(),
                    initiatedAgentName: agentContextApi.getDisplayName(),
                    switchToGroupAgentSipId: agentId
                },
                contentType = 'text/json';

            acdConversationExtension.sendData(switchToGroupContext, contentType).then(onSuccess).catch(onError);
        });
    };

    Conversation.prototype.barge = function () {
        var currentEngagement = this;

        return new Promise(function (resolve, reject) {
            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.BargeInRequested.ID
                    ],
                    eventName: telemetry.Events.BargeInRequested.NAME,
                    data: {
                        message: telemetry.Events.BargeInRequested.MESSAGE,
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.BargeInFailed.ID
                    ],
                    eventName: telemetry.Events.BargeInFailed.NAME,
                    data: {
                        message: telemetry.Events.BargeInFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.BargeInFailed.MESSAGE);

                reject(exception);
            }

            if (!currentEngagement.isApiEnabled) {
                var exception = exceptionManager.wrapRequestInvalid(constants.errorMessage.APIDISABLED);

                onError(exception);
                return;
            }

            if (!currentEngagement.acdConversationExtension) {
                var exception = exceptionManager.wrapChannelError(null, constants.errorMessage.CONVERSATIONEXTENSIONMISSING);

                onError(exception);
                return;
            }

            var acdConversationExtension = currentEngagement.acdConversationExtension,
                bargeInContext = {
                    actionType: 'BargeIn',
                    initiatedAgentId: agentContextApi.getId(),
                    initiatedAgentSipId: agentContextApi.getSip(),
                    initiatedAgentName: agentContextApi.getDisplayName(),
                    switchToGroupAgentSipId: agentContextApi.getSip()
                },
                contentType = 'text/json';

            acdConversationExtension.sendData(bargeInContext, contentType).then(onSuccess).catch(onError);
        });
    };

    Conversation.prototype.endChat = function (reason) {
        var currentEngagement = this,
            conversation = currentEngagement.conversation,
            jlync = currentEngagement.jlync;

        return new Promise(function (resolve, reject) {
            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Ended,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.ChatEnded.ID
                    ],
                    eventName: telemetry.Events.ChatEnded.NAME,
                    data: {
                        message: telemetry.Events.ChatEnded.MESSAGE,
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId,
                        extraContext: {
                            reason: endChatReason,
                            conferenceId: currentEngagement.conferenceId
                        }
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                currentEngagement.dispose();

                if (currentEngagement.inviteType === constants.inviteType.Internal) {
                    chatEngagementsApi.removeChatEngagement(currentEngagement.chatId);
                }

                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.EndChatFailed.ID
                    ],
                    eventName: telemetry.Events.EndChatFailed.NAME,
                    data: {
                        message: telemetry.Events.EndChatFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId,
                        extraContext: {
                            reason: endChatReason,
                            conferenceId: currentEngagement.conferenceId
                        }
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.EndChatFailed.MESSAGE);

                reject(exception);
            }

            var endChatReason = reason ? reason : constants.endChatReason.AGENTINVOKEDISENGAGE;

            skypeConversationApi.removeConversation(jlync, conversation).then(onSuccess).catch(onError);
        });
    };

    Conversation.prototype.startInternalChat = function (params) {
        var currentEngagement = this;

        return new Promise(function (resolve, reject) {
            function onSuccess(sfbConversation) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.InternalChatStarted.ID
                    ],
                    eventName: telemetry.Events.InternalChatStarted.NAME,
                    data: {
                        message: telemetry.Events.InternalChatStarted.MESSAGE,
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);

                var params = {
                        conversation: sfbConversation,
                        chatType: constants.chatType.Outgoing
                    },
                    conversation = new Conversation(params),
                    internalChat = internalChatModel.build(conversation);

                chatEngagementsApi.addChatEngagement(internalChat);
                resolve(internalChat);
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes[currentEngagement.inviteType],
                        telemetry.StatusEventCodes.Connected,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.StartInternalChatFailed.ID
                    ],
                    eventName: telemetry.Events.StartInternalChatFailed.NAME,
                    data: {
                        message: telemetry.Events.StartInternalChatFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                        visitId: currentEngagement.visitId,
                        engagementId: currentEngagement.engagementId,
                        partnerId: currentEngagement.partnerId
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);
                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.StartInternalChatFailed.MESSAGE);

                reject(exception);
            }

            function validate() {
                if (!currentEngagement.isApiEnabled) {
                    return constants.errorMessage.APIDISABLED;
                }

                if (!params || !params.agentSipId) {
                    return 'agent sip id is required for starting an internal chat';
                }
            }

            var errorMessage = validate();

            if (errorMessage) {
                var exception = exceptionManager.wrapRequestInvalid(errorMessage);

                onError(exception);
                return;
            }

            var convContext = {
                    visitId: currentEngagement.visitId,
                    engagementId: currentEngagement.engagementId,
                    partnerId: currentEngagement.partnerId,
                    conferenceId: currentEngagement.conferenceId,
                    inviteType: constants.inviteType.Internal,
                    initiatedAgentName: agentContextApi.getDisplayName()
                },
                visitContext = {
                    context: convContext
                };

            skypeConversationApi.startConversation(params.agentSipId, visitContext)
            .then(onSuccess)
            .catch(onError);
        });
    };

    exports.build = function (params) {
        return new Conversation(params);
    };
});
define('skype/incomingChatRequestHandler',['require','exports','module','skype/jlyncApplication','constants/common','models/chatEngagement','models/internalChat','skype/conversation','models/conversation','services/serviceLocator','telemetry/telemetryClient','constants/telemetry'],function (require, exports){
    'use strict';

    var jlyncApp = require('skype/jlyncApplication'),
        constants = require('constants/common'),
        chatEngagementModel = require('models/chatEngagement'),
        internalChatModel = require('models/internalChat'),
        skypeConversationApi = require('skype/conversation'),
        conversationModel = require('models/conversation'),
        serviceLocator = require('services/serviceLocator'),
        telemetryClient = require('telemetry/telemetryClient'),
        telemetry = require('constants/telemetry'),
        loggingContext;

    exports.init = function () {
        function publishInComingChatRequest(sfbConversation, context) {
            sfbConversation.id = function () {
                return context.chatId;
            };

            sfbConversation.context = function () {
                return {
                    visitId: context.visitId,
                    engagementId: context.engagementId,
                    partnerId: context.partnerId,
                    conferenceId: context.conferenceId,
                    inviteType: context.inviteType,
                    isFilterOn: context.isFilterOn
                };
            };

            var params = {
                    conversation: sfbConversation,
                    chatType: constants.chatType.Rehydration
                },
                conversation = conversationModel.build(params),
                chat = chatEngagementModel.build(conversation);

            chatEngagementsApi.addChatEngagement(chat);
            activeEngagementsApi.addActiveEngagement(chat);
            pubSub.publish(constants.events.INCOMING_CHAT_REQUEST, [chat]);
        }

        var jlync = jlyncApp.get(),
            conversationAddedSub,
            pubSub = serviceLocator.resolve(constants.serviceLocator.PUBSUB),
            chatEngagementsApi = serviceLocator.resolve(constants.serviceLocator.CHAT_ENGAGEMENTS),
            activeEngagementsApi = serviceLocator.resolve(constants.serviceLocator.ACTIVE_ENGAGEMENTS),
            agentContextApi = serviceLocator.resolve(constants.serviceLocator.AGENT_CONTEXT);

        conversationAddedSub = jlync.conversationsManager.conversations.added(function (sfbConversation) {
            if (sfbConversation.selfParticipant.chat.state() === 'Notified') {
                var params = {
                        conversation: sfbConversation,
                        chatType: constants.chatType.Incoming
                    },
                    conversation = conversationModel.build(params),
                    isAtMax = activeEngagementsApi.currentChatCount() >= agentContextApi.getMaxChatCount(),
                    chat;

                if (conversation.inviteType === constants.inviteType.Internal) {
                    chat = internalChatModel.build(conversation);
                } else {
                    chat = chatEngagementModel.build(conversation);
                }

                if (!chat.visitId || !chat.engagementId) {
                    chat.reject('SystemInvoked:InvalidInvite');
                    return;
                }

                // Mitigation for multiple agents joining into 1 normal chat
                if (chat.inviteType === constants.inviteType.Normal && sfbConversation.participantsCount() > 1) {
                    chat.reject('SystemInvoked:AgentJoinedAlready');
                    return;
                }

                // Mitigation for inviting agents when at max
                if (chat.inviteType !== constants.inviteType.Internal && isAtMax) {
                    chat.reject('SystemInvoked:AtMax');
                    return;
                }

                agentContextApi.setIsPendingAcceptance(true);
                chatEngagementsApi.addChatEngagement(chat);
                pubSub.publish(constants.events.INCOMING_CHAT_REQUEST, [chat]);
            } else if (sfbConversation.state() !== constants.conversationState.Created) {
                var snapshot = agentContextApi.getSnapshot(),
                    engagementId = sfbConversation.topic(),
                    context = snapshot[engagementId];

                if (context) {
                    var syncParticipantPromise = sfbConversation.participants.sync ? sfbConversation.participants.sync() : Promise.resolve(),
                        getConversationExtensionPromise = sfbConversation.extensions.size() < 1 ? sfbConversation.extensions.get() : Promise.resolve();

                    Promise.all([syncParticipantPromise, getConversationExtensionPromise])
                    .then(function () {
                        publishInComingChatRequest(sfbConversation, context);
                    }).catch(function (error) {
                        loggingContext = {
                            eventId: [
                                telemetry.MilestoneCodes[context.inviteType],
                                telemetry.StatusEventCodes.Connected,
                                telemetry.OutcomeBits.Failure,
                                telemetry.Events.RehydrateChatEngagementError.ID
                            ],
                            eventName: telemetry.Events.RehydrateChatEngagementError.NAME,
                            data: {
                                message: telemetry.Events.RehydrateChatEngagementError.MESSAGE,
                                faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                                visitId: context.visitId,
                                engagementId: context.engagementId,
                                partnerId: context.partnerId,
                                extraContext: {
                                    inviteType: context.inviteType,
                                    chatId: context.chatId
                                }
                            }
                        };

                        telemetryClient.get().sendEvent(loggingContext);
                        publishInComingChatRequest(sfbConversation, context);
                    });
                } else {
                    skypeConversationApi.removeConversation(jlync, sfbConversation);
                }
            }
        });
        jlyncApp.addSubscription(conversationAddedSub);
    };
});
define('skype/skypeIdleHandler',['require','exports','module','skype/auth','skype/jlyncApplication','skype/incomingChatRequestHandler','constants/common','services/serviceLocator'],function (require, exports){
    'use strict';

    var skypeAuthApi = require('skype/auth'),
        jlyncApp = require('skype/jlyncApplication'),
        incomingChatRequestHandler = require('skype/incomingChatRequestHandler'),
        constants = require('constants/common'),
        serviceLocator = require('services/serviceLocator');

    exports.init = function () {
        function reauth() {
            function onSuccess() {
                reauthTimeout = setTimeout(reauth, IDLE_TIMEOUT);
                incomingChatRequestHandler.init();
            }

            function onError(error) {
                var eventData = {
                    reason: 'SkypeReauthFailed',
                    context: error ? error : {}
                };

                pubSub.publish(constants.events.CHAT_CHANNEL_UNAVAILABLE, [eventData]);
            }

            Promise.resolve().then(function () {
                return jlyncApp.get().signInManager.signOut();
            }).then(function () {
                // reset the jlync app
                jlyncApp.create();
                return skypeAuthApi.signIn();
            }).then(onSuccess).catch(onError);
        }

        function onNoChatEngagement() {
            if (!reauthTimeout) {
                reauthTimeout = setTimeout(reauth, IDLE_TIMEOUT);
            }
        }

        function onChatEngagementAdded() {
            if (reauthTimeout) {
                clearTimeout(reauthTimeout);
                reauthTimeout = null;
            }
        }

        var IDLE_TIMEOUT = 15 * 60000,
            reauthTimeout,
            pubSub = serviceLocator.resolve(constants.serviceLocator.PUBSUB);

        pubSub.subscribe(constants.events.NO_CHAT_ENGAGEMENT, onNoChatEngagement);
        pubSub.subscribe(constants.events.CHAT_ENGAGEMENT_ADDED, onChatEngagementAdded);
        reauthTimeout = setTimeout(reauth, IDLE_TIMEOUT);
    };
});
define('api/agentAvailability',['require','exports','module','lodash','constants/common','settings','skype/auth','eventHandlers/agentAvailabilityHandler','skype/incomingChatRequestHandler','skype/skypeIdleHandler','services/serviceLocator','telemetry/telemetryClient','constants/telemetry'],function(require, exports){
    'use strict';

    var _ = require('lodash'),
        constants = require('constants/common'),
        settings = require('settings'),
        skypeAuthApi = require('skype/auth'),
        agentAvailabilityHandler = require('eventHandlers/agentAvailabilityHandler'),
        incomingChatRequestHandler = require('skype/incomingChatRequestHandler'),
        skypeIdleHandler = require('skype/skypeIdleHandler'),
        serviceLocator = require('services/serviceLocator'),
        telemetryClient = require('telemetry/telemetryClient'),
        telemetry = require('constants/telemetry'),
        loggingContext, gatewayService, agentContextApi,
        chatEngagementsApi, activeEngagementsApi, exceptionManager;

    exports.initAgent = function (params) {
        return new Promise(function (resolve, reject) {
            function onSuccess() {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Initialize,
                        telemetry.StatusEventCodes.Initiated,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.AgentInitialized.ID
                    ],
                    eventName: telemetry.Events.AgentInitialized.NAME,
                    data: {
                        message: telemetry.Events.AgentInitialized.MESSAGE,
                        extraContext: {
                            availabilityStatus: availabilityStatus
                        }
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);

                agentContextApi.setIsInitialized(true);
                agentContextApi.setAvailabilityStatus(availabilityStatus);
                agentContextApi.setModalityDetails(requestParams.modalityDetails);
                agentAvailabilityHandler.init();

                if (isSupportingChat) {
                    if (settings.disableSkypeSilentReauth === false) {
                        skypeIdleHandler.init();
                    }

                    setTimeout(incomingChatRequestHandler.init, 0);
                }

                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Initialize,
                        telemetry.StatusEventCodes.Initiated,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.InitAgentFailed.ID
                    ],
                    eventName: telemetry.Events.InitAgentFailed.NAME,
                    data: {
                        message: telemetry.Events.InitAgentFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error)
                    }
                };
                loggingContext.isChatEntityEvent = true;
                telemetryClient.get().sendEvent(loggingContext);

                // If initAgent api fails during a rehydration attempt, the same snapshot can be returned instead of an empty object.
                if (isSupportingChat) {
                    chatEngagementsApi = serviceLocator.resolve(constants.serviceLocator.CHAT_ENGAGEMENTS);
                    chatEngagementsApi.getSnapshot = agentContextApi.getSnapshot;
                }

                var exception = exceptionManager.wrapServerError(error, telemetry.Events.InitAgentFailed.MESSAGE);

                reject(exception);
            }

            exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER);

            var reset = true,
                isSupportingChat,
                availabilityStatus,
                currentChatCount = 0,
                signInParam,
                requestParams,
                reason;

            availabilityStatus = (!params || !params.availabilityStatus) ? constants.availabilityStatus.NOT_AVAILABLE : params.availabilityStatus;
            reason = (!params || !params.reason) ? '' : params.reason;
            gatewayService = serviceLocator.resolve(constants.serviceLocator.GATEWAY);
            agentContextApi = serviceLocator.resolve(constants.serviceLocator.AGENT_CONTEXT);
            isSupportingChat = agentContextApi.isSupportingChat();

            if (params && !_.isEmpty(params.snapshot)) {
                reset = false;
                currentChatCount = _.size(params.snapshot) - 1;
                signInParam = params.snapshot.sfbSnapshot;
                agentContextApi.setSnapshot(params.snapshot);
                activeEngagementsApi = serviceLocator.resolve(constants.serviceLocator.ACTIVE_ENGAGEMENTS);

                _.forEach(params.snapshot, function(item, key) {
                    key !== 'sfbSnapshot' && activeEngagementsApi.addActiveEngagement(item);
                });
            }

            if (params.modalityDetails) {
                _.forEach(params.modalityDetails, function(modalityDetail) {
                    modalityDetail.availabilityStatus = modalityDetail.availabilityStatus ? modalityDetail.availabilityStatus : constants.availabilityStatus.NOT_AVAILABLE;
                    modalityDetail.reason = modalityDetail.reason ? modalityDetail.reason : '';
                });
            }

            if (isSupportingChat) {
                Promise.resolve(signInParam).then(skypeAuthApi.signIn).then(function (sipEndpointUrl) {
                    var chatModalityDetails = [
                        {
                            modality: constants.modality.CHAT,
                            availabilityStatus: availabilityStatus,
                            reason: reason
                        }
                    ];

                    if (reset) {
                        requestParams = {
                            sipEndpointUrl: sipEndpointUrl,
                            availabilityStatus: availabilityStatus,
                            reason: reason
                        };

                        requestParams.modalityDetails = params.modalityDetails ? params.modalityDetails : chatModalityDetails;

                        return gatewayService.initAgent(requestParams);
                    } else {
                        requestParams = {
                            sipEndpointUrl: sipEndpointUrl,
                            availabilityStatus: availabilityStatus,
                            currentChatCount: currentChatCount,
                            reason: reason
                        };

                        requestParams.modalityDetails = params.modalityDetails ? params.modalityDetails : chatModalityDetails;

                        return gatewayService.setAvailability(requestParams);
                    }
                }).then(onSuccess).catch(onError);
            } else {
                requestParams = {
                    modalityDetails: params.modalityDetails
                };

                gatewayService.initAgent(requestParams).then(onSuccess).catch(onError);
            }
        });
    };

    exports.setAvailability = function (params) {
        var availabilityStatus,
            isSupportingChat,
            requestParams,
            reason = (params && params.reason) ? params.reason : '',
            authService,
            token,
            chatModalityDetails;

        gatewayService = serviceLocator.resolve(constants.serviceLocator.GATEWAY);
        agentContextApi = serviceLocator.resolve(constants.serviceLocator.AGENT_CONTEXT);
        isSupportingChat = agentContextApi.isSupportingChat();

        if (params && !params.sync) {
            return new Promise(function (resolve, reject) {
                function onSuccess() {
                    loggingContext = {
                        eventId: [
                            telemetry.MilestoneCodes.Availability,
                            telemetry.StatusEventCodes.Initiated,
                            telemetry.OutcomeBits.Success,
                            telemetry.Events.AvailabilitySet.ID
                        ],
                        eventName: telemetry.Events.AvailabilitySet.NAME,
                        data: {
                            message: telemetry.Events.AvailabilitySet.MESSAGE,
                            extraContext: {
                                availabilityStatus: availabilityStatus
                            }
                        }
                    };
                    telemetryClient.get().sendEvent(loggingContext);

                    if (!params.targetAgentId) {
                        agentContextApi.setAvailabilityStatus(availabilityStatus);
                        agentContextApi.setModalityDetails(requestParams.modalityDetails);
                    }

                    resolve();
                }

                function onError(error) {
                    loggingContext = {
                        eventId: [
                            telemetry.MilestoneCodes.Availability,
                            telemetry.StatusEventCodes.Initiated,
                            telemetry.OutcomeBits.Failure,
                            telemetry.Events.SetAvailabilityFailed.ID
                        ],
                        eventName: telemetry.Events.SetAvailabilityFailed.NAME,
                        data: {
                            message: telemetry.Events.SetAvailabilityFailed.MESSAGE,
                            faultContext: typeof error === 'string' ? error : JSON.stringify(error)
                        }
                    };
                    loggingContext.isChatEntityEvent = true;
                    telemetryClient.get().sendEvent(loggingContext);
                    var exception = exceptionManager.wrapServerError(error, telemetry.Events.SetAvailabilityFailed.MESSAGE);

                    reject(exception);
                }

                exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER);

                if (isSupportingChat) {
                    if ((!params || !params.availabilityStatus) && !params.targetAgentId) {
                        var exception = exceptionManager.wrapRequestInvalid('availabilityStatus is required in params object');

                        onError(exception);
                        return;
                    }
                } else {
                    if (!params || !_.isArray(params.modalityDetails)) {
                        var exception = exceptionManager.wrapRequestInvalid('modalityDetails as array is required in params object');

                        onError(exception);
                        return;
                    }
                }

                availabilityStatus = params.availabilityStatus;
                chatModalityDetails = [
                    {
                        modality: constants.modality.CHAT,
                        availabilityStatus: availabilityStatus,
                        reason: reason
                    }
                ];
                requestParams = {
                    availabilityStatus: availabilityStatus,
                    reason: reason
                };
                requestParams.modalityDetails = (params.modalityDetails && params.modalityDetails.length > 0) ? params.modalityDetails : chatModalityDetails;

                if (params.targetAgentId) {
                    requestParams.targetAgentId = params.targetAgentId;
                }

                gatewayService.setAvailability(requestParams).then(onSuccess).catch(onError);
            });
        }

        authService = serviceLocator.resolve(constants.serviceLocator.AUTH_SERVICE);
        token = authService.getCachedToken();
        availabilityStatus = (params && params.availabilityStatus) ? params.availabilityStatus : constants.availabilityStatus.NOT_AVAILABLE;
        chatModalityDetails = [
            {
                modality: constants.modality.CHAT,
                availabilityStatus: availabilityStatus,
                reason: reason
            }
        ];
        requestParams = {
            availabilityStatus: availabilityStatus,
            reason: reason
        };
        requestParams.modalityDetails = (params.modalityDetails && params.modalityDetails.length > 0) ? params.modalityDetails : chatModalityDetails;

        return gatewayService.setAvailabilitySync(token, availabilityStatus, reason, requestParams.modalityDetails);
    };

    exports.getAvailability = function (isInternal) {
        function parseModalityDetails(details) {
            var parsedOutput = [];

            _.forEach(details, function(detail) {
                var modality = {};

                modality.modality = detail.Modality;
                modality.availabilityStatus = detail.AvailabilityStatus === 1 ? constants.availabilityStatus.AVAILABLE : constants.availabilityStatus.NOT_AVAILABLE;
                modality.reason = detail.Reason ? detail.Reason : '';
                parsedOutput.push(modality);
            });

            return parsedOutput;
        }

        function onSuccess(result) {
            var status = _.isArray(result) ? result[0] : {},
                isUnreachable = !!status.IsUnreachable,
                maxChatCount = _.isNumber(status.MaximumChatCount) ? status.MaximumChatCount : agentContextApi.getMaxChatCount(),
                updatedById = status.UpdatedById,
                activeEngagements = _.isArray(status.VisitDetails) ? status.VisitDetails : [],
                modalityDetails = _.isArray(status.ModalityDetails) ? status.ModalityDetails : [],
                parsedModalityDetails = parseModalityDetails(modalityDetails),
                output = {
                    isUnreachable: isUnreachable,
                    updatedById: updatedById,
                    maxChatCount: maxChatCount,
                    activeEngagements: activeEngagements,
                    modalityDetails: parsedModalityDetails
                };

            loggingContext = {
                eventId: [
                    telemetry.MilestoneCodes.Availability,
                    telemetry.StatusEventCodes.Initiated,
                    telemetry.OutcomeBits.Success,
                    telemetry.Events.AvailabilityFetched.ID
                ],
                eventName: telemetry.Events.AvailabilityFetched.NAME,
                data: {
                    message: telemetry.Events.AvailabilityFetched.MESSAGE,
                    extraContext: output
                }
            };
            telemetryClient.get().sendEvent(loggingContext);

            if (isInternal) {
                return output;
            } else {
                return parsedModalityDetails;
            }
        }

        function onError(error) {
            loggingContext = {
                eventId: [
                    telemetry.MilestoneCodes.Availability,
                    telemetry.StatusEventCodes.Initiated,
                    telemetry.OutcomeBits.Failure,
                    telemetry.Events.FetchAvailabilityFailed.ID
                ],
                eventName: telemetry.Events.FetchAvailabilityFailed.NAME,
                data: {
                    message: telemetry.Events.FetchAvailabilityFailed.MESSAGE,
                    faultContext: typeof error === 'string' ? error : JSON.stringify(error)
                }
            };
            loggingContext.isChatEntityEvent = true;
            telemetryClient.get().sendEvent(loggingContext);

            throw error;
        }

        agentContextApi = serviceLocator.resolve(constants.serviceLocator.AGENT_CONTEXT);
        gatewayService = serviceLocator.resolve(constants.serviceLocator.GATEWAY);

        return Promise.resolve()
            .then(gatewayService.getAvailability)
            .then(onSuccess)
            .catch(onError);
    };
});
define('skype/loadJlync',['require','skype/jlyncApplication','settings','constants/common','services/serviceLocator','telemetry/telemetryClient','constants/telemetry'],function (require) {
    'use strict';

    var jlyncApplication = require('skype/jlyncApplication'),
        settings = require('settings'),
        constants = require('constants/common'),
        serviceLocator = require('services/serviceLocator'),
        telemetryClient = require('telemetry/telemetryClient'),
        telemetry = require('constants/telemetry'),
        exceptionManager, loggingContext;

    function getJlync(initParams) {
        return new Promise(function (resolve, reject) {
            function onSuccess(api) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Initiated,
                        telemetry.OutcomeBits.Success,
                        telemetry.Events.SkypeSdkLoaded.ID
                    ],
                    eventName: telemetry.Events.SkypeSdkLoaded.NAME,
                    data: {
                        message: telemetry.Events.SkypeSdkLoaded.MESSAGE
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);

                jlyncApplication.set(api);
                resolve();
            }

            function onError(error) {
                loggingContext = {
                    eventId: [
                        telemetry.MilestoneCodes.Default,
                        telemetry.StatusEventCodes.Initiated,
                        telemetry.OutcomeBits.Failure,
                        telemetry.Events.LoadSkypeSdkFailed.ID
                    ],
                    eventName: telemetry.Events.LoadSkypeSdkFailed.NAME,
                    data: {
                        message: telemetry.Events.LoadSkypeSdkFailed.MESSAGE,
                        faultContext: typeof error === 'string' ? error : JSON.stringify(error)
                    }
                };
                telemetryClient.get().sendEvent(loggingContext);

                var exception = exceptionManager.wrapChannelError(error, telemetry.Events.LoadSkypeSdkFailed.MESSAGE);

                reject(exception);
            }

            var Skype = window.Skype || null,
                jlyncSettings = {
                    apiKey: settings.jlync.apiKey
                };

            if (!Skype) {
                onError('Skype bootstrapper was not loaded.');
                return;
            }

            if (initParams && initParams.correlationIds) {
                jlyncSettings.correlationIds = initParams.correlationIds;
            }

            exceptionManager = serviceLocator.resolve(constants.serviceLocator.EXCEPTION_MANAGER);
            Skype.initialize(jlyncSettings, onSuccess, onError);
        });
    }

    return getJlync;
});
define('services/gatewayService',['require','exports','module','lodash','telemetry/telemetryClient','settings','constants/common'],function (require, exports) {
    'use strict';

    var _ = require('lodash'),
        telemetryClient = require('telemetry/telemetryClient'),
        settings = require('settings'),
        constants = require('constants/common'),
        instance;

    function GatewayService() {
        var self = this,
            serviceUrl = settings.gatewayService.baseUrl,
            agentApiRoute = settings.gatewayService.agentApiRoute,
            queueApiRoute = settings.gatewayService.queueApiRoute,
            contextApiRoute = settings.gatewayService.contextApiRoute,
            transcriptApiRoute = settings.gatewayService.transcriptApiRoute,
            configApiRoute = settings.gatewayService.configApiRoute,
            acdApiRoute = settings.gatewayService.acdApiRoute,
            assignmentApiRoute = settings.gatewayService.assignmentApiRoute,
            httpClient = telemetryClient.get().service;

        function addHeaders(context) {
            var headers = {};

            if (context.partnerId) {
                headers[constants.headerKey.PARTNER_ID] = context.partnerId;
            }

            if (context.sessionId) {
                headers[constants.headerKey.SESSION_ID] = context.sessionId;
            }

            if (context.visitId) {
                headers[constants.headerKey.VISIT_ID] = context.visitId;
            }

            if (context.engagementId) {
                headers[constants.headerKey.ENGAGEMENT_ID] = context.engagementId;
            }

            if (context.conferenceId) {
                headers[constants.headerKey.CONFERENCE_ID] = context.conferenceId;
            }

            if (settings.testHeader) {
                headers[constants.headerKey.TEST] = settings.testHeader;
            }

            if (context.targetAgentId) {
                headers[constants.headerKey.TARGET_AGENT_ID] = context.targetAgentId;
            }

            if (context.assigneeUpn) {
                headers[constants.headerKey.ASSIGNEE_UPN] = context.assigneeUpn;
            }

            return headers;
        }

        function buildQueryString(queryParams) {
            var pairs = [];

            _.forEach(queryParams, function (value, key) {
                pairs.push([key, value].join('='));
            });

            return pairs.length ? '?' + pairs.join('&') : '';
        }

        function initAgent(params) {
            var initParams = {
                    sipEndpointUrl: params.sipEndpointUrl,
                    availabilityStatus: params.availabilityStatus,
                    reason: params.reason,
                    modalityDetails: params.modalityDetails
                },
                requestOptions = {
                    operationName: 'initAgent',
                    serviceName: 'GatewayService',
                    url: serviceUrl + agentApiRoute + 'initialize',
                    contentType: 'application/json',
                    dataType: 'text',
                    additionalHeaders: addHeaders({}),
                    body: initParams
                };

            return httpClient.post(requestOptions);
        }

        function getAvailability() {
            var requestOptions = {
                operationName: 'getAgentAvailability',
                serviceName: 'GatewayService',
                url: serviceUrl + agentApiRoute + 'availability',
                accept: 'application/json',
                additionalHeaders: addHeaders({})
            };

            return httpClient.get(requestOptions);
        }

        function setAvailability(params) {
            var requestParams = {
                    availabilityStatus : params.availabilityStatus,
                    reason: params.reason
                },
                requestOptions = {
                    operationName: 'setAgentAvailability',
                    serviceName: 'GatewayService',
                    url: serviceUrl + agentApiRoute + 'availability',
                    contentType: 'application/json',
                    dataType: 'text',
                    body: requestParams
                },
                headerContext = {};

            if (params.sipEndpointUrl) {
                requestParams.sipEndpointUrl = params.sipEndpointUrl;
            }

            if (params.currentChatCount > 0) {
                requestParams.currentChatCount = params.currentChatCount;
            }

            if (params.modalityDetails) {
                requestParams.modalityDetails = params.modalityDetails;
            }

            if (params.targetAgentId) {
                headerContext.targetAgentId = params.targetAgentId;
            }

            requestOptions.additionalHeaders = addHeaders(headerContext);

            return httpClient.put(requestOptions);
        }

        function setAvailabilitySync(token, availabilityStatus, reason, modalityDetails) {
            var params = {
                    availabilityStatus : availabilityStatus,
                    reason: reason
                },
                requestOptions = {
                    url: serviceUrl + agentApiRoute + 'availability',
                    contentType: 'application/json',
                    headers: {},
                    method: 'put',
                    async: false // making sure this fires in browser unload
                };

            if (modalityDetails) {
                params.modalityDetails = modalityDetails;
            }

            requestOptions.data = JSON.stringify(params);
            requestOptions.headers[constants.headerKey.BEARER_TOKEN] = token;

            return $.ajax(requestOptions);
        }

        function addEngagement(params) {
            var data = {
                    properties: {
                        engagementId: params.engagementId
                    },
                    eventName: 'invitationaccepted'
                },
                requestOptions = {
                    operationName: 'addEngagement',
                    serviceName: 'GatewayService',
                    url: serviceUrl + agentApiRoute + 'notifyevent',
                    contentType: 'application/json',
                    dataType: 'text',
                    additionalHeaders: addHeaders(params),
                    body: data
                };

            return httpClient.put(requestOptions);
        }

        function endEngagement(visitId, engagementId, conferenceId, partnerId, predicted) {
            var params = {
                    properties: {
                        engagementId: engagementId
                    },
                    eventName: predicted ? 'caseendedpredicted' : 'caseended'
                },
                headers = {
                    visitId: visitId,
                    engagementId: engagementId,
                    conferenceId: conferenceId,
                    partnerId: partnerId
                },
                requestOptions = {
                    operationName: 'endEngagement',
                    serviceName: 'GatewayService',
                    url: serviceUrl + agentApiRoute + 'notifyevent',
                    contentType: 'application/json',
                    dataType: 'text',
                    additionalHeaders: addHeaders(headers),
                    body: params
                };

            return httpClient.put(requestOptions);
        }

        function getContext(params) {
            var requestOptions = {
                operationName: 'getContext',
                serviceName: 'GatewayService',
                url: serviceUrl + contextApiRoute + buildQueryString(params),
                accept: 'application/json',
                additionalHeaders: addHeaders(params)
            };

            return httpClient.get(requestOptions);
        }

        function updateContext(sessionContext) {
            var requestOptions = {
                operationName: 'updateContext',
                serviceName: 'GatewayService',
                url: serviceUrl + contextApiRoute,
                contentType: 'application/json',
                additionalHeaders: addHeaders(sessionContext),
                body: sessionContext
            };

            return httpClient.put(requestOptions);
        }

        function getTranscript(params) {
            var requestOptions = {
                operationName: 'GetTranscript',
                serviceName: 'GatewayService',
                url: serviceUrl + transcriptApiRoute + buildQueryString(params),
                accept: 'application/json',
                additionalHeaders: addHeaders(params)
            };

            return httpClient.get(requestOptions);
        }

        function postTranscript(request) {
            var requestOptions = {
                operationName: 'PostTranscript',
                serviceName: 'GatewayService',
                url: serviceUrl + transcriptApiRoute,
                contentType: 'application/json',
                dataType: 'text',
                additionalHeaders: addHeaders(request),
                body: request
            };

            return httpClient.post(requestOptions);
        }

        function whisper(visitId, engagementId, partnerId) {
            var params = {
                    visitId: visitId,
                    engagementId: engagementId,
                    partnerId: partnerId
                },
                requestOptions = {
                    operationName: 'Whisper',
                    serviceName: 'GatewayService',
                    url: serviceUrl + acdApiRoute + 'whisper',
                    contentType: 'application/json',
                    additionalHeaders: addHeaders(params),
                    body: params
                };

            return httpClient.post(requestOptions);
        }

        function getSupportHours(params, logContext) {
            var requestOptions = {
                operationName: 'GetSupportHours',
                serviceName: 'GatewayService',
                url: serviceUrl + configApiRoute + 'supporthours' + buildQueryString(params),
                accept: 'application/json',
                additionalHeaders: addHeaders(logContext)
            };

            return httpClient.get(requestOptions);
        }

        function getChatQueueLength(params, logContext) {
            var requestOptions = {
                operationName: 'GetQueueLength',
                serviceName: 'GatewayService',
                url: serviceUrl + queueApiRoute + 'queuelength' + buildQueryString(params),
                accept: 'application/json',
                additionalHeaders: addHeaders(logContext)
            };

            return httpClient.get(requestOptions);
        }

        function getReachableAgentCount(params, logContext) {
            var requestOptions = {
                operationName: 'GetReachableAgentCount',
                serviceName: 'GatewayService',
                url: serviceUrl + agentApiRoute + 'reachablecount' + buildQueryString(params),
                accept: 'application/json',
                additionalHeaders: addHeaders(logContext)
            };

            return httpClient.get(requestOptions);
        }

        function assign(params) {
            var requestBody = {
                    caseId: params.caseId
                },
                requestHeader = {
                    assigneeUpn: params.assigneeUpn
                },
                requestOptions = {
                    operationName: 'Assignment/Assign',
                    serviceName: 'GatewayService',
                    url: serviceUrl + assignmentApiRoute + 'assign',
                    contentType: 'application/json',
                    additionalHeaders: addHeaders(requestHeader)
                };

            if (params.taskId) {
                requestBody.taskId = params.taskId;
            }

            if (params.currentOwnerAgentUpn) {
                requestBody.currentOwnerAgentUpn = params.currentOwnerAgentUpn;
            }

            requestOptions.body = requestBody;

            return httpClient.post(requestOptions);
        }

        self.initAgent = initAgent;
        self.getAvailability = getAvailability;
        self.setAvailability = setAvailability;
        self.setAvailabilitySync = setAvailabilitySync;
        self.endEngagement = endEngagement;
        self.addEngagement = addEngagement;
        self.getContext = getContext;
        self.updateContext = updateContext;
        self.getTranscript = getTranscript;
        self.postTranscript = postTranscript;
        self.whisper = whisper;
        self.getSupportHours = getSupportHours;
        self.getChatQueueLength = getChatQueueLength;
        self.getReachableAgentCount = getReachableAgentCount;
        self.assign = assign;
    }

    exports.getInstance = function() {
        if (!instance) {
            instance = new GatewayService();
        }

        return instance;
    };
});
define( 'services/agentContext',['require','exports','module','lodash','constants/common'],function (require, exports) {
    'use strict';

    var _ = require('lodash'),
        constants = require('constants/common'),
        defaultContext = {
            // AAD oid or PUID
            id: null,
            // Skype sip id
            sip: null,
            site: null,
            displayName: null,
            skypeEndpointUri: null,
            availabilityStatus: constants.availabilityStatus.NOT_AVAILABLE,
            modalityDetails: {},
            isInitialized: false,
            isPendingAcceptance: false,
            maxChatCount: Number.MAX_VALUE,
            isSupportingChat: true,
            availabilityPingLoop: null,
            snapshot: {}
        },
        context = _.clone(defaultContext);

    exports.get = function get() {
        return context;
    };

    exports.getId = function getId() {
        return context.id;
    };

    exports.setId = function setId(agentId) {
        context.id = agentId;
    };

    exports.getSip = function getSip() {
        return context.sip;
    };

    exports.setSip = function setSip(sip) {
        context.sip = sip;
    };

    exports.getSite = function getSite() {
        return context.site;
    };

    exports.setSite = function setSite(site) {
        context.site = site;
    };

    exports.getDisplayName = function getDisplayName() {
        return context.displayName;
    };

    exports.setDisplayName = function setDisplayName(displayName) {
        context.displayName = displayName;
    };

    exports.getAvailabilityStatus = function getAvailabilityStatus() {
        return context.availabilityStatus;
    };

    exports.setAvailabilityStatus = function setAvailabilityStatus(status) {
        context.availabilityStatus = status;
    };

    exports.getModalityDetails = function getModalityDetails() {
        return context.modalityDetails;
    };

    exports.setModalityDetails = function setModalityDetails(details) {
        var modalityDetails = {};

        _.forEach(details, function (detail) {
            modalityDetails[detail.modality] = {
                availabilityStatus: detail.availabilityStatus.toLowerCase(),
                reason: detail.reason
            };
        });

        _.assignIn(context.modalityDetails, modalityDetails);
    };

    exports.getSkypeEndpointUri = function getSkypeEndpointUri() {
        return context.skypeEndpointUri;
    };

    exports.setSkypeEndpointUri = function setSkypeEndpointUri(uri) {
        context.skypeEndpointUri = uri;
    };

    exports.isInitialized = function isInitialized() {
        return context.isInitialized;
    };

    exports.setIsInitialized = function setIsInitialized(value) {
        context.isInitialized = !!value;
    };

    exports.getSnapshot = function getSnapshot() {
        return context.snapshot;
    };

    exports.setSnapshot = function setSnapshot(snapshot) {
        context.snapshot = snapshot;
    };

    exports.isPendingAcceptance = function isPendingAcceptance() {
        return context.isPendingAcceptance;
    };

    exports.setIsPendingAcceptance = function setIsPendingAcceptance(flag) {
        context.isPendingAcceptance = !!flag;
    };

    exports.getMaxChatCount = function getMaxChatCount() {
        return context.maxChatCount;
    };

    exports.setMaxChatCount = function setMaxChatCount(count) {
        if (_.isNumber(count)) {
            context.maxChatCount = count;
        }
    };

    exports.isSupportingChat = function isSupportingChat() {
        return context.isSupportingChat;
    };

    exports.setIsSupportingChat = function setIsSupportingChat(flag) {
        context.isSupportingChat = !!flag;
    };

    exports.getAvailabilityPingLoop = function getAvailabilityPingLoop() {
        return context.availabilityPingLoop;
    };

    exports.setAvailabilityPingLoop = function setAvailabilityPingLoop(value) {
        context.availabilityPingLoop = value;
    };

    exports.reset = function reset() {
        _.assignIn(context, defaultContext);
    };
});
define( 'services/chatEngagements',['require','exports','module','lodash','skype/jlyncApplication','constants/common','services/serviceLocator'],function (require, exports) {
    'use strict';

    var _ = require('lodash'),
        jlyncApp = require('skype/jlyncApplication'),
        constants = require('constants/common'),
        serviceLocator = require('services/serviceLocator'),
        chatEngagements = {};

    exports.getChatEngagement = function (chatId) {
        if (chatId) {
            return chatEngagements[chatId];
        } else {
            return chatEngagements;
        }
    };

    exports.addChatEngagement = function (chatEngagement) {
        var pubSub = serviceLocator.resolve(constants.serviceLocator.PUBSUB);

        chatEngagements[chatEngagement.chatId] = chatEngagement;
        pubSub.publish(constants.events.CHAT_ENGAGEMENT_ADDED, []);
    };

    exports.removeChatEngagement = function (chatId) {
        delete chatEngagements[chatId];

        if (_.isEmpty(chatEngagements)) {
            var pubSub = serviceLocator.resolve(constants.serviceLocator.PUBSUB);

            pubSub.publish(constants.events.NO_CHAT_ENGAGEMENT, []);
        }
    };

    exports.getSnapshot = function () {
        var snapshot = {},
            activeEngagementsApi = serviceLocator.resolve(constants.serviceLocator.ACTIVE_ENGAGEMENTS),
            activeEngagements = activeEngagementsApi.getActiveEngagement();

        _.forEach(activeEngagements, function (activeEngagement) {
            var chatEngagement = chatEngagements[activeEngagement.chatId];

            if (chatEngagement) {
                snapshot[activeEngagement.engagementId] = chatEngagement._getSnapshot();
            } else {
                snapshot[activeEngagement.engagementId] = activeEngagement;
            }
        });

        if (!_.isEmpty(snapshot)) {
            snapshot.sfbSnapshot = jlyncApp.get().getSnapshot();
        }

        return snapshot;
    };

    exports.resetChatEngagements = function () {
        chatEngagements = {};
    };
});
define( 'services/activeEngagements',['require','exports','module','lodash'],function (require, exports) {
    'use strict';

    var _ = require('lodash'),
        activeEngagements = {};

    exports.hasEngagement = function (engagementId) {
        return !!activeEngagements[engagementId];
    };

    exports.currentChatCount = function () {
        return _.size(activeEngagements);
    };

    exports.getActiveEngagement = function (engagementId) {
        if (engagementId) {
            return activeEngagements[engagementId];
        } else {
            return _.clone(activeEngagements);
        }
    };

    exports.addActiveEngagement = function (chatEngagement) {
        activeEngagements[chatEngagement.engagementId] = {
            visitId: chatEngagement.visitId,
            engagementId: chatEngagement.engagementId,
            conferenceId: chatEngagement.conferenceId,
            partnerId: chatEngagement.partnerId,
            chatId: chatEngagement.chatId
        };
    };

    exports.removeActiveEngagement = function (engagementId) {
        delete activeEngagements[engagementId];
    };

    exports.resetChatEngagements = function () {
        activeEngagements = {};
    };
});
define( 'services/skypeAuthContext',['require','exports','module','lodash','settings','constants/common'],function (require, exports) {
    'use strict';

    var _ = require('lodash'),
        settings = require('settings'),
        constants = require('constants/common'),
        defaultContext = {
            origins: [
                'https://webdir.online.lync.com/autodiscover/autodiscoverservice.svc/root'
            ],
            cors: true,
            imdn: true,
            events: {
                timeout: constants.jlyncPendingGetTimeoutInSecond
            },
            version: 'MSaaSChatAgentWebSdk/' + settings.version
        },
        context = _.clone(defaultContext);

    exports.get = function get() {
        return context;
    };

    exports.setAadClientId = function setAadClientId(clientId) {
        context['client_id'] = clientId;
    };

    exports.setRedirectUri = function setRedirectUri(uri) {
        context['redirect_uri'] = uri;
    };

    exports.setOAuthUri = function setOAuthUri(upn) {
        if (upn){
            context['oauth_uri'] = constants.oauthUriFormat + encodeURIComponent(upn);
        }
    };

    exports.reset = function reset() {
        _.assignIn(context, defaultContext);
    };
});
define( 'services/exceptionManager',['require','exports','module','constants/common'],function (require, exports) {
    'use strict';

    var errorCodes = require('constants/common').errorCodes;

    exports.wrapRequestInvalid = function (errorMessage) {
        return {
            errorCode: errorCodes.REQUEST_INVALID,
            context: {
                message: errorMessage
            }
        };
    };

    exports.wrapChannelError = function (error, errorMessage) {
        if (!error || !error.errorCode) {
            return {
                errorCode: errorCodes.CHANNEL_ERROR,
                context: {
                    message: errorMessage,
                    error: typeof error === 'string' ? error : JSON.stringify(error)
                }
            };
        }

        return error;
    };

    exports.wrapAjaxResponseError = function (error) {
        var statusCode = error.status,
            responseText = error.responseText,
            statusText = error.statusText,
            exception = {
                context: {
                    message: responseText,
                    statusCode: statusCode,
                    statusText: statusText
                }
            };

        if (statusCode === 400) {
            exception.errorCode = errorCodes.REQUEST_INVALID;
        } else if (statusCode === 401) {
            exception.errorCode = errorCodes.REQUEST_UNAUTHORIZED;
        } else if (statusCode === 403) {
            exception.errorCode = errorCodes.REQUEST_FORBIDDEN;
        } else if (statusCode >= 500 && statusCode < 600) {
            exception.errorCode = errorCodes.SERVER_ERROR;
        } else if (statusCode === errorCodes.AAD_ERROR) {
            exception.errorCode = errorCodes.AAD_ERROR;
        } else {
            exception.errorCode = errorCodes.REQUEST_FAILED;
        }

        return exception;
    };

    exports.wrapServerError = function (error, message) {
        if (error && error.errorCode === errorCodes.SERVER_ERROR) {
            error.context = {
                message: message
            };
        }

        return error;
    };
});
define( 'services/authService',['require','exports','module','settings','telemetry/telemetryClient','constants/telemetry','constants/common'],function (require, exports) {
    'use strict';

    var resource = require('settings').gatewayAudienceUri,
        telemetryClient = require('telemetry/telemetryClient'),
        telemetry = require('constants/telemetry'),
        errorCodes = require('constants/common').errorCodes,
        instance, cachedToken, loggingContext;

    exports.setAuthProvider = function setAuthProvider(authService) {
        instance = authService;
    };

    exports.getCachedToken = function getCachedToken() {
        return cachedToken;
    };

    exports.getToken = function getToken() {
        function onSuccess(token) {
            cachedToken = 'Bearer ' + token;

            return cachedToken;
        }

        function onError(error) {
            var errorMessage = typeof error === 'string' ? error : JSON.stringify(error),
                exception = {
                    status: errorCodes.AAD_ERROR,
                    responseText: errorMessage
                };

            loggingContext = {
                eventId: [
                    telemetry.MilestoneCodes.Default,
                    telemetry.StatusEventCodes.Default,
                    telemetry.OutcomeBits.Failure,
                    telemetry.Events.GetTokenFailed.ID
                ],
                eventName: telemetry.Events.GetTokenFailed.NAME,
                data: {
                    message: telemetry.Events.GetTokenFailed.MESSAGE,
                    faultContext: errorMessage
                }
            };
            telemetryClient.get().sendEvent(loggingContext);

            throw exception;
        }

        return Promise.resolve(resource)
            .then(instance.acquireToken)
            .then(onSuccess)
            .catch(onError);
    };
});
define('serviceLocatorInitializer',['require','exports','module','constants/common','services/gatewayService','services/pubSub','services/agentContext','services/chatEngagements','services/activeEngagements','services/skypeAuthContext','services/exceptionManager','services/authService','services/serviceLocator'],function (require, exports) {
    'use strict';

    var constants = require('constants/common'),
        gatewayService = require('services/gatewayService'),
        pubSub = require('services/pubSub'),
        agentContextService = require('services/agentContext'),
        chatEngagementsService = require('services/chatEngagements'),
        activeEngagementsService = require('services/activeEngagements'),
        skypeAuthContextService = require('services/skypeAuthContext'),
        exceptionManagerService = require('services/exceptionManager'),
        authService = require('services/authService'),
        serviceLocator = require('services/serviceLocator');

    exports.registerServices = function() {
        serviceLocator.register(constants.serviceLocator.AGENT_CONTEXT, agentContextService);
        serviceLocator.register(constants.serviceLocator.ACTIVE_ENGAGEMENTS, activeEngagementsService);
        serviceLocator.register(constants.serviceLocator.EXCEPTION_MANAGER, exceptionManagerService);
        serviceLocator.register(constants.serviceLocator.AUTH_SERVICE, authService);
        serviceLocator.register(constants.serviceLocator.GATEWAY, gatewayService.getInstance());
        serviceLocator.register(constants.serviceLocator.PUBSUB, pubSub.build());
        serviceLocator.register(constants.serviceLocator.CHAT_ENGAGEMENTS, chatEngagementsService);
        serviceLocator.register(constants.serviceLocator.SKYPE_AUTH_CONTEXT, skypeAuthContextService);

        return serviceLocator;
    };
});
define('api/builder',['require','exports','module','api/agentAvailability','skype/jlyncApplication','api/engagement','settings','constants/common','eventHandlers/agentAvailabilityHandler','services/serviceLocator'],function (require, exports) {
    'use strict';

    var agentAvailabilityApi = require('api/agentAvailability'),
        jlyncApp = require('skype/jlyncApplication'),
        engagementApi = require('api/engagement'),
        settings = require('settings'),
        constants = require('constants/common'),
        agentAvailabilityHandler = require('eventHandlers/agentAvailabilityHandler'),
        serviceLocator = require('services/serviceLocator'),
        agentContextApi, pubSub;

    exports.get = function () {
        var api = {};

        agentContextApi = serviceLocator.resolve(constants.serviceLocator.AGENT_CONTEXT);
        pubSub = serviceLocator.resolve(constants.serviceLocator.PUBSUB);
        api.agentContext = {
            id: agentContextApi.getId,
            displayName: agentContextApi.getDisplayName
        },

        api.initAgent = agentAvailabilityApi.initAgent;
        api.setAvailability = agentAvailabilityApi.setAvailability;
        api.getAvailability = agentAvailabilityApi.getAvailability;
        api.getContext = engagementApi.getContext;
        api.updateContext = engagementApi.updateContext;
        api.getChatTranscript = engagementApi.getTranscript;
        api.endEngagement = engagementApi.endEngagement;
        api.whisper = engagementApi.whisper;
        api.getHoops = engagementApi.getSupportHours;
        api.getChatQueueLength = engagementApi.getChatQueueLength;
        api.getReachableAgentCount = engagementApi.getReachableAgentCount;
        api.assign = engagementApi.assign;
        api.chatEngagements = engagementApi.chatEngagements;

        api.event = (function () {
            function subscribe(eventName, callback) {
                pubSub.subscribe(eventName, callback);
            }

            function unsubscribe(eventName, callback) {
                pubSub.unsubscribe(eventName, callback);
            }

            return {
                on: subscribe,
                off: unsubscribe
            };
        })();

        api.dispose = function () {
            agentAvailabilityHandler.dispose();
            pubSub.dispose();
            jlyncApp.dispose();
            serviceLocator.reset();
        };

        api._jlync = agentContextApi.isSupportingChat() ? jlyncApp.get() : null;

        api.version = (function () {
            return settings.version;
        })();

        api.availabilityStatus = (function () {
            return {
                available: constants.availabilityStatus.AVAILABLE,
                unavailable: constants.availabilityStatus.NOT_AVAILABLE
            };
        })();

        api.events = (function () {
            return {
                chatChannelUnavailable: constants.events.CHAT_CHANNEL_UNAVAILABLE,
                unreachableByService: constants.events.UNREACHABLE_BY_SERVICE,
                getAvailabilityFailed: constants.events.GET_AVAILABILITY_FAILED,
                getAvailabilityRestored: constants.events.GET_AVAILABILITY_RESTORED,
                availabilityUpdated: constants.events.AVAILABILITY_UPDATED,
                maxChatCountUpdated: constants.events.MAX_CHAT_COUNT_UPDATED
            };
        })();

        api.errorCodes = (function () {
            return {
                REQUEST_INVALID: constants.errorCodes.REQUEST_INVALID,
                REQUEST_FAILED: constants.errorCodes.REQUEST_FAILED,
                REQUEST_UNAUTHORIZED: constants.errorCodes.REQUEST_UNAUTHORIZED,
                SERVER_ERROR: constants.errorCodes.SERVER_ERROR,
                CHANNEL_ERROR: constants.errorCodes.CHANNEL_ERROR
            };
        })();

        api.authResource = function () {
            return settings.gatewayAudienceUri;
        };

        return api;
    };
});
define('telemetry/browserClosedTelemetry',['require','exports','module','constants/telemetry','telemetry/telemetryClient','constants/common'],function (require, exports) {
    'use strict';

    var telemetry = require('constants/telemetry'),
        telemetryClient = require('telemetry/telemetryClient'),
        constants = require('constants/common'),
        loggingContext;

    function onBrowerClosed() {
        loggingContext = {
            eventId: [
                telemetry.MilestoneCodes.Default,
                telemetry.StatusEventCodes.Default,
                telemetry.OutcomeBits.Unknown,
                telemetry.Events.BrowserClosed.ID
            ],
            eventName: telemetry.Events.BrowserClosed.NAME,
            data: {
                message: telemetry.Events.BrowserClosed.MESSAGE
            }
        };
        telemetryClient.get().sendEvent(loggingContext);
    }

    exports.init = function () {
        window.addEventListener(constants.browser.UNLOAD, onBrowerClosed);
    };
});
define('initClientSdk',['require','es6-promise','lodash','api/agentAvailability','skype/loadJlync','serviceLocatorInitializer','services/serviceLocator','api/builder','settings','constants/common','services/serviceLocator','telemetry/telemetryClient','constants/telemetry','telemetry/browserClosedTelemetry'],function (require) {
    'use strict';

    require('es6-promise').polyfill();

    var _ = require('lodash'),
        agentAvailabilityApi = require('api/agentAvailability'),
        loadJlync = require('skype/loadJlync'),
        serviceLocatorInitializer = require('serviceLocatorInitializer'),
        serviceLocator = require('services/serviceLocator'),
        apiBuilder = require('api/builder'),
        settings = require('settings'),
        constants = require('constants/common'),
        serviceLocator = require('services/serviceLocator'),
        telemetryClient = require('telemetry/telemetryClient'),
        telemetry = require('constants/telemetry'),
        browserClosedTelemetry = require('telemetry/browserClosedTelemetry'),
        loggingContext, skypeAuthContextApi, agentContextApi, authService;

    function init(config, onSuccess, onError) {
        function onApiReady(results) {
            loggingContext = {
                eventId: [
                    telemetry.MilestoneCodes.Default,
                    telemetry.StatusEventCodes.Initiated,
                    telemetry.OutcomeBits.Success,
                    telemetry.Events.AgentWebSdkInitialized.ID
                ],
                eventName: telemetry.Events.AgentWebSdkInitialized.NAME,
                data: {
                    message: telemetry.Events.AgentWebSdkInitialized.MESSAGE
                }
            };
            telemetryClient.get().sendEvent(loggingContext);

            if (results[1] && results[1].modalityDetails) {
                agentContextApi.setModalityDetails(results[1].modalityDetails);
                agentContextApi.setMaxChatCount(results[1].maxChatCount);
            }

            browserClosedTelemetry.init();
            onSuccess(apiBuilder.get());
        }

        function onFailure(error) {
            loggingContext = {
                eventId: [
                    telemetry.MilestoneCodes.Default,
                    telemetry.StatusEventCodes.Initiated,
                    telemetry.OutcomeBits.Failure,
                    telemetry.Events.InitAgentWebSdkFailed.ID
                ],
                eventName: telemetry.Events.InitAgentWebSdkFailed.NAME,
                data: {
                    faultContext: typeof error === 'string' ? error : JSON.stringify(error),
                    message: telemetry.Events.InitAgentWebSdkFailed.MESSAGE
                }
            };
            loggingContext.isChatEntityEvent = true;
            telemetryClient.get().sendEvent(loggingContext);
            serviceLocator.reset();

            onError(error);
        }

        function validateSettings(config) {
            if (!config) {
                return 'Initial config setting is required';
            }

            if (!config.agentId) {
                return 'agentId is required';
            }

            if (!config.upn) {
                return 'upn is required';
            }

            if (!config.authService || !_.isFunction(config.authService.acquireToken)) {
                return 'authService is required';
            }

            if (isSupportingChat) {
                if (!config.clientId) {
                    return 'AAD clientId is required';
                }

                if (!config.redirectUri) {
                    return 'redirectUri is required';
                }
            }
        }

        var isSupportingChat = true,
            configValidationError;

        if (config && _.isArray(config.supportedModalities)) {
            _.forEach(config.supportedModalities, function (value, index) {
                config.supportedModalities[index] = value.toLocaleLowerCase();
            });

            isSupportingChat = _.indexOf(config.supportedModalities, constants.modality.CHAT) > -1 ? true : false;
        }

        if (config.correlationVector) {
            settings.correlationVector = config.correlationVector;
            delete config.correlationVector;
        }

        if (config.testHeader) {
            settings.testHeader = JSON.stringify(config.testHeader);
            delete config.testHeader;
        }

        if (config.requestMaxRetry >= 0) {
            settings.requestMaxRetry = config.requestMaxRetry;
        }

        if (config.requestTimeout > 0) {
            settings.requestTimeoutInMillisecond = config.requestTimeout;
        }

        serviceLocatorInitializer.registerServices();
        configValidationError = validateSettings(config);

        if (configValidationError) {
            onFailure(configValidationError);
            return;
        }

        agentContextApi = serviceLocator.resolve(constants.serviceLocator.AGENT_CONTEXT);
        authService = serviceLocator.resolve(constants.serviceLocator.AUTH_SERVICE);
        agentContextApi.setId(config.agentId);
        agentContextApi.setIsSupportingChat(isSupportingChat);
        authService.setAuthProvider(config.authService);

        if (isSupportingChat) {
            skypeAuthContextApi = serviceLocator.resolve(constants.serviceLocator.SKYPE_AUTH_CONTEXT);
            skypeAuthContextApi.setAadClientId(config.clientId);
            skypeAuthContextApi.setRedirectUri(config.redirectUri);
            settings.disableSkypeSilentReauth = config.disableSkypeSilentReauth;
        }

        delete config.disableSkypeSilentReauth;

        if (config.upn) {
            var indexForSite = config.upn.lastIndexOf('_');

            isSupportingChat && skypeAuthContextApi.setOAuthUri(config.upn);
            indexForSite > 0 && agentContextApi.setSite(config.upn.slice(0, indexForSite));
        }

        if (config.siteId) {
            agentContextApi.setSite(config.siteId);
        }

        var jlyncInitParams = {
                correlationIds: {
                    agentId: config.agentId
                }
            },
            loadJlyncPromise = isSupportingChat ? loadJlync(jlyncInitParams) : Promise.resolve(),
            getAvailabilityPromise = agentAvailabilityApi.getAvailability(true);

        Promise.all([loadJlyncPromise, getAvailabilityPromise]).then(onApiReady).catch(onFailure);
    }

    window.channelServicesInt = window.channelServicesInt || {};
    window.channelServicesInt.initAgentSdk = init;
});
!function(){var a={platformId:905,urls:["https://a.config.skype.com","https://b.config.skype.com"],businessUrls:["https://config.edge.skype.com","https://config.edge.skype.com"],team:"SkypeLyncWebExperience",maximumAttempts:3,waitDuration:6e3};window.Skype=window.Skype||{};var b="1.2.29";!function(a){"use strict";function e(a,b){var c=a;return b=void 0===b?1:b,"object"!=typeof c&&(c={message:a||"unknown error"}),void 0===c.code&&(c.code=b),c}function g(a){return e(a,0)}function h(a){if(void 0===a||null===a)throw"No settings provided"}function j(a){if("function"!=typeof a)throw"Success callback was not provided"}a.getVersion=function(){return b},a.initialize=function(b,k,l){function m(a){l&&l(e(a))}function n(a){return d.isSupported(window)?a.packageUrl:a.packageUrlUnsupportedBrowser?a.packageUrlUnsupportedBrowser:void m(g("This browser is unsupported"))}function o(a){p(a)}function p(c){if(!c.packageUrl)return void m(g("No package definition found for this config"));var d=(new Date).getTime(),e={};a.onExperienceLoaded=function(e){var f=(new Date).getTime();e.init({initParams:b,config:c,configLoadDuration:d-q,packageLoadDuration:f-d},k,m),delete a.onExperienceLoaded},c.corsScript&&(e.crossOrigin=""),i.loadScript(n(c),null,m,e)}var q=(new Date).getTime();h(b),j(k),b.fingerprint=b.userId||(b.correlationIds?b.correlationIds.userId:null),b.fingerprint=b.fingerprint||f.get(window),c.loadConfig(b,o,m)}}(window.Skype);var c=function(){"use strict";function c(b){var c=[];return a&&a.urls&&(c=b.business===!0?j(a.businessUrls,b):j(a.urls,b)),c}function d(){for(var c=b.split(".",4);c.length<4;)c.push(0);return a.platformId+"_"+c.join(".")}function f(a){var b,c,d=[];for(b in a)a.hasOwnProperty(b)&&void 0!==(c=a[b])&&d.push([b,c].join("="));return d.join("&")}function i(b,c){var e=a.team,g=d(),h=b+"/config/v1/"+e+"/"+g,i=f(c),j=h;return i&&(j+="?"+i),j}function j(a,b){var c=[],d={apikey:b.apiKey,fingerprint:b.fingerprint,ecsoverride:e.get(window)};b.dogfood!==!0&&"2a9f196e-2926-4f83-80a2-543bfbd2f75a"!==b.apiKey||!b.correlationIds.upn||(d.id=b.correlationIds.upn);for(var f=0;f<a.length;f++)c.push(i(a[f],d));return c}function k(b,d,e){function f(a){q++,b.jsonp===!1?g.request(a,k,m):h.request(a,"onConfigurationLoaded",k,m,"ecsConfig")}function i(){return q/o.length>=(a.maximumAttempts||l)}function j(b){var c=b.ConfigIDs&&b.ConfigIDs[a.team];return c?c.split(/\s*,\s*/):[]}function k(c){var f,g;if(!n){if(n=!0,"string"==typeof c)try{f=JSON.parse(c)}catch(h){}else f=c;g=f&&f[a.team],g?(g.configIds=j(f),g.eTag=f.Headers&&f.Headers.ETag||"",g.countryCode=f.Headers&&f.Headers.CountryCode,d&&d(g)):e&&e("Configuration service did not find any configuration that matches parameters or configuration service response is invalid",b)}}function m(){i()?e&&e("Configuration service is unreachable"):f(o[++p%o.length])}var n,o,p,q=0;return b&&b.apiKey?(o=c(b),o&&o.length?(p=Math.floor(Math.random()*o.length),void f(o[p])):void(e&&e("No configuration service endpoints have been defined"))):void(e&&e("API key was not provided"))}var l=2;return{loadConfig:k}}(),d=function(){"use strict";function a(a){return!!b(a)||!g(a)&&(!i(a)&&(!c(a)&&!e(a)))}function b(a){return a.navigator.userAgent.indexOf("SkypeShell")>-1}function c(a){var b=d(a);return b>-1&&10>b}function d(a){var b,c=-1,d=a.navigator.userAgent||"",e=a.navigator.appName||"";return"Microsoft Internet Explorer"===e&&(b=new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})"),b.exec(d)&&(c=parseFloat(RegExp.$1))),c}function e(a){var b=f(a);return b>-1&&8>b}function f(a){var b,c=-1,d=a.navigator.userAgent||"";return d.indexOf("Safari/")>-1&&d.indexOf("Chrome")===-1&&(b=new RegExp("Version/([0-9]{1,}[.0-9]{0,})"),b.exec(d)&&(c=parseFloat(RegExp.$1))),c}function g(a){var b=h(a);return b>-1&&43>b}function h(a){var b,c=-1,d=a.navigator.userAgent||"";return d.indexOf("Chrome/")>-1&&d.indexOf("Safari/")>-1&&d.indexOf("Edge/")===-1&&(b=new RegExp("Chrome/([0-9]{1,}[.0-9]{0,})"),b.exec(d)&&(c=parseFloat(RegExp.$1))),c}function i(a){var b=j(a);return b>-1&&40>b}function j(a){var b,c=-1,d=a.navigator.userAgent||"";return d.indexOf("Firefox/")>-1&&d.indexOf("Gecko/")>-1&&d.indexOf("Opera")===-1&&(b=new RegExp("Firefox/([0-9]{1,}[.0-9]{0,})"),b.exec(d)&&(c=parseFloat(RegExp.$1))),c}return{isSupported:a}}(),e=function(){"use strict";function a(a){a=a||window;var b=a.location.search.match(new RegExp(c,"i"));return b&&b[1]?b[1]:(b=a.document.cookie.match(new RegExp(d,"i")),b&&b[1]?b[1]:void 0)}var b="ecsoverride",c="\\b"+b+"=([^&]+)",d="\\b"+b+"=([^;]+)";return{get:a}}(),f=function(){"use strict";function a(){return("0000000"+Date.now().toString(16)).slice(-8)+"-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(a){var b=Math.floor(16*Math.random());return("x"===a?b:8+b%4).toString(16)})}function b(b){b=b||window;var d;try{d=b.localStorage.getItem(c)}catch(e){}if(!d){d=a();try{b.localStorage.setItem(c,d)}catch(e){}}return d}var c="skype.fingerprint";return{get:b}}(),g=function(b){"use strict";function c(c,d,e){function f(){4===i.readyState&&(200===i.status?(b.clearTimeout(g),d&&d(i.responseText)):h())}if(!c)throw"URL parameter was not provided";var g,h=function(){b.clearTimeout(g),e&&(e(),e=null,d=null)},i=new XMLHttpRequest;i.onreadystatechange=f,i.open("GET",c,!0),i.send(),g=b.setTimeout(h,a.timeout||2e4)}return{request:c}}(window),h=function(b){"use strict";function c(c,e,f,g,h){if(!c||!e)throw"URL or callback name was not provided";var j,k,l=function(){b.clearTimeout(k),g&&(g(),g=null,f=null)};j=c+(/\?/.test(c)?"&":"?")+"callback=Skype."+e,b.Skype[e]=function(){b.clearTimeout(k),f&&f.apply(null,arguments)},i.loadScript(j,d,l,{id:h}),k=b.setTimeout(l,a.timeout||2e4)}var d=function(){};return{request:c}}(window),i=function(){"use strict";function a(a,b,c,d){var e=document.createElement("script");d=d||{},e.src=a,e.type="text/javascript",e.defer=!0,b&&(e.onload=b),c&&(e.onerror=c);for(var f in d)void 0!==d[f]&&(e[f]=d[f]);document.getElementsByTagName("head")[0].appendChild(e)}return{loadScript:a}}()}();
define("swxBootstrap", function(){});


require(["initClientSdk"]);
}());